module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		9: 0
/******/ 	};
/******/
/******/
/******/
/******/ 	// script path function
/******/ 	function jsonpScriptSrc(chunkId) {
/******/ 		return __webpack_require__.p + "platform-components.common." + ({"0":"defaultVendors~DownloadVideoModal~MyContentUploadModal","1":"AdminComponents","2":"AudioViewer","3":"CreateWithStudioModal","4":"DownloadVideoModal","5":"DualAssignModal2023","6":"GoogleClassroomModal","7":"MyContentUploadModal","8":"ShareModal","10":"vendors~AudioViewer"}[chunkId]||chunkId) + ".js"
/******/ 	}
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var promises = [];
/******/
/******/
/******/ 		// JSONP chunk loading for javascript
/******/
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData !== 0) { // 0 means "already installed".
/******/
/******/ 			// a Promise means "currently loading".
/******/ 			if(installedChunkData) {
/******/ 				promises.push(installedChunkData[2]);
/******/ 			} else {
/******/ 				// setup Promise in chunk cache
/******/ 				var promise = new Promise(function(resolve, reject) {
/******/ 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 				});
/******/ 				promises.push(installedChunkData[2] = promise);
/******/
/******/ 				// start chunk loading
/******/ 				var script = document.createElement('script');
/******/ 				var onScriptComplete;
/******/
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.src = jsonpScriptSrc(chunkId);
/******/
/******/ 				// create error before stack unwound to get useful stacktrace later
/******/ 				var error = new Error();
/******/ 				onScriptComplete = function (event) {
/******/ 					// avoid mem leaks in IE.
/******/ 					script.onerror = script.onload = null;
/******/ 					clearTimeout(timeout);
/******/ 					var chunk = installedChunks[chunkId];
/******/ 					if(chunk !== 0) {
/******/ 						if(chunk) {
/******/ 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 							var realSrc = event && event.target && event.target.src;
/******/ 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 							error.name = 'ChunkLoadError';
/******/ 							error.type = errorType;
/******/ 							error.request = realSrc;
/******/ 							chunk[1](error);
/******/ 						}
/******/ 						installedChunks[chunkId] = undefined;
/******/ 					}
/******/ 				};
/******/ 				var timeout = setTimeout(function(){
/******/ 					onScriptComplete({ type: 'timeout', target: script });
/******/ 				}, 120000);
/******/ 				script.onerror = script.onload = onScriptComplete;
/******/ 				document.head.appendChild(script);
/******/ 			}
/******/ 		}
/******/ 		return Promise.all(promises);
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	var jsonpArray = (typeof self !== 'undefined' ? self : this)["webpackJsonpplatform_components"] = (typeof self !== 'undefined' ? self : this)["webpackJsonpplatform_components"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (str) {
    if (typeof this.exec !== 'function') {
      return nativeTest.call(this, str);
    }
    var result = this.exec(str);
    if (result !== null && !isObject(result)) {
      throw new Error('RegExp exec method returned something other than an Object or null');
    }
    return !!result;
  }
});


/***/ }),

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0148":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseFindIndex.js
var _baseFindIndex = __webpack_require__("1b70");

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseIsNaN.js
var _baseIsNaN = __webpack_require__("c53c");

// CONCATENATED MODULE: ./node_modules/lodash-es/_strictIndexOf.js
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var _strictIndexOf = (strictIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIndexOf.js




/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? _strictIndexOf(array, value, fromIndex)
    : Object(_baseFindIndex["a" /* default */])(array, _baseIsNaN["a" /* default */], fromIndex);
}

/* harmony default export */ var _baseIndexOf = __webpack_exports__["a"] = (baseIndexOf);


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3abe");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5eb274af", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0305":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getNative_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("63bc");


var defineProperty = (function() {
  try {
    var func = Object(_getNative_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "0538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");
var isObject = __webpack_require__("861d");

var slice = [].slice;
var factories = {};

var construct = function (C, argsLength, args) {
  if (!(argsLength in factories)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func -- we have no proper alternatives, IE8- only
    factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = slice.call(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = partArgs.concat(slice.call(arguments));
    return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
  };
  if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
  return boundFunction;
};


/***/ }),

/***/ "0560":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ActionMenu_vue_vue_type_style_index_0_id_7e3182ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("876c");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ActionMenu_vue_vue_type_style_index_0_id_7e3182ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ActionMenu_vue_vue_type_style_index_0_id_7e3182ba_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "062a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseCreate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7378");
/* harmony import */ var _baseLodash_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5c54");



/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = Object(_baseCreate_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_baseLodash_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

/* harmony default export */ __webpack_exports__["a"] = (LazyWrapper);


/***/ }),

/***/ "0649":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b0d7");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5eb4f733", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "06c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _unsupportedIterableToArray; });
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fb6a");
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("a630");
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3ca3");
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("ac1f");
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("00b4");
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("6b75");







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(o, minLen);
}

/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "0a06":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var buildURL = __webpack_require__("30b5");
var InterceptorManager = __webpack_require__("f6b4");
var dispatchRequest = __webpack_require__("5270");
var mergeConfig = __webpack_require__("4a7b");
var validator = __webpack_require__("848b");

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "0a73":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "platform-components-assets/img/earth.png";

/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ImageDetail_vue_vue_type_style_index_0_id_963f194a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0649");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ImageDetail_vue_vue_type_style_index_0_id_963f194a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ImageDetail_vue_vue_type_style_index_0_id_963f194a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0df6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "0e59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/_getNative.js + 1 modules
var _getNative = __webpack_require__("63bc");

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeCreate.js


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(_getNative["a" /* default */])(Object, 'create');

/* harmony default export */ var _nativeCreate = (nativeCreate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashClear.js


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

/* harmony default export */ var _hashClear = (hashClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashDelete.js
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _hashDelete = (hashDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashGet.js


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashGet_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return _hashGet_hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ var _hashGet = (hashGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashHas.js


/** Used for built-in method references. */
var _hashHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _hashHas_hasOwnProperty = _hashHas_objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : _hashHas_hasOwnProperty.call(data, key);
}

/* harmony default export */ var _hashHas = (hashHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hashSet.js


/** Used to stand-in for `undefined` hash values. */
var _hashSet_HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? _hashSet_HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ var _hashSet = (hashSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Hash.js






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

/* harmony default export */ var _Hash = (Hash);

// EXTERNAL MODULE: ./node_modules/lodash-es/_ListCache.js + 6 modules
var _ListCache = __webpack_require__("9cbb");

// EXTERNAL MODULE: ./node_modules/lodash-es/_Map.js
var _Map = __webpack_require__("ddc9");

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheClear.js




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map["a" /* default */] || _ListCache["a" /* default */]),
    'string': new _Hash
  };
}

/* harmony default export */ var _mapCacheClear = (mapCacheClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isKeyable.js
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ var _isKeyable = (isKeyable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getMapData.js


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ var _getMapData = (getMapData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheDelete.js


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ var _mapCacheDelete = (mapCacheDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheGet.js


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

/* harmony default export */ var _mapCacheGet = (mapCacheGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheHas.js


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

/* harmony default export */ var _mapCacheHas = (mapCacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapCacheSet.js


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ var _mapCacheSet = (mapCacheSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_MapCache.js






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

/* harmony default export */ var _MapCache = __webpack_exports__["a"] = (MapCache);


/***/ }),

/***/ "1147":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),

/***/ "131a":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var setPrototypeOf = __webpack_require__("d2bb");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "1433":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to lookup unminified function names. */
var realNames = {};

/* harmony default export */ __webpack_exports__["a"] = (realNames);


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "1767":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.asset-player-content__article{color:#575757;margin:0 auto;max-width:700px;min-height:300px;padding:72px 16px;position:relative}.asset-player-content__article .title{display:block;font-weight:700;margin:8px 0}.asset-player-content__article .para{display:block;line-height:1.6;margin:6px 0 12px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "19aa":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "1a7d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseCreate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7378");
/* harmony import */ var _baseLodash_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5c54");



/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = Object(_baseCreate_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_baseLodash_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

/* harmony default export */ __webpack_exports__["a"] = (LodashWrapper);


/***/ }),

/***/ "1b70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindIndex);


/***/ }),

/***/ "1bc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f0ce");
/* harmony import */ var _isObjectLike_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1147");



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(_isObjectLike_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(value) && Object(_baseGetTag_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1cf9":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}.comet-screenreader-only{clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;order:0;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap}@-webkit-keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}html{box-sizing:border-box;font-size:16px}*,:after,:before{box-sizing:inherit}body{font-family:Proxima Vara,Arial,sans-serif}.sso-ssi-modal .nebula-modal{max-width:640px;width:100%}.sso-ssi-modal .nebula-modal--m .nebula-modal__inner{padding:24px 34px 34px 38px}.sso-ssi-modal .ssi-header{color:var(--nebula-text-color-header-default);font-family:var(--nebula-font-family-header);font-weight:var(--nebula-font-weight-header);line-height:var(--nebula-font-line-height-heading);font-size:var(--nebula-font-size-header-level-6);margin-bottom:24px}.sso-ssi-modal .ssi-content{display:flex;flex-direction:column;align-items:center}.sso-ssi-modal .ssi-content__img{margin:8px 0 16px 0;max-width:128px}.sso-ssi-modal .ssi-content__header-text{font-weight:var(--nebula-font-weight-body);font-size:var(--nebula-font-size-body-1);font-weight:700;flex:2}.sso-ssi-modal .ssi-content__header-text,.sso-ssi-modal .ssi-content__par-text{color:var(--nebula-text-color-body-default);font-family:var(--nebula-font-family-body);line-height:var(--nebula-font-line-height-default)}.sso-ssi-modal .ssi-content__par-text{font-weight:var(--nebula-font-weight-body);font-size:var(--nebula-font-size-body-2)}.sso-ssi-modal .ssi-content__focal-text{color:var(--nebula-text-color-header-default);font-family:var(--nebula-font-family-header);font-weight:var(--nebula-font-weight-header);line-height:var(--nebula-font-line-height-heading);font-size:var(--nebula-font-size-header-level-5);margin-top:8px;text-align:center;word-break:break-all}.sso-ssi-modal .ssi-actions{display:flex;justify-content:center;margin:32px 0}.sso-ssi-modal .ssi-actions__button--submit{-webkit-margin-end:32px;margin-inline-end:32px}.sso-ssi-modal .ssi-state{border-top:solid #e8e8e8;flex:1;padding-top:16px}.sso-ssi-modal .nebula-checkbox__container{margin-bottom:4px}.sso-ssi-modal .nebula-checkbox__text{font-weight:600}.sso-ssi-modal .nebula-modal--m .nebula-modal__inner{padding-bottom:20px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "1d1c":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var defineProperties = __webpack_require__("37e8");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),

/***/ "1d2b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1da1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e6cf");
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_1__);



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "1dae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1de5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    // eslint-disable-next-line no-param-reassign
    options = {};
  } // eslint-disable-next-line no-underscore-dangle, no-param-reassign


  url = url && url.__esModule ? url.default : url;

  if (typeof url !== 'string') {
    return url;
  } // If url is already wrapped in quotes, remove them


  if (/^['"].*['"]$/.test(url)) {
    // eslint-disable-next-line no-param-reassign
    url = url.slice(1, -1);
  }

  if (options.hash) {
    // eslint-disable-next-line no-param-reassign
    url += options.hash;
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, '\\n'), "\"");
  }

  return url;
};

/***/ }),

/***/ "1df0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _identity_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f976");
/* harmony import */ var _metaMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6171");



/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !_metaMap_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"] ? _identity_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] : function(func, data) {
  _metaMap_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].set(func, data);
  return func;
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetData);


/***/ }),

/***/ "20b6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),

/***/ "2250":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ff51");
/* harmony import */ var _isKey_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("bd8f");
/* harmony import */ var _stringToPath_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ff50");
/* harmony import */ var _toString_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("79f6");





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(_isArray_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value)) {
    return value;
  }
  return Object(_isKey_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(value, object) ? [value] : Object(_stringToPath_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(Object(_toString_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var bind = __webpack_require__("0366");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};


/***/ }),

/***/ "2332":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),

/***/ "2392":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.asset-player-content__review-sheet{max-width:700px;margin:0 auto;padding:48px 32px}.asset-player-content__review-sheet h3{font-size:1.5rem;font-weight:400;margin-bottom:16px}.asset-player-content__review-sheet h4{font-size:1.125rem;margin-bottom:16px;text-transform:uppercase}.asset-player-content__review-sheet li{list-style-type:disc;margin:0 0 8px 16px}.asset-player-content__review-sheet p{margin-bottom:32px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2444":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("c532");
var normalizeHeaderName = __webpack_require__("c8af");
var enhanceError = __webpack_require__("387f");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("b50d");
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__("b50d");
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "26ee":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5ea3");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),

/***/ "286d":
/***/ (function(module) {

module.exports = JSON.parse("{\"%(count)d Student\":\"%(count)d Students\"}");

/***/ }),

/***/ "2909":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _toConsumableArray; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__("6b75");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(arrayLikeToArray["a" /* default */])(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__("06c5");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || Object(unsupportedIterableToArray["a" /* default */])(arr) || _nonIterableSpread();
}

/***/ }),

/***/ "292b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/* harmony default export */ __webpack_exports__["a"] = (getHolder);


/***/ }),

/***/ "2976":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "platform-components-assets/img/globe-no-gradient.png";

/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),

/***/ "2c08":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "platform-components-assets/img/spaceman.png";

/***/ }),

/***/ "2c57":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ca54");
/* harmony import */ var _arrayMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("b703");
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ff51");
/* harmony import */ var _isSymbol_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("1bc6");





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] ? _Symbol_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(_isArray_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(_arrayMap_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(value, baseToString) + '';
  }
  if (Object(_isSymbol_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var bind = __webpack_require__("0366");
var html = __webpack_require__("1be4");
var createElement = __webpack_require__("cc12");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var location = global.location;
var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    typeof postMessage == 'function' &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "2d5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _identity_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f976");
/* harmony import */ var _overRest_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("500e");
/* harmony import */ var _setToString_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("c619");




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(_setToString_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(Object(_overRest_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(func, start, _identity_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),

/***/ "2d83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("387f");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "2df1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1767");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4089c006", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2e67":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "2f74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),

/***/ "30b5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "387f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),

/***/ "3934":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ "3abe":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__("1de5");
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__("2976");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.nebula-error-techbook{background:radial-gradient(circle at 50% 100%,#a1cff7 0,rgba(161,207,247,0) 40%);font-family:Proxima Vara,Arial,sans-serif;height:100%;padding:8px 16px 0;width:100%}.nebula-error-techbook__globe{background:no-repeat url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") transparent;background-position:bottom;background-size:cover;height:300px;margin:110px auto 0;max-width:800px;position:relative}.nebula-error-techbook__content{margin:32px auto;max-width:600px}@media screen and (min-width:1200px){.nebula-error-techbook__content{width:1024px}}@media screen and (min-width:1440px){.nebula-error-techbook__content{width:1200px}}.nebula-error-techbook__heading{font-size:2.1875rem;text-align:center}.nebula-error-techbook__heading--science span{color:#18b80f}.nebula-error-techbook__heading--math span{color:#611de2}.nebula-error-techbook__heading--socs span{color:#ff8038}.nebula-error-techbook__heading--stem span{color:#3bc4ab}.nebula-error-techbook__buttons .nebula-button{display:block;margin:16px auto}@media screen and (min-width:375px){.nebula-error-techbook__buttons{display:flex;justify-content:center}.nebula-error-techbook__buttons .nebula-button{margin:0 8px}}.nebula-error-techbook__error-codes{color:#50717c}.nebula-error-techbook__error-codes>span{display:block;margin:16px auto;text-align:center}.nebula-error-techbook__error-codes>.nebula-button{display:block;margin:0 auto}@media screen and (min-width:768px){.nebula-error-techbook__error-codes{display:flex;justify-content:center;margin:24px 0 0}.nebula-error-techbook__error-codes>span{margin:5px 0}.nebula-error-techbook__error-codes>.nebula-button{margin:0 5px}}.nebula-error-techbook__error-codes-label{font-weight:700}.techbook-error-speech-bubble{align-items:center;display:flex;height:80px;left:50%;position:absolute;top:-35px;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:190px}.techbook-error-speech-bubble__svg-container{align-items:center;display:flex;justify-content:center}.techbook-error-speech-bubble__text{color:#0077d1;font-family:Mikado Chan,Quicksand,Proxima Vara,Arial,sans-serif;font-size:1.125rem;font-weight:600;margin:0;text-align:center;width:100%}.techbook-error-speech-bubble__text-container{position:absolute;top:14px;width:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3ee1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a51f");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("cd760168", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3eeb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dc95");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6303478e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3f2c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/_composeArgs.js
var _composeArgs = __webpack_require__("f1fb");

// EXTERNAL MODULE: ./node_modules/lodash-es/_composeArgsRight.js
var _composeArgsRight = __webpack_require__("884d");

// CONCATENATED MODULE: ./node_modules/lodash-es/_countHolders.js
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

/* harmony default export */ var _countHolders = (countHolders);

// EXTERNAL MODULE: ./node_modules/lodash-es/_createCtor.js
var _createCtor = __webpack_require__("b50b");

// EXTERNAL MODULE: ./node_modules/lodash-es/_createRecurry.js
var _createRecurry = __webpack_require__("bafb");

// EXTERNAL MODULE: ./node_modules/lodash-es/_getHolder.js
var _getHolder = __webpack_require__("292b");

// EXTERNAL MODULE: ./node_modules/lodash-es/_copyArray.js
var _copyArray = __webpack_require__("7804");

// EXTERNAL MODULE: ./node_modules/lodash-es/_isIndex.js
var _isIndex = __webpack_require__("7129");

// CONCATENATED MODULE: ./node_modules/lodash-es/_reorder.js



/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = Object(_copyArray["a" /* default */])(array);

  while (length--) {
    var index = indexes[length];
    array[length] = Object(_isIndex["a" /* default */])(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/* harmony default export */ var _reorder = (reorder);

// EXTERNAL MODULE: ./node_modules/lodash-es/_replaceHolders.js
var _replaceHolders = __webpack_require__("9f32");

// EXTERNAL MODULE: ./node_modules/lodash-es/_root.js
var _root = __webpack_require__("26ee");

// CONCATENATED MODULE: ./node_modules/lodash-es/_createHybrid.js










/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : Object(_createCtor["a" /* default */])(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = Object(_getHolder["a" /* default */])(wrapper),
          holdersCount = _countHolders(args, placeholder);
    }
    if (partials) {
      args = Object(_composeArgs["a" /* default */])(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = Object(_composeArgsRight["a" /* default */])(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = Object(_replaceHolders["a" /* default */])(args, placeholder);
      return Object(_createRecurry["a" /* default */])(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = _reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== _root["a" /* default */] && this instanceof wrapper) {
      fn = Ctor || Object(_createCtor["a" /* default */])(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/* harmony default export */ var _createHybrid = __webpack_exports__["a"] = (createHybrid);


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "4362":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("df7c");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "444c":
/***/ (function(module, exports) {

module.exports = require("@discoveryedu/nebula-components");

/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "467f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("2d83");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var IS_NODE = __webpack_require__("605d");
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // eslint-disable-next-line es/no-symbol -- required for testing
  return !Symbol.sham &&
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    (IS_NODE ? V8_VERSION === 38 : V8_VERSION > 37 && V8_VERSION < 41);
});


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4a0c":
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"axios\",\"version\":\"0.21.4\",\"description\":\"Promise based HTTP client for the browser and node.js\",\"main\":\"index.js\",\"scripts\":{\"test\":\"grunt test\",\"start\":\"node ./sandbox/server.js\",\"build\":\"NODE_ENV=production grunt build\",\"preversion\":\"npm test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\",\"postversion\":\"git push && git push --tags\",\"examples\":\"node ./examples/server.js\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"fix\":\"eslint --fix lib/**/*.js\"},\"repository\":{\"type\":\"git\",\"url\":\"https://github.com/axios/axios.git\"},\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"author\":\"Matt Zabriskie\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"homepage\":\"https://axios-http.com\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"jsdelivr\":\"dist/axios.min.js\",\"unpkg\":\"dist/axios.min.js\",\"typings\":\"./index.d.ts\",\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}]}");

/***/ }),

/***/ "4a24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseTrim_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4b6e");
/* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2332");
/* harmony import */ var _isSymbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1bc6");




/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(_isSymbol_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(value)) {
    return NAN;
  }
  if (Object(_isObject_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(_isObject_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = Object(_baseTrim_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),

/***/ "4a7b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),

/***/ "4ae1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var aFunction = __webpack_require__("1c0b");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var bind = __webpack_require__("0538");
var fails = __webpack_require__("d039");

var nativeConstruct = getBuiltIn('Reflect', 'construct');

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});
var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "4b6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _trimmedEndIndex_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b890");


/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, Object(_trimmedEndIndex_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(string) + 1).replace(reTrimStart, '')
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTrim);


/***/ }),

/***/ "4ba1":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.action-menu{display:flex;gap:16px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4dc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isSymbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1bc6");


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(_isSymbol_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4ec9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__("6d61");
var collectionStrong = __webpack_require__("6566");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $entries = __webpack_require__("6f53").entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "500e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _apply_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b911");


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(_apply_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5132":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _castPath_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2250");
/* harmony import */ var _toKey_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("4dc8");



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(_castPath_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(_toKey_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "517b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _debounce_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("85b1");
/* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2332");



/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (Object(_isObject_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return Object(_debounce_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/* harmony default export */ __webpack_exports__["a"] = (throttle);


/***/ }),

/***/ "5192":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_TechbookContentErrorPage_vue_vue_type_style_index_0_id_41096048_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("02f4");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_TechbookContentErrorPage_vue_vue_type_style_index_0_id_41096048_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_TechbookContentErrorPage_vue_vue_type_style_index_0_id_41096048_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5270":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var transformData = __webpack_require__("c401");
var isCancel = __webpack_require__("2e67");
var defaults = __webpack_require__("2444");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");

var max = Math.max;
var min = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', 2, function (REPLACE, nativeReplace, maybeCallNative, reason) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === 'string' && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
});


/***/ }),

/***/ "5530":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectSpread2; });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b64b");
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a4d3");
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d3b7");
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("e439");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("159b");
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("dbb4");
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("1d1c");
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("7a82");
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ade3");











function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        Object(_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__[/* default */ "a"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

/***/ }),

/***/ "5634":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("b006");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6e03aac8", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.10.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "58e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("26ee");
/* harmony import */ var _stubFalse_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2f74");



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || _stubFalse_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("dd40")(module)))

/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var isRegExp = __webpack_require__("44e7");

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5ac7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_IframeViewer_vue_vue_type_style_index_0_id_66fa21ca_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ce7f");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_IframeViewer_vue_vue_type_style_index_0_id_66fa21ca_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_IframeViewer_vue_vue_type_style_index_0_id_66fa21ca_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5c54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

/* harmony default export */ __webpack_exports__["a"] = (baseLodash);


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5e89":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

var floor = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "5ea3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "5f02":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6071":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),

/***/ "6171":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _WeakMap_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9b92");


/** Used to store function metadata. */
var metaMap = _WeakMap_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] && new _WeakMap_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"];

/* harmony default export */ __webpack_exports__["a"] = (metaMap);


/***/ }),

/***/ "63bc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseIsNative.js + 1 modules
var _baseIsNative = __webpack_require__("94da");

// CONCATENATED MODULE: ./node_modules/lodash-es/_getValue.js
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ var _getValue = (getValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getNative.js



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return Object(_baseIsNative["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ var _getNative = __webpack_exports__["a"] = (getNative);


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "6566":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__("9bf2").f;
var create = __webpack_require__("7c73");
var redefineAll = __webpack_require__("e2cc");
var bind = __webpack_require__("0366");
var anInstance = __webpack_require__("19aa");
var iterate = __webpack_require__("2266");
var defineIterator = __webpack_require__("7dd0");
var setSpecies = __webpack_require__("2626");
var DESCRIPTORS = __webpack_require__("83ab");
var fastKey = __webpack_require__("f183").fastKey;
var InternalStateModule = __webpack_require__("69f3");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "661c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _LazyWrapper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("062a");
/* harmony import */ var _getData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fa3e");
/* harmony import */ var _getFuncName_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7edc");
/* harmony import */ var _wrapperLodash_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("96d9");





/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = Object(_getFuncName_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(func),
      other = _wrapperLodash_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"][funcName];

  if (typeof other != 'function' || !(funcName in _LazyWrapper_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = Object(_getData_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(other);
  return !!data && func === data[0];
}

/* harmony default export */ __webpack_exports__["a"] = (isLaziable);


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6b04":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("26ee");


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = (now);


/***/ }),

/***/ "6b0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.default = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ "6b75":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _arrayLikeToArray; });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ "6d61":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var InternalMetadataModule = __webpack_require__("f183");
var iterate = __webpack_require__("2266");
var anInstance = __webpack_require__("19aa");
var isObject = __webpack_require__("861d");
var fails = __webpack_require__("d039");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var setToStringTag = __webpack_require__("d44e");
var inheritIfRequired = __webpack_require__("7156");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var propertyIsEnumerable = __webpack_require__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "7037":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("a4d3");

__webpack_require__("e01a");

__webpack_require__("d3b7");

__webpack_require__("d28b");

__webpack_require__("e260");

__webpack_require__("3ca3");

__webpack_require__("ddb0");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "706c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),

/***/ "7104":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f118");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("73e31360", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7129":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "72fb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseIndexOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0148");


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && Object(_baseIndexOf_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(array, value, 0) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayIncludes);


/***/ }),

/***/ "7378":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2332");


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(_isObject_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "74b5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),

/***/ "7526":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ReviewSheet_vue_vue_type_style_index_0_id_4b50ef7a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b668");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ReviewSheet_vue_vue_type_style_index_0_id_4b50ef7a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ReviewSheet_vue_vue_type_style_index_0_id_4b50ef7a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7804":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "79f6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseToString_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2c57");


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(_baseToString_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),

/***/ "7a77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "7a82":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var objectDefinePropertyModile = __webpack_require__("9bf2");

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$({ target: 'Object', stat: true, forced: !DESCRIPTORS, sham: !DESCRIPTORS }, {
  defineProperty: objectDefinePropertyModile.f
});


/***/ }),

/***/ "7aac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7b2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_TextSelectTools_vue_vue_type_style_index_0_id_561d7002_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d8cb");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_TextSelectTools_vue_vue_type_style_index_0_id_561d7002_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_TextSelectTools_vue_vue_type_style_index_0_id_561d7002_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7ec8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _toFinite_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cb09");


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = Object(_toFinite_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toInteger);


/***/ }),

/***/ "7edc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _realNames_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1433");


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = _realNames_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"][result],
      length = hasOwnProperty.call(_realNames_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getFuncName);


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "82a6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_SearchBox_vue_vue_type_style_index_0_id_0529b166_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5634");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_SearchBox_vue_vue_type_style_index_0_id_0529b166_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_SearchBox_vue_vue_type_style_index_0_id_0529b166_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8301":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.de-highlight{border:0;color:inherit;cursor:pointer;font-style:inherit;font-weight:inherit}.de-highlight:not(.de-highlight--selected):active,.de-highlight:not(.de-highlight--selected):focus,.de-highlight:not(.de-highlight--selected):hover{outline:1px dotted #575757}.de-highlight--has-note{border-bottom:2px dashed #3d3d3d}.de-highlight--selected{border-bottom:4px solid #005a9e}.de-highlight--blue{background-color:#adebff}.de-highlight--green{background-color:#adffad}.de-highlight--pink{background-color:#ffaedf}.de-highlight--yellow{background-color:#fffc8f}.text-select__wrapper{background-color:#fff;border-radius:8px;box-shadow:0 4px 26px 5px rgba(0,0,0,.1);display:flex;flex-direction:column;gap:4px;padding:4px;position:absolute;z-index:400}.text-select__controls-wrapper{align-items:flex-start;display:flex;--nebula-button-group-gap:8px}.text-select__controls-highlight-buttons{border-left:1px solid #c1d1d7;display:flex;-webkit-padding-start:8px;padding-inline-start:8px}.text-select__button--active{background:var(--nebula-button-background-active);border-color:var(--nebula-button-border-color-active);color:var(--nebula-button-text-color-active)}.text-select__button--close{-webkit-margin-start:8px;margin-inline-start:8px}.text-select__highlight-button:before{content:\"\";display:block;height:12px;-webkit-margin-start:2px;margin-inline-start:2px;position:absolute;width:12px}.text-select__highlight-button--active{background-color:#9ed5ff}.text-select__highlight-button--blue:before{background-color:#adebff}.text-select__highlight-button--green:before{background-color:#adffad}.text-select__highlight-button--pink:before{background-color:#ffaedf}.text-select__highlight-button--yellow:before{background-color:#fffc8f}.text-select__controls,.text-select__options{display:flex}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "83b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__("d925");
var combineURLs = __webpack_require__("e683");

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "848b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__("4a0c");

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ "85b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2332");
/* harmony import */ var _now_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("6b04");
/* harmony import */ var _toNumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("4a24");




/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = Object(_toNumber_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(wait) || 0;
  if (Object(_isObject_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(Object(_toNumber_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = Object(_now_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(Object(_now_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])());
  }

  function debounced() {
    var time = Object(_now_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/* harmony default export */ __webpack_exports__["a"] = (debounce);


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "876c":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4ba1");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("bd9d8c60", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "884d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (composeArgsRight);


/***/ }),

/***/ "88e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("26ee");


/** Used to detect overreaching core-js shims. */
var coreJsData = _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "89f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/* harmony default export */ __webpack_exports__["a"] = (noop);


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8ba4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var isInteger = __webpack_require__("5e89");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isInteger
});


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8d2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ArticleViewer_vue_vue_type_style_index_0_id_4e337c4a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2df1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ArticleViewer_vue_vue_type_style_index_0_id_4e337c4a_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ArticleViewer_vue_vue_type_style_index_0_id_4e337c4a_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("7a77");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
// eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "92b4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_OtherViewer_vue_vue_type_style_index_0_id_1df292fd_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3eeb");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_OtherViewer_vue_vue_type_style_index_0_id_1df292fd_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_OtherViewer_vue_vue_type_style_index_0_id_1df292fd_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "93af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_SSOStaySignedInModal_vue_vue_type_style_index_0_id_18caa4ad_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("df64");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_SSOStaySignedInModal_vue_vue_type_style_index_0_id_18caa4ad_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_SSOStaySignedInModal_vue_vue_type_style_index_0_id_18caa4ad_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "94da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/isFunction.js
var isFunction = __webpack_require__("bc9b");

// EXTERNAL MODULE: ./node_modules/lodash-es/_coreJsData.js
var _coreJsData = __webpack_require__("88e0");

// CONCATENATED MODULE: ./node_modules/lodash-es/_isMasked.js


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData["a" /* default */] && _coreJsData["a" /* default */].keys && _coreJsData["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ var _isMasked = (isMasked);

// EXTERNAL MODULE: ./node_modules/lodash-es/isObject.js
var isObject = __webpack_require__("2332");

// EXTERNAL MODULE: ./node_modules/lodash-es/_toSource.js
var _toSource = __webpack_require__("74b5");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsNative.js





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var _baseIsNative_hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(_baseIsNative_hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(isObject["a" /* default */])(value) || _isMasked(value)) {
    return false;
  }
  var pattern = Object(isFunction["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(_toSource["a" /* default */])(value));
}

/* harmony default export */ var _baseIsNative = __webpack_exports__["a"] = (baseIsNative);


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),

/***/ "96d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _LazyWrapper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("062a");
/* harmony import */ var _LodashWrapper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1a7d");
/* harmony import */ var _baseLodash_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("5c54");
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ff51");
/* harmony import */ var _isObjectLike_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("1147");
/* harmony import */ var _wrapperClone_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("e79e");







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (Object(_isObjectLike_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(value) && !Object(_isArray_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(value) && !(value instanceof _LazyWrapper_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])) {
    if (value instanceof _LodashWrapper_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return Object(_wrapperClone_js__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(value);
    }
  }
  return new _LodashWrapper_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = _baseLodash_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].prototype;
lodash.prototype.constructor = lodash;

/* harmony default export */ __webpack_exports__["a"] = (lodash);


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9b63":
/***/ (function(module) {

module.exports = JSON.parse("{\"tokens\":{\"blur\":{\"glass\":{\"100\":\"15px\"}},\"border\":{\"radius\":{\"small\":\"8px\",\"default\":\"16px\",\"large\":\"24px\",\"button\":{\"default\":\"8px\",\"pill\":\"32px\"},\"badge\":{\"default\":\"4px\"}}},\"breakpoints\":{\"mobile-portrait-small\":\"320px\",\"mobile-portrait\":\"375px\",\"mobile-landscape\":\"500px\",\"tablet-portrait\":\"768px\",\"tablet-landscape\":\"1024px\",\"desktop\":\"1200px\",\"desktop-wide\":\"1440px\"},\"color\":{\"white\":\"#ffffff\",\"black\":\"#000000\",\"neutral\":{\"100\":\"#ffffff\",\"200\":\"#fafafa\",\"300\":\"#e8e8e8\",\"400\":\"#595959\",\"500\":\"#3d3d3d\",\"600\":\"#000000\"},\"interface-blue\":{\"100\":\"#e0e8eb\",\"200\":\"#c1d1d7\",\"300\":\"#a2bbc3\",\"400\":\"#648d9b\",\"500\":\"#50717c\",\"600\":\"#28393e\"},\"interactive-blue\":{\"100\":\"#6bbfff\",\"200\":\"#38a9ff\",\"300\":\"#0077d1\",\"400\":\"#005a9e\",\"500\":\"#003d6b\"},\"platform\":{\"white\":\"#ffffff\",\"black\":\"#000000\",\"neutral\":{\"100\":\"#fafafa\",\"200\":\"#f0f0f0\",\"300\":\"#d6d6d6\",\"400\":\"#bdbdbd\",\"500\":\"#a3a3a3\",\"600\":\"#8a8a8a\",\"700\":\"#707070\",\"800\":\"#575757\",\"900\":\"#3d3d3d\",\"1000\":\"#242424\",\"1100\":\"#0a0a0a\"},\"interface\":{\"100\":\"#f9fafb\",\"200\":\"#f0f4f5\",\"300\":\"#e0e8eb\",\"400\":\"#c1d1d7\",\"500\":\"#a2bbc3\",\"600\":\"#83a4af\",\"700\":\"#648d9b\",\"800\":\"#50717c\",\"900\":\"#3c555d\",\"1000\":\"#28393e\",\"1100\":\"#141c1f\"},\"interactive\":{\"100\":\"#f0f9ff\",\"200\":\"#dbf0ff\",\"300\":\"#d1ebff\",\"400\":\"#9ed5ff\",\"500\":\"#6bbfff\",\"600\":\"#38a9ff\",\"700\":\"#0593ff\",\"800\":\"#0077d1\",\"900\":\"#005a9e\",\"1000\":\"#003d6b\",\"1100\":\"#002038\"}},\"science\":{\"primary\":{\"100\":\"#cefbcb\",\"200\":\"#74f36d\",\"300\":\"#1ee713\",\"400\":\"#18b80f\",\"500\":\"#12880b\",\"600\":\"#0c5907\"},\"secondary\":{\"100\":\"#94f0df\",\"200\":\"#2eb7bf\",\"300\":\"#037fc5\"},\"gradient\":{\"1\":\"#000000\",\"2\":\"#000000\",\"3\":\"#000000\"}},\"health\":{\"primary\":{\"100\":\"#e1b7cf\",\"200\":\"#d194b6\",\"300\":\"#c2709e\",\"400\":\"#b34c86\",\"500\":\"#8f3d6b\",\"600\":\"#6b2e50\"},\"secondary\":{\"100\":\"#eafc83\",\"200\":\"#ceee07\",\"300\":\"#a2bd05\"}},\"social-studies\":{\"primary\":{\"100\":\"#ffe2d1\",\"200\":\"#ffc19e\",\"300\":\"#ffa06b\",\"400\":\"#ff8038\",\"500\":\"#ff5f05\",\"600\":\"#9e3900\"},\"secondary\":{\"100\":\"#bfcdff\",\"200\":\"#7d82fb\",\"300\":\"#3941ff\"},\"gradient\":{\"1\":\"#000000\",\"2\":\"#000000\",\"3\":\"#000000\"}},\"math\":{\"primary\":{\"100\":\"#c0a4f4\",\"200\":\"#a077ee\",\"300\":\"#814ae8\",\"400\":\"#611de2\",\"500\":\"#4e17b5\",\"600\":\"#270b5a\"},\"secondary\":{\"100\":\"#ffb970\",\"200\":\"#ff8605\",\"300\":\"#f82289\"},\"gradient\":{\"1\":\"#000000\",\"2\":\"#000000\",\"3\":\"#000000\"}},\"teach\":{\"primary\":{\"100\":\"#fffae0\",\"200\":\"#fff2ad\",\"300\":\"#ffea7a\",\"400\":\"#ffe247\",\"500\":\"#ffda15\",\"600\":\"#ad9200\"},\"secondary\":{\"100\":\"#89a3ff\",\"200\":\"#577cfe\",\"300\":\"#4830dd\"}},\"coding\":{\"primary\":{\"100\":\"#a1cff7\",\"200\":\"#72b7f3\",\"300\":\"#439fef\",\"400\":\"#1487eb\",\"500\":\"#106cbc\",\"600\":\"#0c518d\"},\"secondary\":{\"100\":\"#10c1d8\",\"200\":\"#1170c3\",\"300\":\"#972ee3\"}},\"stem\":{\"primary\":{\"100\":\"#b1e7dd\",\"200\":\"#89dccd\",\"300\":\"#62d0bc\",\"400\":\"#3bc4ab\",\"500\":\"#2f9d89\",\"600\":\"#174f45\"},\"secondary\":{\"100\":\"#ffe926\",\"200\":\"#d6c31d\",\"300\":\"#ac9d15\"}},\"feedback\":{\"success\":{\"50\":\"#e8fcec\",\"100\":\"#d2f9d8\",\"200\":\"#a5f3b2\",\"300\":\"#78ed8b\",\"400\":\"#4be764\",\"500\":\"#1ee13e\",\"600\":\"#18b431\",\"700\":\"#128725\",\"800\":\"#0c5a19\",\"900\":\"#062d0c\",\"1000\":\"#031706\"},\"error\":{\"50\":\"#fce8e8\",\"100\":\"#f9d2d2\",\"200\":\"#f3a5a5\",\"300\":\"#ed7878\",\"400\":\"#e74b4b\",\"500\":\"#e11e1e\",\"600\":\"#b41818\",\"700\":\"#871212\",\"800\":\"#5a0c0c\",\"900\":\"#2d0606\",\"1000\":\"#170303\"},\"warning\":{\"50\":\"#fff3e5\",\"100\":\"#ffe8cc\",\"200\":\"#ffd099\",\"300\":\"#ffb966\",\"400\":\"#ffa133\",\"500\":\"#ff8a00\",\"600\":\"#cc6e00\",\"700\":\"#995300\",\"800\":\"#663700\",\"900\":\"#331c00\",\"1000\":\"#1a0e00\"}},\"highlight\":{\"pastel\":{\"yellow\":\"#fffc8f\",\"blush\":\"#ffaedf\",\"peach\":\"#ffc9ad\",\"mint\":\"#adffad\",\"turquoise\":\"#adebff\",\"lavendar\":\"#dbadff\"},\"vibrant\":{\"yellow\":\"#fffa5c\",\"blush\":\"#ff5cbe\",\"peach\":\"#ff935c\",\"mint\":\"#5cff5c\",\"turquoise\":\"#5cd7ff\",\"lavendar\":\"#b75cff\"}},\"error\":\"#e32b2b\",\"warning\":\"#db7600\",\"success\":\"#128725\",\"glass\":{\"100\":\"rgba(#50717c, .75)\"}},\"dim\":{\"scale\":\"8px\",\"quarter\":\"2px\",\"half\":\"4px\",\"1x\":\"8px\",\"2x\":\"16px\",\"3x\":\"24px\",\"4x\":\"32px\",\"5x\":\"40px\",\"6x\":\"48px\",\"7x\":\"56px\",\"8x\":\"64px\",\"9x\":\"72px\",\"10x\":\"80px\"},\"gradient\":{\"science-1\":\"linear-gradient(53.49deg, #2EE916 22.68%, #00C000 88.08%)\",\"science-2\":\"linear-gradient(240.47deg, #2EB7BF 12.66%, #7ADF07 115.1%)\",\"science-3\":\"linear-gradient(247.05deg, #2EBFA5 16.79%, #037FC5 101.74%)\",\"math-1\":\"linear-gradient(53.49deg, #4E17B5 22.68%, #7E00CC 71.96%)\",\"math-2\":\"linear-gradient(240.47deg, #F82289 12.66%, #7E00CC 115.1%)\",\"math-3\":\"linear-gradient(234.63deg, #FFB970 12.36%, #F82289 115.93%)\",\"social-studies-1\":\"linear-gradient(53.49deg, #FF5E03 22.68%, #CB4814 88.08%)\",\"social-studies-2\":\"linear-gradient(233.24deg, #BFCDFF -1.34%, #FF5E03 98.48%)\",\"social-studies-3\":\"linear-gradient(238.41deg, #BFCDFF 0.41%, #3941FF 77.83%)\"},\"font\":{\"family\":{\"display\":[\"'Proxima Vara'\",\"Arial\",\"sans-serif\"],\"body\":[\"'Proxima Vara'\",\"Arial\",\"sans-serif\"],\"header\":[\"'Proxima Vara'\",\"Arial\",\"sans-serif\"],\"serif\":[\"'Droid Serif'\",\"Georgia\",\"serif\"],\"mystery\":[\"Agrandir\",\"sans-serif\"]},\"size\":{\"rem-base\":\"16px\",\"body-1\":\"1.125rem\",\"body-2\":\"1rem\",\"header\":{\"level-1\":\"4.25rem\",\"level-2\":\"3.375rem\",\"level-3\":\"2.6875rem\",\"level-4\":\"2.1875rem\",\"level-5\":\"1.75rem\",\"level-6\":\"1.5rem\"},\"caption\":\".875rem\",\"jumbo\":\"5.3125rem\",\"card\":{\"title\":\"1.25rem\"},\"mobile\":{\"body 1\":\"1rem\",\"header\":{\"level-1\":\"2rem\",\"level-2\":\"1.75rem\",\"level-3\":\"1.625rem\",\"level-4\":\"1.5rem\",\"level-5\":\"1.375rem\",\"level-6\":\"1.25rem\"}}},\"line-height\":{\"default\":\"1.4\",\"heading\":\"1.2\"},\"weight\":{\"body\":\"normal\",\"header\":\"bold\"}},\"icon\":{\"size\":{\"s\":\"16px\",\"m\":\"24px\",\"l\":\"32px\",\"xl\":\"40px\",\"xxl\":\"48px\"}},\"overlay\":{\"default\":\".65\",\"dark\":\".85\"},\"shadow\":{\"100\":\"0px 2px 6px rgba(0, 0, 0, 0.15)\",\"200\":\"0px 2px 10px 2px rgba(0, 0, 0, 0.1)\",\"300\":\"0px 4px 15px 2px rgba(0, 0, 0, 0.1)\",\"400\":\"0px 4px 26px 5px rgba(0, 0, 0, 0.1)\"},\"space\":{\"scale\":\"8px\",\"quarter\":\"2px\",\"half\":\"4px\",\"1x\":\"8px\",\"2x\":\"16px\",\"3x\":\"24px\",\"4x\":\"32px\",\"5x\":\"40px\",\"6x\":\"48px\",\"7x\":\"56px\",\"8x\":\"64px\",\"9x\":\"72px\",\"10x\":\"80px\"},\"text-color\":{\"body\":{\"default\":\"#575757\",\"on-dark\":\"#ffffff\"},\"header\":{\"default\":\"#3d3d3d\",\"on-dark\":\"#ffffff\"},\"link\":{\"default\":\"#0077d1\",\"active\":\"#005a9e\",\"hover\":\"#003d6b\",\"on-dark\":\"#ffffff\"}},\"text-decoration\":{\"link\":\"underline\"},\"transition\":{\"default\":\".25s ease-in-out\",\"fade-in\":\".25s ease-in\",\"fade-out\":\".45s ease-out\"}}}");

/***/ }),

/***/ "9b92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getNative_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("63bc");
/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("26ee");



/* Built-in method references that are verified to be native. */
var WeakMap = Object(_getNative_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_root_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var iteratorClose = __webpack_require__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9cbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheClear.js
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ var _listCacheClear = (listCacheClear);

// EXTERNAL MODULE: ./node_modules/lodash-es/eq.js
var eq = __webpack_require__("6071");

// CONCATENATED MODULE: ./node_modules/lodash-es/_assocIndexOf.js


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(eq["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ var _assocIndexOf = (assocIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheDelete.js


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ var _listCacheDelete = (listCacheDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheGet.js


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ var _listCacheGet = (listCacheGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheHas.js


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

/* harmony default export */ var _listCacheHas = (listCacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_listCacheSet.js


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ var _listCacheSet = (listCacheSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_ListCache.js






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

/* harmony default export */ var _ListCache = __webpack_exports__["a"] = (ListCache);


/***/ }),

/***/ "9e08":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseSetData.js
var _baseSetData = __webpack_require__("1df0");

// EXTERNAL MODULE: ./node_modules/lodash-es/_createCtor.js
var _createCtor = __webpack_require__("b50b");

// EXTERNAL MODULE: ./node_modules/lodash-es/_root.js
var _root = __webpack_require__("26ee");

// CONCATENATED MODULE: ./node_modules/lodash-es/_createBind.js



/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = Object(_createCtor["a" /* default */])(func);

  function wrapper() {
    var fn = (this && this !== _root["a" /* default */] && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/* harmony default export */ var _createBind = (createBind);

// EXTERNAL MODULE: ./node_modules/lodash-es/_apply.js
var _apply = __webpack_require__("b911");

// EXTERNAL MODULE: ./node_modules/lodash-es/_createHybrid.js + 2 modules
var _createHybrid = __webpack_require__("3f2c");

// EXTERNAL MODULE: ./node_modules/lodash-es/_createRecurry.js
var _createRecurry = __webpack_require__("bafb");

// EXTERNAL MODULE: ./node_modules/lodash-es/_getHolder.js
var _getHolder = __webpack_require__("292b");

// EXTERNAL MODULE: ./node_modules/lodash-es/_replaceHolders.js
var _replaceHolders = __webpack_require__("9f32");

// CONCATENATED MODULE: ./node_modules/lodash-es/_createCurry.js








/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = Object(_createCtor["a" /* default */])(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = Object(_getHolder["a" /* default */])(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : Object(_replaceHolders["a" /* default */])(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return Object(_createRecurry["a" /* default */])(
        func, bitmask, _createHybrid["a" /* default */], wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== _root["a" /* default */] && this instanceof wrapper) ? Ctor : func;
    return Object(_apply["a" /* default */])(fn, this, args);
  }
  return wrapper;
}

/* harmony default export */ var _createCurry = (createCurry);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createPartial.js




/** Used to compose bitmasks for function metadata. */
var _createPartial_WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & _createPartial_WRAP_BIND_FLAG,
      Ctor = Object(_createCtor["a" /* default */])(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== _root["a" /* default */] && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return Object(_apply["a" /* default */])(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/* harmony default export */ var _createPartial = (createPartial);

// EXTERNAL MODULE: ./node_modules/lodash-es/_getData.js
var _getData = __webpack_require__("fa3e");

// EXTERNAL MODULE: ./node_modules/lodash-es/_composeArgs.js
var _composeArgs = __webpack_require__("f1fb");

// EXTERNAL MODULE: ./node_modules/lodash-es/_composeArgsRight.js
var _composeArgsRight = __webpack_require__("884d");

// CONCATENATED MODULE: ./node_modules/lodash-es/_mergeData.js




/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var _mergeData_WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (_mergeData_WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & _mergeData_WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & _mergeData_WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? Object(_composeArgs["a" /* default */])(partials, value, source[4]) : value;
    data[4] = partials ? Object(_replaceHolders["a" /* default */])(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? Object(_composeArgsRight["a" /* default */])(partials, value, source[6]) : value;
    data[6] = partials ? Object(_replaceHolders["a" /* default */])(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

/* harmony default export */ var _mergeData = (mergeData);

// EXTERNAL MODULE: ./node_modules/lodash-es/_setData.js
var _setData = __webpack_require__("d36f");

// EXTERNAL MODULE: ./node_modules/lodash-es/_setWrapToString.js + 3 modules
var _setWrapToString = __webpack_require__("ddf8");

// EXTERNAL MODULE: ./node_modules/lodash-es/toInteger.js
var toInteger = __webpack_require__("7ec8");

// CONCATENATED MODULE: ./node_modules/lodash-es/_createWrap.js











/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var _createWrap_WRAP_BIND_FLAG = 1,
    _createWrap_WRAP_BIND_KEY_FLAG = 2,
    _createWrap_WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & _createWrap_WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(Object(toInteger["a" /* default */])(ary), 0);
  arity = arity === undefined ? arity : Object(toInteger["a" /* default */])(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : Object(_getData["a" /* default */])(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    _mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (_createWrap_WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(_createWrap_WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == _createWrap_WRAP_BIND_FLAG) {
    var result = _createBind(func, bitmask, thisArg);
  } else if (bitmask == _createWrap_WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = _createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (_createWrap_WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = _createPartial(func, bitmask, thisArg, partials);
  } else {
    result = _createHybrid["a" /* default */].apply(undefined, newData);
  }
  var setter = data ? _baseSetData["a" /* default */] : _setData["a" /* default */];
  return Object(_setWrapToString["a" /* default */])(setter(result, newData), func, bitmask);
}

/* harmony default export */ var _createWrap = __webpack_exports__["a"] = (createWrap);


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f32":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (replaceHolders);


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a134":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _MapCache_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0e59");


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || _MapCache_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = _MapCache_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),

/***/ "a258":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");

// `Array.prototype.{ findLast, findLastIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_FIND_INDEX = TYPE == 6;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var index = toLength(self.length);
    var value, result;
    while (index-- > 0) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (result) switch (TYPE) {
        case 5: return value; // find
        case 6: return index; // findIndex
      }
    }
    return IS_FIND_INDEX ? -1 : undefined;
  };
};

module.exports = {
  // `Array.prototype.findLast` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLast: createMethod(5),
  // `Array.prototype.findLastIndex` method
  // https://github.com/tc39/proposal-array-find-from-last
  findLastIndex: createMethod(6)
};


/***/ }),

/***/ "a343":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_CleverIDMappingDropdown_vue_vue_type_style_index_0_id_c4cd04e6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7104");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_CleverIDMappingDropdown_vue_vue_type_style_index_0_id_c4cd04e6_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_CleverIDMappingDropdown_vue_vue_type_style_index_0_id_c4cd04e6_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a51f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__("1de5");
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__("0a73");
var ___CSS_LOADER_URL_IMPORT_1___ = __webpack_require__("2c08");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.nebula-error{background:no-repeat url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") #000;background-position:50% 100%;background-size:cover;font-family:Proxima Vara,Arial,sans-serif;height:100%;padding:8px 16px 100px;width:100%}.nebula-error__content{margin:0 auto;width:100%}@media screen and (min-width:1200px){.nebula-error__content{width:1024px}}@media screen and (min-width:1440px){.nebula-error__content{width:1200px}}.nebula-error__type{color:#fff;font-size:1.125rem;margin:32px 0 0;text-transform:uppercase}@media screen and (min-width:768px){.nebula-error__type{margin:130px 56px 0;width:50%}}.nebula-error__heading{color:#fff;font-size:2.1875rem;margin:32px 0}@media screen and (min-width:768px){.nebula-error__heading{margin:16px 56px 24px;width:50%}}@media screen and (min-width:1440px){.nebula-error__heading{font-size:3.375rem}}.nebula-error__message{background-color:#28393e;border-radius:8px;color:#fff;font-size:1.125rem;opacity:.9;padding:16px;position:relative}@media screen and (min-width:768px){.nebula-error__message{margin:0 56px;padding:40px;width:60%}}.nebula-error__home-link{margin:24px 0 16px}.nebula-error__help a{color:#6bbfff}.nebula-error__error-codes,.nebula-error__extra-info,.nebula-error__html-display-message{font-size:.875rem;margin:40px 0}.nebula-error__error-codes span,.nebula-error__extra-info span,.nebula-error__html-display-message span{display:block}.nebula-error__spaceman{background:no-repeat url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") transparent;background-position:75px 0;background-size:cover;bottom:0;height:135px;position:absolute;right:0;width:240px}@media screen and (min-width:768px){.nebula-error__spaceman{-webkit-animation-name:floating;animation-name:floating;-webkit-animation-duration:3s;animation-duration:3s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;background-position:0 0;bottom:auto;height:270px;top:110px;width:35%}}@media screen and (min-width:1024px){.nebula-error__spaceman{background-position:-24px 0;height:370px}}@media screen and (min-width:768px){html[dir=rtl] .nebula-error__spaceman{-webkit-animation-name:floating-rtl;animation-name:floating-rtl;left:0;right:auto}}@-webkit-keyframes floating-rtl{0%{-webkit-transform:scaleX(-1) translate(0);transform:scaleX(-1) translate(0)}50%{-webkit-transform:scaleX(-1) translateY(15px);transform:scaleX(-1) translateY(15px)}to{-webkit-transform:scaleX(-1) translate(0);transform:scaleX(-1) translate(0)}}@keyframes floating-rtl{0%{-webkit-transform:scaleX(-1) translate(0);transform:scaleX(-1) translate(0)}50%{-webkit-transform:scaleX(-1) translateY(15px);transform:scaleX(-1) translateY(15px)}to{-webkit-transform:scaleX(-1) translate(0);transform:scaleX(-1) translate(0)}}@-webkit-keyframes floating{0%{-webkit-transform:translate(0);transform:translate(0)}50%{-webkit-transform:translateY(15px);transform:translateY(15px)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes floating{0%{-webkit-transform:translate(0);transform:translate(0)}50%{-webkit-transform:translateY(15px);transform:translateY(15px)}to{-webkit-transform:translate(0);transform:translate(0)}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a978":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bccb");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5bc2d793", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ade3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7a82");
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_0__);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "af54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ChannelCardCarousel_vue_vue_type_style_index_0_id_47f29a98_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d137");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ChannelCardCarousel_vue_vue_type_style_index_0_id_47f29a98_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ChannelCardCarousel_vue_vue_type_style_index_0_id_47f29a98_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b006":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.comet-product-bar__search-input{width:100%}.comet-product-bar__search-input::-ms-clear{display:none;width:0;height:0}.comet-product-bar__all-results-button{background:#fff}.comet-product-bar__search-button{background-color:#3884c7}.comet-product-bar__search-button:focus,.comet-product-bar__search-button:hover{background-color:#224f77}.comet-product-bar__search-button .comet-button__icon{fill:#fff;vertical-align:baseline}.comet-product-bar__search-asset-type{display:none;position:absolute;right:90px;top:1px;z-index:700}@media screen and (min-width:768px){.comet-product-bar__search-asset-type{display:block}}.comet-product-bar__search-button-microphone{bottom:0;display:none;margin:0;padding:13px 10px;position:absolute;right:54px;top:0;z-index:100}.comet-product-bar__search-button-microphone--available{display:block}.comet-product-bar__search-button-microphone svg{fill:#2d6a9f}.comet-product-bar__search-button-microphone--recording svg{fill:#b42818}.comet-product-bar__search-box-autocomplete{background-color:#fff;border:1px solid #d6d6d6;border-radius:8px;max-height:400px;max-width:none;padding:8px 0;position:absolute;opacity:0;overflow-x:hidden;overflow-y:auto;top:40px;visibility:hidden;width:100%;z-index:600}.comet-product-bar__search-box-autocomplete.comet-product-bar__search-box-autocomplete--open{opacity:1;visibility:visible}.comet-product-bar__search-box-autocomplete .nebula-list-group__header{border-top:1px solid #e0e8eb;font-size:1rem;font-weight:500;margin:8px 40px 0 8px;padding:8px 0 8px 16px}.comet-product-bar__search-box-autocomplete .nebula-list-item{display:flex;padding-left:8px;padding-right:40px;width:100%}.comet-product-bar__search-box-autocomplete .nebula-list-item:focus-within,.comet-product-bar__search-box-autocomplete .nebula-list-item:hover{background:transparent}.comet-product-bar__search-box-autocomplete .nebula-list-item__inner{border-radius:8px;color:#595959;padding:8px 0 8px 16px}.comet-product-bar__search-box-autocomplete .nebula-list-item__inner:focus-within,.comet-product-bar__search-box-autocomplete .nebula-list-item__inner:hover{background-color:#dbf0ff}.comet-product-bar__search-box-autocomplete .nebula-list-item__icon{align-items:center;border-radius:16px;display:flex;fill:#fff;height:32px;justify-content:center;margin-right:8px;padding:7px;width:32px}.comet-product-bar__search-box-autocomplete .nebula-list-item--science-flask .nebula-list-item__icon{background-color:#18b80f}.comet-product-bar__search-box-autocomplete .nebula-list-item--math .nebula-list-item__icon{background-color:#814ae8}.comet-product-bar__search-box-autocomplete .nebula-list-item--stem-connect .nebula-list-item__icon{background-color:#3bc4ab}.comet-product-bar__search-box-autocomplete .nebula-list-item--social-studies .nebula-list-item__icon{background-color:#ff5f05}.comet-product-bar__search-box-autocomplete .nebula-list-item--coding .nebula-list-item__icon{background-color:#1487eb}.comet-product-bar__search-box-autocomplete .nebula-list-item--health .nebula-list-item__icon{background-color:#b34c86}.comet-product-bar__search-box-autocomplete .nebula-list-item--pathway .nebula-list-item__icon{background-color:#ad9200}.comet-product-bar__search-box-autocomplete .nebula-list-item--espresso .nebula-list-item__icon{background-color:#611de2}.comet-product-bar__search-box-autocomplete .nebula-list-item--mysteryscience .nebula-list-item__icon{background-color:#4e17b5}.comet-product-bar__search-box-autocomplete .suggestions-list.nebula-product-bar__suggestions-list{border-radius:none;box-shadow:none;margin-top:0;padding:0;position:relative}html[dir=rtl] .comet-product-bar__search-asset-type{left:100px;right:auto}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0d7":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.image-detail{--nebula-image-width:100%;background-color:#648d9b;height:100%;width:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "b50b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseCreate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7378");
/* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2332");



/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = Object(_baseCreate_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return Object(_isObject_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(result) ? result : thisBinding;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCtor);


/***/ }),

/***/ "b50d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var settle = __webpack_require__("467f");
var cookies = __webpack_require__("7aac");
var buildURL = __webpack_require__("30b5");
var buildFullPath = __webpack_require__("83b9");
var parseHeaders = __webpack_require__("c345");
var isURLSameOrigin = __webpack_require__("3934");
var createError = __webpack_require__("2d83");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b668":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2392");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("33d16cda", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b703":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod(7)
};


/***/ }),

/***/ "b890":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/* harmony default export */ __webpack_exports__["a"] = (trimmedEndIndex);


/***/ }),

/***/ "b911":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),

/***/ "baa5":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var lastIndexOf = __webpack_require__("e58c");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "bafb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isLaziable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("661c");
/* harmony import */ var _setData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d36f");
/* harmony import */ var _setWrapToString_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ddf8");




/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (Object(_isLaziable_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(func)) {
    Object(_setData_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(result, newData);
  }
  result.placeholder = placeholder;
  return Object(_setWrapToString_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(result, func, bitmask);
}

/* harmony default export */ __webpack_exports__["a"] = (createRecurry);


/***/ }),

/***/ "bb2f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "bb4f":
/***/ (function(module) {

module.exports = JSON.parse("[{\"gender\":\"male\",\"language\":{\"codes\":[\"ar\",\"ar-ae\"],\"display_name\":\"العربية\",\"name\":\"Arabic\",\"rtl\":true},\"vendor\":\"Nuance\",\"voice_id\":\"Tarik\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"zh\",\"zh-cn\"],\"display_name\":\"中文(简体)\",\"name\":\"Chinese (Mandarin - Simplified)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Tian-Tian\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"zh-tw\"],\"display_name\":\"中文(台灣)\",\"name\":\"Chinese (Mandarin - Traditional)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Mei-Jia\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"cs\",\"cs-cz\"],\"display_name\":\"Čeština\",\"name\":\"Czech\"},\"vendor\":\"Nuance\",\"voice_id\":\"Zuzana\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"nl\",\"nl-nl\"],\"display_name\":\"Nederlands\",\"name\":\"Dutch (Netherlands)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Claire\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"en-au\"],\"display_name\":\"English (Australia)\",\"name\":\"English (Australia)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Karen\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"en-gb\"],\"display_name\":\"English (UK)\",\"name\":\"English (UK)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Serena\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"en\",\"en-us\"],\"display_name\":\"English (US)\",\"name\":\"English (US)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Ava\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"fi\",\"fi-fi\"],\"display_name\":\"Suomi\",\"name\":\"Finnish\"},\"vendor\":\"Nuance\",\"voice_id\":\"Satu\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"fr\",\"fr-fr\"],\"display_name\":\"Français\",\"name\":\"French\"},\"vendor\":\"Nuance\",\"voice_id\":\"Audrey\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"fr-ca\"],\"display_name\":\"Français (Canada)\",\"name\":\"French (Canada)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Amelie\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"de\",\"de-de\"],\"display_name\":\"Deutsch\",\"name\":\"German\"},\"vendor\":\"Nuance\",\"voice_id\":\"Anna\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"el\",\"el-gr\"],\"display_name\":\"Ελληνικά\",\"name\":\"Greek\"},\"vendor\":\"Nuance\",\"voice_id\":\"Melina\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"hi\",\"hi-in\"],\"display_name\":\"हिन्दी\",\"name\":\"Hindi\"},\"vendor\":\"Nuance\",\"voice_id\":\"Lekha\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"hu\",\"hu-hu\"],\"display_name\":\"Magyar\",\"name\":\"Hungarian\"},\"vendor\":\"Nuance\",\"voice_id\":\"Mariska\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"id\",\"id-id\"],\"display_name\":\"Bahasa Indonesia\",\"name\":\"Indonesian\"},\"vendor\":\"Nuance\",\"voice_id\":\"Damayanti\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"it\",\"it-it\"],\"display_name\":\"Italiano\",\"name\":\"Italian\"},\"vendor\":\"Nuance\",\"voice_id\":\"Alice\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"ja\",\"ja-jp\"],\"display_name\":\"日本語\",\"name\":\"Japanese\"},\"vendor\":\"Nuance\",\"voice_id\":\"Sakura\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"ko\",\"ko-kr\"],\"display_name\":\"한국어\",\"name\":\"Korean\"},\"vendor\":\"Nuance\",\"voice_id\":\"Sora\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"pl\",\"pl-pl\"],\"display_name\":\"Polski\",\"name\":\"Polish\"},\"vendor\":\"Nuance\",\"voice_id\":\"Ewa\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"pt\",\"pt-pt\"],\"display_name\":\"Português\",\"name\":\"Portuguese\"},\"vendor\":\"Nuance\",\"voice_id\":\"Joana\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"pt-br\"],\"display_name\":\"Português (Brasil)\",\"name\":\"Portuguese (Brazilian)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Luciana\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"ro\",\"ro-ro\"],\"display_name\":\"Română\",\"name\":\"Romanian\"},\"vendor\":\"Nuance\",\"voice_id\":\"Ioana\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"ru\",\"ru-ru\"],\"display_name\":\"Русский\",\"name\":\"Russian\"},\"vendor\":\"Nuance\",\"voice_id\":\"Milena\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"es-ar\",\"es-bo\",\"es-cl\",\"es-cr\",\"es-do\",\"es-ec\",\"es-gt\",\"es-hn\",\"es-mx\",\"es-ni\",\"es-pa\",\"es-py\",\"es-pe\",\"es-pr\",\"es-sv\",\"es-us\",\"es-uy\",\"es-vz\"],\"display_name\":\"Español\",\"name\":\"Spanish (Mexican)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Paulina\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"es\",\"es-es\"],\"display_name\":\"Español (España)\",\"name\":\"Spanish (Castilian)\"},\"vendor\":\"Nuance\",\"voice_id\":\"Monica\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"sv\",\"sv-se\"],\"display_name\":\"Svenska\",\"name\":\"Swedish\"},\"vendor\":\"Nuance\",\"voice_id\":\"Alva\"},{\"gender\":\"female\",\"language\":{\"codes\":[\"th\",\"th-th\"],\"display_name\":\"ภาษาไทย\",\"name\":\"Thai\"},\"vendor\":\"Nuance\",\"voice_id\":\"Kanya\"}]");

/***/ }),

/***/ "bc3a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cee4");

/***/ }),

/***/ "bc9b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGetTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f0ce");
/* harmony import */ var _isObject_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2332");



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(_isObject_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(_baseGetTag_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),

/***/ "bccb":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}[hidden],template{display:none}.comet-screenreader-only{clip:rect(1px,1px,1px,1px);-webkit-clip-path:inset(50%);clip-path:inset(50%);height:1px;order:0;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap}@-webkit-keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}html{box-sizing:border-box;font-size:16px}*,:after,:before{box-sizing:inherit}body{font-family:Proxima Vara,Arial,sans-serif}.ssi-modal .nebula-modal{max-width:545px}.ssi-modal .nebula-modal--m .nebula-modal__inner{padding:24px 34px 34px 38px}.ssi-modal .ssi-header{color:var(--nebula-text-color-header-default);font-family:var(--nebula-font-family-header);font-weight:var(--nebula-font-weight-header);line-height:var(--nebula-font-line-height-heading);font-size:var(--nebula-font-size-header-level-6);margin-bottom:24px}.ssi-modal .ssi-content{align-items:center;display:flex}.ssi-modal .ssi-content__img{flex:1;-webkit-margin-end:24px;margin-inline-end:24px;max-width:130px}.ssi-modal .ssi-content__text{color:var(--nebula-text-color-body-default);font-family:var(--nebula-font-family-body);font-weight:var(--nebula-font-weight-body);line-height:var(--nebula-font-line-height-default);font-size:var(--nebula-font-size-body-1);flex:2}.ssi-modal .ssi-actions{display:flex;justify-content:flex-end}.ssi-modal .ssi-actions__button--yes{margin:0 8px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "bd8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _isArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ff51");
/* harmony import */ var _isSymbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1bc6");



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(_isArray_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(_isSymbol_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c0e2":
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ }),

/***/ "c20d":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var trim = __webpack_require__("58a8").trim;
var whitespaces = __webpack_require__("5899");

var $parseInt = global.parseInt;
var hex = /^[+-]?0[Xx]/;
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(String(string));
  return $parseInt(S, (radix >>> 0) || (hex.test(S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "c2bc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findLast = __webpack_require__("a258").findLast;
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.findLast` method
// https://github.com/tc39/proposal-array-find-from-last
$({ target: 'Array', proto: true }, {
  findLast: function findLast(callbackfn /* , that = undefined */) {
    return $findLast(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

addToUnscopables('findLast');


/***/ }),

/***/ "c345":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "c401":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var defaults = __webpack_require__("2444");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("1d2b");

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),

/***/ "c53c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNaN);


/***/ }),

/***/ "c619":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/constant.js
var constant = __webpack_require__("706c");

// EXTERNAL MODULE: ./node_modules/lodash-es/_defineProperty.js
var _defineProperty = __webpack_require__("0305");

// EXTERNAL MODULE: ./node_modules/lodash-es/identity.js
var identity = __webpack_require__("f976");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSetToString.js




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !_defineProperty["a" /* default */] ? identity["a" /* default */] : function(func, string) {
  return Object(_defineProperty["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(constant["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ var _baseSetToString = (baseSetToString);

// EXTERNAL MODULE: ./node_modules/lodash-es/_shortOut.js
var _shortOut = __webpack_require__("1dae");

// CONCATENATED MODULE: ./node_modules/lodash-es/_setToString.js



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(_shortOut["a" /* default */])(_baseSetToString);

/* harmony default export */ var _setToString = __webpack_exports__["a"] = (setToString);


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6eb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5ea3");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("dd40")(module)))

/***/ }),

/***/ "c8af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("26ee");


/** Built-in value references. */
var Symbol = _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _toNumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4a24");


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = Object(_toNumber_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toFinite);


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ce7f":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ea83");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7b243a60", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "cee4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");
var bind = __webpack_require__("1d2b");
var Axios = __webpack_require__("0a06");
var mergeConfig = __webpack_require__("4a7b");
var defaults = __webpack_require__("2444");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("7a77");
axios.CancelToken = __webpack_require__("8df4");
axios.isCancel = __webpack_require__("2e67");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("0df6");

// Expose isAxiosError
axios.isAxiosError = __webpack_require__("5f02");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d137":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ea55");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("40f2792d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d339":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ErrorPage_vue_vue_type_style_index_0_id_9f3e3ed2_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3ee1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ErrorPage_vue_vue_type_style_index_0_id_9f3e3ed2_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_ErrorPage_vue_vue_type_style_index_0_id_9f3e3ed2_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d36f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseSetData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1df0");
/* harmony import */ var _shortOut_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1dae");



/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = Object(_shortOut_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_baseSetData_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (setData);


/***/ }),

/***/ "d3ae":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ac1f");

__webpack_require__("5319");

// In the Core app where this package is used through requirejs, we need
// to tell the entrypoint where to find platform-components' assets, like images

/* eslint-disable no-undef */
if (typeof window !== 'undefined' && window.require && window.require.toUrl && !__webpack_require__.p) {
  __webpack_require__.p = window.require.toUrl('@discoveryedu/platform-components').replace(/(platform-components\/dist\/)(.*)/, '$1');
} else if (!__webpack_require__.p) {
  __webpack_require__.p = '/_nuxt/';
}

/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === RegExp.prototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d8cb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8301");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1fe3ef46", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d925":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc95":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.asset-player-content__other{padding:24px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "dca8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var FREEZING = __webpack_require__("bb2f");
var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var onFreeze = __webpack_require__("f183").onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ "dd40":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if (!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "ddc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getNative_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("63bc");
/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("26ee");



/* Built-in method references that are verified to be native. */
var Map = Object(_getNative_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_root_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),

/***/ "ddf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/lodash-es/_getWrapDetails.js
/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/* harmony default export */ var _getWrapDetails = (getWrapDetails);

// CONCATENATED MODULE: ./node_modules/lodash-es/_insertWrapDetails.js
/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/* harmony default export */ var _insertWrapDetails = (insertWrapDetails);

// EXTERNAL MODULE: ./node_modules/lodash-es/_setToString.js + 1 modules
var _setToString = __webpack_require__("c619");

// EXTERNAL MODULE: ./node_modules/lodash-es/_arrayEach.js
var _arrayEach = __webpack_require__("20b6");

// EXTERNAL MODULE: ./node_modules/lodash-es/_arrayIncludes.js
var _arrayIncludes = __webpack_require__("72fb");

// CONCATENATED MODULE: ./node_modules/lodash-es/_updateWrapDetails.js



/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  Object(_arrayEach["a" /* default */])(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !Object(_arrayIncludes["a" /* default */])(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/* harmony default export */ var _updateWrapDetails = (updateWrapDetails);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setWrapToString.js





/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return Object(_setToString["a" /* default */])(wrapper, _insertWrapDetails(source, _updateWrapDetails(_getWrapDetails(source), bitmask)));
}

/* harmony default export */ var _setWrapToString = __webpack_exports__["a"] = (setWrapToString);


/***/ }),

/***/ "df64":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1cf9");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("9f6c36ea", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "df7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "dff1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var _root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("26ee");


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("dd40")(module)))

/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e25e":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var parseIntImplementation = __webpack_require__("c20d");

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != parseIntImplementation }, {
  parseInt: parseIntImplementation
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e58c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var toIndexedObject = __webpack_require__("fc6a");
var toInteger = __webpack_require__("a691");
var toLength = __webpack_require__("50c4");
var arrayMethodIsStrict = __webpack_require__("a640");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return $lastIndexOf.apply(this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = toLength(O.length);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toInteger(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e683":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var NativePromise = __webpack_require__("fea9");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var isObject = __webpack_require__("861d");
var aFunction = __webpack_require__("1c0b");
var anInstance = __webpack_require__("19aa");
var inspectSource = __webpack_require__("8925");
var iterate = __webpack_require__("2266");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var promiseResolve = __webpack_require__("cdf9");
var hostReportErrors = __webpack_require__("44de");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var InternalStateModule = __webpack_require__("69f3");
var isForced = __webpack_require__("94ca");
var wellKnownSymbol = __webpack_require__("b622");
var IS_NODE = __webpack_require__("605d");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');
var PROMISE = 'Promise';
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var PromiseConstructor = NativePromise;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var $fetch = getBuiltIn('fetch');
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (V8_VERSION === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE && !NATIVE_REJECTION_EVENT) return true;
  }
  // We need Promise#finally in the pure version for preventing prototype pollution
  if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  return !(promise.then(function () { /* empty */ }) instanceof FakePromise);
});

var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task.call(global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction(executor);
    Internal.call(this);
    var state = getInternalState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE ? process.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && typeof NativePromise == 'function') {
    nativeThen = NativePromise.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
      var that = this;
      return new PromiseConstructor(function (resolve, reject) {
        nativeThen.call(that, resolve, reject);
      }).then(onFulfilled, onRejected);
    // https://github.com/zloirock/core-js/issues/640
    }, { unsafe: true });

    // wrap fetch result
    if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
      // eslint-disable-next-line no-unused-vars -- required for `.length`
      fetch: function fetch(input /* , init */) {
        return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
      }
    });
  }
}

$({ global: true, wrap: true, forced: FORCED }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
$({ target: PROMISE, stat: true, forced: FORCED }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
  }
});

$({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction(C.resolve);
      iterate(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "e79e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _LazyWrapper_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("062a");
/* harmony import */ var _LodashWrapper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("1a7d");
/* harmony import */ var _copyArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7804");




/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof _LazyWrapper_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]) {
    return wrapper.clone();
  }
  var result = new _LodashWrapper_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"](wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = Object(_copyArray_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperClone);


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e9c4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var fails = __webpack_require__("d039");

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}


/***/ }),

/***/ "ea55":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.nebula-card-row .nebula-card.nebula-card--invisible{height:0;margin:0;visibility:hidden}.channels-rows-container .nebula-card-carousel__outer-wrap{margin-bottom:0;z-index:var(--z-index)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ea83":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.embedded-player__container--iframe{max-width:100%}.embedded-player__container--iframe iframe{display:block;margin:0 auto;max-width:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ec41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseGet_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5132");


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(_baseGet_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("1c0b");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f0ce":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__("ca54");

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol["a" /* default */] ? _Symbol["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol["a" /* default */] ? _Symbol["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = __webpack_exports__["a"] = (baseGetTag);


/***/ }),

/***/ "f118":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".nebula-text-italic{font-variation-settings:\"ital\" 75}.nebula-text-semibold{font-weight:500}.school-dropdown{left:0;right:unset;z-index:15}.school-dropdown__list{margin:0;max-height:480px;overflow-y:auto;padding:0}.school-dropdown-item__button{align-items:flex-start;display:flex;flex-direction:column;width:100%}.school-dropdown-item__button--none{font-style:italic}.school-dropdown-item__button--none[aria-disabled=true]{opacity:.5;pointer-events:none}.school-dropdown__search .nebula-input-with-buttons__input{flex:1}.school-dropdown__search .nebula-button,.school-dropdown__search .nebula-input{background-color:rgba(0,0,0,.2)}.school-dropdown__search .nebula-input{border:0;caret-color:#fff;color:#fff;margin:0}.school-dropdown__search .nebula-input::-webkit-input-placeholder{color:#fff}.school-dropdown__search .nebula-input::placeholder{color:#fff}.school-dropdown__search .nebula-input:focus::-webkit-input-placeholder{color:hsla(0,0%,100%,.5)}.school-dropdown__search .nebula-input:focus::placeholder{color:hsla(0,0%,100%,.5)}.school-dropdown__search .nebula-button__icon{fill:#fff}.school-dropdown .school-dropdown-item__no-results{color:#fff;padding:8px 16px;text-align:center}.school-dropdown .school-dropdown-item__no-results--filter{font-style:italic}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f183":
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__("d012");
var isObject = __webpack_require__("861d");
var has = __webpack_require__("5135");
var defineProperty = __webpack_require__("9bf2").f;
var uid = __webpack_require__("90e3");
var FREEZING = __webpack_require__("bb2f");

var METADATA = uid('meta');
var id = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "f1fb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (composeArgs);


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f6b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("c532");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f838":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_StaySignedInModal_vue_vue_type_style_index_0_id_8c6ff5e4_lang_stylus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a978");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_StaySignedInModal_vue_vue_type_style_index_0_id_8c6ff5e4_lang_stylus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_12_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_12_oneOf_1_1_node_modules_vue_loader_v16_dist_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_12_oneOf_1_3_node_modules_stylus_loader_index_js_ref_12_oneOf_1_4_node_modules_style_resources_loader_lib_index_js_ref_12_oneOf_1_5_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_v16_dist_index_js_ref_1_1_StaySignedInModal_vue_vue_type_style_index_0_id_8c6ff5e4_lang_stylus__WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f8c9":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var setToStringTag = __webpack_require__("d44e");

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),

/***/ "f949":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _baseRest_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2d5d");
/* harmony import */ var _createWrap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9e08");
/* harmony import */ var _getHolder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("292b");
/* harmony import */ var _replaceHolders_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("9f32");





/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = Object(_baseRest_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = Object(_replaceHolders_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(partials, Object(_getHolder_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return Object(_createWrap_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

/* harmony default export */ __webpack_exports__["a"] = (bind);


/***/ }),

/***/ "f976":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),

/***/ "fa3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _metaMap_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6171");
/* harmony import */ var _noop_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("89f2");



/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !_metaMap_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] ? _noop_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"] : function(func) {
  return _metaMap_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].get(func);
};

/* harmony default export */ __webpack_exports__["a"] = (getData);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "ActionMenu", function() { return /* reexport */ main_lib_ActionMenu; });
__webpack_require__.d(__webpack_exports__, "ErrorPage", function() { return /* reexport */ main_lib_ErrorPage; });
__webpack_require__.d(__webpack_exports__, "TechbookContentErrorPage", function() { return /* reexport */ main_lib_TechbookContentErrorPage; });
__webpack_require__.d(__webpack_exports__, "MyContentUploadModal", function() { return /* reexport */ MyContentUploadModal; });
__webpack_require__.d(__webpack_exports__, "PlayerComponents", function() { return /* reexport */ PlayerComponents; });
__webpack_require__.d(__webpack_exports__, "SearchBox", function() { return /* reexport */ main_lib_SearchBox; });
__webpack_require__.d(__webpack_exports__, "ShareModal", function() { return /* reexport */ ShareModal; });
__webpack_require__.d(__webpack_exports__, "DownloadVideoModal", function() { return /* reexport */ DownloadVideoModal; });
__webpack_require__.d(__webpack_exports__, "DualAssignModal2023", function() { return /* reexport */ DualAssignModal2023; });
__webpack_require__.d(__webpack_exports__, "CreateWithStudioModal", function() { return /* reexport */ CreateWithStudioModal; });
__webpack_require__.d(__webpack_exports__, "ChannelCardCarousel", function() { return /* reexport */ main_lib_ChannelCardCarousel; });
__webpack_require__.d(__webpack_exports__, "StaySignedInModal", function() { return /* reexport */ main_lib_StaySignedInModal; });
__webpack_require__.d(__webpack_exports__, "SSOStaySignedInModal", function() { return /* reexport */ main_lib_SSOStaySignedInModal; });
__webpack_require__.d(__webpack_exports__, "GoogleClassroomModal", function() { return /* reexport */ GoogleClassroomModal; });
__webpack_require__.d(__webpack_exports__, "CleverIDMappingDropdown", function() { return /* reexport */ main_lib_CleverIDMappingDropdown; });
__webpack_require__.d(__webpack_exports__, "textToSpeech", function() { return /* reexport */ textToSpeech; });
__webpack_require__.d(__webpack_exports__, "imageUrl", function() { return /* reexport */ imageUrl; });
__webpack_require__.d(__webpack_exports__, "profileAvatars", function() { return /* reexport */ profileAvatars; });
__webpack_require__.d(__webpack_exports__, "profileBackgrounds", function() { return /* reexport */ profileBackgrounds; });
__webpack_require__.d(__webpack_exports__, "UsersImportAccordion", function() { return /* reexport */ UsersImportAccordion; });
__webpack_require__.d(__webpack_exports__, "UsersManageAccordion", function() { return /* reexport */ UsersManageAccordion; });
__webpack_require__.d(__webpack_exports__, "i18nPluralTerms", function() { return /* reexport */ main_lib_i18nPluralTerms; });
__webpack_require__.d(__webpack_exports__, "DomHelper", function() { return /* reexport */ main_lib_DomHelper; });
__webpack_require__.d(__webpack_exports__, "Highlight", function() { return /* reexport */ main_lib_Highlight; });
__webpack_require__.d(__webpack_exports__, "HighlightHelper", function() { return /* reexport */ main_lib_HighlightHelper; });
__webpack_require__.d(__webpack_exports__, "Selection", function() { return /* reexport */ main_lib_Selection; });
__webpack_require__.d(__webpack_exports__, "SelectionHelper", function() { return /* reexport */ main_lib_SelectionHelper; });
__webpack_require__.d(__webpack_exports__, "TextSelectTools", function() { return /* reexport */ main_lib_TextSelectTools; });

// NAMESPACE OBJECT: ./src/utils/constants/profileAvatars.js
var profileAvatars_namespaceObject = {};
__webpack_require__.r(profileAvatars_namespaceObject);
__webpack_require__.d(profileAvatars_namespaceObject, "AVATARS", function() { return AVATARS; });
__webpack_require__.d(profileAvatars_namespaceObject, "avatarImagePath", function() { return avatarImagePath; });

// NAMESPACE OBJECT: ./src/utils/constants/profileBackgrounds.js
var profileBackgrounds_namespaceObject = {};
__webpack_require__.r(profileBackgrounds_namespaceObject);
__webpack_require__.d(profileBackgrounds_namespaceObject, "THEMES", function() { return THEMES; });
__webpack_require__.d(profileBackgrounds_namespaceObject, "themeImagePath", function() { return themeImagePath; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");

// EXTERNAL MODULE: ./src/utils/public-path.js
var public_path = __webpack_require__("d3ae");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ActionMenu.vue?vue&type=template&id=7e3182ba

var _hoisted_1 = {
  class: "action-menu"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaFavoritesButton = Object(external_vue_["resolveComponent"])("NebulaFavoritesButton");

  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  var _component_NebulaDropdownItem = Object(external_vue_["resolveComponent"])("NebulaDropdownItem");

  var _component_NebulaDropdown = Object(external_vue_["resolveComponent"])("NebulaDropdown");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_1, [$props.use2024HeartIcon ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaFavoritesButton, {
    key: 0,
    isFavorite: $options.isInQL,
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.isInQL ? $options.removeFromQL($props.asset) : $options.addToQL($props.asset);
    })
  }, null, 8, ["isFavorite"])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createVNode"])(_component_NebulaDropdown, {
    buttonId: $options.dropdownTriggerId,
    dropdownWrapperClass: $data.actionMenuClass
  }, {
    trigger: Object(external_vue_["withCtx"])(function (_ref) {
      var toggleDropdown = _ref.toggleDropdown,
          checkArrowKeyOnTrigger = _ref.checkArrowKeyOnTrigger,
          checkArrowKeyAfterTrigger = _ref.checkArrowKeyAfterTrigger,
          isOpen = _ref.isOpen;
      return [Object(external_vue_["createVNode"])(_component_NebulaButton, {
        iconLeft: "ellipses-vertical",
        id: $options.dropdownTriggerId,
        shape: "pill",
        size: "s",
        type: "ghost",
        "aria-label": _ctx.$t('Open actions menu'),
        onClick: function onClick($event) {
          return $options.dropdownHandler(isOpen, toggleDropdown);
        },
        onKeydown: checkArrowKeyOnTrigger,
        onKeyup: checkArrowKeyAfterTrigger,
        "aria-expanded": isOpen && 'true' || 'false'
      }, null, 8, ["id", "aria-label", "onClick", "onKeydown", "onKeyup", "aria-expanded"])];
    }),
    content: Object(external_vue_["withCtx"])(function () {
      return [$data.prioritizeAssign ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 0
      }, [$options.hasAssign ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, {
        key: 0,
        link: $options.assignHref,
        icon: "arrow-right-circle",
        text: _ctx.$t('Assign'),
        "tracking-data": $props.trackingData.assign
      }, null, 8, ["link", "text", "tracking-data"])) : Object(external_vue_["createCommentVNode"])("", true)], 64)) : Object(external_vue_["createCommentVNode"])("", true), $options.isChannel && !$props.userIsStudent ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 1
      }, [$options.isSubscribedChannel($props.subscribedChannelIds) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, {
        key: 0,
        icon: "bookmark",
        text: _ctx.$t('Remove from My Channels'),
        onDropdownItemClicked: _cache[1] || (_cache[1] = function ($event) {
          return $options.unSubscribeToChannel($props.asset);
        })
      }, null, 8, ["text"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, {
        key: 1,
        icon: "bookmark",
        text: _ctx.$t('Add to My Channels'),
        onDropdownItemClicked: _cache[2] || (_cache[2] = function ($event) {
          return $options.subscribeToChannel($props.asset);
        })
      }, null, 8, ["text"]))], 64)) : Object(external_vue_["createCommentVNode"])("", true), $options.showQuickListOptions ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 2
      }, [$options.isInQL ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, {
        key: 0,
        icon: "heart--filled",
        text: _ctx.$t('Remove from Favorites'),
        onDropdownItemClicked: _cache[3] || (_cache[3] = function ($event) {
          return $options.removeFromQL($props.asset);
        })
      }, null, 8, ["text"])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, {
        key: 1,
        icon: "heart",
        text: _ctx.$t('Add to Favorites'),
        onDropdownItemClicked: _cache[4] || (_cache[4] = function ($event) {
          return $options.addToQL($props.asset);
        })
      }, null, 8, ["text"]))], 64)) : Object(external_vue_["createCommentVNode"])("", true), $props.showCreateWithStudio ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, {
        key: 3,
        icon: "studio",
        text: _ctx.$t('Create with Studio'),
        onDropdownItemClicked: _cache[5] || (_cache[5] = function ($event) {
          return $options.createWithStudio($props.asset);
        })
      }, null, 8, ["text"])) : Object(external_vue_["createCommentVNode"])("", true), !$data.prioritizeAssign ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], {
        key: 4
      }, [$options.hasAssign ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, {
        key: 0,
        link: $options.assignHref,
        icon: "arrow-right-circle",
        text: _ctx.$t('Assign'),
        "tracking-data": $props.trackingData.assign
      }, null, 8, ["link", "text", "tracking-data"])) : Object(external_vue_["createCommentVNode"])("", true)], 64)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createVNode"])(_component_NebulaDropdownItem, {
        icon: "share",
        text: _ctx.$t('Share'),
        onDropdownItemClicked: _cache[6] || (_cache[6] = function ($event) {
          return $options.share($props.asset);
        })
      }, null, 8, ["text"]), $options.myContentEnabled ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaDropdownItem, {
        key: 5,
        icon: "drive",
        text: _ctx.$t('Save to My Content'),
        onDropdownItemClicked: _cache[7] || (_cache[7] = function ($event) {
          return $options.addToMyContent($props.asset);
        })
      }, null, 8, ["text"])) : Object(external_vue_["createCommentVNode"])("", true)];
    }),
    _: 1
  }, 8, ["buttonId", "dropdownWrapperClass"])]);
}
// CONCATENATED MODULE: ./src/components/ActionMenu.vue?vue&type=template&id=7e3182ba

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// EXTERNAL MODULE: external "@discoveryedu/nebula-components"
var nebula_components_ = __webpack_require__("444c");

// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var stringify_i = 0; stringify_i < 256; ++stringify_i) {
  byteToHex.push((stringify_i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ActionMenu.vue?vue&type=script&lang=js






var ASSIGN_EXPERIMENT_ID = 'assign-cta-placement-experiment';
/* harmony default export */ var ActionMenuvue_type_script_lang_js = ({
  name: 'ActionMenu',
  components: {
    NebulaButton: nebula_components_["NebulaButton"],
    NebulaDropdown: nebula_components_["NebulaDropdown"],
    NebulaDropdownItem: nebula_components_["NebulaDropdownItem"],
    NebulaFavoritesButton: nebula_components_["NebulaFavoritesButton"]
  },
  data: function data() {
    var isInAssignExperiment = false;
    var prioritizeAssign = false;

    if (typeof window !== 'undefined') {
      var _window$initData, _window$initData$expe;

      var assignExperiment = ((_window$initData = window.initData) === null || _window$initData === void 0 ? void 0 : (_window$initData$expe = _window$initData.experiments) === null || _window$initData$expe === void 0 ? void 0 : _window$initData$expe[ASSIGN_EXPERIMENT_ID]) || {};
      isInAssignExperiment = !!assignExperiment.is_member;
      prioritizeAssign = assignExperiment.is_member && !assignExperiment.is_control;
    }

    return {
      actionMenuClass: 'nebula-card__action-menu',
      isInAssignExperiment: isInAssignExperiment,
      prioritizeAssign: prioritizeAssign
    };
  },
  props: {
    asset: {
      type: Object,
      required: true
    },
    assetType: String,
    backUrl: String,
    quicklistIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    subscribedChannelIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    learnUrl: {
      type: String,
      default: '/learn'
    },
    userIsStudent: {
      type: Boolean,
      default: false
    },
    showCreateWithStudio: {
      type: Boolean,
      default: true
    },
    trackingData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    use2024HeartIcon: {
      type: Boolean,
      default: false
    }
  },
  emits: ['assign', 'subscribe', 'quicklist:add', 'quicklist:remove', 'save', 'share', 'studio:create', 'unsubscribe'],
  computed: {
    assetTypeFriendly: function assetTypeFriendly() {
      if (this.assetType) {
        return this.assetType;
      }

      if (this.asset.type && this.asset.type.name) {
        return this.asset.type.name;
      }

      if (this.asset.type_name) {
        return this.asset.type_name;
      }

      return null;
    },
    assetSubtypeId: function assetSubtypeId() {
      var _this$asset$subtype, _this$asset$sub_type, _this$asset$asset_sub, _this$asset$asset_sub2;

      return this.asset.subtype_id || this.asset.sub_type_id || ((_this$asset$subtype = this.asset.subtype) === null || _this$asset$subtype === void 0 ? void 0 : _this$asset$subtype.id) || ((_this$asset$sub_type = this.asset.sub_type) === null || _this$asset$sub_type === void 0 ? void 0 : _this$asset$sub_type.id) || ((_this$asset$asset_sub = this.asset.asset_subtype) === null || _this$asset$asset_sub === void 0 ? void 0 : _this$asset$asset_sub.id) || ((_this$asset$asset_sub2 = this.asset.asset_sub_type) === null || _this$asset$asset_sub2 === void 0 ? void 0 : _this$asset$asset_sub2.id);
    },
    assetTypeId: function assetTypeId() {
      var _this$asset$type, _this$asset$asset_typ;

      return this.asset.type_id || ((_this$asset$type = this.asset.type) === null || _this$asset$type === void 0 ? void 0 : _this$asset$type.id) || ((_this$asset$asset_typ = this.asset.asset_type) === null || _this$asset$asset_typ === void 0 ? void 0 : _this$asset$asset_typ.id);
    },
    assignHref: function assignHref() {
      var backUrl = this.backUrl || this.$windowLocation && this.$windowLocation.href || window.location.href;
      return "".concat(this.learnUrl, "/assign/").concat(this.asset.id, "?back=").concat(encodeURIComponent(backUrl));
    },
    dropdownTriggerId: function dropdownTriggerId() {
      // There may be more than one ActionMenu on the page for the same asset.
      // The element ids need to be unique so that the dropdowns are connected
      // correctly for a11y.
      return "action-menu--".concat(esm_browser_v4());
    },
    hasAssign: function hasAssign() {
      if (!this.showCreateWithStudio && this.isStudioAsset) {
        return false;
      }

      return !this.isChannel && !this.isPage && !this.isInvestigation && !this.userIsStudent && this.classroomsEnabled;
    },
    myContentEnabled: function myContentEnabled() {
      return window.initData && window.initData.product_settings ? window.initData.product_settings.ENABLEMYCONTENT : true;
    },
    classroomsEnabled: function classroomsEnabled() {
      return window.initData && window.initData.product_settings ? window.initData.product_settings.CLASSROOMMANAGER : true;
    },
    showQuickListOptions: function showQuickListOptions() {
      if (this.use2024HeartIcon) {
        return false;
      }

      if (this.assetTypeId === 'a6d4de3c-8100-4fb5-b910-5cf311b51f1e') {
        // For TEAs, only Studio Quizzes and Lessons can be added to the QuickList
        return this.assetSubtypeId === 'f7217318-a375-42be-bee7-1a991e045ef6' // Studio Quiz
        || this.assetSubtypeId === '9695ae47-bd47-4070-aa05-b8bdaa6ebcb0'; // Lesson
      }

      return true;
    },
    isChannel: function isChannel() {
      return this.assetTypeFriendly === 'Channel';
    },
    isPage: function isPage() {
      return this.assetTypeId === 'b5bc40ea-f28b-4c3c-a8fb-34c600cd8d57';
    },
    isInvestigation: function isInvestigation() {
      return this.assetTypeId === '9c864e63-0018-452f-8cf6-e7bb8c204646';
    },
    isInQL: function isInQL() {
      var _this = this;

      // eslint-disable-next-line max-len
      return this.quicklistIds && this.quicklistIds.find(function (qLGuid) {
        return qLGuid.toLowerCase() === (_this.asset && _this.asset.id.toLowerCase());
      });
    },
    isStudioAsset: function isStudioAsset() {
      return this.assetSubtypeId === 'f7217318-a375-42be-bee7-1a991e045ef6' // Studio Quiz
      || this.assetSubtypeId === '9695ae47-bd47-4070-aa05-b8bdaa6ebcb0' // Lesson
      || ['854f468c-64b9-4bfb-9be2-32c9d5cc5243', // Board
      '9d23b45d-c8da-4fac-852a-c24d5cc4e348', // Slideshow
      'b424e481-30a1-482d-a2d7-ce9c3e5a50d7' // Lesson
      ].includes(this.assetTypeId);
    },
    assetTitleOrName: function assetTitleOrName() {
      return this.asset.title || this.asset.name;
    }
  },
  methods: {
    dropdownHandler: function dropdownHandler(isOpen, toggleDropdown) {
      var _window;

      if (!isOpen && this.isInAssignExperiment && (_window = window) !== null && _window !== void 0 && _window.DEAnalytics) {
        window.DEAnalytics.experiment(ASSIGN_EXPERIMENT_ID);
      }

      toggleDropdown();
    },
    unSubscribeToChannel: function unSubscribeToChannel(asset) {
      this.$emit('unsubscribe', asset);
      document.dispatchEvent(new CustomEvent('actionMenu', {
        detail: {
          type: 'unsubscribe',
          asset: asset
        }
      }));
    },
    subscribeToChannel: function subscribeToChannel(asset) {
      this.$emit('subscribe', asset);
      document.dispatchEvent(new CustomEvent('actionMenu', {
        detail: {
          type: 'subscribe',
          asset: asset
        }
      }));
    },
    removeFromQL: function removeFromQL(asset) {
      this.$emit('quicklist:remove', asset);
      document.dispatchEvent(new CustomEvent('actionMenu', {
        detail: {
          type: 'quicklist:remove',
          asset: asset
        }
      }));
    },
    addToQL: function addToQL(asset) {
      this.$emit('quicklist:add', asset);
      document.dispatchEvent(new CustomEvent('actionMenu', {
        detail: {
          type: 'quicklist:add',
          asset: asset
        }
      }));
    },
    createWithStudio: function createWithStudio(asset) {
      this.$emit('studio:create', asset);
      document.dispatchEvent(new CustomEvent('actionMenu', {
        detail: {
          type: 'studio:create',
          asset: asset
        }
      }));
    },
    share: function share(asset) {
      this.$emit('share', asset);
      document.dispatchEvent(new CustomEvent('actionMenu', {
        detail: {
          type: 'share',
          asset: asset
        }
      }));
    },
    addToMyContent: function addToMyContent(asset) {
      this.$emit('save', asset);
      document.dispatchEvent(new CustomEvent('actionMenu', {
        detail: {
          type: 'save',
          asset: asset
        }
      }));
    },
    openDualAssignModal: function openDualAssignModal(asset) {
      this.$emit('assign', {
        asset: asset,
        assignHref: this.assignHref
      });
      document.dispatchEvent(new CustomEvent('actionMenu', {
        detail: {
          type: 'assign',
          asset: asset,
          assignHref: this.assignHref
        }
      }));
    },
    isSubscribedChannel: function isSubscribedChannel(subscribedChannelIds) {
      var _this2 = this;

      return subscribedChannelIds.find(function (sCGuid) {
        return sCGuid.toLowerCase() === (_this2.asset && _this2.asset.id.toLowerCase());
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/ActionMenu.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ActionMenu.vue?vue&type=style&index=0&id=7e3182ba&lang=stylus
var ActionMenuvue_type_style_index_0_id_7e3182ba_lang_stylus = __webpack_require__("0560");

// EXTERNAL MODULE: ./node_modules/vue-loader-v16/dist/exportHelper.js
var exportHelper = __webpack_require__("6b0d");
var exportHelper_default = /*#__PURE__*/__webpack_require__.n(exportHelper);

// CONCATENATED MODULE: ./src/components/ActionMenu.vue







const __exports__ = /*#__PURE__*/exportHelper_default()(ActionMenuvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var ActionMenu = (__exports__);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ErrorPage.vue?vue&type=template&id=9f3e3ed2

var ErrorPagevue_type_template_id_9f3e3ed2_hoisted_1 = {
  class: "nebula-error"
};
var _hoisted_2 = {
  class: "nebula-error__content"
};
var _hoisted_3 = {
  class: "nebula-error__type"
};
var _hoisted_4 = {
  class: "nebula-error__heading"
};
var _hoisted_5 = {
  class: "nebula-error__message"
};
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  class: "nebula-error__help"
};
var _hoisted_8 = ["href"];
var _hoisted_9 = {
  key: 1,
  class: "nebula-error__error-codes"
};
var _hoisted_10 = {
  key: 0
};
var _hoisted_11 = {
  key: 1
};
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = {
  key: 3,
  class: "nebula-error__extra-info"
};

var _hoisted_14 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("div", {
  class: "nebula-error__spaceman"
}, null, -1);

function ErrorPagevue_type_template_id_9f3e3ed2_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", ErrorPagevue_type_template_id_9f3e3ed2_hoisted_1, [Object(external_vue_["createElementVNode"])("div", _hoisted_2, [Object(external_vue_["createElementVNode"])("h3", _hoisted_3, Object(external_vue_["toDisplayString"])($props.error), 1), Object(external_vue_["createElementVNode"])("h1", _hoisted_4, Object(external_vue_["toDisplayString"])($props.headline), 1), Object(external_vue_["createElementVNode"])("div", _hoisted_5, [$props.message ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", _hoisted_6, Object(external_vue_["toDisplayString"])($props.message), 1)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["renderSlot"])(_ctx.$slots, "content"), Object(external_vue_["renderSlot"])(_ctx.$slots, "buttons", {}, function () {
    return [Object(external_vue_["createVNode"])(_component_NebulaButton, {
      link: "/",
      class: "nebula-error__home-link",
      size: "m",
      text: _ctx.$t('Go to the DE Home')
    }, null, 8, ["text"])];
  }), Object(external_vue_["createElementVNode"])("p", _hoisted_7, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(_ctx.$t('Need Help?')) + " ", 1), Object(external_vue_["createElementVNode"])("a", {
    href: $props.helpUrl
  }, Object(external_vue_["toDisplayString"])(_ctx.$t('Contact Support')), 9, _hoisted_8)]), $props.problemIdent || $props.requestId ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", _hoisted_9, [Object(external_vue_["createElementVNode"])("span", null, Object(external_vue_["toDisplayString"])(_ctx.$t('If you require assistance, please include these codes when asking for help:')), 1), $props.problemIdent ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", _hoisted_10, Object(external_vue_["toDisplayString"])(_ctx.$t('Problem ID:')) + " " + Object(external_vue_["toDisplayString"])($props.problemIdent), 1)) : Object(external_vue_["createCommentVNode"])("", true), $props.requestId ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", _hoisted_11, Object(external_vue_["toDisplayString"])(_ctx.$t('Request ID:')) + " " + Object(external_vue_["toDisplayString"])($props.requestId), 1)) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true), $props.htmlDisplayMessage ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 2,
    innerHTML: $props.htmlDisplayMessage,
    class: "nebula-error__html-display-message"
  }, null, 8, _hoisted_12)) : Object(external_vue_["createCommentVNode"])("", true), $props.extraInformationDict ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", _hoisted_13, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.extraInformationDict, function (value, name) {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", {
      key: name
    }, Object(external_vue_["toDisplayString"])(name) + ": " + Object(external_vue_["toDisplayString"])(value), 1);
  }), 128))])) : Object(external_vue_["createCommentVNode"])("", true)])]), _hoisted_14]);
}
// CONCATENATED MODULE: ./src/components/ErrorPage.vue?vue&type=template&id=9f3e3ed2

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ErrorPage.vue?vue&type=script&lang=js

/* harmony default export */ var ErrorPagevue_type_script_lang_js = ({
  name: 'ErrorPage',
  components: {
    NebulaButton: nebula_components_["NebulaButton"]
  },
  props: {
    headline: {
      type: String
    },
    message: {
      type: String
    },
    error: {
      type: String
    },
    helpUrl: {
      type: String
    },
    problemIdent: {
      type: String
    },
    requestId: {
      type: String
    },
    htmlDisplayMessage: {
      type: String
    },
    extraInformationDict: {
      type: Object
    }
  }
});
// CONCATENATED MODULE: ./src/components/ErrorPage.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ErrorPage.vue?vue&type=style&index=0&id=9f3e3ed2&lang=stylus
var ErrorPagevue_type_style_index_0_id_9f3e3ed2_lang_stylus = __webpack_require__("d339");

// CONCATENATED MODULE: ./src/components/ErrorPage.vue







const ErrorPage_exports_ = /*#__PURE__*/exportHelper_default()(ErrorPagevue_type_script_lang_js, [['render',ErrorPagevue_type_template_id_9f3e3ed2_render]])

/* harmony default export */ var ErrorPage = (ErrorPage_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/TechbookContentErrorPage.vue?vue&type=template&id=41096048

var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_1 = {
  class: "nebula-error-techbook"
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_2 = {
  class: "nebula-error-techbook__content"
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_3 = ["innerHTML"];
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_4 = {
  class: "nebula-error-techbook__message"
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_5 = {
  class: "nebula-error-techbook__buttons"
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_6 = {
  key: 0,
  class: "nebula-error-techbook__error-codes"
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_7 = {
  key: 0
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_8 = {
  class: "nebula-error-techbook__error-codes-label"
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_9 = {
  key: 1
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_10 = {
  class: "nebula-error-techbook__error-codes-label"
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_11 = {
  class: "nebula-error-techbook__globe"
};
var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_12 = {
  class: "techbook-error-speech-bubble"
};

var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_13 = /*#__PURE__*/Object(external_vue_["createStaticVNode"])("<div class=\"techbook-error-speech-bubble__svg-container\"><svg width=\"194\" height=\"158\" viewBox=\"0 0 194 158\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g filter=\"url(#filter0_d_2738_53325)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M106.146 20.3854C125.311 10.5872 148.639 20.6311 153.915 40.3101C175.702 39.0036 184.526 64.9085 169.558 77.2636C171.718 89.9387 162.744 106.5 137.788 102.266C134.347 107.613 129.85 111.222 124.966 113.253C124.988 113.499 125 113.748 125 114C125 118.418 121.418 122 117 122C112.786 122 109.333 118.742 109.023 114.608C103.006 113.256 97.4527 109.831 93.5565 104.62C79.6359 119.975 49.5136 120.084 40.4109 91.1053C21.1525 93.0041 5.72604 65.45 27.9449 50.2849C22.641 27.0918 52.655 13.0359 69.8205 24.0149C79.2039 8.16229 98.6677 11.7044 106.146 20.3854ZM106 132C108.209 132 110 130.209 110 128C110 125.791 108.209 124 106 124C103.791 124 102 125.791 102 128C102 130.209 103.791 132 106 132ZM97 135C97 136.105 96.1046 137 95 137C93.8954 137 93 136.105 93 135C93 133.895 93.8954 133 95 133C96.1046 133 97 133.895 97 135Z\" fill=\"white\"></path></g><defs><filter id=\"filter0_d_2738_53325\" x=\"0\" y=\"0\" width=\"194\" height=\"158\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"></feColorMatrix><feMorphology radius=\"2\" operator=\"dilate\" in=\"SourceAlpha\" result=\"effect1_dropShadow_2738_53325\"></feMorphology><feOffset dy=\"4\"></feOffset><feGaussianBlur stdDeviation=\"7.5\"></feGaussianBlur><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0\"></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_2738_53325\"></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_2738_53325\" result=\"shape\"></feBlend></filter></defs></svg></div>", 1);

var TechbookContentErrorPagevue_type_template_id_41096048_hoisted_14 = {
  class: "techbook-error-speech-bubble__text-container"
};
var _hoisted_15 = {
  class: "techbook-error-speech-bubble__text"
};
function TechbookContentErrorPagevue_type_template_id_41096048_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_1, [Object(external_vue_["createElementVNode"])("div", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_2, [Object(external_vue_["createElementVNode"])("h1", {
    class: Object(external_vue_["normalizeClass"])(["nebula-error-techbook__heading", $options.headingClass]),
    innerHTML: $options.headingText
  }, null, 10, TechbookContentErrorPagevue_type_template_id_41096048_hoisted_3), Object(external_vue_["createElementVNode"])("div", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_4, [Object(external_vue_["createElementVNode"])("div", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_5, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
    link: "/",
    class: "nebula-error-techbook__home-link",
    size: "m",
    text: _ctx.$t('Go to the DE Home')
  }, null, 8, ["text"]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
    link: $props.helpUrl,
    class: "nebula-error-techbook__home-link",
    size: "m",
    text: _ctx.$t('Contact Support'),
    type: "flat"
  }, null, 8, ["link", "text"])]), $props.problemIdent || $props.requestId ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("p", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_6, [$props.problemIdent ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_7, [Object(external_vue_["createElementVNode"])("span", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_8, Object(external_vue_["toDisplayString"])(_ctx.$t('Problem ID:')), 1), Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])($props.problemIdent), 1)])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createVNode"])(_component_NebulaButton, {
    "icon-left": "copy-to-clipboard",
    size: "s",
    type: "flat",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.copy($props.problemIdent);
    })
  }), $props.requestId ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_9, [Object(external_vue_["createElementVNode"])("span", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_10, Object(external_vue_["toDisplayString"])(_ctx.$t('Request ID:')), 1), Object(external_vue_["createTextVNode"])(" " + Object(external_vue_["toDisplayString"])($props.requestId), 1)])) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createVNode"])(_component_NebulaButton, {
    "icon-left": "copy-to-clipboard",
    size: "s",
    type: "flat",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.copy($props.requestId);
    })
  })])) : Object(external_vue_["createCommentVNode"])("", true)])]), Object(external_vue_["createElementVNode"])("div", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_11, [Object(external_vue_["createElementVNode"])("div", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_12, [TechbookContentErrorPagevue_type_template_id_41096048_hoisted_13, Object(external_vue_["createElementVNode"])("div", TechbookContentErrorPagevue_type_template_id_41096048_hoisted_14, [Object(external_vue_["createElementVNode"])("p", _hoisted_15, Object(external_vue_["toDisplayString"])(_ctx.$t('I AM LOST!')), 1)])])])]);
}
// CONCATENATED MODULE: ./src/components/TechbookContentErrorPage.vue?vue&type=template&id=41096048

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/TechbookContentErrorPage.vue?vue&type=script&lang=js

/* harmony default export */ var TechbookContentErrorPagevue_type_script_lang_js = ({
  name: 'TechbookContentErrorPageImport',
  components: {
    NebulaButton: nebula_components_["NebulaButton"]
  },
  props: {
    error: {
      type: String
    },
    helpUrl: {
      type: String
    },
    problemIdent: {
      type: String
    },
    requestId: {
      type: String
    },
    extraInformationDict: {
      type: Object
    },
    assetProductCode: {
      type: String
    }
  },
  computed: {
    headingClass: function headingClass() {
      switch (this.assetProductCode) {
        case 'DEMB':
          return 'nebula-error-techbook__heading--math';

        case 'SCIFTX':
        case 'DETB':
          return 'nebula-error-techbook__heading--science';

        case 'SOCS':
          return 'nebula-error-techbook__heading--socs';

        case 'STEM':
          return 'nebula-error-techbook__heading--stem';

        default:
          return false;
      }
    },
    headingText: function headingText() {
      if (this.techbookName) {
        return this.$t('Sorry, but it seems this resource is for<span> %(tb)s </span>subscribers.', {
          tb: this.techbookName
        });
      }

      return this.$t('Sorry, but it seems you don\'t have access to this resource.');
    },
    techbookName: function techbookName() {
      switch (this.assetProductCode) {
        case 'DEMB':
          return 'Math Techbook';

        case 'DETB':
          return 'Science Techbook';

        case 'SCIFTX':
          return 'Science for Texas';

        case 'SOCS':
          return 'Social Studies Techbook';

        case 'STEM':
          return 'STEM Connect';

        default:
          return false;
      }
    }
  },
  methods: {
    copy: function copy(code) {
      navigator.clipboard.writeText(code);
    }
  }
});
// CONCATENATED MODULE: ./src/components/TechbookContentErrorPage.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/TechbookContentErrorPage.vue?vue&type=style&index=0&id=41096048&lang=stylus
var TechbookContentErrorPagevue_type_style_index_0_id_41096048_lang_stylus = __webpack_require__("5192");

// CONCATENATED MODULE: ./src/components/TechbookContentErrorPage.vue







const TechbookContentErrorPage_exports_ = /*#__PURE__*/exportHelper_default()(TechbookContentErrorPagevue_type_script_lang_js, [['render',TechbookContentErrorPagevue_type_template_id_41096048_render]])

/* harmony default export */ var TechbookContentErrorPage = (TechbookContentErrorPage_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/index.vue?vue&type=template&id=6ddc1384

function player_componentsvue_type_template_id_6ddc1384_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_PDFViewer = Object(external_vue_["resolveComponent"])("PDFViewer");

  var _component_AudioViewer = Object(external_vue_["resolveComponent"])("AudioViewer");

  var _component_ArticleViewer = Object(external_vue_["resolveComponent"])("ArticleViewer");

  var _component_ReviewSheet = Object(external_vue_["resolveComponent"])("ReviewSheet");

  var _component_InteractiveViewer = Object(external_vue_["resolveComponent"])("InteractiveViewer");

  var _component_IframeViewer = Object(external_vue_["resolveComponent"])("IframeViewer");

  var _component_ImageDetail = Object(external_vue_["resolveComponent"])("ImageDetail");

  var _component_OtherViewer = Object(external_vue_["resolveComponent"])("OtherViewer");

  return $props.template === 'pdf' && $data.assetData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_PDFViewer, {
    key: 0,
    asset: $data.assetData,
    docreaderDomain: $data.resolvedDocreaderDomain || $props.docreaderDomain
  }, null, 8, ["asset", "docreaderDomain"])) : $props.template === 'audio' && $data.assetData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_AudioViewer, {
    key: 1,
    asset: $data.assetData,
    id: $data.assetData.id,
    showTitle: $props.showTitle,
    baseUrl: _ctx.baseUrl,
    "onAudio:audioprocess": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('audio:audioprocess');
    })
  }, null, 8, ["asset", "id", "showTitle", "baseUrl"])) : $props.template === 'article' && $data.assetData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_ArticleViewer, {
    key: 2,
    asset: $data.assetData
  }, null, 8, ["asset"])) : $props.template === 'review_sheet' && $data.assetData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_ReviewSheet, {
    key: 3,
    asset: $data.assetData
  }, null, 8, ["asset"])) : $props.template === 'embedded_interactive' && $data.assetData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_InteractiveViewer, {
    key: 4,
    asset: $data.assetData,
    windowPaths: $props.windowPaths
  }, null, 8, ["asset", "windowPaths"])) : $props.template === 'iframe' && $data.assetData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_IframeViewer, {
    key: 5,
    asset: $data.assetData,
    codingUrl: $props.codingUrl,
    isPreviewModal: $props.isPreviewModal
  }, null, 8, ["asset", "codingUrl", "isPreviewModal"])) : $props.template === 'image' && $data.assetData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_ImageDetail, {
    key: 6,
    asset: $data.assetData,
    showTitle: $props.showTitle,
    isInline: $props.isInline,
    caption: $props.caption,
    onImgLoaded: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('img-loaded');
    })
  }, null, 8, ["asset", "showTitle", "isInline", "caption"])) : $props.template === 'other' && $data.assetData ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_OtherViewer, {
    key: 7,
    asset: $data.assetData
  }, null, 8, ["asset"])) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/player-components/index.vue?vue&type=template&id=6ddc1384

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("bc3a");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/ArticleViewer.vue?vue&type=template&id=4e337c4a

var ArticleViewervue_type_template_id_4e337c4a_hoisted_1 = ["innerHTML"];
function ArticleViewervue_type_template_id_4e337c4a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.asset ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    key: 0,
    class: "asset-player-content__article",
    innerHTML: $props.asset.article_html
  }, null, 8, ArticleViewervue_type_template_id_4e337c4a_hoisted_1)) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/player-components/ArticleViewer.vue?vue&type=template&id=4e337c4a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/ArticleViewer.vue?vue&type=script&lang=js
/* harmony default export */ var ArticleViewervue_type_script_lang_js = ({
  name: 'ArticleViewer',
  props: {
    asset: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/player-components/ArticleViewer.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/player-components/ArticleViewer.vue?vue&type=style&index=0&id=4e337c4a&lang=stylus
var ArticleViewervue_type_style_index_0_id_4e337c4a_lang_stylus = __webpack_require__("8d2b");

// CONCATENATED MODULE: ./src/components/player-components/ArticleViewer.vue







const ArticleViewer_exports_ = /*#__PURE__*/exportHelper_default()(ArticleViewervue_type_script_lang_js, [['render',ArticleViewervue_type_template_id_4e337c4a_render]])

/* harmony default export */ var ArticleViewer = (ArticleViewer_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/PDFViewer.vue?vue&type=template&id=f75c7c7e

var PDFViewervue_type_template_id_f75c7c7e_hoisted_1 = {
  key: 0
};
var PDFViewervue_type_template_id_f75c7c7e_hoisted_2 = ["src"];
function PDFViewervue_type_template_id_f75c7c7e_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.asset ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", PDFViewervue_type_template_id_f75c7c7e_hoisted_1, [Object(external_vue_["createElementVNode"])("iframe", {
    src: $options.formattedSrc,
    width: "100%",
    height: "1000",
    frameborder: "0"
  }, null, 8, PDFViewervue_type_template_id_f75c7c7e_hoisted_2)])) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/player-components/PDFViewer.vue?vue&type=template&id=f75c7c7e

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/PDFViewer.vue?vue&type=script&lang=js

/* harmony default export */ var PDFViewervue_type_script_lang_js = ({
  name: 'PDFViewer',
  props: {
    asset: {
      type: Object,
      required: true
    },
    docreaderDomain: {
      type: String
    }
  },
  computed: {
    docReaderBaseURL: function docReaderBaseURL() {
      return "https://".concat(this.docreaderDomain, "/docreader/index.php?");
    },
    formattedSrc: function formattedSrc() {
      return "".concat(this.docReaderBaseURL).concat(this.formatUrlParams()).concat(encodeURIComponent(this.asset.clean_media_files[0].url));
    }
  },
  methods: {
    formatUrlParams: function formatUrlParams() {
      var defaultParams = 'jsmode=1&cid=brqmy&bp=sptol=0.3&glang=en&url=';
      return this.asset.is_downloadable ? defaultParams : "conf=adapted&".concat(defaultParams);
    }
  }
});
// CONCATENATED MODULE: ./src/components/player-components/PDFViewer.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/player-components/PDFViewer.vue





const PDFViewer_exports_ = /*#__PURE__*/exportHelper_default()(PDFViewervue_type_script_lang_js, [['render',PDFViewervue_type_template_id_f75c7c7e_render]])

/* harmony default export */ var PDFViewer = (PDFViewer_exports_);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/ReviewSheet.vue?vue&type=template&id=4b50ef7a



var ReviewSheetvue_type_template_id_4b50ef7a_hoisted_1 = {
  key: 0,
  class: "asset-player-content__review-sheet"
};
var ReviewSheetvue_type_template_id_4b50ef7a_hoisted_2 = {
  key: 0
};
var ReviewSheetvue_type_template_id_4b50ef7a_hoisted_3 = {
  key: 1
};
var ReviewSheetvue_type_template_id_4b50ef7a_hoisted_4 = {
  key: 2
};
var ReviewSheetvue_type_template_id_4b50ef7a_hoisted_5 = ["innerHTML"];
var ReviewSheetvue_type_template_id_4b50ef7a_hoisted_6 = ["innerHTML"];
function ReviewSheetvue_type_template_id_4b50ef7a_render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.asset ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", ReviewSheetvue_type_template_id_4b50ef7a_hoisted_1, [$props.asset.review_sheet_data.is_techbook_unit ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h3", ReviewSheetvue_type_template_id_4b50ef7a_hoisted_2, Object(external_vue_["toDisplayString"])(_ctx.$t('Unit Review')) + ": " + Object(external_vue_["toDisplayString"])($props.asset.title), 1)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("h3", ReviewSheetvue_type_template_id_4b50ef7a_hoisted_3, Object(external_vue_["toDisplayString"])(_ctx.$t('Concept Review')) + ": " + Object(external_vue_["toDisplayString"])($props.asset.title), 1)), $props.asset.review_sheet_data.unit_reviews ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", ReviewSheetvue_type_template_id_4b50ef7a_hoisted_4, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.asset.review_sheet_data.unit_reviews, function (review) {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
      key: review.title
    }, [Object(external_vue_["createElementVNode"])("h4", {
      innerHTML: review.title
    }, null, 8, ReviewSheetvue_type_template_id_4b50ef7a_hoisted_5), Object(external_vue_["createElementVNode"])("div", {
      innerHTML: review.description
    }, null, 8, ReviewSheetvue_type_template_id_4b50ef7a_hoisted_6)]);
  }), 128))])) : Object(external_vue_["createCommentVNode"])("", true)])) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/player-components/ReviewSheet.vue?vue&type=template&id=4b50ef7a

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/ReviewSheet.vue?vue&type=script&lang=js
/* harmony default export */ var ReviewSheetvue_type_script_lang_js = ({
  name: 'ReviewSheet',
  components: {},
  props: {
    asset: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/player-components/ReviewSheet.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/player-components/ReviewSheet.vue?vue&type=style&index=0&id=4b50ef7a&lang=stylus
var ReviewSheetvue_type_style_index_0_id_4b50ef7a_lang_stylus = __webpack_require__("7526");

// CONCATENATED MODULE: ./src/components/player-components/ReviewSheet.vue







const ReviewSheet_exports_ = /*#__PURE__*/exportHelper_default()(ReviewSheetvue_type_script_lang_js, [['render',ReviewSheetvue_type_template_id_4b50ef7a_render]])

/* harmony default export */ var ReviewSheet = (ReviewSheet_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/InteractiveViewer.vue?vue&type=template&id=002cf824

var InteractiveViewervue_type_template_id_002cf824_hoisted_1 = {
  class: "dad-asset-content dad-asset-content--interactive"
};
var InteractiveViewervue_type_template_id_002cf824_hoisted_2 = {
  class: "dad-asset-content__inner"
};
var InteractiveViewervue_type_template_id_002cf824_hoisted_3 = ["id"];
function InteractiveViewervue_type_template_id_002cf824_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", InteractiveViewervue_type_template_id_002cf824_hoisted_1, [Object(external_vue_["createElementVNode"])("div", InteractiveViewervue_type_template_id_002cf824_hoisted_2, [Object(external_vue_["createElementVNode"])("div", {
    id: "interactive-".concat($props.asset.id)
  }, null, 8, InteractiveViewervue_type_template_id_002cf824_hoisted_3)])]);
}
// CONCATENATED MODULE: ./src/components/player-components/InteractiveViewer.vue?vue&type=template&id=002cf824

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/InteractiveViewer.vue?vue&type=script&lang=js




/* global DEInteractivesClient */
/* harmony default export */ var InteractiveViewervue_type_script_lang_js = ({
  name: 'InteractiveViewer',
  props: {
    asset: {
      type: Object,
      required: true
    },
    windowPaths: {
      type: Object
    }
  },
  data: function data() {
    return {
      scriptsLoaded: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    var linkTag = document.createElement('link');
    linkTag.setAttribute('href', "".concat(this.windowPaths.core_static, "dist/cssmin/player/embedded-interactive.css"));
    linkTag.setAttribute('rel', 'stylesheet');
    linkTag.setAttribute('type', 'text/css');
    linkTag.setAttribute('id', 'interactives-styles');
    document.head.appendChild(linkTag);
    var scripts = ["".concat(this.windowPaths.core_static, "interactives/mathjax/MathJax.js?config=TeX-AMS-MML_HTMLorMML-full"), "".concat(this.windowPaths.core_static, "js/interactives/client/client.js"), "".concat(this.windowPaths.core_static, "interactives/math/common/js/api/interactives-api.js"), "".concat(this.windowPaths.core_static, "interactives/math/common/js/api/preloader.js")];
    scripts.forEach(function (script, i) {
      var tag = document.createElement('script');
      tag.setAttribute('id', "interactives-script-".concat(i + 1));
      tag.setAttribute('src', script);
      tag.addEventListener('load', _this.onLoaded);
      document.head.appendChild(tag);
    });
  },
  beforeUnmount: function beforeUnmount() {
    document.getElementById('interactives-styles').disabled = true;
    document.querySelectorAll('script[id^=interactives-script-]').forEach(function (elem) {
      return elem.remove();
    });
  },
  methods: {
    onLoaded: function onLoaded() {
      this.scriptsLoaded += 1;

      if (this.scriptsLoaded === 4) {
        var folderName = null;
        var htmlMediaFile = this.asset.media_files.find(function (mediaFile) {
          return mediaFile.format_id === 43;
        });

        if (htmlMediaFile) {
          folderName = htmlMediaFile.file_name || null;
        }

        DEInteractivesClient.init({
          basePath: this.asset.embedded_interactive_data.base_path,
          staticPath: this.windowPaths.edde_static
        });
        DEInteractivesClient.loadInteractive({
          bAllowAccessibility: true,
          callbackData: {
            interactiveGuid: this.asset.id
          },
          // callbacks
          success: function noop() {},
          error: function noop() {},
          complete: function noop() {},
          containerId: "interactive-".concat(this.asset.id),
          folderName: folderName,
          initialState: null,
          initialTabIndex: 10000,
          interactiveGuid: this.asset.id,
          lang: this.asset.language_code || 'eng',
          // 4=english, currently only english is supported
          bookId: 4,
          pageId: this.asset.id
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/player-components/InteractiveViewer.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/player-components/InteractiveViewer.vue





const InteractiveViewer_exports_ = /*#__PURE__*/exportHelper_default()(InteractiveViewervue_type_script_lang_js, [['render',InteractiveViewervue_type_template_id_002cf824_render]])

/* harmony default export */ var InteractiveViewer = (InteractiveViewer_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/IframeViewer.vue?vue&type=template&id=66fa21ca

var IframeViewervue_type_template_id_66fa21ca_hoisted_1 = {
  class: "embedded-player__container--iframe"
};
var IframeViewervue_type_template_id_66fa21ca_hoisted_2 = ["title", "src", "width", "height"];
var IframeViewervue_type_template_id_66fa21ca_hoisted_3 = ["title", "data-src", "src", "width", "height", "padding"];
function IframeViewervue_type_template_id_66fa21ca_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", IframeViewervue_type_template_id_66fa21ca_hoisted_1, [$props.asset.iframe_data.embed ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("embed", {
    key: 0,
    title: $props.asset.title,
    src: $props.asset.iframe_data.html_url,
    width: $props.asset.iframe_data.width,
    height: $props.asset.iframe_data.height
  }, null, 8, IframeViewervue_type_template_id_66fa21ca_hoisted_2)) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("iframe", {
    key: 1,
    title: $props.asset.title,
    allowfullscreen: "true",
    frameborder: "0",
    class: Object(external_vue_["normalizeClass"])($props.asset.type.id === $data.codingType && 'de-coding-app'),
    "data-src": $props.asset.type.id === $data.codingType && $props.asset.iframe_data.html5_url,
    src: $options.src,
    width: $options.width,
    height: $options.height,
    padding: $options.padding,
    referrerpolicy: "strict-origin-when-cross-origin"
  }, null, 10, IframeViewervue_type_template_id_66fa21ca_hoisted_3))]);
}
// CONCATENATED MODULE: ./src/components/player-components/IframeViewer.vue?vue&type=template&id=66fa21ca

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/IframeViewer.vue?vue&type=script&lang=js
/* harmony default export */ var IframeViewervue_type_script_lang_js = ({
  name: 'IframeViewer',
  props: {
    asset: {
      type: Object,
      required: true
    },
    codingUrl: {
      type: String
    }
  },
  data: function data() {
    return {
      codingType: '3a02114e-f812-4840-82de-ec9c68835e5d'
    };
  },
  mounted: function mounted() {
    if (this.asset.type.id === this.codingType) {
      var tag = document.createElement('script');
      tag.setAttribute('src', "".concat(this.codingUrl, "/app/dist/embed-global-hub.js"));
      document.head.appendChild(tag);
    }
  },
  computed: {
    src: function src() {
      if (this.asset.type.id === this.codingType) {
        return false;
      }

      if (this.asset.iframe_data.html5_url) {
        return this.asset.iframe_data.html5_url;
      }

      return this.asset.iframe_data.html_url;
    },
    width: function width() {
      if (this.asset.iframe_data.html5_url) {
        return this.asset.iframe_data.html5_width;
      }

      return this.asset.iframe_data.width;
    },
    height: function height() {
      if (this.asset.iframe_data.html5_url) {
        return this.asset.iframe_data.html5_height;
      }

      return this.asset.iframe_data.height;
    },
    padding: function padding() {
      if (this.asset.iframe_data.html5_url) {
        return this.asset.iframe_data.html5_padding;
      }

      return this.asset.iframe_data.padding;
    }
  }
});
// CONCATENATED MODULE: ./src/components/player-components/IframeViewer.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/player-components/IframeViewer.vue?vue&type=style&index=0&id=66fa21ca&lang=stylus
var IframeViewervue_type_style_index_0_id_66fa21ca_lang_stylus = __webpack_require__("5ac7");

// CONCATENATED MODULE: ./src/components/player-components/IframeViewer.vue







const IframeViewer_exports_ = /*#__PURE__*/exportHelper_default()(IframeViewervue_type_script_lang_js, [['render',IframeViewervue_type_template_id_66fa21ca_render]])

/* harmony default export */ var IframeViewer = (IframeViewer_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/OtherViewer.vue?vue&type=template&id=1df292fd

var OtherViewervue_type_template_id_1df292fd_hoisted_1 = {
  key: 0,
  class: "asset-player-content__other"
};
function OtherViewervue_type_template_id_1df292fd_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  return $props.asset ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", OtherViewervue_type_template_id_1df292fd_hoisted_1, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.asset.clean_media_files, function (mediaFile) {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
      key: mediaFile.id,
      link: mediaFile.url,
      size: "m",
      "icon-left": "download",
      text: _ctx.$t('Download')
    }, null, 8, ["link", "text"]);
  }), 128))])) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/player-components/OtherViewer.vue?vue&type=template&id=1df292fd

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/OtherViewer.vue?vue&type=script&lang=js

/* harmony default export */ var OtherViewervue_type_script_lang_js = ({
  name: 'OtherViewer',
  components: {
    NebulaButton: nebula_components_["NebulaButton"]
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/player-components/OtherViewer.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/player-components/OtherViewer.vue?vue&type=style&index=0&id=1df292fd&lang=stylus
var OtherViewervue_type_style_index_0_id_1df292fd_lang_stylus = __webpack_require__("92b4");

// CONCATENATED MODULE: ./src/components/player-components/OtherViewer.vue







const OtherViewer_exports_ = /*#__PURE__*/exportHelper_default()(OtherViewervue_type_script_lang_js, [['render',OtherViewervue_type_template_id_1df292fd_render]])

/* harmony default export */ var OtherViewer = (OtherViewer_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/ImageDetail.vue?vue&type=template&id=963f194a



function ImageDetailvue_type_template_id_963f194a_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaImage = Object(external_vue_["resolveComponent"])("NebulaImage");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaImage, {
    alt: $props.asset.description,
    contained: true,
    src: _ctx.imageUrl,
    style: Object(external_vue_["normalizeStyle"])($options.cssProps),
    class: "image-detail"
  }, null, 8, ["alt", "src", "style"]);
}
// CONCATENATED MODULE: ./src/components/player-components/ImageDetail.vue?vue&type=template&id=963f194a

// CONCATENATED MODULE: ./src/mixins/image-url.js


/* harmony default export */ var image_url = ({
  computed: {
    imageUrl: function imageUrl() {
      var img = '';

      if (this.asset.type.name === 'Clip Art') {
        img = this.asset.clean_media_files.find(function (mediaFile) {
          return mediaFile.format_id === 9;
        });

        if (img) {
          return img.url;
        }

        return this.asset.clean_media_files.find(function (mediaFile) {
          return mediaFile.format_id === 36;
        }).url;
      } // large image


      img = this.asset.clean_media_files.find(function (mediaFile) {
        return mediaFile.format_id === 38;
      });

      if (img) {
        return img.url;
      } // medium image


      img = this.asset.clean_media_files.find(function (mediaFile) {
        return mediaFile.format_id === 37;
      });

      if (img) {
        return img.url;
      } // small image


      img = this.asset.clean_media_files.find(function (mediaFile) {
        return mediaFile.format_id === 36;
      });

      if (img) {
        return img.url;
      }

      if (window.ga) {
        window.ga('send', 'event', 'assetdetailimagenotfound', this.asset.id);
      }

      return img;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/ImageDetail.vue?vue&type=script&lang=js


/* harmony default export */ var ImageDetailvue_type_script_lang_js = ({
  name: 'ImageDetail',
  components: {
    NebulaImage: nebula_components_["NebulaImage"]
  },
  mixins: [image_url],
  props: {
    asset: {
      type: Object,
      required: true
    },
    isInline: {
      type: Boolean
    }
  },
  emits: ['img-loaded'],
  computed: {
    cssProps: function cssProps() {
      if (this.isInline) {
        return '--nebula-image-aspect-ratio: 16/9';
      }

      return '';
    }
  }
});
// CONCATENATED MODULE: ./src/components/player-components/ImageDetail.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/player-components/ImageDetail.vue?vue&type=style&index=0&id=963f194a&lang=stylus
var ImageDetailvue_type_style_index_0_id_963f194a_lang_stylus = __webpack_require__("0d0c");

// CONCATENATED MODULE: ./src/components/player-components/ImageDetail.vue







const ImageDetail_exports_ = /*#__PURE__*/exportHelper_default()(ImageDetailvue_type_script_lang_js, [['render',ImageDetailvue_type_template_id_963f194a_render]])

/* harmony default export */ var ImageDetail = (ImageDetail_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/player-components/index.vue?vue&type=script&lang=js
















var AudioViewer = Object(external_vue_["defineAsyncComponent"])(function () {
  return Promise.all(/* import() | AudioViewer */[__webpack_require__.e(10), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "ffe6"));
});
/* harmony default export */ var player_componentsvue_type_script_lang_js = ({
  name: 'PlayerComponents',
  components: {
    AudioViewer: AudioViewer,
    ArticleViewer: ArticleViewer,
    PDFViewer: PDFViewer,
    ReviewSheet: ReviewSheet,
    InteractiveViewer: InteractiveViewer,
    IframeViewer: IframeViewer,
    OtherViewer: OtherViewer,
    ImageDetail: ImageDetail
  },
  props: {
    asset: {
      type: Object,
      required: false
    },
    assetId: {
      type: String,
      required: false
    },
    template: {
      type: String,
      required: false
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    baseURL: {
      type: String,
      required: false
    },
    windowPaths: {
      type: Object
    },
    codingUrl: {
      type: String
    },
    // custom caption for CIT content
    caption: {
      type: String
    },
    isInline: {
      type: Boolean
    },
    isPreviewModal: {
      type: Boolean,
      required: false,
      default: false
    },
    docreaderDomain: {
      type: String,
      default: 'docreader-na.readspeaker.com'
    }
  },
  emits: ['audio:audioprocess', 'img-loaded'],
  data: function data() {
    return {
      assetData: null,
      resolvedDocreaderDomain: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.asset) {
      axios_default.a.get("/player/".concat(this.assetId), {
        baseURL: '/learn',
        headers: {
          'X-Requested-with': 'XMLHttpRequest'
        }
      }).then(function (response) {
        if (response.data.page_data) {
          _this.assetData = response.data.page_data.asset;

          if (response.data.page_data.docreader_domain) {
            _this.resolvedDocreaderDomain = response.data.page_data.docreader_domain;
          }

          _this.clicklog();
        } else {
          // it either errored or redirected, so just redirect the page
          window.location.href = "/learn/player/".concat(_this.assetId);
        }
      });
    } else {
      this.assetData = this.asset;
      this.clicklog();
    }
  },
  methods: {
    clicklog: function clicklog() {
      var payload = {
        asset_guids: this.assetData.id,
        access_type: 1
      };
      var formData = new FormData();
      Object.keys(payload).forEach(function (key) {
        return formData.append(key, payload[key]);
      });
      axios_default.a.post('/clicklog', formData, {
        baseURL: this.baseURL || '/apiproxy/v1',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/player-components/index.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/player-components/index.vue





const player_components_exports_ = /*#__PURE__*/exportHelper_default()(player_componentsvue_type_script_lang_js, [['render',player_componentsvue_type_template_id_6ddc1384_render]])

/* harmony default export */ var player_components = (player_components_exports_);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/SearchBox.vue?vue&type=template&id=0529b166







var SearchBoxvue_type_template_id_0529b166_hoisted_1 = ["aria-hidden"];
var SearchBoxvue_type_template_id_0529b166_hoisted_2 = ["name", "value"];
var SearchBoxvue_type_template_id_0529b166_hoisted_3 = ["value"];
var SearchBoxvue_type_template_id_0529b166_hoisted_4 = {
  id: "nebula-product-bar__search-label",
  for: "nebula-product-bar__search-input",
  class: "nebula-screenreader-only"
};
var SearchBoxvue_type_template_id_0529b166_hoisted_5 = ["placeholder", "aria-label", "aria-description", "aria-activedescendant"];
var SearchBoxvue_type_template_id_0529b166_hoisted_6 = {
  class: "comet-product-bar__search-asset-type"
};
var SearchBoxvue_type_template_id_0529b166_hoisted_7 = ["innerHTML"];
var SearchBoxvue_type_template_id_0529b166_hoisted_8 = {
  class: "comet-button comet-button--medium comet-button--icon-only comet-product-bar__search-button global-nav-ga-event",
  type: "submit",
  "data-gac": "Link",
  "data-gaa": "Click",
  "data-gal": "Search|Icon"
};
var SearchBoxvue_type_template_id_0529b166_hoisted_9 = {
  class: "comet-screenreader-only"
};
var SearchBoxvue_type_template_id_0529b166_hoisted_10 = ["aria-hidden"];
var SearchBoxvue_type_template_id_0529b166_hoisted_11 = {
  class: "comet-screenreader-only"
};
function SearchBoxvue_type_template_id_0529b166_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  var _component_NebulaListboxItem = Object(external_vue_["resolveComponent"])("NebulaListboxItem");

  var _component_NebulaCombobox = Object(external_vue_["resolveComponent"])("NebulaCombobox");

  var _component_NebulaIcon = Object(external_vue_["resolveComponent"])("NebulaIcon");

  var _component_NebulaListItem = Object(external_vue_["resolveComponent"])("NebulaListItem");

  var _component_NebulaListGroup = Object(external_vue_["resolveComponent"])("NebulaListGroup");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("form", {
    class: Object(external_vue_["normalizeClass"])(["comet-product-bar__search-box-wrapper comet-product-bar__search-box-wrapper-dex", {
      'comet-product-bar__search-box-wrapper-dex--visible': $props.isSearchOpen,
      'do-form-submit': $props.usePushState
    }]),
    action: "/learn/search",
    role: "combobox",
    "aria-hidden": !$props.isSearchOpen,
    ref: "searchForm"
  }, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.filteredAdditonalParams, function (param, index) {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("input", {
      key: index,
      type: "hidden",
      name: param.name,
      value: param.value
    }, null, 8, SearchBoxvue_type_template_id_0529b166_hoisted_2);
  }), 128)), $data.selectedType && $data.selectedType.value !== '' ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("input", {
    key: 0,
    type: "hidden",
    name: "group",
    value: $data.selectedType.value
  }, null, 8, SearchBoxvue_type_template_id_0529b166_hoisted_3)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("label", SearchBoxvue_type_template_id_0529b166_hoisted_4, Object(external_vue_["toDisplayString"])(_ctx.$t("enter term to search for")), 1), Object(external_vue_["withDirectives"])(Object(external_vue_["createElementVNode"])("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.inputValue = $event;
    }),
    id: "comet-product-bar__search-input",
    class: "comet-form__input comet-product-bar__search-input",
    type: "text",
    placeholder: _ctx.$t('Search'),
    autocomplete: "off",
    haspopup: "true",
    name: "q",
    role: "searchbox",
    "aria-haspopup": "listbox",
    "aria-autocomplete": "list",
    "aria-label": _ctx.$t('Search'),
    "aria-description": _ctx.$t('Search the Discovery Education asset library'),
    "aria-activedescendant": $data.currentSuggestion && $data.currentSuggestion,
    ref: "searchInputEl",
    onKeydown: _cache[1] || (_cache[1] = function () {
      return $options.suggestionsListKeyDownEvents && $options.suggestionsListKeyDownEvents.apply($options, arguments);
    })
  }, null, 40, SearchBoxvue_type_template_id_0529b166_hoisted_5), [[external_vue_["vModelText"], $data.inputValue]]), Object(external_vue_["createElementVNode"])("div", SearchBoxvue_type_template_id_0529b166_hoisted_6, [Object(external_vue_["createElementVNode"])("label", {
    class: "nebula-screenreader-only",
    id: "search-asset-type-label",
    innerHTML: _ctx.$t('Select Asset Type')
  }, null, 8, SearchBoxvue_type_template_id_0529b166_hoisted_7), $data.selectedType ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaCombobox, {
    key: 0,
    buttonId: "search-asset-type-button",
    ref: "searchAssetTypeCombo"
  }, {
    trigger: Object(external_vue_["withCtx"])(function (_ref) {
      var toggleDropdown = _ref.toggleDropdown,
          checkArrowKeyOnTrigger = _ref.checkArrowKeyOnTrigger,
          checkArrowKeyAfterTrigger = _ref.checkArrowKeyAfterTrigger,
          isOpen = _ref.isOpen;
      return [Object(external_vue_["createVNode"])(_component_NebulaButton, {
        class: "comet-product-bar__all-results-button",
        iconRight: "caret-down",
        id: "search-asset-type-button",
        shape: "square",
        size: "s",
        text: $data.selectedType.text,
        type: "ghost",
        "aria-activedescendant": "search-asset-type-item-".concat($props.suggestionTypes.indexOf($data.focusedType)),
        "aria-controls": "search-asset-type-dropdown",
        "aria-expanded": isOpen && 'true' || 'false',
        "aria-haspopup": "listbox",
        "aria-labelledby": "search-asset-type-label",
        role: "combobox",
        onClick: toggleDropdown,
        onKeydown: checkArrowKeyOnTrigger,
        onKeyup: checkArrowKeyAfterTrigger
      }, null, 8, ["text", "aria-activedescendant", "aria-expanded", "onClick", "onKeydown", "onKeyup"])];
    }),
    content: Object(external_vue_["withCtx"])(function () {
      return [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($props.suggestionTypes, function (type, index) {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListboxItem, {
          text: type.text,
          key: index,
          id: "search-asset-type-item-".concat(index),
          selected: $data.selectedType === type,
          onListboxItemClicked: function onListboxItemClicked($event) {
            return $options.setSelectedAssetType(type);
          },
          onListboxItemFocused: function onListboxItemFocused($event) {
            return $options.setFocusedAssetType(type);
          }
        }, null, 8, ["text", "id", "selected", "onListboxItemClicked", "onListboxItemFocused"]);
      }), 128))];
    }),
    _: 1
  }, 512)) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("button", SearchBoxvue_type_template_id_0529b166_hoisted_8, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    symbolId: "arrow-right",
    class: "comet-button__icon comet-button__icon--left",
    size: "m"
  }), Object(external_vue_["createElementVNode"])("span", SearchBoxvue_type_template_id_0529b166_hoisted_9, Object(external_vue_["toDisplayString"])(_ctx.$t("Search")), 1)]), Object(external_vue_["createElementVNode"])("button", {
    class: Object(external_vue_["normalizeClass"])(["comet-button comet-button--medium comet-button--icon-only comet-product-bar__search-button-microphone", {
      'comet-product-bar__search-button-microphone--recording': $data.isRecognizingAudioInput,
      'comet-product-bar__search-button-microphone--available': $options.hasSpeechRecognition
    }]),
    "aria-hidden": !$options.hasSpeechRecognition,
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.captureAudioInput && $options.captureAudioInput.apply($options, arguments);
    }),
    type: "button"
  }, [Object(external_vue_["createVNode"])(_component_NebulaIcon, {
    symbolId: "microphone",
    class: "comet-product-bar__action-icon",
    size: "m"
  }), Object(external_vue_["createElementVNode"])("span", SearchBoxvue_type_template_id_0529b166_hoisted_11, Object(external_vue_["toDisplayString"])(_ctx.$t("Search by voice")), 1)], 10, SearchBoxvue_type_template_id_0529b166_hoisted_10), Object(external_vue_["createElementVNode"])("div", {
    class: Object(external_vue_["normalizeClass"])(["comet-product-bar__search-box-autocomplete", $data.suggestions && $data.suggestions.length >= 1 ? 'comet-product-bar__search-box-autocomplete--open' : '']),
    id: "search-autosuggest",
    "data-comet-popover-align": "left",
    "aria-hidden": "false",
    ref: "suggestionsList"
  }, [$data.inputValue.length ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListGroup, {
    key: 0,
    onKeydown: $options.suggestionsListKeyDownEvents,
    "aria-labelledby": "nebula-product-bar__search-label",
    class: "suggestions-list nebula-product-bar__suggestions-list",
    id: "nebula-product-bar__suggestions-list",
    nested: "",
    role: "listbox"
  }, {
    content: Object(external_vue_["withCtx"])(function () {
      return [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($data.suggestions, function (suggestion, index) {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
          itemId: "search-suggest-".concat(suggestion.text.toLowerCase().replace(' ', '-')),
          link: "/learn/search?q=".concat(suggestion.text),
          text: suggestion.text,
          key: index
        }, null, 8, ["itemId", "link", "text"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["onKeydown"])) : Object(external_vue_["createCommentVNode"])("", true), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($data.suggestionGroups, function (suggestionGroup, index) {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListGroup, {
      onKeydown: $options.suggestionsListKeyDownEvents,
      header: _ctx.$t('Curriculum Packs'),
      "aria-labelledby": "nebula-product-bar__search-label",
      class: "suggestions-list nebula-product-bar__suggestions-list nebula-product-bar__suggestions-list--curriculum-packs",
      id: "nebula-product-bar__curriculum-packs-list",
      key: index,
      nested: "",
      role: "listbox"
    }, {
      content: Object(external_vue_["withCtx"])(function () {
        return [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])(suggestionGroup.values, function (suggestion, suggestionIndex) {
          return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaListItem, {
            icon: $options.hasIcons[suggestion.text] && $options.hasIcons[suggestion.text].icon,
            iconSize: "s",
            itemId: "search-suggest-".concat($options.hasIcons[suggestion.text] && $options.hasIcons[suggestion.text].display.replace(' ', '-')),
            liClass: "nebula-list-item--".concat($options.hasIcons[suggestion.text] && $options.hasIcons[suggestion.text].icon),
            link: suggestion.href,
            text: $options.hasIcons[suggestion.text] && $options.hasIcons[suggestion.text].display,
            key: suggestionIndex
          }, null, 8, ["icon", "itemId", "liClass", "link", "text"]);
        }), 128))];
      }),
      _: 2
    }, 1032, ["onKeydown", "header"]);
  }), 128))], 2)], 10, SearchBoxvue_type_template_id_0529b166_hoisted_1);
}
// CONCATENATED MODULE: ./src/components/SearchBox.vue?vue&type=template&id=0529b166

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("1da1");

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// CONCATENATED MODULE: ./src/utils/api/searchApi.js



/* eslint-disable import/prefer-default-export */

function getSearchSuggestions(term) {
  var params = term.replace(' ', '+');
  var url = "/apiproxy/v1/search/suggest?text=".concat(params);
  var resp = axios_default.a.get(url).then(function (response) {
    return response.data;
  }).catch(function (err) {
    return err;
  });
  return resp;
}
/* eslint-enable import/prefer-default-export */
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/SearchBox.vue?vue&type=script&lang=js










/* harmony default export */ var SearchBoxvue_type_script_lang_js = ({
  name: 'SearchBox',
  data: function data() {
    return {
      inputValue: this.query || '',
      suggestions: [],
      suggestionGroups: [],
      currentSuggestion: null,
      isRecognizingAudioInput: false,
      recognitionTimeout: null,
      selectedType: this.suggestionTypes && this.suggestionTypes[0],
      focusedType: null
    };
  },
  components: {
    NebulaButton: nebula_components_["NebulaButton"],
    NebulaCombobox: nebula_components_["NebulaCombobox"],
    NebulaIcon: nebula_components_["NebulaIcon"],
    NebulaListboxItem: nebula_components_["NebulaListboxItem"],
    NebulaListGroup: nebula_components_["NebulaListGroup"],
    NebulaListItem: nebula_components_["NebulaListItem"]
  },
  props: {
    action: {
      required: false,
      type: String
    },
    additonalParams: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isSearchOpen: {
      default: false,
      type: Boolean
    },
    query: {
      required: false,
      type: String
    },
    suggestionTypes: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    usePushState: {
      default: false,
      type: Boolean
    }
  },
  mounted: function mounted() {
    var _this = this;

    // if additional param contains group, set the type select
    var inititalSelected = this.additonalParams.find(function (obj) {
      return obj.name === 'group';
    });

    if (inititalSelected) {
      this.selectedType = this.suggestionTypes.find(function (type) {
        return type.value === inititalSelected.value;
      });
    }

    if (this.hasSpeechRecognition) {
      /* eslint-disable-next-line new-cap, no-undef */
      this.recognition = new webkitSpeechRecognition();
      this.recognition.continuous = true;
      this.recognition.interimResults = true;
      this.recognition.onstart = this.onRecognizeStart;

      this.recognition.onend = function () {
        _this.isRecognizingAudioInput = false;
      };

      this.recognition.onresult = this.onRecognize;
    }
  },
  methods: {
    getSearchSuggestions: getSearchSuggestions,
    suggestionsListKeyDownEvents: function suggestionsListKeyDownEvents(e) {
      if (this.suggestions) {
        this.keyCodeEvents(e); // tab key, close if exiting menu

        if (e.keyCode === 9) {
          var focusable = this.getFocusable();
          var index = Array.prototype.indexOf.call(focusable, document.activeElement);

          if (e.shiftKey) {
            if (index === 0) {
              this.suggestionGroups = [];
              this.suggestions = [];
            }
          } else if (index === focusable.length - 1) {
            this.suggestionGroups = [];
            this.suggestions = [];
          } else {
            var suggestionTextEl = focusable[index];

            if (suggestionTextEl) {
              var suggestionText = suggestionTextEl.getElementsByClassName('nebula-list-item__text')[0].innerText;
              var suggestionId = focusable[index].id;
              this.$refs.searchInputEl.setAttribute('aria-activedescendant', suggestionId);
              this.$refs.searchInputEl.value = suggestionText;
            }
          }
        }
      }
    },
    keyCodeEvents: function keyCodeEvents(e) {
      // escape key
      if (e.keyCode === 27) {
        this.suggestionGroups = [];
        this.suggestions = [];
      } // up arrow pressed


      if (e.keyCode === 38) {
        e.preventDefault();
        this.selectNextUp(e); // down arrow pressed
      } else if (e.keyCode === 40) {
        e.preventDefault();
        this.selectNextDown(e);
      }
    },
    selectNextUp: function selectNextUp() {
      var focusable = this.getFocusable();
      var index = Array.prototype.indexOf.call(focusable, document.activeElement);

      if (index > 0) {
        var suggestionTextEl = focusable[index - 1];

        if (suggestionTextEl) {
          var suggestionText = suggestionTextEl.getElementsByClassName('nebula-list-item__text')[0].innerText;
          var suggestionId = focusable[index - 1].id;
          this.$refs.searchInputEl.setAttribute('aria-activedescendant', suggestionId);
          this.$refs.searchInputEl.value = suggestionText;
          focusable[index - 1].focus();
        }
      } else {
        focusable[focusable.length - 1].focus();
      }
    },
    selectNextDown: function selectNextDown() {
      var focusable = this.getFocusable();
      var index = Array.prototype.indexOf.call(focusable, document.activeElement);

      if (index < focusable.length - 1) {
        var suggestionTextEl = focusable[index + 1];

        if (suggestionTextEl) {
          var suggestionText = suggestionTextEl.getElementsByClassName('nebula-list-item__text')[0].innerText;
          var suggestionId = focusable[index + 1].id;
          this.$refs.searchInputEl.setAttribute('aria-activedescendant', suggestionId);
          this.$refs.searchInputEl.value = suggestionText;
          focusable[index + 1].focus();
        }
      } else {
        focusable[0].focus();
      }
    },
    getFocusable: function getFocusable() {
      /* eslint-disable max-len */
      return this.$refs.suggestionsList ? this.$refs.suggestionsList.querySelectorAll('button:not([tabindex="-1"]), [href]:not([tabindex="-1"])') : null;
      /* eslint-enable max-len */
    },
    updateSelectedSuggest: function updateSelectedSuggest(e) {
      this.currentSuggestion = e.currentTarget.getAttribute('id');
    },
    setSelectedAssetType: function setSelectedAssetType(type) {
      this.selectedType = type;
      this.$refs.searchAssetTypeCombo.closeDropdown();
    },
    setFocusedAssetType: function setFocusedAssetType(type) {
      this.focusedType = type;
    },
    captureAudioInput: function captureAudioInput() {
      if (this.isRecognizingAudioInput) {
        this.recognition.stop();
      } else {
        this.recognition.start();
      }
    },
    onRecognizeStart: function onRecognizeStart() {
      var _this2 = this;

      // give user 8 seconds to say what they want to search for
      if (this.recognitionTimeout) {
        clearTimeout(this.recognitionTimeout);
      }

      this.recognitionTimeout = setTimeout(function () {
        if (_this2.isRecognizingAudioInput) {
          _this2.recognition.stop();
        }
      }, 8000);
      this.isRecognizingAudioInput = true;
    },
    onRecognize: function onRecognize(event) {
      var _this3 = this;

      Object.keys(event.results).forEach(function (key) {
        if (event.results[key].isFinal) {
          _this3.$refs.searchInputEl.value = event.results[key][0].transcript;

          _this3.recognition.stop();

          _this3.$refs.searchForm.submit();
        }
      });
    },
    urlForSuggestion: function urlForSuggestion(suggestion) {
      var suggestionUrl = "/learn/search?q=".concat(encodeURIComponent(suggestion));

      if (this.selectedType.value) {
        suggestionUrl += "&group=".concat(this.selectedType.value);
      }

      return suggestionUrl;
    }
  },
  computed: {
    hasSpeechRecognition: function hasSpeechRecognition() {
      return 'webkitSpeechRecognition' in window;
    },
    filteredAdditonalParams: function filteredAdditonalParams() {
      // filter out group filter, if it was passed in
      // it will be set on the type select in mounted
      return this.additonalParams.filter(function (obj) {
        return obj.name !== 'group';
      });
    },
    hasIcons: function hasIcons() {
      return {
        'Science Middle School': {
          display: 'Science Middle School',
          icon: 'science-flask'
        },
        'Science Elementary': {
          display: 'Science Elementary',
          icon: 'science-flask'
        },
        'Science Course': {
          display: 'Science Techbook',
          icon: 'science-flask'
        },
        'Science Techbook': {
          display: 'Science Techbook',
          icon: 'science-flask'
        },
        'Health and Relationships': {
          display: 'Health and Relationships',
          icon: 'health'
        },
        'Math Techbook': {
          display: 'Math Techbook',
          icon: 'math'
        },
        'STEM Connect': {
          display: 'STEM Connect',
          icon: 'stem-connect'
        },
        'Social Studies Techbook': {
          display: 'Social Studies Techbook',
          icon: 'social-studies'
        },
        'Mystery Science': {
          display: 'Mystery Science',
          icon: 'mysteryscience'
        },
        Coding: {
          display: 'Coding',
          icon: 'coding'
        },
        Pathway: {
          display: 'Pathway',
          icon: 'pathway'
        },
        Espresso: {
          display: 'Espresso',
          icon: 'espresso'
        },
        Health: {
          display: 'Health',
          icon: 'health'
        }
      };
    }
  },
  watch: {
    inputValue: function inputValue(newInput, oldInput) {
      var _this4 = this;

      return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.suggestionGroups = [];
                _this4.suggestions = [];

                if (!(newInput !== oldInput && newInput.length > 2)) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 3;
                _context.next = 6;
                return _this4.getSearchSuggestions(newInput);

              case 6:
                response = _context.sent;

                if (response) {
                  _this4.suggestions = response.data;
                  _this4.suggestionGroups = response.user_suggestions;
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                // To-Do, handle errors in this api call.

                /* eslint-disable no-console */
                console.log('Search Suggestion failed with status:', _context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }))();
    },
    isSearchOpen: function isSearchOpen(isOpen) {
      var _this5 = this;

      if (isOpen) {
        this.$nextTick(function () {
          _this5.$refs.searchInputEl.focus();
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/SearchBox.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/SearchBox.vue?vue&type=style&index=0&id=0529b166&lang=stylus
var SearchBoxvue_type_style_index_0_id_0529b166_lang_stylus = __webpack_require__("82a6");

// CONCATENATED MODULE: ./src/components/SearchBox.vue







const SearchBox_exports_ = /*#__PURE__*/exportHelper_default()(SearchBoxvue_type_script_lang_js, [['render',SearchBoxvue_type_template_id_0529b166_render]])

/* harmony default export */ var SearchBox = (SearchBox_exports_);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ChannelCardCarousel.vue?vue&type=template&id=47f29a98


var ChannelCardCarouselvue_type_template_id_47f29a98_hoisted_1 = {
  class: "nebula-card-row"
};

var ChannelCardCarouselvue_type_template_id_47f29a98_hoisted_2 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("li", {
  class: "nebula-card nebula-card--invisible"
}, null, -1);

var ChannelCardCarouselvue_type_template_id_47f29a98_hoisted_3 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("li", {
  class: "nebula-card nebula-card--invisible"
}, null, -1);

var ChannelCardCarouselvue_type_template_id_47f29a98_hoisted_4 = /*#__PURE__*/Object(external_vue_["createElementVNode"])("li", {
  class: "nebula-card nebula-card--invisible"
}, null, -1);

function ChannelCardCarouselvue_type_template_id_47f29a98_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ActionMenu = Object(external_vue_["resolveComponent"])("ActionMenu");

  var _component_NebulaCardCarousel = Object(external_vue_["resolveComponent"])("NebulaCardCarousel");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    style: Object(external_vue_["normalizeStyle"])($options.cssVars)
  }, [Object(external_vue_["createVNode"])(_component_NebulaCardCarousel, {
    carouselName: "channel",
    ref: "channelCarousel",
    adjustHeight: 34,
    breakpoints: $options.carouselBreakpoints,
    extraTrackingData: {
      carouselTitle: $props.title
    }
  }, {
    default: Object(external_vue_["withCtx"])(function () {
      return [Object(external_vue_["createElementVNode"])("ul", ChannelCardCarouselvue_type_template_id_47f29a98_hoisted_1, [(Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.appendTagsForCardMetadata($props.assets), function (asset, index) {
        return Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(Object(external_vue_["resolveDynamicComponent"])(asset.type_name === 'Channel' ? 'NebulaChannelCard' : 'NebulaAssetCard'), {
          class: "nebula-card-carousel__list-item nebula-card",
          key: asset.id,
          asset: asset,
          assetType: asset.type_name,
          cardProps: {
            userGenContent: $options.isUserGeneratedContent(asset)
          },
          cardIds: $props.assets.map(function (asset) {
            return asset.id;
          }),
          clickTrackSegment: "true",
          embed: $props.embed,
          showEmbedButton: $props.embed,
          segmentTrackingData: {
            carouselTitle: $props.title,
            position: index + 1
          }
        }, Object(external_vue_["createSlots"])({
          _: 2
        }, [$props.showActions ? {
          name: "actionsMenu",
          fn: Object(external_vue_["withCtx"])(function () {
            return [Object(external_vue_["createVNode"])(_component_ActionMenu, {
              asset: asset,
              quicklistIds: $props.quicklistIds,
              showCreateWithStudio: $props.showCreateWithStudio,
              subscribedChannelIds: $props.subscribedChannelIds,
              userIsStudent: $props.userIsStudent
            }, null, 8, ["asset", "quicklistIds", "showCreateWithStudio", "subscribedChannelIds", "userIsStudent"])];
          }),
          key: "0"
        } : undefined]), 1032, ["asset", "assetType", "cardProps", "cardIds", "embed", "showEmbedButton", "segmentTrackingData"]);
      }), 128)), ChannelCardCarouselvue_type_template_id_47f29a98_hoisted_2, ChannelCardCarouselvue_type_template_id_47f29a98_hoisted_3, ChannelCardCarouselvue_type_template_id_47f29a98_hoisted_4])];
    }),
    _: 1
  }, 8, ["breakpoints", "extraTrackingData"])], 4);
}
// CONCATENATED MODULE: ./src/components/ChannelCardCarousel.vue?vue&type=template&id=47f29a98

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("2909");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/ChannelCardCarousel.vue?vue&type=script&lang=js







/* harmony default export */ var ChannelCardCarouselvue_type_script_lang_js = ({
  name: 'ChannelCardCarousel',
  components: {
    NebulaCardCarousel: nebula_components_["NebulaCardCarousel"],
    NebulaAssetCard: nebula_components_["NebulaAssetCard"],
    NebulaChannelCard: nebula_components_["NebulaChannelCard"],
    ActionMenu: ActionMenu
  },
  props: {
    assets: {
      type: Object,
      required: true
    },
    embed: {
      type: Boolean,
      default: false
    },
    quicklistIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showActions: {
      type: Boolean,
      default: true
    },
    showCreateWithStudio: {
      type: Boolean,
      default: false
    },
    subscribedChannelIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    },
    userIsStudent: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    carouselBreakpoints: function carouselBreakpoints() {
      return [{
        bleed: 16,
        minWidth: 800,
        name: 'tabletLandscape',
        showFades: false
      }, {
        bleed: 16,
        minWidth: 500,
        name: 'tabletPortrait',
        showFades: false
      }, {
        bleed: 16,
        minWidth: 0,
        name: 'mobile',
        showFades: false
      }];
    },
    cssVars: function cssVars() {
      return {
        '--z-index': this.zIndex
      };
    }
  },
  methods: {
    hasTags: function hasTags(asset) {
      var _asset$tags;

      return ((_asset$tags = asset.tags) === null || _asset$tags === void 0 ? void 0 : _asset$tags.length) > 0;
    },
    appendTagsForCardMetadata: function appendTagsForCardMetadata(assets) {
      var _this = this;

      return assets.map(function (asset) {
        // Note: We want to exclude 'User Generated Content' tags because we have a special card variation for this.
        if (_this.hasTags(asset) && !_this.isUserGeneratedContent(asset)) {
          var _asset$info_pills;

          var metadata = asset.tags.filter(function (tag) {
            return tag.type.name === 'Promotion';
          });

          (_asset$info_pills = asset.info_pills).push.apply(_asset$info_pills, Object(toConsumableArray["a" /* default */])(metadata));
        }

        return asset;
      });
    },
    isUserGeneratedContent: function isUserGeneratedContent(asset) {
      return this.hasTags(asset) && asset.tags.filter(function (tag) {
        return tag.name === 'User Generated Content';
      }).length > 0;
    }
  }
});
// CONCATENATED MODULE: ./src/components/ChannelCardCarousel.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/ChannelCardCarousel.vue?vue&type=style&index=0&id=47f29a98&lang=stylus
var ChannelCardCarouselvue_type_style_index_0_id_47f29a98_lang_stylus = __webpack_require__("af54");

// CONCATENATED MODULE: ./src/components/ChannelCardCarousel.vue







const ChannelCardCarousel_exports_ = /*#__PURE__*/exportHelper_default()(ChannelCardCarouselvue_type_script_lang_js, [['render',ChannelCardCarouselvue_type_template_id_47f29a98_render]])

/* harmony default export */ var ChannelCardCarousel = (ChannelCardCarousel_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/modals/StaySignedInModal.vue?vue&type=template&id=8c6ff5e4

var StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_1 = {
  class: "ssi-header"
};
var StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_2 = {
  class: "ssi-content"
};
var StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_3 = ["src", "alt"];
var StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_4 = {
  class: "ssi-content__text"
};
var StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_5 = {
  class: "ssi-actions"
};
function StaySignedInModalvue_type_template_id_8c6ff5e4_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  var _component_NebulaModal = Object(external_vue_["resolveComponent"])("NebulaModal");

  return $data.showModal ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaModal, {
    key: 0,
    id: "stay-signed-in-modal",
    size: "m",
    showHeader: "",
    class: "ssi-modal",
    hideCloseButton: "",
    firstFocusedElement: "ssi-primary-btn"
  }, {
    header: Object(external_vue_["withCtx"])(function () {
      return [Object(external_vue_["createElementVNode"])("h1", StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_1, Object(external_vue_["toDisplayString"])($props.headerText), 1)];
    }),
    content: Object(external_vue_["withCtx"])(function () {
      return [Object(external_vue_["createElementVNode"])("section", StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_2, [$props.avatarImgUrl ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
        key: 0,
        class: "ssi-content__img",
        src: $props.avatarImgUrl,
        alt: $props.avatarImgAlt
      }, null, 8, StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_3)) : Object(external_vue_["createCommentVNode"])("", true), Object(external_vue_["createElementVNode"])("p", StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_4, Object(external_vue_["toDisplayString"])($props.messageText), 1)])];
    }),
    actionsRow: Object(external_vue_["withCtx"])(function () {
      return [Object(external_vue_["createElementVNode"])("section", StaySignedInModalvue_type_template_id_8c6ff5e4_hoisted_5, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
        id: "ssi-primary-btn",
        onClick: $options.primaryAction,
        class: "ssi-actions__button ssi-actions__button--yes",
        shape: "square",
        size: "m",
        type: "fill",
        text: $props.primaryBtnLabel
      }, null, 8, ["onClick", "text"]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
        onClick: $options.secondaryAction,
        class: "ssi-actions__button",
        shape: "square",
        size: "m",
        type: "ghost",
        text: $props.secondaryBtnLabel
      }, null, 8, ["onClick", "text"])])];
    }),
    _: 1
  })) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/modals/StaySignedInModal.vue?vue&type=template&id=8c6ff5e4

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/modals/StaySignedInModal.vue?vue&type=script&lang=js

/* harmony default export */ var StaySignedInModalvue_type_script_lang_js = ({
  name: 'StaySignedInModal',
  components: {
    NebulaModal: nebula_components_["NebulaModal"],
    NebulaButton: nebula_components_["NebulaButton"]
  },
  data: function data() {
    return {
      showModal: false
    };
  },
  props: {
    avatarImgAlt: {
      type: String
    },
    avatarImgUrl: {
      required: false,
      type: String
    },
    nextUrl: {
      default: '/suite',
      required: true,
      type: String
    },
    headerText: {
      type: String
    },
    messageText: {
      type: String
    },
    primaryBtnLabel: {
      type: String
    },
    secondaryBtnLabel: {
      type: String
    }
  },
  emits: ['close-modal', 'primaryAction', 'secondaryAction'],
  created: function created() {
    this.showModal = true;
  },
  methods: {
    primaryAction: function primaryAction() {
      this.$emit('primaryAction');
    },
    secondaryAction: function secondaryAction() {
      this.$emit('secondaryAction');
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.$emit('close-modal');
    }
  }
});
// CONCATENATED MODULE: ./src/components/modals/StaySignedInModal.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/modals/StaySignedInModal.vue?vue&type=style&index=0&id=8c6ff5e4&lang=stylus
var StaySignedInModalvue_type_style_index_0_id_8c6ff5e4_lang_stylus = __webpack_require__("f838");

// CONCATENATED MODULE: ./src/components/modals/StaySignedInModal.vue







const StaySignedInModal_exports_ = /*#__PURE__*/exportHelper_default()(StaySignedInModalvue_type_script_lang_js, [['render',StaySignedInModalvue_type_template_id_8c6ff5e4_render]])

/* harmony default export */ var StaySignedInModal = (StaySignedInModal_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/modals/SSOStaySignedInModal.vue?vue&type=template&id=18caa4ad

var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_1 = {
  class: "ssi-content"
};
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_2 = ["src", "alt"];
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_3 = {
  key: 1
};
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_4 = {
  class: "ssi-content__header-text"
};
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_5 = {
  class: "ssi-content__par-text"
};
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_6 = {
  class: "ssi-content__focal-text"
};
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_7 = {
  key: 2
};
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_8 = {
  class: "ssi-content__par-text"
};
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_9 = {
  class: "ssi-actions"
};
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_10 = ["action"];
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_11 = ["value"];
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_12 = ["value"];
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_13 = ["value"];
var SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_14 = {
  key: 0,
  class: "ssi-state"
};
function SSOStaySignedInModalvue_type_template_id_18caa4ad_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  var _component_NebulaCheckbox = Object(external_vue_["resolveComponent"])("NebulaCheckbox");

  var _component_NebulaModal = Object(external_vue_["resolveComponent"])("NebulaModal");

  return $data.showModal ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaModal, {
    key: 0,
    id: "sso-stay-signed-in-modal",
    size: "m",
    class: "sso-ssi-modal",
    hideCloseButton: "",
    firstFocusedElement: "ssi-primary-btn"
  }, {
    content: Object(external_vue_["withCtx"])(function () {
      return [Object(external_vue_["createElementVNode"])("section", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_1, [$props.imgUrl ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("img", {
        key: 0,
        class: "ssi-content__img",
        src: $props.imgUrl,
        alt: $props.imgAlt
      }, null, 8, SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_2)) : Object(external_vue_["createCommentVNode"])("", true), !$data.isSessionExpired ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_3, [Object(external_vue_["createElementVNode"])("h1", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_4, Object(external_vue_["toDisplayString"])($props.headerText), 1), Object(external_vue_["createElementVNode"])("p", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_5, Object(external_vue_["toDisplayString"])($props.parText), 1), Object(external_vue_["createElementVNode"])("p", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_6, Object(external_vue_["toDisplayString"])($props.focalText), 1)])) : (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_7, [Object(external_vue_["createElementVNode"])("p", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_8, Object(external_vue_["toDisplayString"])($props.sessionExpiredText), 1)]))]), Object(external_vue_["createElementVNode"])("section", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_9, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
        link: $props.cancelBtnHref,
        class: "ssi-actions__button ssi-actions__button--submit",
        shape: "square",
        size: "m",
        type: "ghost",
        text: $props.secondaryBtnLabel
      }, null, 8, ["link", "text"]), Object(external_vue_["createElementVNode"])("form", {
        id: "ssi-sign-in",
        action: $props.formActionUrl,
        method: "POST"
      }, [Object(external_vue_["createElementVNode"])("input", {
        type: "hidden",
        value: $props.nextUrl,
        name: "next"
      }, null, 8, SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_11), Object(external_vue_["createElementVNode"])("input", {
        type: "hidden",
        value: $props.userInfoToken,
        name: "user_token_info"
      }, null, 8, SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_12), Object(external_vue_["createElementVNode"])("input", {
        type: "hidden",
        value: $props.formToken,
        name: "token"
      }, null, 8, SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_13), !$data.isSessionExpired ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
        key: 0,
        id: "ssi-primary-btn",
        isSubmit: "",
        onClick: $options.primaryAction,
        class: "ssi-actions__button",
        shape: "square",
        size: "m",
        type: "fill",
        text: $props.primaryBtnLabel
      }, null, 8, ["onClick", "text"])) : Object(external_vue_["createCommentVNode"])("", true), $data.isSessionExpired ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createBlock"])(_component_NebulaButton, {
        key: 1,
        id: "ssi-retry-btn",
        class: "ssi-actions__button",
        shape: "square",
        size: "m",
        type: "fill",
        text: $props.retryBtnLabel,
        link: $props.retryUrl
      }, null, 8, ["text", "link"])) : Object(external_vue_["createCommentVNode"])("", true)], 8, SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_10)])];
    }),
    actionsRow: Object(external_vue_["withCtx"])(function () {
      return [!$data.isSessionExpired ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("section", SSOStaySignedInModalvue_type_template_id_18caa4ad_hoisted_14, [Object(external_vue_["createVNode"])(_component_NebulaCheckbox, {
        checkboxId: $props.checkboxId,
        labelText: $props.checkboxLabel
      }, {
        checkbox: Object(external_vue_["withCtx"])(function () {
          return [Object(external_vue_["createElementVNode"])("input", {
            form: "ssi-sign-in",
            class: "nebula-checkbox",
            id: "ssi-status",
            onChange: _cache[0] || (_cache[0] = function () {
              return $options.changeChecked && $options.changeChecked.apply($options, arguments);
            }),
            name: "stay_signed_in",
            type: "checkbox"
          }, null, 32)];
        }),
        _: 1
      }, 8, ["checkboxId", "labelText"])])) : Object(external_vue_["createCommentVNode"])("", true)];
    }),
    _: 1
  })) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/modals/SSOStaySignedInModal.vue?vue&type=template&id=18caa4ad

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/modals/SSOStaySignedInModal.vue?vue&type=script&lang=js

/* harmony default export */ var SSOStaySignedInModalvue_type_script_lang_js = ({
  name: 'SSOStaySignedInModal',
  components: {
    NebulaButton: nebula_components_["NebulaButton"],
    NebulaCheckbox: nebula_components_["NebulaCheckbox"],
    NebulaModal: nebula_components_["NebulaModal"]
  },
  data: function data() {
    return {
      showModal: false,
      isSessionExpired: false,
      sessionCheck: null
    };
  },
  props: {
    cancelBtnHref: {
      type: String
    },
    checkboxId: {
      type: String
    },
    checkboxLabel: {
      type: String
    },
    focalText: {
      type: String
    },
    formActionUrl: {
      type: String
    },
    formToken: {
      type: String
    },
    headerText: {
      type: String
    },
    imgAlt: {
      type: String
    },
    imgUrl: {
      required: false,
      type: String
    },
    nextUrl: {
      type: String
    },
    parText: {
      type: String
    },
    primaryBtnLabel: {
      type: String
    },
    secondaryBtnLabel: {
      type: String
    },
    userInfoToken: {
      type: String
    },
    sessionExpiry: {
      type: Object
    },
    sessionExpiredText: {
      type: String
    },
    retryUrl: {
      type: String
    },
    retryBtnLabel: {
      type: String
    }
  },
  emits: ['checkbox-status', 'close-modal', 'primaryAction', 'secondaryAction'],
  created: function created() {
    var _this = this;

    this.showModal = true;
    this.sessionCheck = setInterval(function () {
      if (new Date() > _this.sessionExpiry) {
        _this.isSessionExpired = true;
        clearInterval(_this.sessionCheck);
      }
    }, 1000);
  },
  methods: {
    primaryAction: function primaryAction() {
      this.$emit('primaryAction');
    },
    secondaryAction: function secondaryAction() {
      this.$emit('secondaryAction');
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.$emit('close-modal');
    },
    changeChecked: function changeChecked(event) {
      this.$emit('checkbox-status', {
        status: event.target.checked
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/modals/SSOStaySignedInModal.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/modals/SSOStaySignedInModal.vue?vue&type=style&index=0&id=18caa4ad&lang=stylus
var SSOStaySignedInModalvue_type_style_index_0_id_18caa4ad_lang_stylus = __webpack_require__("93af");

// CONCATENATED MODULE: ./src/components/modals/SSOStaySignedInModal.vue







const SSOStaySignedInModal_exports_ = /*#__PURE__*/exportHelper_default()(SSOStaySignedInModalvue_type_script_lang_js, [['render',SSOStaySignedInModalvue_type_template_id_18caa4ad_render]])

/* harmony default export */ var SSOStaySignedInModal = (SSOStaySignedInModal_exports_);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CleverIDMappingDropdown.vue?vue&type=template&id=c4cd04e6

var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_1 = {
  class: "school-dropdown nebula-dropdown__content"
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_2 = {
  "aria-labelledby": "de-sites-dropdown",
  role: "region",
  class: "school-dropdown__list"
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_3 = {
  class: "school-dropdown__item nebula-dropdown__item"
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_4 = {
  class: "school-dropdown-item__text school-dropdown-item__text--name"
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_5 = ["onClick"];
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_6 = {
  class: "school-dropdown-item__text school-dropdown-item__text--name"
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_7 = {
  key: 0
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_8 = {
  class: "school-dropdown-item__text school-dropdown-item__text--guid"
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_9 = {
  key: 0,
  class: "school-dropdown-item nebula-dropdown-item"
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_10 = {
  class: "school-dropdown-item__no-results"
};
var CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_11 = {
  class: "school-dropdown-item__no-results--filter"
};
function CleverIDMappingDropdownvue_type_template_id_c4cd04e6_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  var _component_NebulaInput = Object(external_vue_["resolveComponent"])("NebulaInput");

  var _component_NebulaInputWithButtons = Object(external_vue_["resolveComponent"])("NebulaInputWithButtons");

  return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("section", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_1, [Object(external_vue_["createVNode"])(_component_NebulaInputWithButtons, {
    class: "school-dropdown__search",
    borderRadiusSmall: ""
  }, {
    buttonElementStart: Object(external_vue_["withCtx"])(function () {
      return [Object(external_vue_["createVNode"])(_component_NebulaButton, {
        "icon-left": "search",
        size: "s",
        type: "flat"
      })];
    }),
    input: Object(external_vue_["withCtx"])(function () {
      return [Object(external_vue_["createVNode"])(_component_NebulaInput, {
        ref: "searchInput",
        id: "school-dropdown-search-input",
        onKeyup: $options.updateFilterValue,
        placeholder: "Search for a school",
        size: "s"
      }, null, 8, ["onKeyup"])];
    }),
    _: 1
  }), Object(external_vue_["createElementVNode"])("ul", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_2, [Object(external_vue_["withDirectives"])(Object(external_vue_["createElementVNode"])("li", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_3, [Object(external_vue_["createElementVNode"])("button", {
    type: "button",
    class: "school-dropdown-item__button school-dropdown-item__button--none nebula-dropdown-item__inner",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.selectSite && $options.selectSite.apply($options, arguments);
    })
  }, [Object(external_vue_["createElementVNode"])("span", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_4, Object(external_vue_["toDisplayString"])($props.clearOptionLabel), 1)])], 512), [[external_vue_["vShow"], $props.clearOptionLabel && $props.mappedSchoolGuid]]), (Object(external_vue_["openBlock"])(true), Object(external_vue_["createElementBlock"])(external_vue_["Fragment"], null, Object(external_vue_["renderList"])($options.filteredSites, function (site) {
    return Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", {
      key: site.site_guid,
      class: "school-dropdown__item nebula-dropdown__item"
    }, [Object(external_vue_["createElementVNode"])("button", {
      type: "button",
      class: "school-dropdown-item__button nebula-dropdown-item__inner",
      "aria-disabled": "false",
      onClick: function onClick($event) {
        return $options.selectSite(site);
      }
    }, [Object(external_vue_["createElementVNode"])("span", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_6, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])(site.name) + " ", 1), site.is_archived ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("span", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_7, Object(external_vue_["toDisplayString"])($props.siteStatusLabel), 1)) : Object(external_vue_["createCommentVNode"])("", true)]), Object(external_vue_["createElementVNode"])("span", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_8, Object(external_vue_["toDisplayString"])(site.site_guid), 1)], 8, CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_5)]);
  }), 128)), !$options.filteredSites.length ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("li", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_9, [Object(external_vue_["createElementVNode"])("p", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_10, [Object(external_vue_["createTextVNode"])(Object(external_vue_["toDisplayString"])($props.noResultsLabel) + " ", 1), Object(external_vue_["createElementVNode"])("span", CleverIDMappingDropdownvue_type_template_id_c4cd04e6_hoisted_11, Object(external_vue_["toDisplayString"])($data.filterValue), 1)])])) : Object(external_vue_["createCommentVNode"])("", true)])]);
}
// CONCATENATED MODULE: ./src/components/CleverIDMappingDropdown.vue?vue&type=template&id=c4cd04e6

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/CleverIDMappingDropdown.vue?vue&type=script&lang=js





/* harmony default export */ var CleverIDMappingDropdownvue_type_script_lang_js = ({
  name: 'CleverIDMappingDropdown',
  components: {
    NebulaInput: nebula_components_["NebulaInput"],
    NebulaInputWithButtons: nebula_components_["NebulaInputWithButtons"],
    NebulaButton: nebula_components_["NebulaButton"]
  },
  data: function data() {
    return {
      filterValue: ''
    };
  },
  props: {
    clearOptionLabel: {
      type: String
    },
    mappedSchoolGuid: {
      type: String
    },
    noResultsLabel: {
      type: String
    },
    sites: {
      type: Array
    },
    siteStatusLabel: {
      type: String
    }
  },
  emits: ['site-selected'],
  mounted: function mounted() {
    this.$refs.searchInput.$el.focus();
  },
  methods: {
    updateFilterValue: function updateFilterValue(event) {
      this.filterValue = event.target.value;
    },
    selectSite: function selectSite(site) {
      var emitSite = site.site_guid ? site : {
        site_guid: '',
        name: ''
      };
      this.$emit('site-selected', emitSite);
    }
  },
  computed: {
    filteredSites: function filteredSites() {
      var _this = this;

      return this.sites.filter(function (site) {
        return site.name.toLowerCase().includes(_this.filterValue.toLowerCase());
      });
    }
  }
});
// CONCATENATED MODULE: ./src/components/CleverIDMappingDropdown.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/CleverIDMappingDropdown.vue?vue&type=style&index=0&id=c4cd04e6&lang=stylus
var CleverIDMappingDropdownvue_type_style_index_0_id_c4cd04e6_lang_stylus = __webpack_require__("a343");

// CONCATENATED MODULE: ./src/components/CleverIDMappingDropdown.vue







const CleverIDMappingDropdown_exports_ = /*#__PURE__*/exportHelper_default()(CleverIDMappingDropdownvue_type_script_lang_js, [['render',CleverIDMappingDropdownvue_type_template_id_c4cd04e6_render]])

/* harmony default export */ var CleverIDMappingDropdown = (CleverIDMappingDropdown_exports_);
// CONCATENATED MODULE: ./src/utils/constants/profileAvatars.js

var AVATARS = {
  robot01: {
    name: 'walking robot',
    img: 'avatar-de-robot-1.png',
    category: 'robots'
  },
  robot02: {
    name: 'robot teacher',
    img: 'avatar-de-robot-2.png',
    category: 'robots'
  },
  robot03: {
    name: 'robot dog',
    img: 'avatar-de-robot-3.png',
    category: 'robots'
  },
  robot04: {
    name: 'wheelchair robot',
    img: 'avatar-de-robot-4.png',
    category: 'robots'
  },
  robot05: {
    name: 'robot rabbit',
    img: 'avatar-de-robot-5.png',
    category: 'robots'
  },
  robot06: {
    name: 'confused robot',
    img: 'avatar-de-robot-6.png',
    category: 'robots'
  },
  robot07: {
    name: 'robot gramps',
    img: 'avatar-de-robot-7.png',
    category: 'robots'
  },
  robot08: {
    name: 'happy robot',
    img: 'avatar-de-robot-8.png',
    category: 'robots'
  },
  coding01: {
    name: 'vampire cartoon',
    img: 'avatar-coding-1.png',
    category: 'cartoons'
  },
  coding02: {
    name: 'spider cartoon',
    img: 'avatar-coding-2.png',
    category: 'cartoons'
  },
  coding03: {
    name: 'bee cartoon',
    img: 'avatar-coding-3.png',
    category: 'cartoons'
  },
  coding04: {
    name: 'tortoise cartoon',
    img: 'avatar-coding-4.png',
    category: 'cartoons'
  },
  coding05: {
    name: 'panda cartoon',
    img: 'avatar-coding-5.png',
    category: 'cartoons'
  },
  coding06: {
    name: 'elephant cartoon',
    img: 'avatar-coding-6.png',
    category: 'cartoons'
  },
  coding07: {
    name: 'rocket cartoon',
    img: 'avatar-coding-7.png',
    category: 'cartoons'
  },
  coding08: {
    name: 'plane cartoon',
    img: 'avatar-coding-8.png',
    category: 'cartoons'
  },
  animal01: {
    name: 'lemur photo',
    img: 'avatar-animals-01.png',
    category: 'animals'
  },
  animal02: {
    name: 'spider photo',
    img: 'avatar-animals-02.png',
    category: 'animals'
  },
  animal03: {
    name: 'turtle photo',
    img: 'avatar-animals-03.png',
    category: 'animals'
  },
  animal04: {
    name: 'dog photo',
    img: 'avatar-animals-04.png',
    category: 'animals'
  },
  animal05: {
    name: 'shark photo',
    img: 'avatar-animals-05.png',
    category: 'animals'
  },
  animal06: {
    name: 'cat photo',
    img: 'avatar-animals-06.png',
    category: 'animals'
  },
  animal07: {
    name: 'bird photo',
    img: 'avatar-animals-07.png',
    category: 'animals'
  },
  animal08: {
    name: 'lion photo',
    img: 'avatar-animals-08.png',
    category: 'animals'
  },
  dinosaur01: {
    name: 'scientifically inaccurate dinosaur toy',
    img: 'avatar-dinosaur-1.png',
    category: 'dinosaurs'
  },
  dinosaur02: {
    name: 'pachycephalosaurus',
    img: 'avatar-dinosaur-2.png',
    category: 'dinosaurs'
  },
  dinosaur03: {
    name: 'deinonychus',
    img: 'avatar-dinosaur-3.png',
    category: 'dinosaurs'
  },
  dinosaur04: {
    name: 'carnotaurus',
    img: 'avatar-dinosaur-4.png',
    category: 'dinosaurs'
  },
  dinosaur05: {
    name: 'the same scientifically inaccurate dinosaur toy at a different angle',
    img: 'avatar-dinosaur-5.png',
    category: 'dinosaurs'
  },
  dinosaur06: {
    name: 't-rex skull',
    img: 'avatar-dinosaur-6.png',
    category: 'dinosaurs'
  },
  dinosaur07: {
    name: 't-rex',
    img: 'avatar-dinosaur-7.png',
    category: 'dinosaurs'
  },
  dinosaur08: {
    name: 'velociraptor',
    img: 'avatar-dinosaur-8.png',
    category: 'dinosaurs'
  },
  illustration01: {
    name: 'synth glasses illustration',
    img: 'avatar-illustrations-01.png',
    category: 'illustrations'
  },
  illustration02: {
    name: 'hypno cat illustration',
    img: 'avatar-illustrations-02.png',
    category: 'illustrations'
  },
  illustration03: {
    name: 'sea man illustration',
    img: 'avatar-illustrations-03.png',
    category: 'illustrations'
  },
  illustration04: {
    name: 'cab driver illustration',
    img: 'avatar-illustrations-04.png',
    category: 'illustrations'
  },
  illustration05: {
    name: 'dog rapper illustration',
    img: 'avatar-illustrations-05.png',
    category: 'illustrations'
  },
  illustration06: {
    name: 'mermaid illustration',
    img: 'avatar-illustrations-06.png',
    category: 'illustrations'
  },
  illustration07: {
    name: 'picasso face illustration',
    img: 'avatar-illustrations-07.png',
    category: 'illustrations'
  },
  illustration08: {
    name: 'frogman illustration',
    img: 'avatar-illustrations-08.png',
    category: 'illustrations'
  },
  default: {
    name: 'generic silhouette',
    img: 'avatar-generic.png'
  }
};
function avatarImagePath(avatarId, coreStaticPath) {
  var path = coreStaticPath || window.paths.core_static;
  var avatar = AVATARS[avatarId] || AVATARS.default;
  return "".concat(path, "apps/students/avatars/").concat(avatar.img);
}
// CONCATENATED MODULE: ./src/utils/constants/profileBackgrounds.js

var THEMES = {
  default: {
    file: 'theme_default.jpg',
    name: 'Cobalt Blue'
  },
  blue: {
    file: 'theme_blue.jpg',
    name: 'Tanzanite Blue'
  },
  bluegreen: {
    file: 'theme_blue_green.jpg',
    name: 'Ocean Blue'
  },
  emerald: {
    file: 'theme_emerald.jpg',
    name: 'Emerald Green'
  },
  grey: {
    file: 'theme_grey.jpg',
    name: 'Concrete Grey'
  },
  orange: {
    file: 'theme_orange.jpg',
    name: 'Sunset Orange'
  },
  purple: {
    file: 'theme_purple.jpg',
    name: 'Amethyst Purple'
  },
  purplepink: {
    file: 'theme_purple_pink.jpg',
    name: 'Lotus Pink and Purple'
  },
  ruby: {
    file: 'theme_ruby.jpg',
    name: 'Ruby Red'
  },
  midnightblue: {
    file: 'theme_midnight_blue.jpg',
    name: 'Midnight Blue'
  },
  lightgreen: {
    file: 'theme_light_green.jpg',
    name: 'Leaf Green'
  },
  mauve: {
    file: 'theme_mauve.jpg',
    name: 'Mauve'
  },
  brightgreen: {
    file: 'theme_bright_green.jpg',
    name: 'Lime Green'
  },
  forestgreen: {
    file: 'theme_forest_green.jpg',
    name: 'Spruce Green'
  },
  dullpurple: {
    file: 'theme_dull_purple.jpg',
    name: 'Purple Haze'
  },
  pink: {
    file: 'theme_pink.jpg',
    name: 'Neon Pink'
  }
};
function themeImagePath(themeId, coreStaticPath) {
  var path = coreStaticPath || window.paths.core_static;
  var theme = THEMES[themeId] || THEMES.default;
  return "".concat(path, "apps/students/images/theme-background/").concat(theme.file);
}
// EXTERNAL MODULE: ./src/utils/constants/i18nPluralTerms.json
var i18nPluralTerms = __webpack_require__("286d");

// EXTERNAL MODULE: ./src/utils/text-to-speech/voice-list.json
var voice_list = __webpack_require__("bb4f");

// EXTERNAL MODULE: ./node_modules/@discoveryedu/nebula-core/dist/data/nebula_tokens.json
var nebula_tokens = __webpack_require__("9b63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__("7a82");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__("131a");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("4ae1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.to-string-tag.js
var es_reflect_to_string_tag = __webpack_require__("f8c9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js


function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js



function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("7037");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (typeof_default()(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js






function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
var es_map = __webpack_require__("4ec9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js



function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/construct.js





function construct_construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    construct_construct = Reflect.construct;
  } else {
    construct_construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return construct_construct.apply(null, arguments);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js









function wrapNativeSuper_wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct_construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return wrapNativeSuper_wrapNativeSuper(Class);
}
// CONCATENATED MODULE: ./src/components/custom-elements/de-speakable.js






/**
 * This is an unstyled custom html element used
 * for grouping a selection of HTMLElements to
 * pass on to the speechstream service.
 *
 * <de-speakable> elements are ephemeral by design
 * they are unregistered immediately after they've been used
 * in the context of text to speech.
 */
var de_speakable_DESpeakable = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DESpeakable, _HTMLElement);

  var _super = _createSuper(DESpeakable);

  // eslint-disable-next-line no-useless-constructor
  function DESpeakable() {
    _classCallCheck(this, DESpeakable);

    return _super.call(this);
  }

  return _createClass(DESpeakable);
}( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(HTMLElement));


window.customElements.define('de-speakable', de_speakable_DESpeakable);
// CONCATENATED MODULE: ./src/utils/text-to-speech/speechstream-loader.js






var SpeechStreamLoader = {
  configVersion: 'DiscoveryEdTechbooksv351R1',
  version: '3.9.1',
  domControl: null,
  ignoredClassList: null,
  promise: null,
  speechstream: null,
  speechTools: null,
  textHelpScript: false,
  // registers the custom element
  DESpeakable: de_speakable_DESpeakable,
  initTextHelpScript: function initTextHelpScript() {
    var _this = this;

    var resolve;
    var reject;

    if (this.promise) {
      return this.promise;
    }

    this.promise = new Promise(function (_resolve, _reject) {
      resolve = _resolve;
      reject = _reject;
    }); // Docs site for TextHelp: https://docs.speechstream.net
    // Create script element so we can load the provided TextHelp script on mounted

    this.textHelpScript = document.createElement('script');
    this.textHelpScript.async = true;

    this.textHelpScript.onerror = function (event) {
      reject(event);
    };

    var timer = setInterval(function () {
      var _window$speechstream, _window$speechstream$;

      // Note: Waiting for speechstream.Loader is not sufficient and has the potential
      // to cause race conditions in certain cases.
      // We need to wait and ensure that the API's actual static methods are available
      // before assigning window.speechstream object to our own speechstream object.
      if (!((_window$speechstream = window.speechstream) !== null && _window$speechstream !== void 0 && (_window$speechstream$ = _window$speechstream.speechTools) !== null && _window$speechstream$ !== void 0 && _window$speechstream$.play)) {
        return;
      }

      _this.speechstream = window.speechstream;
      resolve();
      clearInterval(timer);
    }, 100);
    this.textHelpScript.setAttribute('id', 'de-tts');
    this.textHelpScript.setAttribute('data-speechstream-config', this.configVersion);
    this.textHelpScript.setAttribute('src', "https://toolbar.speechstream.net/SpeechStream/".concat(this.version, "/speechstream.js"));
    document.body.appendChild(this.textHelpScript);
    return this.promise;
  },
  init: function init() {
    var _this2 = this;

    return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var ignoredClassListSelectors, sreObject;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.initTextHelpScript();

            case 2:
              if (window.speechstream) {
                // lifting commonly used API objects so they're less verbose to get to.
                // DomControl on the window is for setting ignored and allowed elements
                //  by id, or querySelectors
                _this2.domControl = _this2.speechstream.domControlTools.getNewDomControl(window.document);
                _this2.speechTools = _this2.speechstream.speechTools;
                _this2.ignoredClassList = ['not-visible-on-device-container', 'rs_skip_always', 'hide', 'device-error-header'];
                ignoredClassListSelectors = _this2.ignoredClassList.map(function (selector) {
                  return ".".concat(selector);
                });

                _this2.domControl.addIgnoreListQuerySelector(ignoredClassListSelectors.join(', '));
              }

              if (window.MathJax) {
                sreObject = _this2.speechstream.mathTools.getMathSreSettings(); // Change the sre settings domain

                sreObject.sreSettings.domain = 'mathspeak';

                _this2.speechstream.mathTools.setMathSreSettings(sreObject);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
/* harmony default export */ var speechstream_loader = ({
  SpeechStreamLoader: SpeechStreamLoader
});
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js







function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__("06c5");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || Object(unsupportedIterableToArray["a" /* default */])(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__("5530");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("ade3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.array.find-last.js
var esnext_array_find_last = __webpack_require__("c2bc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.last-index-of.js
var es_array_last_index_of = __webpack_require__("baa5");

// CONCATENATED MODULE: ./src/utils/helpers/dom.js






















/* eslint-disable no-underscore-dangle */
// DEVELOPER NOTES
// ===============
// Vue 3 uses Proxy, which breaks use of native private class members.
// To work around this, we use a public class members with a underscore
// prefixed naming convention to indicate private vs public use.

/**
 * @typedef {Object} NodeSelectorsData The data for the `nodeSelectors` object.
 * @property {String[]} primary An array of string selectors for the primary element.
 *                              Higher priority selectors should be placed first.
 * @property {String[]} intermediate An array of string selectors for the intermediate element.
 *                                   Higher priority selectors should be placed first.
 * @property {String[]} target An array of string selectors for the target element.
 *                             Higher priority selectors should be placed first.
 * @property {Function} selectorPostProcessor A delegate/callback function to post-process the
 *                                            CSS selectors generated by `.getNodeSelector(...)`.
 *                                            Arguments are `(node, selectorData)` and the return
 *                                            value of the method is used to finalize the CSS
 *                                            selector values.
 *
 * @example
 * // Without a post-processor method
 * domHelper.nodeSelectors = {
 *     primary: ['.cit-row'],
 *     intermediate: ['.cit-rich-copy'],
 *     target: [':scope > *'],
 * };
 *
 * // With a post-processor method
 * domHelper.nodeSelectors = {
 *     primary: ['.cit-row'],
 *     intermediate: ['.cit-rich-copy'],
 *     target: [':scope > *'],
 *
 *     selectorPostProcessor: (node, selectorData) => {
 *         const updatedSelectorData = {
 *             primary: {
 *                 element: elementNode,
 *                 selector: '.css-selector',
 *             },
 *             intermediate: {
 *                 element: elementNode,
 *                 selector: '.css-selector',
 *             },
 *             target: {
 *                 element: elementNode,
 *                 selector: '.css-selector',
 *             },
 *         };
 *
 *         // Perform data manipulation
 *         // ...
 *
 *         return updatedSelectorData;
 *     },
 * };
 */

/**
 * The DomHelper class provides helper methods for various DOM related operations.
 */
var dom_DomHelper = /*#__PURE__*/function () {
  /**
   * @param {Object} options The options to be used by the DomHelper instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   *
   * @example
   * const contextEl = document.querySelector('main');
   *
   * const domHelper = new DomHelper({
   *   contextContainer: contextEl,
   *   ignoredElements: [
   *     'span',
   *     '.nebula-button',
   *   ],
   * });
   *
   * const targetEl = document.querySelector('.target-el');
   *
   * const arrTextNodes = domHelper.getAllTextNodes(targetEl);
   *
   * // Prints the captured array of text nodes.
   * console.log(arrTextNodes);
   */
  function DomHelper(options) {
    _classCallCheck(this, DomHelper);

    Object(defineProperty["a" /* default */])(this, "_clientId", void 0);

    Object(defineProperty["a" /* default */])(this, "_contextContainer", void 0);

    Object(defineProperty["a" /* default */])(this, "_ignoredElements", void 0);

    Object(defineProperty["a" /* default */])(this, "_nodeSelectors", void 0);

    this._clientId = DomHelper.getNextClientId();
    this.contextContainer = options === null || options === void 0 ? void 0 : options.contextContainer;
    this.ignoredElements = options === null || options === void 0 ? void 0 : options.ignoredElements;
    this.nodeSelectors = options === null || options === void 0 ? void 0 : options.nodeSelectors;
  }
  /**
   * Finds the given node within the selectors provided.
   * @param {Node} node The node to find.
   * @param {String[]} selectors Array of selectors to match against. Higher priority selectors should be first.
   * @param {Boolean} [matchSameNode] Whether to consider the input node as a match, or strictly match child-nodes.
   * @param {Node.ELEMENT_NODE} [contextNode] The node within which to perform the search.
   * @returns {Object} Returns an object with `{ element: ..., selector: ... }` as data.
   */


  _createClass(DomHelper, [{
    key: "clientId",
    get:
    /**
     * The unique client ID of this instance.
     * @type {Number}
     * @readonly
     *
     * @example
     * const domHelper = new DomHelper();
     *
     * // prints the client-id
     * console.log(domHelper.clientId);
     *
     * // throws an exception
     * domHelper.clientId = 123;
     */
    function get() {
      return this._clientId;
    }
    /**
     * The context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     */

  }, {
    key: "contextContainer",
    get: function get() {
      return this._contextContainer;
    },
    set: function set(val) {
      var contextContainer = val || document.body; // Always ensure that the contextContainer is
      // an element node type.

      if (!DomHelper.isElementNode(contextContainer)) {
        this.throwError('"contextContainer" should be an Element node-type.');
        return;
      }

      this._contextContainer = contextContainer;
    }
    /**
     * The immediate parent of context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     * @readonly
     */

  }, {
    key: "contextContainerParent",
    get: function get() {
      var _this$contextContaine;

      return ((_this$contextContaine = this.contextContainer) === null || _this$contextContaine === void 0 ? void 0 : _this$contextContaine.parentNode) || null;
    }
    /**
     * The array of ignored element selectors.
     * @type {String[]}
     */

  }, {
    key: "ignoredElements",
    get: function get() {
      return this._ignoredElements;
    },
    set: function set(val) {
      // Ensure ignoredElements is an array.
      if (!val) {
        // If unset, reset to a blank array.
        this._ignoredElements = [];
        return;
      }

      if (!Array.isArray(val)) {
        this._ignoredElements = [val];
        return;
      }

      this._ignoredElements = val;
    }
    /**
     * The node selectors data object.
     * @type {NodeSelectorsData}
     */

  }, {
    key: "nodeSelectors",
    get: function get() {
      if (!this._nodeSelectors) {
        this._nodeSelectors = {
          primary: null,
          intermediate: null,
          target: null,
          selectorPostProcessor: null
        };
      }

      return this._nodeSelectors;
    },
    set: function set(val) {
      this._nodeSelectors = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, this._nodeSelectors), val);
    }
  }, {
    key: "findNodeInSelectors",
    value: function findNodeInSelectors(node, selectors) {
      var _this = this;

      var matchSameNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var contextNode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var retVal = {
        element: null,
        selector: null
      };

      if (!node || !selectors) {
        return retVal;
      }

      var contextElement = contextNode || this.contextContainer;
      selectors.some(function (selector) {
        var elements = Object(toConsumableArray["a" /* default */])(contextElement.querySelectorAll(selector));

        elements.some(function (element) {
          if (_this.isNodeInIgnoredList(element)) {
            // We do NOT want to capture ignored nodes
            // continue the iteration
            return false;
          }

          var nodePosition = DomHelper.compareNodePosition(element, node);

          if (nodePosition.isDescendant || matchSameNode && nodePosition.isSameNode) {
            retVal.element = element;
            retVal.selector = selector; // stop the iteration

            return true;
          } // continue the iteration


          return false;
        });
        return !!retVal.element;
      });
      return retVal;
    }
    /**
     * Get all the element nodes within a given node. If the node is
     * outside of the contextContainer OR if it is in the
     * ignored-elements list, skip them from processing.
     * @param {Node} node The node from which to extract the element nodes.
     * @returns {Array} An array of element-nodes for the given node.
     *
     * @example
     * const targetEl = document.querySelector('.target-el');
     *
     * domHelper.getAllElementNodes(targetEl);
     */

  }, {
    key: "getAllElementNodes",
    value: function getAllElementNodes(node) {
      var _this2 = this;

      var allElementNodes = [];

      if (!this.isNodeInContextContainer(node) || this.isNodeInIgnoredList(node)) {
        // If the `node` is:
        //      - NOT within the contextContainer, OR
        //      - IS within an ignored-elements list.
        //
        // THEN, return a blank array without processing it further.
        return allElementNodes;
      }

      if (!DomHelper.isElementNode(node)) {
        return allElementNodes;
      }

      var children = Object(toConsumableArray["a" /* default */])(node === null || node === void 0 ? void 0 : node.children);

      if (!children.length) {
        // There are no children of this
        // element that can be processed.
        // Return whatever we have so far.
        return allElementNodes;
      }

      children.forEach(function (childElement) {
        allElementNodes.push(childElement);
        allElementNodes = allElementNodes.concat(_this2.getAllElementNodes(childElement));
      });
      return allElementNodes;
    }
    /**
     * Get all the text nodes within a given node. If the node is
     * outside of the contextContainer OR if it is in the
     * ignored-elements list, skip them from processing.
     * @param {Node} node The node from which to extract the text nodes.
     * @param {Boolean} [ignoreEmptyTextNodes] Ignore empty text nodes. These nodes will NOT be returned in the final list. Defaults to `true`.
     * @returns {Array} An array of text-nodes for the given node.
     *
     * @example
     * const targetEl = document.querySelector('.target-el');
     *
     * // returns all the text nodes except empty ones
     * domHelper.getAllTextNodes(targetEl);
     *
     * // returns all the text nodes including empty ones
     * domHelper.getAllTextNodes(targetEl, false);
     */

  }, {
    key: "getAllTextNodes",
    value: function getAllTextNodes(node) {
      var _this3 = this;

      var ignoreEmptyTextNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var allTextNodes = [];

      if (!this.isNodeInContextContainer(node) || this.isNodeInIgnoredList(node)) {
        // If the `node` is:
        //      - NOT within the contextContainer, OR
        //      - IS within an ignored-elements list.
        //
        // THEN, return a blank array without processing it further.
        return allTextNodes;
      }

      if (DomHelper.isTextNode(node)) {
        if (node.textContent.trim().length || !ignoreEmptyTextNodes) {
          allTextNodes.push(node);
        }

        return allTextNodes;
      }

      var childNodes = node.childNodes;

      if (!childNodes.length) {
        // There are no children of this
        // element that can be processed.
        // Return whatever we have so far.
        return allTextNodes;
      }

      childNodes.forEach(function (childNode) {
        allTextNodes = allTextNodes.concat(_this3.getAllTextNodes(childNode, ignoreEmptyTextNodes));
      });
      return allTextNodes;
    }
    /**
     * Get the common ancestor for the given nodes within the scope of the `contextContainer`.
     * @param {Node} node1 The first node.
     * @param {Node} node2 The second node.
     * @returns {Node} The common ancestor for the given nodes.
     */

  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(node1, node2) {
      if (!DomHelper.isNode(node1) || !DomHelper.isNode(node2)) {
        // If either argument is not a node,
        // do NOT process further.
        return null;
      } // We do NOT care if node1 or node2 are:
      //      a. outside the `contextContainer`,
      //      b. in the ignored-elements list.
      //
      // We DO care if the commonAncestor is:
      //      a. outside the contextContainer,
      //          - return `null`
      //      b. in the ignored-elements list.
      //          - attempt to return the closest
      //            non-ignored parent, and return
      //            `null` if that attempt fails.
      //
      //


      var contextContainerParent = this.contextContainerParent;
      var ancestorNode = node1.parentNode;

      while (ancestorNode) {
        if (ancestorNode === contextContainerParent) {
          // This ensures that we avoid breaking
          // out of the jail element with our checks.
          // It will match the contextContainer itself, but
          // will NOT match beyond contextContainerParent.
          break;
        }

        var position = DomHelper.compareNodePosition(ancestorNode, node2);

        if (position.isDescendant && !this.isNodeInIgnoredList(ancestorNode)) {
          return ancestorNode;
        }

        ancestorNode = ancestorNode.parentNode;
      }

      return null;
    }
    /**
     * Gets the first text-node for the given node. If the given node is a text-node, returns itself.
     * @param {Node} node The node for which we need to grab the first text-node.
     * @returns {?Node.TEXT_NODE} Returns the first text-node it finds, otherwise returns `null`.
     */

  }, {
    key: "getFirstTextNode",
    value: function getFirstTextNode(node) {
      var _this4 = this;

      if (!this.isNodeInContextContainer(node) || this.isNodeInIgnoredList(node)) {
        // If the `node` is:
        //      - NOT within the contextContainer, OR
        //      - IS within an ignored-elements list.
        //
        // THEN, return a blank array without processing it further.
        return null;
      }

      if (DomHelper.isTextNode(node)) {
        // If this is already a text-node,
        // return as-is.
        return node;
      }

      var childNodes = Object(toConsumableArray["a" /* default */])(node.childNodes);

      if (!childNodes.length) {
        // If there are no child-nodes of this node,
        // return null.
        return null;
      } // Of all the childNodes, we want to make sure we only
      // look at element-nodes or text-nodes when finding the
      // first text-node.


      var nextNodes = childNodes.filter(function (childNode) {
        return DomHelper.isElementOrTextNode(childNode) && !_this4.isNodeInIgnoredList(childNode);
      });

      if (!nextNodes.length) {
        // If none of the childNodes are element or text
        // nodes, return null.
        return null;
      }

      var firstTextNode = null; // If we have a match, do a recursive
      // search for the first text-node with
      // this method.

      nextNodes.some(function (nextNode) {
        firstTextNode = _this4.getFirstTextNode(nextNode);

        if (!firstTextNode) {
          return false;
        }

        return true;
      });
      return firstTextNode;
    }
    /**
     * Grabs all the intermediate element-nodes for the given start and end nodes (excluding both).
     * @param {Node} startNode The start node.
     * @param {Node} endNode The end node.
     * @param {Node} [contextNode] The context-node to search for nodes. Only used internally for recursion.
     * @returns {Array} Returns an array of intermediate element nodes.
     */

  }, {
    key: "getIntermediateElementNodes",
    value: function getIntermediateElementNodes(startNode, endNode) {
      var _this5 = this;

      var contextNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!DomHelper.isNode(startNode) || !DomHelper.isNode(endNode)) {
        // GIGO
        return [];
      }

      if (startNode === endNode) {
        return [];
      }

      var isEndPrecedingStart = DomHelper.compareNodePosition(startNode, endNode).isPreceding;
      var trueStartNode = isEndPrecedingStart ? endNode : startNode;
      var trueEndNode = isEndPrecedingStart ? startNode : endNode;
      var intermediateElementNodes = [];
      var isMatchStarted = false;
      var contextStartNode = contextNode || null;

      if (!contextStartNode) {
        var commonAncestor = DomHelper.getCommonAncestor(trueStartNode, trueEndNode);
        contextStartNode = commonAncestor;
      }

      var childNodes = Object(toConsumableArray["a" /* default */])(contextStartNode.childNodes) || [];

      if (!childNodes.length) {
        // No child nodes present
        return intermediateElementNodes;
      }

      childNodes.every(function (childNode) {
        if (!isMatchStarted) {
          // Matching hasn't started yet because we are NOT
          // at the start node yet.
          if (childNode === trueStartNode) {
            // We got an exact match for the start-node.
            isMatchStarted = true; // Continue iteration

            return true;
          }

          if (!childNode.contains(trueStartNode)) {
            // No sign of the start node yet.
            // Continue iteration to the next node.
            return true;
          } // We found the child-node that contains the start-node.
          // Dig deeper to retrieve the start and continue.


          intermediateElementNodes = intermediateElementNodes.concat(_this5.getIntermediateElementNodes(trueStartNode, trueEndNode, childNode));
          isMatchStarted = true; // Continue the iteration

          return true;
        } // From this point on, the match is in-progress.


        if (childNode === trueEndNode) {
          // End of the line
          // Stop the iteration
          return false;
        }

        if (childNode.contains(trueEndNode)) {
          var _childNode$childNodes = _slicedToArray(childNode.childNodes, 1),
              firstChildNode = _childNode$childNodes[0];

          if (firstChildNode) {
            // When calling the getIntermediateElementNodes
            // method, start and end nodes are always discarded.
            //
            // When grabbing intermediate nodes, this can cause
            // some intermediate nodes to be discarded.
            //
            // This check here is making sure that if the given
            // "start node" for the recursive call is NOT the end
            // node, we should push that into the stack.
            var _DomHelper$compareNod = DomHelper.compareNodePosition(trueEndNode, firstChildNode),
                isDescendant = _DomHelper$compareNod.isDescendant;

            if (firstChildNode !== trueEndNode && DomHelper.isElementNode(firstChildNode) && !isDescendant && _this5.isNodeInContextContainer(firstChildNode) && !_this5.isNodeInIgnoredList(firstChildNode)) {
              intermediateElementNodes.push(firstChildNode);
            }
          } // We found the node that contains the end-node.
          // Dig deeper to retrieve the end and continue.


          intermediateElementNodes = intermediateElementNodes.concat(_this5.getIntermediateElementNodes(firstChildNode || childNode, trueEndNode, childNode)); // Stop the iteration

          return false;
        } // We are in-between the start-node and end-node.
        // Grab all the element-nodes.


        if (DomHelper.isElementNode(childNode)) {
          intermediateElementNodes.push(childNode);
        }

        intermediateElementNodes = intermediateElementNodes.concat(_this5.getAllElementNodes(childNode)); // Continue the iteration

        return true;
      });
      return intermediateElementNodes;
    }
    /**
     * Grabs all the intermediate text-nodes for the given start and end nodes (excluding both).
     * @param {Node} startNode The start node.
     * @param {Node} endNode The end node.
     * @param {Node} [contextNode] The context-node to search for nodes. Only used internally for recursion.
     * @returns {Array} Returns an array of intermediate text nodes.
     */

  }, {
    key: "getIntermediateTextNodes",
    value: function getIntermediateTextNodes(startNode, endNode) {
      var _this6 = this;

      var contextNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!DomHelper.isNode(startNode) || !DomHelper.isNode(endNode)) {
        // GIGO
        return [];
      }

      if (startNode === endNode) {
        // Avoid going into an endless loop.
        // There are no intermediate nodes for the
        // same node in the DOM.
        return [];
      }

      var isEndPrecedingStart = DomHelper.compareNodePosition(startNode, endNode).isPreceding;
      var trueStartNode = isEndPrecedingStart ? endNode : startNode;
      var trueEndNode = isEndPrecedingStart ? startNode : endNode;
      var intermediateTextNodes = [];
      var isMatchStarted = false;
      var contextStartNode = contextNode || null;

      if (!contextStartNode) {
        var commonAncestor = DomHelper.getCommonAncestor(trueStartNode, trueEndNode);
        contextStartNode = commonAncestor;
      }

      var childNodes = Object(toConsumableArray["a" /* default */])(contextStartNode.childNodes) || [];

      if (!childNodes.length) {
        // No child nodes present
        return intermediateTextNodes;
      }

      childNodes.every(function (childNode) {
        if (!isMatchStarted) {
          // Matching hasn't started yet because we are NOT
          // at the start node yet.
          if (childNode === trueStartNode) {
            // We got an exact match for the start-node.
            isMatchStarted = true; // Continue iteration

            return true;
          }

          if (!childNode.contains(trueStartNode)) {
            // No sign of the start node yet.
            // Continue iteration to the next node.
            return true;
          } // We found the child-node that contains the start-node.
          // Dig deeper to retrieve the start and continue.


          intermediateTextNodes = intermediateTextNodes.concat(_this6.getIntermediateTextNodes(trueStartNode, trueEndNode, childNode));
          isMatchStarted = true; // Continue the iteration

          return true;
        } // From this point on, the match is in-progress.


        if (childNode === trueEndNode) {
          // End of the line
          // Stop the iteration
          return false;
        }

        if (childNode.contains(trueEndNode)) {
          var firstTextNode = DomHelper.getFirstTextNode(childNode);

          if (firstTextNode) {
            // When calling the getIntermediateTextNodes
            // method, start and end nodes are always discarded.
            //
            // When grabbing intermediate nodes, this can cause
            // some intermediate text nodes to be discarded.
            //
            // This check here is making sure that if the given
            // "start node" for the recursive call is NOT the end
            // node, we should push that into the stack.
            var _DomHelper$compareNod2 = DomHelper.compareNodePosition(trueEndNode, firstTextNode),
                isDescendant = _DomHelper$compareNod2.isDescendant;

            if (firstTextNode !== trueEndNode && !isDescendant && _this6.isNodeInContextContainer(firstTextNode) && !_this6.isNodeInIgnoredList(firstTextNode)) {
              intermediateTextNodes.push(firstTextNode);
            }
          } // We found the node that contains the end-node.
          // Dig deeper to retrieve the end and continue.


          intermediateTextNodes = intermediateTextNodes.concat(_this6.getIntermediateTextNodes(firstTextNode || childNode, trueEndNode, childNode)); // Stop the iteration

          return false;
        } // We are in-between the start-node and end-node.
        // Grab all the text-nodes.


        intermediateTextNodes = intermediateTextNodes.concat(_this6.getAllTextNodes(childNode)); // Continue the iteration

        return true;
      });
      return intermediateTextNodes;
    }
    /**
     * Gets the last text-node for the given node. If the given node is a text-node, returns itself.
     * @param {Node} node The node for which we need to grab the last text-node.
     * @returns {?Node.TEXT_NODE} Returns the first text-node it finds, otherwise returns `null`.
     */

  }, {
    key: "getLastTextNode",
    value: function getLastTextNode(node) {
      var _this7 = this;

      if (!this.isNodeInContextContainer(node) || this.isNodeInIgnoredList(node)) {
        // If the `node` is:
        //      - NOT within the contextContainer, OR
        //      - IS within an ignored-elements list.
        //
        // THEN, return a blank array without processing it further.
        return null;
      }

      if (DomHelper.isTextNode(node)) {
        // If this is already a text-node,
        // return as-is.
        return node;
      }

      var childNodes = Object(toConsumableArray["a" /* default */])(node.childNodes);

      if (!childNodes.length) {
        // If there are no child-nodes of this node,
        // return null.
        return null;
      } // Of all the childNodes, we want to make sure we only
      // look at element-nodes or text-nodes when finding the
      // last text-node.


      var nextNode = childNodes.findLast(function (childNode) {
        return DomHelper.isElementOrTextNode(childNode) && !_this7.isNodeInIgnoredList(childNode);
      });

      if (!nextNode) {
        // If none of the childNodes are element or text
        // nodes, return null.
        return null;
      } // If we have a match, do a recursive
      // search for the last text-node with
      // this method.


      return this.getLastTextNode(nextNode);
    }
    /**
     * Grabs the next sibling node. If one doesn't exist in the current parent,
     * it will continue searching for the next sibling in the next element tree.
     * @param {(Node.ELEMENT_NODE|Node.TEXT_NODE)} node The node for which we need the next sibling.
     * @returns {Node} Returns the next valid sibling.
     */

  }, {
    key: "getNextSibling",
    value: function getNextSibling(node) {
      if (!node) {
        return null;
      }

      var nextSibling = node.nextSibling;

      if (!nextSibling || !this.isNodeInContextContainer(nextSibling) || this.isNodeInIgnoredList(nextSibling)) {
        // If `nextSibling` is falsy
        // OR
        // it is NOT in the context-container
        // OR
        // it is in an ignored list,
        // keep looking for the next valid sibling.
        return this.getNextSibling(nextSibling || (node === null || node === void 0 ? void 0 : node.parentElement));
      }

      return nextSibling || null;
    }
    /**
     * Get a generic node selector.
     * @param {Node} node The node for which you need a selector.
     * @returns {?String} Returns a string selector if it matches the argument criteria, `null` otherwise.
     */

  }, {
    key: "getNodeSelector",
    value: function getNodeSelector(node) {
      var _nodeSelectors$primar;

      var selectorData = {
        primary: {
          element: null,
          selector: null
        },
        intermediate: {
          element: null,
          selector: null
        },
        target: {
          element: null,
          selector: null
        }
      };
      var nodeSelectors = this.nodeSelectors;

      if (!((_nodeSelectors$primar = nodeSelectors.primary) !== null && _nodeSelectors$primar !== void 0 && _nodeSelectors$primar.length)) {
        return this.getStrictNodeSelector(node, nodeSelectors.selectorPostProcessor);
      }

      selectorData.primary = this.findNodeInSelectors(node, nodeSelectors.primary, false);

      if (!selectorData.primary.element) {
        return null;
      }

      selectorData.primary.selector += DomHelper.getNthChildString(selectorData.primary.element);
      var intermediateSelectors = nodeSelectors.intermediate || [];

      if (intermediateSelectors.length) {
        selectorData.intermediate = this.findNodeInSelectors(node, intermediateSelectors, false, selectorData.primary.element);

        if (!selectorData.intermediate.element) {
          return null;
        }

        selectorData.intermediate.selector += DomHelper.getNthChildString(selectorData.intermediate.element);
      }

      var activeIntermediateElement = selectorData.intermediate.element || selectorData.primary.element;
      selectorData.target = this.findNodeInSelectors(node, nodeSelectors.target, true, activeIntermediateElement);

      if (!selectorData.target.element) {
        return null;
      }

      selectorData.target.selector += DomHelper.getNthChildString(selectorData.target.element);

      if (typeof nodeSelectors.selectorPostProcessor === 'function') {
        selectorData = nodeSelectors.selectorPostProcessor(node, selectorData);
      }

      var selector = selectorData.primary.selector.trim();

      if (selectorData.intermediate.selector) {
        selector += ' ';
        selector += selectorData.intermediate.selector.replace(/:scope/, '').trim();
      }

      selector += ' ';
      selector += selectorData.target.selector.replace(/:scope/, '').trim();
      return selector;
    }
    /**
     * This method retrieves all the ancestor elements with an optional matching selector.
     * It's use here is to avoid depending on jQuery's `$.fn.parents`.
     * A conscious attempt is made to limit the matches within the contextContainer on the instance.
     * However, it is possible to skirt this check when the node is disconnected from contextContainer's
     * DOM tree.
     * @param {Node} node The node whose parents are to be retrieved.
     * @param {String} [selector] A string selector to match the parent elements.
     * @returns {Array} An array of parent nodes.
    */

  }, {
    key: "getParentElements",
    value: function getParentElements(node) {
      var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var contextContainerParent = this.contextContainerParent;
      var parentElements = [];
      var ancestorElement = node.parentElement;

      while (ancestorElement) {
        if (ancestorElement === contextContainerParent) {
          // This ensures that we avoid breaking out of
          // the container-context element with our checks.
          // It will match the `contextContainer` itself, but
          // will NOT match beyond `contextContainerParent`.
          break;
        } // We do NOT care if the `node` is within the ignored element list.
        // We DO care if the parent is in the ignored element list. Any
        // parents within the ignored-list will NOT be returned in the results.


        if (!this.isNodeInIgnoredList(ancestorElement)) {
          // `ancestorElement` is NOT in ignored list
          if (!selector || ancestorElement.matches(selector)) {
            parentElements.push(ancestorElement);
          }
        }

        ancestorElement = ancestorElement.parentElement;
      }

      return parentElements;
    }
    /**
     * Returns a strict CSS selector for the given node. Traversal stops at the `contextContainer`.
     * @param {Node} node The node for which a selector should be returned.
     * @param {Function} selectorPostProcessor The selector for the node can be post-processed using this function.
     * @param {String} selectorFragment The selector fragment that gets appended to during recursive operation.
     * @returns {String} The CSS selector.
     */

  }, {
    key: "getStrictNodeSelector",
    value: function getStrictNodeSelector(node) {
      var _element$localName;

      var selectorPostProcessor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var selectorFragment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      if (!node) {
        return null;
      }

      var parentElement = node.parentElement;

      if (DomHelper.isTextNode(node)) {
        return this.getStrictNodeSelector(parentElement, selectorPostProcessor);
      }

      if (!DomHelper.isElementNode(node)) {
        this.throwError('[getStrictNodeSelector] `node` should be either a Node.ELEMENT_NODE or Node.TEXT_NODE type.');
        return null;
      }

      var element = node;

      if (element === this.contextContainer) {
        var _this$contextContaine2;

        if (element.id) {
          return "#".concat(element.id, ">").concat(selectorFragment);
        }

        var contextContainerNodeName = (_this$contextContaine2 = this.contextContainer.nodeName) === null || _this$contextContaine2 === void 0 ? void 0 : _this$contextContaine2.toLowerCase();
        var contextContainerClassList = Array.from(this.contextContainer.classList);
        var contextContainerSelector = contextContainerClassList.length ? ".".concat(contextContainerClassList.join('.')) : contextContainerNodeName; // A string that represents a querySelector

        return "".concat(contextContainerSelector, ">").concat(selectorFragment);
      }

      var elementNodeName = (_element$localName = element.localName) === null || _element$localName === void 0 ? void 0 : _element$localName.trim().toLowerCase();

      var siblingElements = Object(toConsumableArray["a" /* default */])(parentElement.children);

      var selector = elementNodeName;

      if (siblingElements.length > 1) {
        // We only get here if we have siblings.
        var elementPosition = siblingElements.indexOf(element) + 1;

        if (elementPosition > 1) {
          // We only get here if the element is NOT the first child.
          selector += ":nth-child(".concat(elementPosition, ")");
        }
      }

      if (typeof selectorPostProcessor === 'function') {
        // If we have a selectorPostProcessor, use it.
        selector = selectorPostProcessor(element, selector);
      }

      var newSelectorFragment = selectorFragment;

      if (selector) {
        newSelectorFragment = selectorFragment.length ? "".concat(selector, ">").concat(selectorFragment) : selector;
      }

      return this.getStrictNodeSelector(parentElement, selectorPostProcessor, newSelectorFragment);
    }
    /**
     * Checks whether the given node belongs in this container context.
     * @param {Node} nodeToCheck The node to check.
     * @returns {Boolean} Returns `true` if yes, else returns `false`.
     */

  }, {
    key: "isNodeInContextContainer",
    value: function isNodeInContextContainer(nodeToCheck) {
      if (!nodeToCheck) {
        return false;
      }

      if (nodeToCheck === this.contextContainer) {
        // Return `true` if the node is the container context-context.
        return true;
      }

      var _DomHelper$compareNod3 = DomHelper.compareNodePosition(this.contextContainer, nodeToCheck),
          isDescendant = _DomHelper$compareNod3.isDescendant;

      return isDescendant;
    }
    /**
     * Checks whether the given node is in the block list.
     * @param {Node} nodeToCheck The node to check.
     * @returns {Boolean} Returns `true` if yes, else returns `false`.
     */

  }, {
    key: "isNodeInIgnoredList",
    value: function isNodeInIgnoredList(nodeToCheck) {
      var ignoredElements = this.ignoredElements.join(',');
      var isNodeInIgnoredList = ignoredElements ? this.isNodeInSelector(nodeToCheck, ignoredElements) : false;
      return isNodeInIgnoredList;
    }
    /**
     * Checks whether the given node is within, or matches the given selector.
     * @param {Node} nodeToCheck Checks if this node is within the specified selector.
     * @param {Node} selector The selector(s) to check against.
     * @returns {Boolean} Returns `true` if `nodeToCheck` is within, or matches the given selector, `false` otherwise.
     */

  }, {
    key: "isNodeInSelector",
    value: function isNodeInSelector(nodeToCheck, selector) {
      if (!nodeToCheck) {
        return false;
      }

      var selectorNodes = this.querySelectorAll(selector);
      return selectorNodes.some(function (selectorNode) {
        var position = DomHelper.compareNodePosition(selectorNode, nodeToCheck);
        return position.isDescendant || position.isSameNode;
      });
    }
    /**
     * Grabs all nodes that match the selector AND also the `contextContainer` (if it matches).
     * @param {String} selector The string selector to match.
     * @returns {Array} An array of matched descendents of contextContainer, and contextContainer (if matched).
     */

  }, {
    key: "querySelectorAll",
    value: function querySelectorAll(selector) {
      var _this$contextContaine3;

      var selectorNodes = Array.from(this.contextContainer.querySelectorAll(selector));

      if ((_this$contextContaine3 = this.contextContainer) !== null && _this$contextContaine3 !== void 0 && _this$contextContaine3.matches(selector)) {
        // If the selector matches the container-context,
        // return that along with the rest of the results.
        return [this.contextContainer].concat(selectorNodes);
      }

      return selectorNodes;
    }
    /**
     * Throws an error with the specified error message along with helpful
     * context and timestamp details.
     * @param {String} message The error message to associate with the error.
     * @param {Object} [options] Optional options to pass into the Error constructor.
     */

  }, {
    key: "throwError",
    value: function throwError(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var formattedMessage = "[DomHelper][client-id=".concat(this.clientId, "] ").concat(message);

      var parsedOptions = Object(objectSpread2["a" /* default */])({
        context: this
      }, options);

      return DomHelper.throwError(formattedMessage, parsedOptions);
    } // +===================================+
    // | Static implementation starts here |
    // +===================================+

  }], [{
    key: "checkNodeType",
    value:
    /**
     * Checks the given node against an array of node types to check against.
     * This method exists to improve the readability of code in other methods.
     * @param {Node} node The node to check.
     * @param {Array} allowedNodeTypes An array of node types to check against. Elements can be Node.ELEMENT_NODE, Node.TEXT_NODE, etc.
     * @returns {Boolean} Returns `true` if the node matches any of the given node types.
     */
    function checkNodeType(node, allowedNodeTypes) {
      var nodeType = (node === null || node === void 0 ? void 0 : node.nodeType) || null;
      return allowedNodeTypes.includes(nodeType);
    }
    /**
     * Returns an object with position related flags for easy consumption.
     * @param {Node} anchorNode The position will be compared against this node.
     * @param {Node} compareNode This is the node that will be used to compare against the `anchorNode`.
     * @returns {Object} An object with the position related flags.
     *                  {
     *                      isAncestor: {Boolean},
     *                      isDescendant: {Boolean},
     *                      isDisconnected: {Boolean},
     *                      isFollowing: {Boolean},
     *                      isPreceding: {Boolean},
     *                      isSameNode: {Boolean},
     *                      isUnreliable: {Boolean},
     *                  }
     */

  }, {
    key: "compareNodePosition",
    value: function compareNodePosition(anchorNode, compareNode) {
      var result = {
        isAncestor: false,
        isDescendant: false,
        isDisconnected: false,
        isFollowing: false,
        isPreceding: false,
        isSameNode: anchorNode === compareNode,
        isUnreliable: false
      };

      if (!anchorNode || !compareNode) {
        result.isUnreliable = true;
        return result;
      } // Native browser support provides element position as a bitmask.
      // https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition


      var positionBitmask = anchorNode.compareDocumentPosition(compareNode);
      /* eslint-disable no-bitwise */
      // Node.DOCUMENT_POSITION_DISCONNECTED (1)
      // Both nodes are in different documents or different trees in the same document.

      result.isDisconnected = !!(positionBitmask & Node.DOCUMENT_POSITION_DISCONNECTED); // Node.DOCUMENT_POSITION_PRECEDING (2)
      // otherNode precedes the node in either a pre-order depth-first traversal of a
      // tree containing both (e.g., as an ancestor or previous sibling or a descendant
      // of a previous sibling or previous sibling of an ancestor) or (if they are
      // disconnected) in an arbitrary but consistent ordering.

      result.isPreceding = !!(positionBitmask & Node.DOCUMENT_POSITION_PRECEDING); // Node.DOCUMENT_POSITION_FOLLOWING (4)
      // otherNode follows the node in either a pre-order depth-first traversal of a
      // tree containing both (e.g., as a descendant or following sibling or a
      // descendant of a following sibling or following sibling of an ancestor) or
      // (if they are disconnected) in an arbitrary but consistent ordering.

      result.isFollowing = !!(positionBitmask & Node.DOCUMENT_POSITION_FOLLOWING); // Node.DOCUMENT_POSITION_CONTAINS (8)
      // otherNode is an ancestor of the node.

      result.isAncestor = !!(positionBitmask & Node.DOCUMENT_POSITION_CONTAINS); // Node.DOCUMENT_POSITION_CONTAINED_BY (16)
      // otherNode is a descendant of the node.

      result.isDescendant = !!(positionBitmask & Node.DOCUMENT_POSITION_CONTAINED_BY); // Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC (32)
      // The result relies upon arbitrary and/or implementation-specific behavior
      // and is not guaranteed to be portable.

      result.isUnreliable = !!(positionBitmask & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC);
      /* eslint-enable no-bitwise */

      return result;
    }
    /**
     * Get all the element nodes within a given node.
     * @param {Node} node The node from which to extract the element nodes.
     * @returns {Array} An array of element-nodes for the given node.
     */

  }, {
    key: "getAllElementNodes",
    value: function getAllElementNodes(node) {
      var domHelper = new DomHelper();
      return domHelper.getAllElementNodes(node);
    }
    /**
     * Get all the text nodes within a given node.
     * @param {Node} node The node from which to extract the text nodes.
     * @param {Boolean} [ignoreEmptyTextNodes=true] Ignore empty text nodes. These nodes will NOT be returned in the final list. Defaults to `true`.
     * @returns {Array} An array of text-nodes for the given node.
     */

  }, {
    key: "getAllTextNodes",
    value: function getAllTextNodes(node) {
      var ignoreEmptyTextNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var domHelper = new DomHelper();
      return domHelper.getAllTextNodes(node, ignoreEmptyTextNodes);
    }
    /**
     * Get the common ancestor for the given nodes.
     * @param {Node} node1 The first node.
     * @param {Node} node2 The second node.
     * @returns {Node} The common ancestor for the given nodes.
     */

  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(node1, node2) {
      var domHelper = new DomHelper();
      return domHelper.getCommonAncestor(node1, node2);
    }
    /**
     * Gets the first text-node for the given node. If the given node is a text-node, returns itself.
     * @param {Node} node The node for which we need to grab the first text-node.
     * @returns {?Node.TEXT_NODE} Returns the first text-node it finds, otherwise returns `null`.
     */

  }, {
    key: "getFirstTextNode",
    value: function getFirstTextNode(node) {
      var domHelper = new DomHelper();
      return domHelper.getFirstTextNode(node);
    }
    /**
     * Grabs all the intermediate element-nodes for the given start and end nodes (excluding both).
     * @param {Node} startNode The start node.
     * @param {Node} endNode The end node.
     * @param {Node} [contextNode] The context-node to search for nodes. Only used internally for recursion.
     * @returns {Array} Returns an array of intermediate element nodes.
     */

  }, {
    key: "getIntermediateElementNodes",
    value: function getIntermediateElementNodes(startNode, endNode) {
      var contextNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var domHelper = new DomHelper();
      return domHelper.getIntermediateElementNodes(startNode, endNode, contextNode);
    }
    /**
     * Grabs all the intermediate text-nodes for the given start and end nodes (excluding both).
     * @param {Node} startNode The start node.
     * @param {Node} endNode The end node.
     * @param {Node} [contextNode] The context-node to search for nodes. Only used internally for recursion.
     * @returns {Array} Returns an array of intermediate text nodes.
     */

  }, {
    key: "getIntermediateTextNodes",
    value: function getIntermediateTextNodes(startNode, endNode) {
      var contextNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var domHelper = new DomHelper();
      return domHelper.getIntermediateTextNodes(startNode, endNode, contextNode);
    }
    /**
     * Gets the last text-node for the given node. If the given node is a text-node, returns itself.
     * @param {Node} node The node for which we need to grab the last text-node.
     * @returns {?Node.TEXT_NODE} Returns the first text-node it finds, otherwise returns `null`.
     */

  }, {
    key: "getLastTextNode",
    value: function getLastTextNode(node) {
      var domHelper = new DomHelper();
      return domHelper.getLastTextNode(node);
    }
    /**
     * Returns a unique numeric client-id for the current window and increments the _nextClientId counter by 1.
     * @returns {Number} A unique numeric client-id for the current window instance.
     */

  }, {
    key: "getNextClientId",
    value: function getNextClientId() {
      var nextClientId = this._nextClientId;
      this._nextClientId += 1;
      return nextClientId;
    }
    /**
     * Grabs the next sibling node. If one doesn't exist in the current parent,
     * it will continue searching for the next sibling in the next element tree.
     * @param {(Node.ELEMENT_NODE|Node.TEXT_NODE)} node The node for which we need the next sibling.
     * @returns {Node} Returns the next valid sibling.
     */

  }, {
    key: "getNextSibling",
    value: function getNextSibling(node) {
      var domHelper = new DomHelper();
      return domHelper.getNextSibling(node);
    }
    /**
     * Get the CSS selector for the given node.
     * @param {Node} node The node for which you need a selector.
     * @param {Object} nodeSelectors The nodeSelectors object with mandatory and optional data needed to generate the selector.
     * @param {String[]} nodeSelectors.primary The primary selectors to use. Higher priority selectors need to be put earlier in the array.
     * @param {String[]} [nodeSelectors.intermediate=[]] The intermediate selectors to use. Higher priority selectors need to be put earlier.
     * @param {String[]} nodeSelectors.target The target selectors to use. Higher priority selectors need to be put earlier.
     * @param {Function} [nodeSelectors.selectorPostProcessor] A delegate to post-process the selector data prior to finalizing the value.
     * @returns {?String} Returns a string selector if it matches the argument criteria, `null` otherwise.
     */

  }, {
    key: "getNodeSelector",
    value: function getNodeSelector(node) {
      var nodeSelectors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var domHelper = new DomHelper({
        nodeSelectors: {
          primary: (nodeSelectors === null || nodeSelectors === void 0 ? void 0 : nodeSelectors.primary) || null,
          intermediate: (nodeSelectors === null || nodeSelectors === void 0 ? void 0 : nodeSelectors.intermediate) || null,
          target: (nodeSelectors === null || nodeSelectors === void 0 ? void 0 : nodeSelectors.target) || null,
          selectorPostProcessor: (nodeSelectors === null || nodeSelectors === void 0 ? void 0 : nodeSelectors.selectorPostProcessor) || null
        }
      });
      return domHelper.getNodeSelector(node);
    }
    /**
     * Get the nth-child number for the given node.
     * @param {Node} node The node for which the nth-child number is to be returned.
     * @returns {Number} The nth-child number for the given node.
     */

  }, {
    key: "getNthChild",
    value: function getNthChild(node) {
      var targetElement = node;

      if (!this.isElementOrTextNode(node)) {
        return null;
      }

      if (this.isTextNode(node)) {
        targetElement = node.parentElement;
      }

      var _targetElement = targetElement,
          parentNode = _targetElement.parentNode;

      var siblingNodes = Object(toConsumableArray["a" /* default */])(parentNode.children);

      var nodePosition = 1;

      if (siblingNodes.length > 1) {
        nodePosition = siblingNodes.indexOf(targetElement) + 1;
      }

      return nodePosition;
    }
    /**
     * Get the nth-child string for the given node.
     * @param {Node} node The node for which the nth-child string is to be returned.
     * @returns {String} The nth-child string in the form of `':nth-child(n)'`, or a zero-length string `''`.
     */

  }, {
    key: "getNthChildString",
    value: function getNthChildString(node) {
      var nodePosition = this.getNthChild(node);

      if (nodePosition > 1) {
        return ":nth-child(".concat(nodePosition, ")");
      }

      return '';
    }
    /**
     * Get the offset of the text node in relation with the parent element.
     * @param {Node.TEXT_NODE} textNode The text-node for which we need the offset from the parent element.
     * @param {Node.ELEMENT_NODE} contextElement The ancestor element from which to calculate the offsets.
     * @param {Number} relativeOffset A relative offset by which the calculated offset will be adjusted. Can be positive or negative. Defaults to 0.
     * @returns {?Number} Returns `null` if the node is NOT a text-node or if it doesn't exist in the DOM.
     */

  }, {
    key: "getOffsetForTextNode",
    value: function getOffsetForTextNode(textNode, contextElement) {
      var relativeOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      // <div class="get-node-selector-terminates-here">
      //     Text node #1
      //     <br />
      //     <span>Text node #2</span>
      //     <br />
      //     Text node #3
      //     <br />
      //     Text node #4 // textNode
      // </div>
      if (!this.isTextNode(textNode) || !this.isNodeInDom(textNode) || !this.isElementNode(contextElement) || !this.isNodeInDom(contextElement)) {
        // If `textNode` is NOT a text-node,
        // or it is NOT in the DOM (parentElement is unset),
        // return without processing.
        return null;
      }

      var trueNodeOffset = 0;
      var textNodes = this.getAllTextNodes(contextElement, false);
      textNodes.some(function (currentTextNode) {
        if (currentTextNode === textNode) {
          trueNodeOffset += relativeOffset;
          return true;
        }

        trueNodeOffset += currentTextNode.textContent.length;
        return false;
      });
      return trueNodeOffset;
    }
    /**
     * This method retrieves all the ancestor elements with an optional matching selector.
     * It's use here is to avoid depending on jQuery's `$.fn.parents`.
     * @param {Node} node The node whose parents are to be retrieved.
     * @param {String} [selector] A string selector to match the parent elements.
     * @returns {Array} An array of parent nodes.
    */

  }, {
    key: "getParentElements",
    value: function getParentElements(node) {
      var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var domHelper = new DomHelper();
      return domHelper.getParentElements(node, selector);
    }
    /**
     * Get the CSS selector for the given node.
     * @param {Node} node The node from which to calculate the selector.
     * @param {Function} selectorPostProcessor The selector for the node can be post-processed using this function.
     * @returns {String} The calculated selector for the given node.
     */

  }, {
    key: "getStrictNodeSelector",
    value: function getStrictNodeSelector(node) {
      var selectorPostProcessor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var domHelper = new DomHelper();
      return domHelper.getStrictNodeSelector(node, selectorPostProcessor);
    }
    /**
     * Given a node and offset, gets the correct text node within it and returns the target and relative offset.
     * @param {Node} node The node to search within.
     * @param {Number} trueOffset The true offset to use for the search.
     * @param {Boolean} [preferNextNode] If set to `true` (default), will prefer to "spill over"
     *                                   to the next node when at the edge of the current node.
     *                                   If set to `false`, will prefer to stay within the confines
     *                                   of a given node.
     * @returns {Object} Returns an object with the `targetNode` and the relative `offset` as properties.
     */

  }, {
    key: "getTextNodeFromOffset",
    value: function getTextNodeFromOffset(node, trueOffset) {
      var preferNextNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var nextNode = node;
      var targetTextNode = null;
      var relativeOffset = trueOffset;

      do {
        var textNodes = this.getAllTextNodes(nextNode, false); // eslint-disable-next-line no-loop-func

        targetTextNode = textNodes.find(function (textNode) {
          var textLength = textNode.textContent.length;

          if (relativeOffset > textLength || preferNextNode && relativeOffset === textLength) {
            // If the current offset is larger or equal to
            // the current text length, we have not
            // found the correct target node yet.
            //
            // Subtract the length from the offset,
            // and repeat the process.
            relativeOffset -= textLength; // Rinse & repeat

            return false;
          } // Found the target node


          return true;
        }) || null;
        nextNode = this.getNextSibling(nextNode);
      } while (targetTextNode === null && nextNode);

      return {
        targetNode: targetTextNode,
        relativeOffset: relativeOffset
      };
    }
    /**
     * Injects a given Element within targetNode at the provided offsets. If unspecified, it will use the start and end
     * of the given node.
     * @param {(Node.ELEMENT_NODE|Node.TEXT_NODE)} targetNode The node that we want to modify.
     * @param {Node.ELEMENT_NODE} injectionElement The element that we want to inject.
     * @param {Number} [startOffset] Optional start offset. Defaults to `0`.
     * @param {Number} [endOffset] Optional end offset. Defaults to end of string.
     */

  }, {
    key: "injectElementInNode",
    value: function injectElementInNode(targetNode, injectionElement) {
      var startOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var newHtmlContent = null;

      if (this.isElementNode(targetNode)) {
        // When targetNode is an element we update
        // offsets to start within the node.
        // <div class="target">My test content</div>
        newHtmlContent = targetNode.outerHTML;
        var nodeStartOffset = newHtmlContent.indexOf('>') + 1;
        var nodeEndOffset = newHtmlContent.lastIndexOf('</'); // <div>abcd efg</div>, 1, 3
        // nodeStartOffset = 4 , nodeEndOffset = 12 - node-offsets
        // startOffset = 5, endOffset = 7
        // <div>abcd efg</div>, 0, 0
        // nodeStartOffset = 4 , nodeEndOffset = 12 - node-offsets
        // startOffset = 4, endOffset = 4
        // <div>abcd efg</div>, null, null
        // nodeStartOffset = 4 , nodeEndOffset = 12 - node-offsets
        // startOffset = 4, endOffset = 12

        /* eslint-disable no-param-reassign */

        startOffset = startOffset || 0;
        startOffset += nodeStartOffset;

        if (endOffset === null) {
          endOffset = nodeEndOffset;
        } else {
          endOffset += nodeStartOffset;
        }
        /* eslint-disable no-param-reassign */

      } else if (this.isTextNode(targetNode)) {
        // Text node
        newHtmlContent = targetNode.textContent;
        /* eslint-disable no-param-reassign */

        startOffset = startOffset || 0;
        endOffset = endOffset || newHtmlContent.length;
        /* eslint-enable no-param-reassign */
      } else {
        // No support for other node-types
        this.throwError('[injectElementInNode] Node needs to be an Element or a Text node.');
        return;
      }

      if (!newHtmlContent.trim().length) {
        // If the content is empty, do NOT inject anything.
        return;
      } // 'test'


      var wrappedString = newHtmlContent.substring(startOffset, endOffset); // <span class="injection-element">test</span>
      // eslint-disable-next-line no-param-reassign

      injectionElement.innerHTML = wrappedString; // <span class="injection-element">test</span>

      var injectionElementStr = injectionElement.outerHTML;
      var preStr = newHtmlContent.substring(0, startOffset);
      var postStr = newHtmlContent.substring(endOffset); // <div class="target">My <span class="injection-element">test</span> content</div>

      newHtmlContent = "".concat(preStr).concat(injectionElementStr).concat(postStr);
      this.replaceNodeWithContent(targetNode, newHtmlContent);
    }
    /**
     * Injects a particular string within targetStr and the given index.
     * @param {String} targetStr The string where `injectionStr` will be injected into.
     * @param {String} injectionStr The string to inject.
     * @param {Number} injectionIndex The (zero-based) index where the string needs to be injected in `targetStr`.
     * @returns {String} The updated string.
     */

  }, {
    key: "injectStringAtIndex",
    value: function injectStringAtIndex(targetStr, injectionStr, injectionIndex) {
      var preStr = targetStr.substring(0, injectionIndex);
      var postStr = targetStr.substring(injectionIndex);
      var updatedStr = "".concat(preStr).concat(injectionStr).concat(postStr);
      return updatedStr;
    }
    /**
     * Check whether a given node is an element-node.
     * @param {Node} node The node to check.
     * @returns {Boolean} Returns `true` if the node is an element-node.
     */

  }, {
    key: "isElementNode",
    value: function isElementNode(node) {
      return this.checkNodeType(node, [Node.ELEMENT_NODE]);
    }
    /**
     * Check whether a given node is either an element-node or a text-node.
     * @param {Node} node The node to check.
     * @returns {Boolean} Returns `true` if the node is either an element-node or a text-node.
     */

  }, {
    key: "isElementOrTextNode",
    value: function isElementOrTextNode(node) {
      return this.checkNodeType(node, [Node.ELEMENT_NODE, Node.TEXT_NODE]);
    }
    /**
     * Checks whether the given parameter is an instance of node.
     * @param {Any} param The parameter to check.
     * @returns {Boolean} Returns `true` if the given parameter is an instance of Node.
     */

  }, {
    key: "isNode",
    value: function isNode(param) {
      // See https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#value
      var validNodeTypes = [Node.ELEMENT_NODE, Node.ATTRIBUTE_NODE, Node.TEXT_NODE, Node.CDATA_SECTION_NODE, Node.PROCESSING_INSTRUCTION_NODE, Node.COMMENT_NODE, Node.DOCUMENT_NODE, Node.DOCUMENT_TYPE_NODE, Node.DOCUMENT_FRAGMENT_NODE];
      return validNodeTypes.includes(param === null || param === void 0 ? void 0 : param.nodeType);
    }
    /**
     * Checks whether the given node is present in the DOM.
     * @param {Node} node The node to check.
     * @returns {Boolean} Returns `true` if the node is in the DOM.
     */

  }, {
    key: "isNodeInDom",
    value: function isNodeInDom(node) {
      // Whenever node is NOT in the DOM,
      // either because it was not injected yet
      // after being created in a script,
      // OR,
      // if it was removed from the DOM after we
      // got a handle to it,
      // the `parentNode` is always unset.
      //
      // The only exception to this is `document`.
      // The document itself does NOT have a parent.
      if (node === document) {
        return true;
      }

      return !!(node !== null && node !== void 0 && node.parentNode);
    }
    /**
     * Checks whether the given node is within, or matches the given selector.
     * @param {Node} nodeToCheck Checks if this node is within the specified selector.
     * @param {Node} selector The selector(s) to check against.
     * @returns {Boolean} Returns `true` if `nodeToCheck` is within, or matches the given selector, `false` otherwise.
     */

  }, {
    key: "isNodeInSelector",
    value: function isNodeInSelector(nodeToCheck, selector) {
      var domHelper = new DomHelper();
      return domHelper.isNodeInSelector(nodeToCheck, selector);
    }
    /**
     * Check whether a given node is a text-node.
     * @param {Node} node The node to check.
     * @returns {Boolean} Returns `true` if the node is a text-node.
     */

  }, {
    key: "isTextNode",
    value: function isTextNode(node) {
      return this.checkNodeType(node, [Node.TEXT_NODE]);
    }
    /**
     * Replace a node with a string representation of the HTML to replace with. Text fragments are supported.
     * @param {Node} targetNode The node to replace.
     * @param {String} replacementContent The HTML content to replace the node with.
     */

  }, {
    key: "replaceNodeWithContent",
    value: function replaceNodeWithContent(targetNode, replacementContent) {
      var parentElement = targetNode.parentElement;
      var fragment = document.createRange().createContextualFragment(replacementContent);
      targetNode.replaceWith(fragment);
      parentElement.normalize();
    }
    /**
     * Throws an error with the specified error message along with helpful
     * context and timestamp details.
     * @param {String} message The error message to associate with the error.
     * @param {Object} [options] Optional options to pass into the Error constructor.
     */

  }, {
    key: "throwError",
    value: function throwError(message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var formattedMessage = "[DomHelper] ".concat(message);
      var errorOptions = {
        cause: Object(objectSpread2["a" /* default */])({
          context: this,
          timestamp: new Date()
        }, options)
      };
      throw new Error(formattedMessage, errorOptions);
    }
  }]);

  return DomHelper;
}();

Object(defineProperty["a" /* default */])(dom_DomHelper, "_nextClientId", 1);

/* harmony default export */ var dom = (dom_DomHelper);
// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__("c0e2");
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSlice.js
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/* harmony default export */ var _baseSlice = (baseSlice);

// EXTERNAL MODULE: ./node_modules/lodash-es/eq.js
var eq = __webpack_require__("6071");

// EXTERNAL MODULE: ./node_modules/lodash-es/isFunction.js
var isFunction = __webpack_require__("bc9b");

// CONCATENATED MODULE: ./node_modules/lodash-es/isLength.js
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isLength = (isLength);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLike.js



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && lodash_es_isLength(value.length) && !Object(isFunction["a" /* default */])(value);
}

/* harmony default export */ var lodash_es_isArrayLike = (isArrayLike);

// EXTERNAL MODULE: ./node_modules/lodash-es/_isIndex.js
var _isIndex = __webpack_require__("7129");

// EXTERNAL MODULE: ./node_modules/lodash-es/isObject.js
var isObject = __webpack_require__("2332");

// CONCATENATED MODULE: ./node_modules/lodash-es/_isIterateeCall.js





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(isObject["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (lodash_es_isArrayLike(object) && Object(_isIndex["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(eq["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ var _isIterateeCall = (isIterateeCall);

// EXTERNAL MODULE: ./node_modules/lodash-es/toInteger.js
var toInteger = __webpack_require__("7ec8");

// CONCATENATED MODULE: ./node_modules/lodash-es/chunk.js




/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? _isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(Object(toInteger["a" /* default */])(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = _baseSlice(array, index, (index += size));
  }
  return result;
}

/* harmony default export */ var lodash_es_chunk = (chunk);

// CONCATENATED MODULE: ./node_modules/lodash-es/compact.js
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var lodash_es_compact = (compact);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayPush.js
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ var _arrayPush = (arrayPush);

// EXTERNAL MODULE: ./node_modules/lodash-es/_Symbol.js
var _Symbol = __webpack_require__("ca54");

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseGetTag.js + 2 modules
var _baseGetTag = __webpack_require__("f0ce");

// EXTERNAL MODULE: ./node_modules/lodash-es/isObjectLike.js
var isObjectLike = __webpack_require__("1147");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArguments.js



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == argsTag;
}

/* harmony default export */ var _baseIsArguments = (baseIsArguments);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArguments.js



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isArguments_hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return Object(isObjectLike["a" /* default */])(value) && isArguments_hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ var lodash_es_isArguments = (isArguments);

// EXTERNAL MODULE: ./node_modules/lodash-es/isArray.js
var isArray = __webpack_require__("ff51");

// CONCATENATED MODULE: ./node_modules/lodash-es/_isFlattenable.js




/** Built-in value references. */
var spreadableSymbol = _Symbol["a" /* default */] ? _Symbol["a" /* default */].isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return Object(isArray["a" /* default */])(value) || lodash_es_isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/* harmony default export */ var _isFlattenable = (isFlattenable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFlatten.js



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = _isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* harmony default export */ var _baseFlatten = (baseFlatten);

// EXTERNAL MODULE: ./node_modules/lodash-es/_copyArray.js
var _copyArray = __webpack_require__("7804");

// CONCATENATED MODULE: ./node_modules/lodash-es/concat.js





/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return _arrayPush(Object(isArray["a" /* default */])(array) ? Object(_copyArray["a" /* default */])(array) : [array], _baseFlatten(args, 1));
}

/* harmony default export */ var lodash_es_concat = (concat);

// EXTERNAL MODULE: ./node_modules/lodash-es/_MapCache.js + 14 modules
var _MapCache = __webpack_require__("0e59");

// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheAdd.js
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ var _setCacheAdd = (setCacheAdd);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setCacheHas.js
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ var _setCacheHas = (setCacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_SetCache.js




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

/* harmony default export */ var _SetCache = (SetCache);

// EXTERNAL MODULE: ./node_modules/lodash-es/_arrayIncludes.js
var _arrayIncludes = __webpack_require__("72fb");

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayIncludesWith.js
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ var _arrayIncludesWith = (arrayIncludesWith);

// EXTERNAL MODULE: ./node_modules/lodash-es/_arrayMap.js
var _arrayMap = __webpack_require__("b703");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnary.js
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ var _baseUnary = (baseUnary);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cacheHas.js
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ var _cacheHas = (cacheHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseDifference.js







/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes["a" /* default */],
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = Object(_arrayMap["a" /* default */])(values, _baseUnary(iteratee));
  }
  if (comparator) {
    includes = _arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = _cacheHas;
    isCommon = false;
    values = new _SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ var _baseDifference = (baseDifference);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseRest.js
var _baseRest = __webpack_require__("2d5d");

// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayLikeObject.js



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(isObjectLike["a" /* default */])(value) && lodash_es_isArrayLike(value);
}

/* harmony default export */ var lodash_es_isArrayLikeObject = (isArrayLikeObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/difference.js





/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = Object(_baseRest["a" /* default */])(function(array, values) {
  return lodash_es_isArrayLikeObject(array)
    ? _baseDifference(array, _baseFlatten(values, 1, lodash_es_isArrayLikeObject, true))
    : [];
});

/* harmony default export */ var lodash_es_difference = (difference);

// EXTERNAL MODULE: ./node_modules/lodash-es/_ListCache.js + 6 modules
var _ListCache = __webpack_require__("9cbb");

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackClear.js


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache["a" /* default */];
  this.size = 0;
}

/* harmony default export */ var _stackClear = (stackClear);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackDelete.js
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ var _stackDelete = (stackDelete);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackGet.js
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ var _stackGet = (stackGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackHas.js
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ var _stackHas = (stackHas);

// EXTERNAL MODULE: ./node_modules/lodash-es/_Map.js
var _Map = __webpack_require__("ddc9");

// CONCATENATED MODULE: ./node_modules/lodash-es/_stackSet.js




/** Used as the size to enable large array optimizations. */
var _stackSet_LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache["a" /* default */]) {
    var pairs = data.__data__;
    if (!_Map["a" /* default */] || (pairs.length < _stackSet_LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ var _stackSet = (stackSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Stack.js







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

/* harmony default export */ var _Stack = (Stack);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySome.js
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ var _arraySome = (arraySome);

// CONCATENATED MODULE: ./node_modules/lodash-es/_equalArrays.js




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalArrays = (equalArrays);

// EXTERNAL MODULE: ./node_modules/lodash-es/_root.js
var _root = __webpack_require__("26ee");

// CONCATENATED MODULE: ./node_modules/lodash-es/_Uint8Array.js


/** Built-in value references. */
var _Uint8Array_Uint8Array = _root["a" /* default */].Uint8Array;

/* harmony default export */ var _Uint8Array = (_Uint8Array_Uint8Array);

// CONCATENATED MODULE: ./node_modules/lodash-es/_mapToArray.js
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ var _mapToArray = (mapToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setToArray.js
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ var _setToArray = (setToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_equalByTag.js







/** Used to compose bitmasks for value comparisons. */
var _equalByTag_COMPARE_PARTIAL_FLAG = 1,
    _equalByTag_COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol["a" /* default */] ? _Symbol["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(eq["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = _mapToArray;

    case setTag:
      var isPartial = bitmask & _equalByTag_COMPARE_PARTIAL_FLAG;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= _equalByTag_COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ var _equalByTag = (equalByTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetAllKeys.js



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(isArray["a" /* default */])(object) ? result : _arrayPush(result, symbolsFunc(object));
}

/* harmony default export */ var _baseGetAllKeys = (baseGetAllKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayFilter.js
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ var _arrayFilter = (arrayFilter);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubArray.js
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ var lodash_es_stubArray = (stubArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbols.js



/** Used for built-in method references. */
var _getSymbols_objectProto = Object.prototype;

/** Built-in value references. */
var _getSymbols_propertyIsEnumerable = _getSymbols_objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? lodash_es_stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return _getSymbols_propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ var _getSymbols = (getSymbols);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseTimes.js
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ var _baseTimes = (baseTimes);

// EXTERNAL MODULE: ./node_modules/lodash-es/isBuffer.js
var isBuffer = __webpack_require__("58e0");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsTypedArray.js




/** `Object#toString` result references. */
var _baseIsTypedArray_argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    _baseIsTypedArray_boolTag = '[object Boolean]',
    _baseIsTypedArray_dateTag = '[object Date]',
    _baseIsTypedArray_errorTag = '[object Error]',
    funcTag = '[object Function]',
    _baseIsTypedArray_mapTag = '[object Map]',
    _baseIsTypedArray_numberTag = '[object Number]',
    objectTag = '[object Object]',
    _baseIsTypedArray_regexpTag = '[object RegExp]',
    _baseIsTypedArray_setTag = '[object Set]',
    _baseIsTypedArray_stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var _baseIsTypedArray_arrayBufferTag = '[object ArrayBuffer]',
    _baseIsTypedArray_dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[_baseIsTypedArray_argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[_baseIsTypedArray_arrayBufferTag] = typedArrayTags[_baseIsTypedArray_boolTag] =
typedArrayTags[_baseIsTypedArray_dataViewTag] = typedArrayTags[_baseIsTypedArray_dateTag] =
typedArrayTags[_baseIsTypedArray_errorTag] = typedArrayTags[funcTag] =
typedArrayTags[_baseIsTypedArray_mapTag] = typedArrayTags[_baseIsTypedArray_numberTag] =
typedArrayTags[objectTag] = typedArrayTags[_baseIsTypedArray_regexpTag] =
typedArrayTags[_baseIsTypedArray_setTag] = typedArrayTags[_baseIsTypedArray_stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(isObjectLike["a" /* default */])(value) &&
    lodash_es_isLength(value.length) && !!typedArrayTags[Object(_baseGetTag["a" /* default */])(value)];
}

/* harmony default export */ var _baseIsTypedArray = (baseIsTypedArray);

// EXTERNAL MODULE: ./node_modules/lodash-es/_nodeUtil.js
var _nodeUtil = __webpack_require__("c6eb");

// CONCATENATED MODULE: ./node_modules/lodash-es/isTypedArray.js




/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

/* harmony default export */ var lodash_es_isTypedArray = (isTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayLikeKeys.js







/** Used for built-in method references. */
var _arrayLikeKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _arrayLikeKeys_hasOwnProperty = _arrayLikeKeys_objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(isArray["a" /* default */])(value),
      isArg = !isArr && lodash_es_isArguments(value),
      isBuff = !isArr && !isArg && Object(isBuffer["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && lodash_es_isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || _arrayLikeKeys_hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(_isIndex["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _arrayLikeKeys = (arrayLikeKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isPrototype.js
/** Used for built-in method references. */
var _isPrototype_objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || _isPrototype_objectProto;

  return value === proto;
}

/* harmony default export */ var _isPrototype = (isPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeys.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

/* harmony default export */ var _nativeKeys = (nativeKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeys.js



/** Used for built-in method references. */
var _baseKeys_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeys_hasOwnProperty = _baseKeys_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (_baseKeys_hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeys = (baseKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/keys.js




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

/* harmony default export */ var lodash_es_keys = (keys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeys.js




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, lodash_es_keys, _getSymbols);
}

/* harmony default export */ var _getAllKeys = (getAllKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/_equalObjects.js


/** Used to compose bitmasks for value comparisons. */
var _equalObjects_COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var _equalObjects_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _equalObjects_hasOwnProperty = _equalObjects_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & _equalObjects_COMPARE_PARTIAL_FLAG,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : _equalObjects_hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ var _equalObjects = (equalObjects);

// EXTERNAL MODULE: ./node_modules/lodash-es/_getNative.js + 1 modules
var _getNative = __webpack_require__("63bc");

// CONCATENATED MODULE: ./node_modules/lodash-es/_DataView.js



/* Built-in method references that are verified to be native. */
var DataView = Object(_getNative["a" /* default */])(_root["a" /* default */], 'DataView');

/* harmony default export */ var _DataView = (DataView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Promise.js



/* Built-in method references that are verified to be native. */
var _Promise_Promise = Object(_getNative["a" /* default */])(_root["a" /* default */], 'Promise');

/* harmony default export */ var _Promise = (_Promise_Promise);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Set.js



/* Built-in method references that are verified to be native. */
var Set = Object(_getNative["a" /* default */])(_root["a" /* default */], 'Set');

/* harmony default export */ var _Set = (Set);

// EXTERNAL MODULE: ./node_modules/lodash-es/_WeakMap.js
var _WeakMap = __webpack_require__("9b92");

// EXTERNAL MODULE: ./node_modules/lodash-es/_toSource.js
var _toSource = __webpack_require__("74b5");

// CONCATENATED MODULE: ./node_modules/lodash-es/_getTag.js








/** `Object#toString` result references. */
var _getTag_mapTag = '[object Map]',
    _getTag_objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    _getTag_setTag = '[object Set]',
    _getTag_weakMapTag = '[object WeakMap]';

var _getTag_dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(_toSource["a" /* default */])(_DataView),
    mapCtorString = Object(_toSource["a" /* default */])(_Map["a" /* default */]),
    promiseCtorString = Object(_toSource["a" /* default */])(_Promise),
    setCtorString = Object(_toSource["a" /* default */])(_Set),
    weakMapCtorString = Object(_toSource["a" /* default */])(_WeakMap["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != _getTag_dataViewTag) ||
    (_Map["a" /* default */] && getTag(new _Map["a" /* default */]) != _getTag_mapTag) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != _getTag_setTag) ||
    (_WeakMap["a" /* default */] && getTag(new _WeakMap["a" /* default */]) != _getTag_weakMapTag)) {
  getTag = function(value) {
    var result = Object(_baseGetTag["a" /* default */])(value),
        Ctor = result == _getTag_objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(_toSource["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return _getTag_dataViewTag;
        case mapCtorString: return _getTag_mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return _getTag_setTag;
        case weakMapCtorString: return _getTag_weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ var _getTag = (getTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqualDeep.js









/** Used to compose bitmasks for value comparisons. */
var _baseIsEqualDeep_COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var _baseIsEqualDeep_argsTag = '[object Arguments]',
    _baseIsEqualDeep_arrayTag = '[object Array]',
    _baseIsEqualDeep_objectTag = '[object Object]';

/** Used for built-in method references. */
var _baseIsEqualDeep_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseIsEqualDeep_hasOwnProperty = _baseIsEqualDeep_objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(isArray["a" /* default */])(object),
      othIsArr = Object(isArray["a" /* default */])(other),
      objTag = objIsArr ? _baseIsEqualDeep_arrayTag : _getTag(object),
      othTag = othIsArr ? _baseIsEqualDeep_arrayTag : _getTag(other);

  objTag = objTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : objTag;
  othTag = othTag == _baseIsEqualDeep_argsTag ? _baseIsEqualDeep_objectTag : othTag;

  var objIsObj = objTag == _baseIsEqualDeep_objectTag,
      othIsObj = othTag == _baseIsEqualDeep_objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(isBuffer["a" /* default */])(object)) {
    if (!Object(isBuffer["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || lodash_es_isTypedArray(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & _baseIsEqualDeep_COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && _baseIsEqualDeep_hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && _baseIsEqualDeep_hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ var _baseIsEqualDeep = (baseIsEqualDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsEqual.js



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(isObjectLike["a" /* default */])(value) && !Object(isObjectLike["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ var _baseIsEqual = (baseIsEqual);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsMatch.js



/** Used to compose bitmasks for value comparisons. */
var _baseIsMatch_COMPARE_PARTIAL_FLAG = 1,
    _baseIsMatch_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new _Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? _baseIsEqual(srcValue, objValue, _baseIsMatch_COMPARE_PARTIAL_FLAG | _baseIsMatch_COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ var _baseIsMatch = (baseIsMatch);

// CONCATENATED MODULE: ./node_modules/lodash-es/_isStrictComparable.js


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(isObject["a" /* default */])(value);
}

/* harmony default export */ var _isStrictComparable = (isStrictComparable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getMatchData.js



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = lodash_es_keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, _isStrictComparable(value)];
  }
  return result;
}

/* harmony default export */ var _getMatchData = (getMatchData);

// CONCATENATED MODULE: ./node_modules/lodash-es/_matchesStrictComparable.js
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ var _matchesStrictComparable = (matchesStrictComparable);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMatches.js




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = _getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || _baseIsMatch(object, source, matchData);
  };
}

/* harmony default export */ var _baseMatches = (baseMatches);

// EXTERNAL MODULE: ./node_modules/lodash-es/get.js
var lodash_es_get = __webpack_require__("ec41");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseHasIn.js
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ var _baseHasIn = (baseHasIn);

// EXTERNAL MODULE: ./node_modules/lodash-es/_castPath.js
var _castPath = __webpack_require__("2250");

// EXTERNAL MODULE: ./node_modules/lodash-es/_toKey.js
var _toKey = __webpack_require__("4dc8");

// CONCATENATED MODULE: ./node_modules/lodash-es/_hasPath.js







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(_castPath["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(_toKey["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && lodash_es_isLength(length) && Object(_isIndex["a" /* default */])(key, length) &&
    (Object(isArray["a" /* default */])(object) || lodash_es_isArguments(object));
}

/* harmony default export */ var _hasPath = (hasPath);

// CONCATENATED MODULE: ./node_modules/lodash-es/hasIn.js



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && _hasPath(object, path, _baseHasIn);
}

/* harmony default export */ var lodash_es_hasIn = (hasIn);

// EXTERNAL MODULE: ./node_modules/lodash-es/_isKey.js
var _isKey = __webpack_require__("bd8f");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMatchesProperty.js








/** Used to compose bitmasks for value comparisons. */
var _baseMatchesProperty_COMPARE_PARTIAL_FLAG = 1,
    _baseMatchesProperty_COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(_isKey["a" /* default */])(path) && _isStrictComparable(srcValue)) {
    return _matchesStrictComparable(Object(_toKey["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(lodash_es_get["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? lodash_es_hasIn(object, path)
      : _baseIsEqual(srcValue, objValue, _baseMatchesProperty_COMPARE_PARTIAL_FLAG | _baseMatchesProperty_COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ var _baseMatchesProperty = (baseMatchesProperty);

// EXTERNAL MODULE: ./node_modules/lodash-es/identity.js
var identity = __webpack_require__("f976");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseProperty.js
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _baseProperty = (baseProperty);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseGet.js
var _baseGet = __webpack_require__("5132");

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePropertyDeep.js


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(_baseGet["a" /* default */])(object, path);
  };
}

/* harmony default export */ var _basePropertyDeep = (basePropertyDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/property.js





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(_isKey["a" /* default */])(path) ? _baseProperty(Object(_toKey["a" /* default */])(path)) : _basePropertyDeep(path);
}

/* harmony default export */ var lodash_es_property = (property);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIteratee.js






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(isArray["a" /* default */])(value)
      ? _baseMatchesProperty(value[0], value[1])
      : _baseMatches(value);
  }
  return lodash_es_property(value);
}

/* harmony default export */ var _baseIteratee = (baseIteratee);

// CONCATENATED MODULE: ./node_modules/lodash-es/last.js
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ var lodash_es_last = (last);

// CONCATENATED MODULE: ./node_modules/lodash-es/differenceBy.js







/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = Object(_baseRest["a" /* default */])(function(array, values) {
  var iteratee = lodash_es_last(values);
  if (lodash_es_isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return lodash_es_isArrayLikeObject(array)
    ? _baseDifference(array, _baseFlatten(values, 1, lodash_es_isArrayLikeObject, true), _baseIteratee(iteratee, 2))
    : [];
});

/* harmony default export */ var lodash_es_differenceBy = (differenceBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/differenceWith.js






/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */
var differenceWith = Object(_baseRest["a" /* default */])(function(array, values) {
  var comparator = lodash_es_last(values);
  if (lodash_es_isArrayLikeObject(comparator)) {
    comparator = undefined;
  }
  return lodash_es_isArrayLikeObject(array)
    ? _baseDifference(array, _baseFlatten(values, 1, lodash_es_isArrayLikeObject, true), undefined, comparator)
    : [];
});

/* harmony default export */ var lodash_es_differenceWith = (differenceWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/drop.js



/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function drop(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : Object(toInteger["a" /* default */])(n);
  return _baseSlice(array, n < 0 ? 0 : n, length);
}

/* harmony default export */ var lodash_es_drop = (drop);

// CONCATENATED MODULE: ./node_modules/lodash-es/dropRight.js



/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : Object(toInteger["a" /* default */])(n);
  n = length - n;
  return _baseSlice(array, 0, n < 0 ? 0 : n);
}

/* harmony default export */ var lodash_es_dropRight = (dropRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseWhile.js


/**
 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
 * without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {Function} predicate The function invoked per iteration.
 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the slice of `array`.
 */
function baseWhile(array, predicate, isDrop, fromRight) {
  var length = array.length,
      index = fromRight ? length : -1;

  while ((fromRight ? index-- : ++index < length) &&
    predicate(array[index], index, array)) {}

  return isDrop
    ? _baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
    : _baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
}

/* harmony default export */ var _baseWhile = (baseWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/dropRightWhile.js



/**
 * Creates a slice of `array` excluding elements dropped from the end.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.dropRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropRightWhile(users, ['active', false]);
 * // => objects for ['barney']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropRightWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropRightWhile(array, predicate) {
  return (array && array.length)
    ? _baseWhile(array, _baseIteratee(predicate, 3), true, true)
    : [];
}

/* harmony default export */ var lodash_es_dropRightWhile = (dropRightWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/dropWhile.js



/**
 * Creates a slice of `array` excluding elements dropped from the beginning.
 * Elements are dropped until `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.dropWhile(users, function(o) { return !o.active; });
 * // => objects for ['pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.dropWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.dropWhile(users, ['active', false]);
 * // => objects for ['pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.dropWhile(users, 'active');
 * // => objects for ['barney', 'fred', 'pebbles']
 */
function dropWhile(array, predicate) {
  return (array && array.length)
    ? _baseWhile(array, _baseIteratee(predicate, 3), true)
    : [];
}

/* harmony default export */ var lodash_es_dropWhile = (dropWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseClamp.js
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/* harmony default export */ var _baseClamp = (baseClamp);

// CONCATENATED MODULE: ./node_modules/lodash-es/toLength.js



/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Converts `value` to an integer suitable for use as the length of an
 * array-like object.
 *
 * **Note:** This method is based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toLength(3.2);
 * // => 3
 *
 * _.toLength(Number.MIN_VALUE);
 * // => 0
 *
 * _.toLength(Infinity);
 * // => 4294967295
 *
 * _.toLength('3.2');
 * // => 3
 */
function toLength(value) {
  return value ? _baseClamp(Object(toInteger["a" /* default */])(value), 0, MAX_ARRAY_LENGTH) : 0;
}

/* harmony default export */ var lodash_es_toLength = (toLength);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFill.js



/**
 * The base implementation of `_.fill` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 */
function baseFill(array, value, start, end) {
  var length = array.length;

  start = Object(toInteger["a" /* default */])(start);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : Object(toInteger["a" /* default */])(end);
  if (end < 0) {
    end += length;
  }
  end = start > end ? 0 : lodash_es_toLength(end);
  while (start < end) {
    array[start++] = value;
  }
  return array;
}

/* harmony default export */ var _baseFill = (baseFill);

// CONCATENATED MODULE: ./node_modules/lodash-es/fill.js



/**
 * Fills elements of `array` with `value` from `start` up to, but not
 * including, `end`.
 *
 * **Note:** This method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Array
 * @param {Array} array The array to fill.
 * @param {*} value The value to fill `array` with.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.fill(array, 'a');
 * console.log(array);
 * // => ['a', 'a', 'a']
 *
 * _.fill(Array(3), 2);
 * // => [2, 2, 2]
 *
 * _.fill([4, 6, 8, 10], '*', 1, 3);
 * // => [4, '*', '*', 10]
 */
function fill(array, value, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (start && typeof start != 'number' && _isIterateeCall(array, value, start)) {
    start = 0;
    end = length;
  }
  return _baseFill(array, value, start, end);
}

/* harmony default export */ var lodash_es_fill = (fill);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseFindIndex.js
var _baseFindIndex = __webpack_require__("1b70");

// CONCATENATED MODULE: ./node_modules/lodash-es/findIndex.js




/* Built-in method references for those with the same name as other `lodash` methods. */
var findIndex_nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : Object(toInteger["a" /* default */])(fromIndex);
  if (index < 0) {
    index = findIndex_nativeMax(length + index, 0);
  }
  return Object(_baseFindIndex["a" /* default */])(array, _baseIteratee(predicate, 3), index);
}

/* harmony default export */ var lodash_es_findIndex = (findIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/findLastIndex.js




/* Built-in method references for those with the same name as other `lodash` methods. */
var findLastIndex_nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */
function findLastIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length - 1;
  if (fromIndex !== undefined) {
    index = Object(toInteger["a" /* default */])(fromIndex);
    index = fromIndex < 0
      ? findLastIndex_nativeMax(length + index, 0)
      : nativeMin(index, length - 1);
  }
  return Object(_baseFindIndex["a" /* default */])(array, _baseIteratee(predicate, 3), index, true);
}

/* harmony default export */ var lodash_es_findLastIndex = (findLastIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/head.js
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

/* harmony default export */ var lodash_es_head = (head);

// CONCATENATED MODULE: ./node_modules/lodash-es/flatten.js


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}

/* harmony default export */ var lodash_es_flatten = (flatten);

// CONCATENATED MODULE: ./node_modules/lodash-es/flattenDeep.js


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */
function flattenDeep(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, INFINITY) : [];
}

/* harmony default export */ var lodash_es_flattenDeep = (flattenDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/flattenDepth.js



/**
 * Recursively flatten `array` up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * var array = [1, [2, [3, [4]], 5]];
 *
 * _.flattenDepth(array, 1);
 * // => [1, 2, [3, [4]], 5]
 *
 * _.flattenDepth(array, 2);
 * // => [1, 2, 3, [4], 5]
 */
function flattenDepth(array, depth) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  depth = depth === undefined ? 1 : Object(toInteger["a" /* default */])(depth);
  return _baseFlatten(array, depth);
}

/* harmony default export */ var lodash_es_flattenDepth = (flattenDepth);

// CONCATENATED MODULE: ./node_modules/lodash-es/fromPairs.js
/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

/* harmony default export */ var lodash_es_fromPairs = (fromPairs);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseIndexOf.js + 1 modules
var _baseIndexOf = __webpack_require__("0148");

// CONCATENATED MODULE: ./node_modules/lodash-es/indexOf.js



/* Built-in method references for those with the same name as other `lodash` methods. */
var indexOf_nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf_indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : Object(toInteger["a" /* default */])(fromIndex);
  if (index < 0) {
    index = indexOf_nativeMax(length + index, 0);
  }
  return Object(_baseIndexOf["a" /* default */])(array, value, index);
}

/* harmony default export */ var lodash_es_indexOf = (indexOf_indexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/initial.js


/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */
function initial(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseSlice(array, 0, -1) : [];
}

/* harmony default export */ var lodash_es_initial = (initial);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIntersection.js







/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseIntersection_nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? _arrayIncludesWith : _arrayIncludes["a" /* default */],
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = Object(_arrayMap["a" /* default */])(array, _baseUnary(iteratee));
    }
    maxLength = _baseIntersection_nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new _SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? _cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? _cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ var _baseIntersection = (baseIntersection);

// CONCATENATED MODULE: ./node_modules/lodash-es/_castArrayLikeObject.js


/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return lodash_es_isArrayLikeObject(value) ? value : [];
}

/* harmony default export */ var _castArrayLikeObject = (castArrayLikeObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/intersection.js





/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = Object(_baseRest["a" /* default */])(function(arrays) {
  var mapped = Object(_arrayMap["a" /* default */])(arrays, _castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? _baseIntersection(mapped)
    : [];
});

/* harmony default export */ var lodash_es_intersection = (intersection);

// CONCATENATED MODULE: ./node_modules/lodash-es/intersectionBy.js







/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */
var intersectionBy = Object(_baseRest["a" /* default */])(function(arrays) {
  var iteratee = lodash_es_last(arrays),
      mapped = Object(_arrayMap["a" /* default */])(arrays, _castArrayLikeObject);

  if (iteratee === lodash_es_last(mapped)) {
    iteratee = undefined;
  } else {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? _baseIntersection(mapped, _baseIteratee(iteratee, 2))
    : [];
});

/* harmony default export */ var lodash_es_intersectionBy = (intersectionBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/intersectionWith.js






/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */
var intersectionWith = Object(_baseRest["a" /* default */])(function(arrays) {
  var comparator = lodash_es_last(arrays),
      mapped = Object(_arrayMap["a" /* default */])(arrays, _castArrayLikeObject);

  comparator = typeof comparator == 'function' ? comparator : undefined;
  if (comparator) {
    mapped.pop();
  }
  return (mapped.length && mapped[0] === arrays[0])
    ? _baseIntersection(mapped, undefined, comparator)
    : [];
});

/* harmony default export */ var lodash_es_intersectionWith = (intersectionWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/join.js
/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

/* harmony default export */ var lodash_es_join = (join);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseIsNaN.js
var _baseIsNaN = __webpack_require__("c53c");

// CONCATENATED MODULE: ./node_modules/lodash-es/_strictLastIndexOf.js
/**
 * A specialized version of `_.lastIndexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictLastIndexOf(array, value, fromIndex) {
  var index = fromIndex + 1;
  while (index--) {
    if (array[index] === value) {
      return index;
    }
  }
  return index;
}

/* harmony default export */ var _strictLastIndexOf = (strictLastIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/lastIndexOf.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var lastIndexOf_nativeMax = Math.max,
    lastIndexOf_nativeMin = Math.min;

/**
 * This method is like `_.indexOf` except that it iterates over elements of
 * `array` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.lastIndexOf([1, 2, 1, 2], 2);
 * // => 3
 *
 * // Search from the `fromIndex`.
 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
 * // => 1
 */
function lastIndexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = length;
  if (fromIndex !== undefined) {
    index = Object(toInteger["a" /* default */])(fromIndex);
    index = index < 0 ? lastIndexOf_nativeMax(length + index, 0) : lastIndexOf_nativeMin(index, length - 1);
  }
  return value === value
    ? _strictLastIndexOf(array, value, index)
    : Object(_baseFindIndex["a" /* default */])(array, _baseIsNaN["a" /* default */], index, true);
}

/* harmony default export */ var lodash_es_lastIndexOf = (lastIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseNth.js


/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */
function baseNth(array, n) {
  var length = array.length;
  if (!length) {
    return;
  }
  n += n < 0 ? length : 0;
  return Object(_isIndex["a" /* default */])(n, length) ? array[n] : undefined;
}

/* harmony default export */ var _baseNth = (baseNth);

// CONCATENATED MODULE: ./node_modules/lodash-es/nth.js



/**
 * Gets the element at index `n` of `array`. If `n` is negative, the nth
 * element from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.11.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=0] The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 *
 * _.nth(array, 1);
 * // => 'b'
 *
 * _.nth(array, -2);
 * // => 'c';
 */
function nth(array, n) {
  return (array && array.length) ? _baseNth(array, Object(toInteger["a" /* default */])(n)) : undefined;
}

/* harmony default export */ var lodash_es_nth = (nth);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIndexOfWith.js
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var _baseIndexOfWith = (baseIndexOfWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePullAll.js






/** Used for built-in method references. */
var _basePullAll_arrayProto = Array.prototype;

/** Built-in value references. */
var splice = _basePullAll_arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? _baseIndexOfWith : _baseIndexOf["a" /* default */],
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = Object(_copyArray["a" /* default */])(values);
  }
  if (iteratee) {
    seen = Object(_arrayMap["a" /* default */])(array, _baseUnary(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

/* harmony default export */ var _basePullAll = (basePullAll);

// CONCATENATED MODULE: ./node_modules/lodash-es/pullAll.js


/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values)
    : array;
}

/* harmony default export */ var lodash_es_pullAll = (pullAll);

// CONCATENATED MODULE: ./node_modules/lodash-es/pull.js



/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = Object(_baseRest["a" /* default */])(lodash_es_pullAll);

/* harmony default export */ var lodash_es_pull = (pull);

// CONCATENATED MODULE: ./node_modules/lodash-es/pullAllBy.js



/**
 * This method is like `_.pullAll` except that it accepts `iteratee` which is
 * invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The iteratee is invoked with one argument: (value).
 *
 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
 *
 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
 * console.log(array);
 * // => [{ 'x': 2 }]
 */
function pullAllBy(array, values, iteratee) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values, _baseIteratee(iteratee, 2))
    : array;
}

/* harmony default export */ var lodash_es_pullAllBy = (pullAllBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/pullAllWith.js


/**
 * This method is like `_.pullAll` except that it accepts `comparator` which
 * is invoked to compare elements of `array` to `values`. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
 *
 * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
 * console.log(array);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
 */
function pullAllWith(array, values, comparator) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values, undefined, comparator)
    : array;
}

/* harmony default export */ var lodash_es_pullAllWith = (pullAllWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAt.js


/**
 * The base implementation of `_.at` without support for individual paths.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {string[]} paths The property paths to pick.
 * @returns {Array} Returns the picked elements.
 */
function baseAt(object, paths) {
  var index = -1,
      length = paths.length,
      result = Array(length),
      skip = object == null;

  while (++index < length) {
    result[index] = skip ? undefined : Object(lodash_es_get["a" /* default */])(object, paths[index]);
  }
  return result;
}

/* harmony default export */ var _baseAt = (baseAt);

// CONCATENATED MODULE: ./node_modules/lodash-es/_parent.js



/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function _parent_parent(object, path) {
  return path.length < 2 ? object : Object(_baseGet["a" /* default */])(object, _baseSlice(path, 0, -1));
}

/* harmony default export */ var _parent = (_parent_parent);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUnset.js





/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = Object(_castPath["a" /* default */])(path, object);
  object = _parent(object, path);
  return object == null || delete object[Object(_toKey["a" /* default */])(lodash_es_last(path))];
}

/* harmony default export */ var _baseUnset = (baseUnset);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePullAt.js



/** Used for built-in method references. */
var _basePullAt_arrayProto = Array.prototype;

/** Built-in value references. */
var _basePullAt_splice = _basePullAt_arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (Object(_isIndex["a" /* default */])(index)) {
        _basePullAt_splice.call(array, index, 1);
      } else {
        _baseUnset(array, index);
      }
    }
  }
  return array;
}

/* harmony default export */ var _basePullAt = (basePullAt);

// EXTERNAL MODULE: ./node_modules/lodash-es/isSymbol.js
var isSymbol = __webpack_require__("1bc6");

// CONCATENATED MODULE: ./node_modules/lodash-es/_compareAscending.js


/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = Object(isSymbol["a" /* default */])(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = Object(isSymbol["a" /* default */])(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/* harmony default export */ var _compareAscending = (compareAscending);

// EXTERNAL MODULE: ./node_modules/lodash-es/_overRest.js
var _overRest = __webpack_require__("500e");

// EXTERNAL MODULE: ./node_modules/lodash-es/_setToString.js + 1 modules
var _setToString = __webpack_require__("c619");

// CONCATENATED MODULE: ./node_modules/lodash-es/_flatRest.js




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return Object(_setToString["a" /* default */])(Object(_overRest["a" /* default */])(func, undefined, lodash_es_flatten), func + '');
}

/* harmony default export */ var _flatRest = (flatRest);

// CONCATENATED MODULE: ./node_modules/lodash-es/pullAt.js







/**
 * Removes elements from `array` corresponding to `indexes` and returns an
 * array of removed elements.
 *
 * **Note:** Unlike `_.at`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...(number|number[])} [indexes] The indexes of elements to remove.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = ['a', 'b', 'c', 'd'];
 * var pulled = _.pullAt(array, [1, 3]);
 *
 * console.log(array);
 * // => ['a', 'c']
 *
 * console.log(pulled);
 * // => ['b', 'd']
 */
var pullAt = _flatRest(function(array, indexes) {
  var length = array == null ? 0 : array.length,
      result = _baseAt(array, indexes);

  _basePullAt(array, Object(_arrayMap["a" /* default */])(indexes, function(index) {
    return Object(_isIndex["a" /* default */])(index, length) ? +index : index;
  }).sort(_compareAscending));

  return result;
});

/* harmony default export */ var lodash_es_pullAt = (pullAt);

// CONCATENATED MODULE: ./node_modules/lodash-es/remove.js



/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = _baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  _basePullAt(array, indexes);
  return result;
}

/* harmony default export */ var lodash_es_remove = (remove);

// CONCATENATED MODULE: ./node_modules/lodash-es/reverse.js
/** Used for built-in method references. */
var reverse_arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeReverse = reverse_arrayProto.reverse;

/**
 * Reverses `array` so that the first element becomes the last, the second
 * element becomes the second to last, and so on.
 *
 * **Note:** This method mutates `array` and is based on
 * [`Array#reverse`](https://mdn.io/Array/reverse).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.reverse(array);
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function reverse(array) {
  return array == null ? array : nativeReverse.call(array);
}

/* harmony default export */ var lodash_es_reverse = (reverse);

// CONCATENATED MODULE: ./node_modules/lodash-es/slice.js




/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && _isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : Object(toInteger["a" /* default */])(start);
    end = end === undefined ? length : Object(toInteger["a" /* default */])(end);
  }
  return _baseSlice(array, start, end);
}

/* harmony default export */ var lodash_es_slice = (slice);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSortedIndexBy.js


/** Used as references for the maximum length and index of an array. */
var _baseSortedIndexBy_MAX_ARRAY_LENGTH = 4294967295,
    MAX_ARRAY_INDEX = _baseSortedIndexBy_MAX_ARRAY_LENGTH - 1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    _baseSortedIndexBy_nativeMin = Math.min;

/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndexBy(array, value, iteratee, retHighest) {
  var low = 0,
      high = array == null ? 0 : array.length;
  if (high === 0) {
    return 0;
  }

  value = iteratee(value);
  var valIsNaN = value !== value,
      valIsNull = value === null,
      valIsSymbol = Object(isSymbol["a" /* default */])(value),
      valIsUndefined = value === undefined;

  while (low < high) {
    var mid = nativeFloor((low + high) / 2),
        computed = iteratee(array[mid]),
        othIsDefined = computed !== undefined,
        othIsNull = computed === null,
        othIsReflexive = computed === computed,
        othIsSymbol = Object(isSymbol["a" /* default */])(computed);

    if (valIsNaN) {
      var setLow = retHighest || othIsReflexive;
    } else if (valIsUndefined) {
      setLow = othIsReflexive && (retHighest || othIsDefined);
    } else if (valIsNull) {
      setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
    } else if (valIsSymbol) {
      setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
    } else if (othIsNull || othIsSymbol) {
      setLow = false;
    } else {
      setLow = retHighest ? (computed <= value) : (computed < value);
    }
    if (setLow) {
      low = mid + 1;
    } else {
      high = mid;
    }
  }
  return _baseSortedIndexBy_nativeMin(high, MAX_ARRAY_INDEX);
}

/* harmony default export */ var _baseSortedIndexBy = (baseSortedIndexBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSortedIndex.js




/** Used as references for the maximum length and index of an array. */
var _baseSortedIndex_MAX_ARRAY_LENGTH = 4294967295,
    HALF_MAX_ARRAY_LENGTH = _baseSortedIndex_MAX_ARRAY_LENGTH >>> 1;

/**
 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
 * performs a binary search of `array` to determine the index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */
function baseSortedIndex(array, value, retHighest) {
  var low = 0,
      high = array == null ? low : array.length;

  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
    while (low < high) {
      var mid = (low + high) >>> 1,
          computed = array[mid];

      if (computed !== null && !Object(isSymbol["a" /* default */])(computed) &&
          (retHighest ? (computed <= value) : (computed < value))) {
        low = mid + 1;
      } else {
        high = mid;
      }
    }
    return high;
  }
  return _baseSortedIndexBy(array, value, identity["a" /* default */], retHighest);
}

/* harmony default export */ var _baseSortedIndex = (baseSortedIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedIndex.js


/**
 * Uses a binary search to determine the lowest index at which `value`
 * should be inserted into `array` in order to maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedIndex([30, 50], 40);
 * // => 1
 */
function sortedIndex(array, value) {
  return _baseSortedIndex(array, value);
}

/* harmony default export */ var lodash_es_sortedIndex = (sortedIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedIndexBy.js



/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */
function sortedIndexBy(array, value, iteratee) {
  return _baseSortedIndexBy(array, value, _baseIteratee(iteratee, 2));
}

/* harmony default export */ var lodash_es_sortedIndexBy = (sortedIndexBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedIndexOf.js



/**
 * This method is like `_.indexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
 * // => 1
 */
function sortedIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = _baseSortedIndex(array, value);
    if (index < length && Object(eq["a" /* default */])(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var lodash_es_sortedIndexOf = (sortedIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedLastIndex.js


/**
 * This method is like `_.sortedIndex` except that it returns the highest
 * index at which `value` should be inserted into `array` in order to
 * maintain its sort order.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
 * // => 4
 */
function sortedLastIndex(array, value) {
  return _baseSortedIndex(array, value, true);
}

/* harmony default export */ var lodash_es_sortedLastIndex = (sortedLastIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedLastIndexBy.js



/**
 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 1
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
 * // => 1
 */
function sortedLastIndexBy(array, value, iteratee) {
  return _baseSortedIndexBy(array, value, _baseIteratee(iteratee, 2), true);
}

/* harmony default export */ var lodash_es_sortedLastIndexBy = (sortedLastIndexBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedLastIndexOf.js



/**
 * This method is like `_.lastIndexOf` except that it performs a binary
 * search on a sorted `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
 * // => 3
 */
function sortedLastIndexOf(array, value) {
  var length = array == null ? 0 : array.length;
  if (length) {
    var index = _baseSortedIndex(array, value, true) - 1;
    if (Object(eq["a" /* default */])(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var lodash_es_sortedLastIndexOf = (sortedLastIndexOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSortedUniq.js


/**
 * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseSortedUniq(array, iteratee) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    if (!index || !Object(eq["a" /* default */])(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}

/* harmony default export */ var _baseSortedUniq = (baseSortedUniq);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedUniq.js


/**
 * This method is like `_.uniq` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniq([1, 1, 2]);
 * // => [1, 2]
 */
function sortedUniq(array) {
  return (array && array.length)
    ? _baseSortedUniq(array)
    : [];
}

/* harmony default export */ var lodash_es_sortedUniq = (sortedUniq);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortedUniqBy.js



/**
 * This method is like `_.uniqBy` except that it's designed and optimized
 * for sorted arrays.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
 * // => [1.1, 2.3]
 */
function sortedUniqBy(array, iteratee) {
  return (array && array.length)
    ? _baseSortedUniq(array, _baseIteratee(iteratee, 2))
    : [];
}

/* harmony default export */ var lodash_es_sortedUniqBy = (sortedUniqBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/tail.js


/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */
function tail(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseSlice(array, 1, length) : [];
}

/* harmony default export */ var lodash_es_tail = (tail);

// CONCATENATED MODULE: ./node_modules/lodash-es/take.js



/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : Object(toInteger["a" /* default */])(n);
  return _baseSlice(array, 0, n < 0 ? 0 : n);
}

/* harmony default export */ var lodash_es_take = (take);

// CONCATENATED MODULE: ./node_modules/lodash-es/takeRight.js



/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : Object(toInteger["a" /* default */])(n);
  n = length - n;
  return _baseSlice(array, n < 0 ? 0 : n, length);
}

/* harmony default export */ var lodash_es_takeRight = (takeRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/takeRightWhile.js



/**
 * Creates a slice of `array` with elements taken from the end. Elements are
 * taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.takeRightWhile(users, function(o) { return !o.active; });
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
 * // => objects for ['pebbles']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeRightWhile(users, ['active', false]);
 * // => objects for ['fred', 'pebbles']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeRightWhile(users, 'active');
 * // => []
 */
function takeRightWhile(array, predicate) {
  return (array && array.length)
    ? _baseWhile(array, _baseIteratee(predicate, 3), false, true)
    : [];
}

/* harmony default export */ var lodash_es_takeRightWhile = (takeRightWhile);

// CONCATENATED MODULE: ./node_modules/lodash-es/takeWhile.js



/**
 * Creates a slice of `array` with elements taken from the beginning. Elements
 * are taken until `predicate` returns falsey. The predicate is invoked with
 * three arguments: (value, index, array).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.takeWhile(users, function(o) { return !o.active; });
 * // => objects for ['barney', 'fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.takeWhile(users, { 'user': 'barney', 'active': false });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.takeWhile(users, ['active', false]);
 * // => objects for ['barney', 'fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.takeWhile(users, 'active');
 * // => []
 */
function takeWhile(array, predicate) {
  return (array && array.length)
    ? _baseWhile(array, _baseIteratee(predicate, 3))
    : [];
}

/* harmony default export */ var lodash_es_takeWhile = (takeWhile);

// EXTERNAL MODULE: ./node_modules/lodash-es/noop.js
var noop = __webpack_require__("89f2");

// CONCATENATED MODULE: ./node_modules/lodash-es/_createSet.js




/** Used as references for various `Number` constants. */
var _createSet_INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(_Set && (1 / _setToArray(new _Set([,-0]))[1]) == _createSet_INFINITY) ? noop["a" /* default */] : function(values) {
  return new _Set(values);
};

/* harmony default export */ var _createSet = (createSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUniq.js







/** Used as the size to enable large array optimizations. */
var _baseUniq_LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = _arrayIncludes["a" /* default */],
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = _arrayIncludesWith;
  }
  else if (length >= _baseUniq_LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : _createSet(array);
    if (set) {
      return _setToArray(set);
    }
    isCommon = false;
    includes = _cacheHas;
    seen = new _SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ var _baseUniq = (baseUniq);

// CONCATENATED MODULE: ./node_modules/lodash-es/union.js





/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = Object(_baseRest["a" /* default */])(function(arrays) {
  return _baseUniq(_baseFlatten(arrays, 1, lodash_es_isArrayLikeObject, true));
});

/* harmony default export */ var lodash_es_union = (union);

// CONCATENATED MODULE: ./node_modules/lodash-es/unionBy.js







/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = Object(_baseRest["a" /* default */])(function(arrays) {
  var iteratee = lodash_es_last(arrays);
  if (lodash_es_isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return _baseUniq(_baseFlatten(arrays, 1, lodash_es_isArrayLikeObject, true), _baseIteratee(iteratee, 2));
});

/* harmony default export */ var lodash_es_unionBy = (unionBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/unionWith.js






/**
 * This method is like `_.union` except that it accepts `comparator` which
 * is invoked to compare elements of `arrays`. Result values are chosen from
 * the first array in which the value occurs. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.unionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var unionWith = Object(_baseRest["a" /* default */])(function(arrays) {
  var comparator = lodash_es_last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return _baseUniq(_baseFlatten(arrays, 1, lodash_es_isArrayLikeObject, true), undefined, comparator);
});

/* harmony default export */ var lodash_es_unionWith = (unionWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/uniq.js


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? _baseUniq(array) : [];
}

/* harmony default export */ var lodash_es_uniq = (uniq);

// CONCATENATED MODULE: ./node_modules/lodash-es/uniqBy.js



/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? _baseUniq(array, _baseIteratee(iteratee, 2)) : [];
}

/* harmony default export */ var lodash_es_uniqBy = (uniqBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/uniqWith.js


/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */
function uniqWith(array, comparator) {
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return (array && array.length) ? _baseUniq(array, undefined, comparator) : [];
}

/* harmony default export */ var lodash_es_uniqWith = (uniqWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/unzip.js






/* Built-in method references for those with the same name as other `lodash` methods. */
var unzip_nativeMax = Math.max;

/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */
function unzip(array) {
  if (!(array && array.length)) {
    return [];
  }
  var length = 0;
  array = _arrayFilter(array, function(group) {
    if (lodash_es_isArrayLikeObject(group)) {
      length = unzip_nativeMax(group.length, length);
      return true;
    }
  });
  return _baseTimes(length, function(index) {
    return Object(_arrayMap["a" /* default */])(array, _baseProperty(index));
  });
}

/* harmony default export */ var lodash_es_unzip = (unzip);

// EXTERNAL MODULE: ./node_modules/lodash-es/_apply.js
var _apply = __webpack_require__("b911");

// CONCATENATED MODULE: ./node_modules/lodash-es/unzipWith.js




/**
 * This method is like `_.unzip` except that it accepts `iteratee` to specify
 * how regrouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  regrouped values.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
 * // => [[1, 10, 100], [2, 20, 200]]
 *
 * _.unzipWith(zipped, _.add);
 * // => [3, 30, 300]
 */
function unzipWith(array, iteratee) {
  if (!(array && array.length)) {
    return [];
  }
  var result = lodash_es_unzip(array);
  if (iteratee == null) {
    return result;
  }
  return Object(_arrayMap["a" /* default */])(result, function(group) {
    return Object(_apply["a" /* default */])(iteratee, undefined, group);
  });
}

/* harmony default export */ var lodash_es_unzipWith = (unzipWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/without.js




/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = Object(_baseRest["a" /* default */])(function(array, values) {
  return lodash_es_isArrayLikeObject(array)
    ? _baseDifference(array, values)
    : [];
});

/* harmony default export */ var lodash_es_without = (without);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseXor.js




/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? _baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = _baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return _baseUniq(_baseFlatten(result, 1), iteratee, comparator);
}

/* harmony default export */ var _baseXor = (baseXor);

// CONCATENATED MODULE: ./node_modules/lodash-es/xor.js





/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = Object(_baseRest["a" /* default */])(function(arrays) {
  return _baseXor(_arrayFilter(arrays, lodash_es_isArrayLikeObject));
});

/* harmony default export */ var lodash_es_xor = (xor);

// CONCATENATED MODULE: ./node_modules/lodash-es/xorBy.js







/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var xorBy = Object(_baseRest["a" /* default */])(function(arrays) {
  var iteratee = lodash_es_last(arrays);
  if (lodash_es_isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return _baseXor(_arrayFilter(arrays, lodash_es_isArrayLikeObject), _baseIteratee(iteratee, 2));
});

/* harmony default export */ var lodash_es_xorBy = (xorBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/xorWith.js






/**
 * This method is like `_.xor` except that it accepts `comparator` which is
 * invoked to compare elements of `arrays`. The order of result values is
 * determined by the order they occur in the arrays. The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.xorWith(objects, others, _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
 */
var xorWith = Object(_baseRest["a" /* default */])(function(arrays) {
  var comparator = lodash_es_last(arrays);
  comparator = typeof comparator == 'function' ? comparator : undefined;
  return _baseXor(_arrayFilter(arrays, lodash_es_isArrayLikeObject), undefined, comparator);
});

/* harmony default export */ var lodash_es_xorWith = (xorWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/zip.js



/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */
var zip = Object(_baseRest["a" /* default */])(lodash_es_unzip);

/* harmony default export */ var lodash_es_zip = (zip);

// EXTERNAL MODULE: ./node_modules/lodash-es/_defineProperty.js
var _defineProperty = __webpack_require__("0305");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignValue.js


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty["a" /* default */]) {
    Object(_defineProperty["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ var _baseAssignValue = (baseAssignValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_assignValue.js



/** Used for built-in method references. */
var _assignValue_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _assignValue_hasOwnProperty = _assignValue_objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(_assignValue_hasOwnProperty.call(object, key) && Object(eq["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignValue = (assignValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseZipObject.js
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

/* harmony default export */ var _baseZipObject = (baseZipObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/zipObject.js



/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return _baseZipObject(props || [], values || [], _assignValue);
}

/* harmony default export */ var lodash_es_zipObject = (zipObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSet.js






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!Object(isObject["a" /* default */])(object)) {
    return object;
  }
  path = Object(_castPath["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = Object(_toKey["a" /* default */])(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = Object(isObject["a" /* default */])(objValue)
          ? objValue
          : (Object(_isIndex["a" /* default */])(path[index + 1]) ? [] : {});
      }
    }
    _assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* harmony default export */ var _baseSet = (baseSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/zipObjectDeep.js



/**
 * This method is like `_.zipObject` except that it supports property paths.
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
 */
function zipObjectDeep(props, values) {
  return _baseZipObject(props || [], values || [], _baseSet);
}

/* harmony default export */ var lodash_es_zipObjectDeep = (zipObjectDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/zipWith.js



/**
 * This method is like `_.zip` except that it accepts `iteratee` to specify
 * how grouped values should be combined. The iteratee is invoked with the
 * elements of each group: (...group).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @param {Function} [iteratee=_.identity] The function to combine
 *  grouped values.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
 *   return a + b + c;
 * });
 * // => [111, 222]
 */
var zipWith = Object(_baseRest["a" /* default */])(function(arrays) {
  var length = arrays.length,
      iteratee = length > 1 ? arrays[length - 1] : undefined;

  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
  return lodash_es_unzipWith(arrays, iteratee);
});

/* harmony default export */ var lodash_es_zipWith = (zipWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/array.default.js


































































/* harmony default export */ var array_default = ({
  chunk: lodash_es_chunk, compact: lodash_es_compact, concat: lodash_es_concat, difference: lodash_es_difference, differenceBy: lodash_es_differenceBy,
  differenceWith: lodash_es_differenceWith, drop: lodash_es_drop, dropRight: lodash_es_dropRight, dropRightWhile: lodash_es_dropRightWhile, dropWhile: lodash_es_dropWhile,
  fill: lodash_es_fill, findIndex: lodash_es_findIndex, findLastIndex: lodash_es_findLastIndex, first: lodash_es_head, flatten: lodash_es_flatten,
  flattenDeep: lodash_es_flattenDeep, flattenDepth: lodash_es_flattenDepth, fromPairs: lodash_es_fromPairs, head: lodash_es_head, indexOf: lodash_es_indexOf,
  initial: lodash_es_initial, intersection: lodash_es_intersection, intersectionBy: lodash_es_intersectionBy, intersectionWith: lodash_es_intersectionWith, join: lodash_es_join,
  last: lodash_es_last, lastIndexOf: lodash_es_lastIndexOf, nth: lodash_es_nth, pull: lodash_es_pull, pullAll: lodash_es_pullAll,
  pullAllBy: lodash_es_pullAllBy, pullAllWith: lodash_es_pullAllWith, pullAt: lodash_es_pullAt, remove: lodash_es_remove, reverse: lodash_es_reverse,
  slice: lodash_es_slice, sortedIndex: lodash_es_sortedIndex, sortedIndexBy: lodash_es_sortedIndexBy, sortedIndexOf: lodash_es_sortedIndexOf, sortedLastIndex: lodash_es_sortedLastIndex,
  sortedLastIndexBy: lodash_es_sortedLastIndexBy, sortedLastIndexOf: lodash_es_sortedLastIndexOf, sortedUniq: lodash_es_sortedUniq, sortedUniqBy: lodash_es_sortedUniqBy, tail: lodash_es_tail,
  take: lodash_es_take, takeRight: lodash_es_takeRight, takeRightWhile: lodash_es_takeRightWhile, takeWhile: lodash_es_takeWhile, union: lodash_es_union,
  unionBy: lodash_es_unionBy, unionWith: lodash_es_unionWith, uniq: lodash_es_uniq, uniqBy: lodash_es_uniqBy, uniqWith: lodash_es_uniqWith,
  unzip: lodash_es_unzip, unzipWith: lodash_es_unzipWith, without: lodash_es_without, xor: lodash_es_xor, xorBy: lodash_es_xorBy,
  xorWith: lodash_es_xorWith, zip: lodash_es_zip, zipObject: lodash_es_zipObject, zipObjectDeep: lodash_es_zipObjectDeep, zipWith: lodash_es_zipWith
});

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayAggregator.js
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/* harmony default export */ var _arrayAggregator = (arrayAggregator);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createBaseFor.js
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ var _createBaseFor = (createBaseFor);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFor.js


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = _createBaseFor();

/* harmony default export */ var _baseFor = (baseFor);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseForOwn.js



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && _baseFor(object, iteratee, lodash_es_keys);
}

/* harmony default export */ var _baseForOwn = (baseForOwn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createBaseEach.js


/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!lodash_es_isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/* harmony default export */ var _createBaseEach = (createBaseEach);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseEach.js



/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = _createBaseEach(_baseForOwn);

/* harmony default export */ var _baseEach = (baseEach);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAggregator.js


/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  _baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/* harmony default export */ var _baseAggregator = (baseAggregator);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createAggregator.js





/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = Object(isArray["a" /* default */])(collection) ? _arrayAggregator : _baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, _baseIteratee(iteratee, 2), accumulator);
  };
}

/* harmony default export */ var _createAggregator = (createAggregator);

// CONCATENATED MODULE: ./node_modules/lodash-es/countBy.js



/** Used for built-in method references. */
var countBy_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var countBy_hasOwnProperty = countBy_objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */
var countBy = _createAggregator(function(result, value, key) {
  if (countBy_hasOwnProperty.call(result, key)) {
    ++result[key];
  } else {
    _baseAssignValue(result, key, 1);
  }
});

/* harmony default export */ var lodash_es_countBy = (countBy);

// EXTERNAL MODULE: ./node_modules/lodash-es/_arrayEach.js
var _arrayEach = __webpack_require__("20b6");

// CONCATENATED MODULE: ./node_modules/lodash-es/_castFunction.js


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity["a" /* default */];
}

/* harmony default export */ var _castFunction = (castFunction);

// CONCATENATED MODULE: ./node_modules/lodash-es/forEach.js





/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayEach["a" /* default */] : _baseEach;
  return func(collection, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forEach = (forEach);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayEachRight.js
/**
 * A specialized version of `_.forEachRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEachRight(array, iteratee) {
  var length = array == null ? 0 : array.length;

  while (length--) {
    if (iteratee(array[length], length, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ var _arrayEachRight = (arrayEachRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseForRight.js


/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = _createBaseFor(true);

/* harmony default export */ var _baseForRight = (baseForRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseForOwnRight.js



/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && _baseForRight(object, iteratee, lodash_es_keys);
}

/* harmony default export */ var _baseForOwnRight = (baseForOwnRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseEachRight.js



/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = _createBaseEach(_baseForOwnRight, true);

/* harmony default export */ var _baseEachRight = (baseEachRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/forEachRight.js





/**
 * This method is like `_.forEach` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @alias eachRight
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEach
 * @example
 *
 * _.forEachRight([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `2` then `1`.
 */
function forEachRight(collection, iteratee) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayEachRight : _baseEachRight;
  return func(collection, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forEachRight = (forEachRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayEvery.js
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var _arrayEvery = (arrayEvery);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseEvery.js


/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  _baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

/* harmony default export */ var _baseEvery = (baseEvery);

// CONCATENATED MODULE: ./node_modules/lodash-es/every.js






/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayEvery : _baseEvery;
  if (guard && _isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, _baseIteratee(predicate, 3));
}

/* harmony default export */ var lodash_es_every = (every);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFilter.js


/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  _baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/* harmony default export */ var _baseFilter = (baseFilter);

// CONCATENATED MODULE: ./node_modules/lodash-es/filter.js





/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayFilter : _baseFilter;
  return func(collection, _baseIteratee(predicate, 3));
}

/* harmony default export */ var lodash_es_filter = (filter);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createFind.js




/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!lodash_es_isArrayLike(collection)) {
      var iteratee = _baseIteratee(predicate, 3);
      collection = lodash_es_keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/* harmony default export */ var _createFind = (createFind);

// CONCATENATED MODULE: ./node_modules/lodash-es/find.js



/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = _createFind(lodash_es_findIndex);

/* harmony default export */ var lodash_es_find = (find);

// CONCATENATED MODULE: ./node_modules/lodash-es/findLast.js



/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */
var findLast = _createFind(lodash_es_findLastIndex);

/* harmony default export */ var lodash_es_findLast = (findLast);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMap.js



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = lodash_es_isArrayLike(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/* harmony default export */ var _baseMap = (baseMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/map.js





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayMap["a" /* default */] : _baseMap;
  return func(collection, _baseIteratee(iteratee, 3));
}

/* harmony default export */ var lodash_es_map = (map);

// CONCATENATED MODULE: ./node_modules/lodash-es/flatMap.js



/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return _baseFlatten(lodash_es_map(collection, iteratee), 1);
}

/* harmony default export */ var lodash_es_flatMap = (flatMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/flatMapDeep.js



/** Used as references for various `Number` constants. */
var flatMapDeep_INFINITY = 1 / 0;

/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMapDeep(collection, iteratee) {
  return _baseFlatten(lodash_es_map(collection, iteratee), flatMapDeep_INFINITY);
}

/* harmony default export */ var lodash_es_flatMapDeep = (flatMapDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/flatMapDepth.js




/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results up to `depth` times.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {number} [depth=1] The maximum recursion depth.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDepth([1, 2], duplicate, 2);
 * // => [[1, 1], [2, 2]]
 */
function flatMapDepth(collection, iteratee, depth) {
  depth = depth === undefined ? 1 : Object(toInteger["a" /* default */])(depth);
  return _baseFlatten(lodash_es_map(collection, iteratee), depth);
}

/* harmony default export */ var lodash_es_flatMapDepth = (flatMapDepth);

// CONCATENATED MODULE: ./node_modules/lodash-es/groupBy.js



/** Used for built-in method references. */
var groupBy_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var groupBy_hasOwnProperty = groupBy_objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = _createAggregator(function(result, value, key) {
  if (groupBy_hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    _baseAssignValue(result, key, [value]);
  }
});

/* harmony default export */ var lodash_es_groupBy = (groupBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/isString.js




/** `Object#toString` result references. */
var isString_stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!Object(isArray["a" /* default */])(value) && Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == isString_stringTag);
}

/* harmony default export */ var lodash_es_isString = (isString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseValues.js


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return Object(_arrayMap["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ var _baseValues = (baseValues);

// CONCATENATED MODULE: ./node_modules/lodash-es/values.js



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values_values(object) {
  return object == null ? [] : _baseValues(object, lodash_es_keys(object));
}

/* harmony default export */ var lodash_es_values = (values_values);

// CONCATENATED MODULE: ./node_modules/lodash-es/includes.js






/* Built-in method references for those with the same name as other `lodash` methods. */
var includes_nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes_includes(collection, value, fromIndex, guard) {
  collection = lodash_es_isArrayLike(collection) ? collection : lodash_es_values(collection);
  fromIndex = (fromIndex && !guard) ? Object(toInteger["a" /* default */])(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = includes_nativeMax(length + fromIndex, 0);
  }
  return lodash_es_isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && Object(_baseIndexOf["a" /* default */])(collection, value, fromIndex) > -1);
}

/* harmony default export */ var lodash_es_includes = (includes_includes);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseInvoke.js






/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = Object(_castPath["a" /* default */])(path, object);
  object = _parent(object, path);
  var func = object == null ? object : object[Object(_toKey["a" /* default */])(lodash_es_last(path))];
  return func == null ? undefined : Object(_apply["a" /* default */])(func, object, args);
}

/* harmony default export */ var _baseInvoke = (baseInvoke);

// CONCATENATED MODULE: ./node_modules/lodash-es/invokeMap.js






/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */
var invokeMap = Object(_baseRest["a" /* default */])(function(collection, path, args) {
  var index = -1,
      isFunc = typeof path == 'function',
      result = lodash_es_isArrayLike(collection) ? Array(collection.length) : [];

  _baseEach(collection, function(value) {
    result[++index] = isFunc ? Object(_apply["a" /* default */])(path, value, args) : _baseInvoke(value, path, args);
  });
  return result;
});

/* harmony default export */ var lodash_es_invokeMap = (invokeMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/keyBy.js



/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = _createAggregator(function(result, value, key) {
  _baseAssignValue(result, key, value);
});

/* harmony default export */ var lodash_es_keyBy = (keyBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSortBy.js
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/* harmony default export */ var _baseSortBy = (baseSortBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_compareMultiple.js


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = _compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/* harmony default export */ var _compareMultiple = (compareMultiple);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseOrderBy.js










/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = Object(_arrayMap["a" /* default */])(iteratees, function(iteratee) {
      if (Object(isArray["a" /* default */])(iteratee)) {
        return function(value) {
          return Object(_baseGet["a" /* default */])(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity["a" /* default */]];
  }

  var index = -1;
  iteratees = Object(_arrayMap["a" /* default */])(iteratees, _baseUnary(_baseIteratee));

  var result = _baseMap(collection, function(value, key, collection) {
    var criteria = Object(_arrayMap["a" /* default */])(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return _baseSortBy(result, function(object, other) {
    return _compareMultiple(object, other, orders);
  });
}

/* harmony default export */ var _baseOrderBy = (baseOrderBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/orderBy.js



/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!Object(isArray["a" /* default */])(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!Object(isArray["a" /* default */])(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return _baseOrderBy(collection, iteratees, orders);
}

/* harmony default export */ var lodash_es_orderBy = (orderBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/partition.js


/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */
var partition = _createAggregator(function(result, value, key) {
  result[key ? 0 : 1].push(value);
}, function() { return [[], []]; });

/* harmony default export */ var lodash_es_partition = (partition);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayReduce.js
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/* harmony default export */ var _arrayReduce = (arrayReduce);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseReduce.js
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

/* harmony default export */ var _baseReduce = (baseReduce);

// CONCATENATED MODULE: ./node_modules/lodash-es/reduce.js






/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayReduce : _baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, _baseIteratee(iteratee, 4), accumulator, initAccum, _baseEach);
}

/* harmony default export */ var lodash_es_reduce = (reduce);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayReduceRight.js
/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduceRight(array, iteratee, accumulator, initAccum) {
  var length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[--length];
  }
  while (length--) {
    accumulator = iteratee(accumulator, array[length], length, array);
  }
  return accumulator;
}

/* harmony default export */ var _arrayReduceRight = (arrayReduceRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/reduceRight.js






/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */
function reduceRight(collection, iteratee, accumulator) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayReduceRight : _baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, _baseIteratee(iteratee, 4), accumulator, initAccum, _baseEachRight);
}

/* harmony default export */ var lodash_es_reduceRight = (reduceRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/negate.js
/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

/* harmony default export */ var lodash_es_negate = (negate);

// CONCATENATED MODULE: ./node_modules/lodash-es/reject.js






/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayFilter : _baseFilter;
  return func(collection, lodash_es_negate(_baseIteratee(predicate, 3)));
}

/* harmony default export */ var lodash_es_reject = (reject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRandom.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseRandom_nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + _baseRandom_nativeFloor(nativeRandom() * (upper - lower + 1));
}

/* harmony default export */ var _baseRandom = (baseRandom);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySample.js


/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[_baseRandom(0, length - 1)] : undefined;
}

/* harmony default export */ var _arraySample = (arraySample);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSample.js



/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return _arraySample(lodash_es_values(collection));
}

/* harmony default export */ var _baseSample = (baseSample);

// CONCATENATED MODULE: ./node_modules/lodash-es/sample.js




/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = Object(isArray["a" /* default */])(collection) ? _arraySample : _baseSample;
  return func(collection);
}

/* harmony default export */ var lodash_es_sample = (sample);

// CONCATENATED MODULE: ./node_modules/lodash-es/_shuffleSelf.js


/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = _baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

/* harmony default export */ var _shuffleSelf = (shuffleSelf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arraySampleSize.js




/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return _shuffleSelf(Object(_copyArray["a" /* default */])(array), _baseClamp(n, 0, array.length));
}

/* harmony default export */ var _arraySampleSize = (arraySampleSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSampleSize.js




/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = lodash_es_values(collection);
  return _shuffleSelf(array, _baseClamp(n, 0, array.length));
}

/* harmony default export */ var _baseSampleSize = (baseSampleSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/sampleSize.js






/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? _isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = Object(toInteger["a" /* default */])(n);
  }
  var func = Object(isArray["a" /* default */])(collection) ? _arraySampleSize : _baseSampleSize;
  return func(collection, n);
}

/* harmony default export */ var lodash_es_sampleSize = (sampleSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_arrayShuffle.js



/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return _shuffleSelf(Object(_copyArray["a" /* default */])(array));
}

/* harmony default export */ var _arrayShuffle = (arrayShuffle);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseShuffle.js



/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return _shuffleSelf(lodash_es_values(collection));
}

/* harmony default export */ var _baseShuffle = (baseShuffle);

// CONCATENATED MODULE: ./node_modules/lodash-es/shuffle.js




/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = Object(isArray["a" /* default */])(collection) ? _arrayShuffle : _baseShuffle;
  return func(collection);
}

/* harmony default export */ var lodash_es_shuffle = (shuffle);

// CONCATENATED MODULE: ./node_modules/lodash-es/_asciiSize.js


/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = _baseProperty('length');

/* harmony default export */ var _asciiSize = (asciiSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hasUnicode.js
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/* harmony default export */ var _hasUnicode = (hasUnicode);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unicodeSize.js
/** Used to compose unicode character classes. */
var _unicodeSize_rsAstralRange = '\\ud800-\\udfff',
    _unicodeSize_rsComboMarksRange = '\\u0300-\\u036f',
    _unicodeSize_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    _unicodeSize_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    _unicodeSize_rsComboRange = _unicodeSize_rsComboMarksRange + _unicodeSize_reComboHalfMarksRange + _unicodeSize_rsComboSymbolsRange,
    _unicodeSize_rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + _unicodeSize_rsAstralRange + ']',
    rsCombo = '[' + _unicodeSize_rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + _unicodeSize_rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    _unicodeSize_rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + _unicodeSize_rsVarRange + ']?',
    rsOptJoin = '(?:' + _unicodeSize_rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

/* harmony default export */ var _unicodeSize = (unicodeSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stringSize.js




/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return _hasUnicode(string)
    ? _unicodeSize(string)
    : _asciiSize(string);
}

/* harmony default export */ var _stringSize = (stringSize);

// CONCATENATED MODULE: ./node_modules/lodash-es/size.js






/** `Object#toString` result references. */
var size_mapTag = '[object Map]',
    size_setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size_size(collection) {
  if (collection == null) {
    return 0;
  }
  if (lodash_es_isArrayLike(collection)) {
    return lodash_es_isString(collection) ? _stringSize(collection) : collection.length;
  }
  var tag = _getTag(collection);
  if (tag == size_mapTag || tag == size_setTag) {
    return collection.size;
  }
  return _baseKeys(collection).length;
}

/* harmony default export */ var lodash_es_size = (size_size);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSome.js


/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  _baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

/* harmony default export */ var _baseSome = (baseSome);

// CONCATENATED MODULE: ./node_modules/lodash-es/some.js






/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = Object(isArray["a" /* default */])(collection) ? _arraySome : _baseSome;
  if (guard && _isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, _baseIteratee(predicate, 3));
}

/* harmony default export */ var lodash_es_some = (some);

// CONCATENATED MODULE: ./node_modules/lodash-es/sortBy.js





/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = Object(_baseRest["a" /* default */])(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && _isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && _isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return _baseOrderBy(collection, _baseFlatten(iteratees, 1), []);
});

/* harmony default export */ var lodash_es_sortBy = (sortBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/collection.default.js





























/* harmony default export */ var collection_default = ({
  countBy: lodash_es_countBy, each: lodash_es_forEach, eachRight: lodash_es_forEachRight, every: lodash_es_every, filter: lodash_es_filter,
  find: lodash_es_find, findLast: lodash_es_findLast, flatMap: lodash_es_flatMap, flatMapDeep: lodash_es_flatMapDeep, flatMapDepth: lodash_es_flatMapDepth,
  forEach: lodash_es_forEach, forEachRight: lodash_es_forEachRight, groupBy: lodash_es_groupBy, includes: lodash_es_includes, invokeMap: lodash_es_invokeMap,
  keyBy: lodash_es_keyBy, map: lodash_es_map, orderBy: lodash_es_orderBy, partition: lodash_es_partition, reduce: lodash_es_reduce,
  reduceRight: lodash_es_reduceRight, reject: lodash_es_reject, sample: lodash_es_sample, sampleSize: lodash_es_sampleSize, shuffle: lodash_es_shuffle,
  size: lodash_es_size, some: lodash_es_some, sortBy: lodash_es_sortBy
});

// EXTERNAL MODULE: ./node_modules/lodash-es/now.js
var now = __webpack_require__("6b04");

// CONCATENATED MODULE: ./node_modules/lodash-es/date.default.js


/* harmony default export */ var date_default = ({
  now: now["a" /* default */]
});

// CONCATENATED MODULE: ./node_modules/lodash-es/after.js


/** Error message constants. */
var after_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The opposite of `_.before`; this method creates a function that invokes
 * `func` once it's called `n` or more times.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {number} n The number of calls before `func` is invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var saves = ['profile', 'settings'];
 *
 * var done = _.after(saves.length, function() {
 *   console.log('done saving!');
 * });
 *
 * _.forEach(saves, function(type) {
 *   asyncSave({ 'type': type, 'complete': done });
 * });
 * // => Logs 'done saving!' after the two async saves have completed.
 */
function after(n, func) {
  if (typeof func != 'function') {
    throw new TypeError(after_FUNC_ERROR_TEXT);
  }
  n = Object(toInteger["a" /* default */])(n);
  return function() {
    if (--n < 1) {
      return func.apply(this, arguments);
    }
  };
}

/* harmony default export */ var lodash_es_after = (after);

// EXTERNAL MODULE: ./node_modules/lodash-es/_createWrap.js + 4 modules
var _createWrap = __webpack_require__("9e08");

// CONCATENATED MODULE: ./node_modules/lodash-es/ary.js


/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return Object(_createWrap["a" /* default */])(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

/* harmony default export */ var lodash_es_ary = (ary);

// CONCATENATED MODULE: ./node_modules/lodash-es/before.js


/** Error message constants. */
var before_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(before_FUNC_ERROR_TEXT);
  }
  n = Object(toInteger["a" /* default */])(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/* harmony default export */ var lodash_es_before = (before);

// EXTERNAL MODULE: ./node_modules/lodash-es/bind.js
var bind = __webpack_require__("f949");

// EXTERNAL MODULE: ./node_modules/lodash-es/_getHolder.js
var _getHolder = __webpack_require__("292b");

// EXTERNAL MODULE: ./node_modules/lodash-es/_replaceHolders.js
var _replaceHolders = __webpack_require__("9f32");

// CONCATENATED MODULE: ./node_modules/lodash-es/bindKey.js





/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes the method at `object[key]` with `partials`
 * prepended to the arguments it receives.
 *
 * This method differs from `_.bind` by allowing bound functions to reference
 * methods that may be redefined or don't yet exist. See
 * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
 * for more details.
 *
 * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Function
 * @param {Object} object The object to invoke the method on.
 * @param {string} key The key of the method.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * var object = {
 *   'user': 'fred',
 *   'greet': function(greeting, punctuation) {
 *     return greeting + ' ' + this.user + punctuation;
 *   }
 * };
 *
 * var bound = _.bindKey(object, 'greet', 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * object.greet = function(greeting, punctuation) {
 *   return greeting + 'ya ' + this.user + punctuation;
 * };
 *
 * bound('!');
 * // => 'hiya fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bindKey(object, 'greet', _, '!');
 * bound('hi');
 * // => 'hiya fred!'
 */
var bindKey = Object(_baseRest["a" /* default */])(function(object, key, partials) {
  var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
  if (partials.length) {
    var holders = Object(_replaceHolders["a" /* default */])(partials, Object(_getHolder["a" /* default */])(bindKey));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return Object(_createWrap["a" /* default */])(key, bitmask, object, partials, holders);
});

// Assign default placeholders.
bindKey.placeholder = {};

/* harmony default export */ var lodash_es_bindKey = (bindKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/curry.js


/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = Object(_createWrap["a" /* default */])(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

/* harmony default export */ var lodash_es_curry = (curry);

// CONCATENATED MODULE: ./node_modules/lodash-es/curryRight.js


/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_RIGHT_FLAG = 16;

/**
 * This method is like `_.curry` except that arguments are applied to `func`
 * in the manner of `_.partialRight` instead of `_.partial`.
 *
 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curryRight(abc);
 *
 * curried(3)(2)(1);
 * // => [1, 2, 3]
 *
 * curried(2, 3)(1);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(3)(1, _)(2);
 * // => [1, 2, 3]
 */
function curryRight(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = Object(_createWrap["a" /* default */])(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curryRight.placeholder;
  return result;
}

// Assign default placeholders.
curryRight.placeholder = {};

/* harmony default export */ var lodash_es_curryRight = (curryRight);

// EXTERNAL MODULE: ./node_modules/lodash-es/debounce.js
var debounce = __webpack_require__("85b1");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseDelay.js
/** Error message constants. */
var _baseDelay_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(_baseDelay_FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

/* harmony default export */ var _baseDelay = (baseDelay);

// CONCATENATED MODULE: ./node_modules/lodash-es/defer.js



/**
 * Defers invoking the `func` until the current call stack has cleared. Any
 * additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to defer.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.defer(function(text) {
 *   console.log(text);
 * }, 'deferred');
 * // => Logs 'deferred' after one millisecond.
 */
var defer = Object(_baseRest["a" /* default */])(function(func, args) {
  return _baseDelay(func, 1, args);
});

/* harmony default export */ var lodash_es_defer = (defer);

// EXTERNAL MODULE: ./node_modules/lodash-es/toNumber.js
var toNumber = __webpack_require__("4a24");

// CONCATENATED MODULE: ./node_modules/lodash-es/delay.js




/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = Object(_baseRest["a" /* default */])(function(func, wait, args) {
  return _baseDelay(func, Object(toNumber["a" /* default */])(wait) || 0, args);
});

/* harmony default export */ var lodash_es_delay = (delay);

// CONCATENATED MODULE: ./node_modules/lodash-es/flip.js


/** Used to compose bitmasks for function metadata. */
var WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that invokes `func` with arguments reversed.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to flip arguments for.
 * @returns {Function} Returns the new flipped function.
 * @example
 *
 * var flipped = _.flip(function() {
 *   return _.toArray(arguments);
 * });
 *
 * flipped('a', 'b', 'c', 'd');
 * // => ['d', 'c', 'b', 'a']
 */
function flip(func) {
  return Object(_createWrap["a" /* default */])(func, WRAP_FLIP_FLAG);
}

/* harmony default export */ var lodash_es_flip = (flip);

// EXTERNAL MODULE: ./node_modules/lodash-es/memoize.js
var memoize = __webpack_require__("a134");

// CONCATENATED MODULE: ./node_modules/lodash-es/once.js


/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return lodash_es_before(2, func);
}

/* harmony default export */ var lodash_es_once = (once);

// CONCATENATED MODULE: ./node_modules/lodash-es/_castRest.js


/**
 * A `baseRest` alias which can be replaced with `identity` by module
 * replacement plugins.
 *
 * @private
 * @type {Function}
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
var castRest = _baseRest["a" /* default */];

/* harmony default export */ var _castRest = (castRest);

// CONCATENATED MODULE: ./node_modules/lodash-es/overArgs.js









/* Built-in method references for those with the same name as other `lodash` methods. */
var overArgs_nativeMin = Math.min;

/**
 * Creates a function that invokes `func` with its arguments transformed.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Function
 * @param {Function} func The function to wrap.
 * @param {...(Function|Function[])} [transforms=[_.identity]]
 *  The argument transforms.
 * @returns {Function} Returns the new function.
 * @example
 *
 * function doubled(n) {
 *   return n * 2;
 * }
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var func = _.overArgs(function(x, y) {
 *   return [x, y];
 * }, [square, doubled]);
 *
 * func(9, 3);
 * // => [81, 6]
 *
 * func(10, 5);
 * // => [100, 10]
 */
var overArgs = _castRest(function(func, transforms) {
  transforms = (transforms.length == 1 && Object(isArray["a" /* default */])(transforms[0]))
    ? Object(_arrayMap["a" /* default */])(transforms[0], _baseUnary(_baseIteratee))
    : Object(_arrayMap["a" /* default */])(_baseFlatten(transforms, 1), _baseUnary(_baseIteratee));

  var funcsLength = transforms.length;
  return Object(_baseRest["a" /* default */])(function(args) {
    var index = -1,
        length = overArgs_nativeMin(args.length, funcsLength);

    while (++index < length) {
      args[index] = transforms[index].call(this, args[index]);
    }
    return Object(_apply["a" /* default */])(func, this, args);
  });
});

/* harmony default export */ var lodash_es_overArgs = (overArgs);

// CONCATENATED MODULE: ./node_modules/lodash-es/partial.js





/** Used to compose bitmasks for function metadata. */
var partial_WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = Object(_baseRest["a" /* default */])(function(func, partials) {
  var holders = Object(_replaceHolders["a" /* default */])(partials, Object(_getHolder["a" /* default */])(partial));
  return Object(_createWrap["a" /* default */])(func, partial_WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

/* harmony default export */ var lodash_es_partial = (partial);

// CONCATENATED MODULE: ./node_modules/lodash-es/partialRight.js





/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = Object(_baseRest["a" /* default */])(function(func, partials) {
  var holders = Object(_replaceHolders["a" /* default */])(partials, Object(_getHolder["a" /* default */])(partialRight));
  return Object(_createWrap["a" /* default */])(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

/* harmony default export */ var lodash_es_partialRight = (partialRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/rearg.js



/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = _flatRest(function(func, indexes) {
  return Object(_createWrap["a" /* default */])(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

/* harmony default export */ var lodash_es_rearg = (rearg);

// CONCATENATED MODULE: ./node_modules/lodash-es/rest.js



/** Error message constants. */
var rest_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as
 * an array.
 *
 * **Note:** This method is based on the
 * [rest parameter](https://mdn.io/rest_parameters).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.rest(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function rest(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(rest_FUNC_ERROR_TEXT);
  }
  start = start === undefined ? start : Object(toInteger["a" /* default */])(start);
  return Object(_baseRest["a" /* default */])(func, start);
}

/* harmony default export */ var lodash_es_rest = (rest);

// CONCATENATED MODULE: ./node_modules/lodash-es/_castSlice.js


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : _baseSlice(array, start, end);
}

/* harmony default export */ var _castSlice = (castSlice);

// CONCATENATED MODULE: ./node_modules/lodash-es/spread.js






/** Error message constants. */
var spread_FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var spread_nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * create function and an array of arguments much like
 * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
 *
 * **Note:** This method is based on the
 * [spread operator](https://mdn.io/spread_operator).
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Function
 * @param {Function} func The function to spread arguments over.
 * @param {number} [start=0] The start position of the spread.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.spread(function(who, what) {
 *   return who + ' says ' + what;
 * });
 *
 * say(['fred', 'hello']);
 * // => 'fred says hello'
 *
 * var numbers = Promise.all([
 *   Promise.resolve(40),
 *   Promise.resolve(36)
 * ]);
 *
 * numbers.then(_.spread(function(x, y) {
 *   return x + y;
 * }));
 * // => a Promise of 76
 */
function spread(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(spread_FUNC_ERROR_TEXT);
  }
  start = start == null ? 0 : spread_nativeMax(Object(toInteger["a" /* default */])(start), 0);
  return Object(_baseRest["a" /* default */])(function(args) {
    var array = args[start],
        otherArgs = _castSlice(args, 0, start);

    if (array) {
      _arrayPush(otherArgs, array);
    }
    return Object(_apply["a" /* default */])(func, this, otherArgs);
  });
}

/* harmony default export */ var lodash_es_spread = (spread);

// EXTERNAL MODULE: ./node_modules/lodash-es/throttle.js
var throttle = __webpack_require__("517b");

// CONCATENATED MODULE: ./node_modules/lodash-es/unary.js


/**
 * Creates a function that accepts up to one argument, ignoring any
 * additional arguments.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.unary(parseInt));
 * // => [6, 8, 10]
 */
function unary(func) {
  return lodash_es_ary(func, 1);
}

/* harmony default export */ var lodash_es_unary = (unary);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrap.js



/**
 * Creates a function that provides `value` to `wrapper` as its first
 * argument. Any additional arguments provided to the function are appended
 * to those provided to the `wrapper`. The wrapper is invoked with the `this`
 * binding of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {*} value The value to wrap.
 * @param {Function} [wrapper=identity] The wrapper function.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var p = _.wrap(_.escape, function(func, text) {
 *   return '<p>' + func(text) + '</p>';
 * });
 *
 * p('fred, barney, & pebbles');
 * // => '<p>fred, barney, &amp; pebbles</p>'
 */
function wrap(value, wrapper) {
  return lodash_es_partial(_castFunction(wrapper), value);
}

/* harmony default export */ var lodash_es_wrap = (wrap);

// CONCATENATED MODULE: ./node_modules/lodash-es/function.default.js
























/* harmony default export */ var function_default = ({
  after: lodash_es_after, ary: lodash_es_ary, before: lodash_es_before, bind: bind["a" /* default */], bindKey: lodash_es_bindKey,
  curry: lodash_es_curry, curryRight: lodash_es_curryRight, debounce: debounce["a" /* default */], defer: lodash_es_defer, delay: lodash_es_delay,
  flip: lodash_es_flip, memoize: memoize["a" /* default */], negate: lodash_es_negate, once: lodash_es_once, overArgs: lodash_es_overArgs,
  partial: lodash_es_partial, partialRight: lodash_es_partialRight, rearg: lodash_es_rearg, rest: lodash_es_rest, spread: lodash_es_spread,
  throttle: throttle["a" /* default */], unary: lodash_es_unary, wrap: lodash_es_wrap
});

// CONCATENATED MODULE: ./node_modules/lodash-es/castArray.js


/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return Object(isArray["a" /* default */])(value) ? value : [value];
}

/* harmony default export */ var lodash_es_castArray = (castArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copyObject.js



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ var _copyObject = (copyObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssign.js



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, lodash_es_keys(source), object);
}

/* harmony default export */ var _baseAssign = (baseAssign);

// CONCATENATED MODULE: ./node_modules/lodash-es/_nativeKeysIn.js
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _nativeKeysIn = (nativeKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseKeysIn.js




/** Used for built-in method references. */
var _baseKeysIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseKeysIn_hasOwnProperty = _baseKeysIn_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(isObject["a" /* default */])(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !_baseKeysIn_hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ var _baseKeysIn = (baseKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/keysIn.js




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return lodash_es_isArrayLike(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}

/* harmony default export */ var lodash_es_keysIn = (keysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseAssignIn.js



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, lodash_es_keysIn(source), object);
}

/* harmony default export */ var _baseAssignIn = (baseAssignIn);

// EXTERNAL MODULE: ./node_modules/lodash-es/_cloneBuffer.js
var _cloneBuffer = __webpack_require__("dff1");

// CONCATENATED MODULE: ./node_modules/lodash-es/_copySymbols.js



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}

/* harmony default export */ var _copySymbols = (copySymbols);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getSymbolsIn.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var _getSymbolsIn_nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !_getSymbolsIn_nativeGetSymbols ? lodash_es_stubArray : function(object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};

/* harmony default export */ var _getSymbolsIn = (getSymbolsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_copySymbolsIn.js



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}

/* harmony default export */ var _copySymbolsIn = (copySymbolsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getAllKeysIn.js




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, lodash_es_keysIn, _getSymbolsIn);
}

/* harmony default export */ var _getAllKeysIn = (getAllKeysIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneArray.js
/** Used for built-in method references. */
var _initCloneArray_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _initCloneArray_hasOwnProperty = _initCloneArray_objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && _initCloneArray_hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ var _initCloneArray = (initCloneArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneArrayBuffer.js


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}

/* harmony default export */ var _cloneArrayBuffer = (cloneArrayBuffer);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneDataView.js


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ var _cloneDataView = (cloneDataView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneRegExp.js
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ var _cloneRegExp = (cloneRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneSymbol.js


/** Used to convert symbols to primitives and strings. */
var _cloneSymbol_symbolProto = _Symbol["a" /* default */] ? _Symbol["a" /* default */].prototype : undefined,
    _cloneSymbol_symbolValueOf = _cloneSymbol_symbolProto ? _cloneSymbol_symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return _cloneSymbol_symbolValueOf ? Object(_cloneSymbol_symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ var _cloneSymbol = (cloneSymbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_cloneTypedArray.js


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ var _cloneTypedArray = (cloneTypedArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneByTag.js






/** `Object#toString` result references. */
var _initCloneByTag_boolTag = '[object Boolean]',
    _initCloneByTag_dateTag = '[object Date]',
    _initCloneByTag_mapTag = '[object Map]',
    _initCloneByTag_numberTag = '[object Number]',
    _initCloneByTag_regexpTag = '[object RegExp]',
    _initCloneByTag_setTag = '[object Set]',
    _initCloneByTag_stringTag = '[object String]',
    _initCloneByTag_symbolTag = '[object Symbol]';

var _initCloneByTag_arrayBufferTag = '[object ArrayBuffer]',
    _initCloneByTag_dataViewTag = '[object DataView]',
    _initCloneByTag_float32Tag = '[object Float32Array]',
    _initCloneByTag_float64Tag = '[object Float64Array]',
    _initCloneByTag_int8Tag = '[object Int8Array]',
    _initCloneByTag_int16Tag = '[object Int16Array]',
    _initCloneByTag_int32Tag = '[object Int32Array]',
    _initCloneByTag_uint8Tag = '[object Uint8Array]',
    _initCloneByTag_uint8ClampedTag = '[object Uint8ClampedArray]',
    _initCloneByTag_uint16Tag = '[object Uint16Array]',
    _initCloneByTag_uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case _initCloneByTag_arrayBufferTag:
      return _cloneArrayBuffer(object);

    case _initCloneByTag_boolTag:
    case _initCloneByTag_dateTag:
      return new Ctor(+object);

    case _initCloneByTag_dataViewTag:
      return _cloneDataView(object, isDeep);

    case _initCloneByTag_float32Tag: case _initCloneByTag_float64Tag:
    case _initCloneByTag_int8Tag: case _initCloneByTag_int16Tag: case _initCloneByTag_int32Tag:
    case _initCloneByTag_uint8Tag: case _initCloneByTag_uint8ClampedTag: case _initCloneByTag_uint16Tag: case _initCloneByTag_uint32Tag:
      return _cloneTypedArray(object, isDeep);

    case _initCloneByTag_mapTag:
      return new Ctor;

    case _initCloneByTag_numberTag:
    case _initCloneByTag_stringTag:
      return new Ctor(object);

    case _initCloneByTag_regexpTag:
      return _cloneRegExp(object);

    case _initCloneByTag_setTag:
      return new Ctor;

    case _initCloneByTag_symbolTag:
      return _cloneSymbol(object);
  }
}

/* harmony default export */ var _initCloneByTag = (initCloneByTag);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseCreate.js
var _baseCreate = __webpack_require__("7378");

// CONCATENATED MODULE: ./node_modules/lodash-es/_initCloneObject.js




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !_isPrototype(object))
    ? Object(_baseCreate["a" /* default */])(_getPrototype(object))
    : {};
}

/* harmony default export */ var _initCloneObject = (initCloneObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsMap.js



/** `Object#toString` result references. */
var _baseIsMap_mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return Object(isObjectLike["a" /* default */])(value) && _getTag(value) == _baseIsMap_mapTag;
}

/* harmony default export */ var _baseIsMap = (baseIsMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/isMap.js




/* Node.js helper references. */
var nodeIsMap = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;

/* harmony default export */ var lodash_es_isMap = (isMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsSet.js



/** `Object#toString` result references. */
var _baseIsSet_setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return Object(isObjectLike["a" /* default */])(value) && _getTag(value) == _baseIsSet_setTag;
}

/* harmony default export */ var _baseIsSet = (baseIsSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/isSet.js




/* Node.js helper references. */
var nodeIsSet = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;

/* harmony default export */ var lodash_es_isSet = (isSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseClone.js























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var _baseClone_argsTag = '[object Arguments]',
    _baseClone_arrayTag = '[object Array]',
    _baseClone_boolTag = '[object Boolean]',
    _baseClone_dateTag = '[object Date]',
    _baseClone_errorTag = '[object Error]',
    _baseClone_funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    _baseClone_mapTag = '[object Map]',
    _baseClone_numberTag = '[object Number]',
    _baseClone_objectTag = '[object Object]',
    _baseClone_regexpTag = '[object RegExp]',
    _baseClone_setTag = '[object Set]',
    _baseClone_stringTag = '[object String]',
    _baseClone_symbolTag = '[object Symbol]',
    _baseClone_weakMapTag = '[object WeakMap]';

var _baseClone_arrayBufferTag = '[object ArrayBuffer]',
    _baseClone_dataViewTag = '[object DataView]',
    _baseClone_float32Tag = '[object Float32Array]',
    _baseClone_float64Tag = '[object Float64Array]',
    _baseClone_int8Tag = '[object Int8Array]',
    _baseClone_int16Tag = '[object Int16Array]',
    _baseClone_int32Tag = '[object Int32Array]',
    _baseClone_uint8Tag = '[object Uint8Array]',
    _baseClone_uint8ClampedTag = '[object Uint8ClampedArray]',
    _baseClone_uint16Tag = '[object Uint16Array]',
    _baseClone_uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[_baseClone_argsTag] = cloneableTags[_baseClone_arrayTag] =
cloneableTags[_baseClone_arrayBufferTag] = cloneableTags[_baseClone_dataViewTag] =
cloneableTags[_baseClone_boolTag] = cloneableTags[_baseClone_dateTag] =
cloneableTags[_baseClone_float32Tag] = cloneableTags[_baseClone_float64Tag] =
cloneableTags[_baseClone_int8Tag] = cloneableTags[_baseClone_int16Tag] =
cloneableTags[_baseClone_int32Tag] = cloneableTags[_baseClone_mapTag] =
cloneableTags[_baseClone_numberTag] = cloneableTags[_baseClone_objectTag] =
cloneableTags[_baseClone_regexpTag] = cloneableTags[_baseClone_setTag] =
cloneableTags[_baseClone_stringTag] = cloneableTags[_baseClone_symbolTag] =
cloneableTags[_baseClone_uint8Tag] = cloneableTags[_baseClone_uint8ClampedTag] =
cloneableTags[_baseClone_uint16Tag] = cloneableTags[_baseClone_uint32Tag] = true;
cloneableTags[_baseClone_errorTag] = cloneableTags[_baseClone_funcTag] =
cloneableTags[_baseClone_weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!Object(isObject["a" /* default */])(value)) {
    return value;
  }
  var isArr = Object(isArray["a" /* default */])(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return Object(_copyArray["a" /* default */])(value, result);
    }
  } else {
    var tag = _getTag(value),
        isFunc = tag == _baseClone_funcTag || tag == genTag;

    if (Object(isBuffer["a" /* default */])(value)) {
      return Object(_cloneBuffer["a" /* default */])(value, isDeep);
    }
    if (tag == _baseClone_objectTag || tag == _baseClone_argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? _copySymbolsIn(value, _baseAssignIn(result, value))
          : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (lodash_es_isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (lodash_es_isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? _getAllKeysIn : _getAllKeys)
    : (isFlat ? lodash_es_keysIn : lodash_es_keys);

  var props = isArr ? undefined : keysFunc(value);
  Object(_arrayEach["a" /* default */])(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ var _baseClone = (baseClone);

// CONCATENATED MODULE: ./node_modules/lodash-es/clone.js


/** Used to compose bitmasks for cloning. */
var clone_CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone_clone(value) {
  return _baseClone(value, clone_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_clone = (clone_clone);

// CONCATENATED MODULE: ./node_modules/lodash-es/cloneDeep.js


/** Used to compose bitmasks for cloning. */
var cloneDeep_CLONE_DEEP_FLAG = 1,
    cloneDeep_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, cloneDeep_CLONE_DEEP_FLAG | cloneDeep_CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ var lodash_es_cloneDeep = (cloneDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/cloneDeepWith.js


/** Used to compose bitmasks for cloning. */
var cloneDeepWith_CLONE_DEEP_FLAG = 1,
    cloneDeepWith_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return _baseClone(value, cloneDeepWith_CLONE_DEEP_FLAG | cloneDeepWith_CLONE_SYMBOLS_FLAG, customizer);
}

/* harmony default export */ var lodash_es_cloneDeepWith = (cloneDeepWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/cloneWith.js


/** Used to compose bitmasks for cloning. */
var cloneWith_CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it accepts `customizer` which
 * is invoked to produce the cloned value. If `customizer` returns `undefined`,
 * cloning is handled by the method instead. The `customizer` is invoked with
 * up to four arguments; (value [, index|key, object, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeepWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(false);
 *   }
 * }
 *
 * var el = _.cloneWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 0
 */
function cloneWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return _baseClone(value, cloneWith_CLONE_SYMBOLS_FLAG, customizer);
}

/* harmony default export */ var lodash_es_cloneWith = (cloneWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseConformsTo.js
/**
 * The base implementation of `_.conformsTo` which accepts `props` to check.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 */
function baseConformsTo(object, source, props) {
  var length = props.length;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (length--) {
    var key = props[length],
        predicate = source[key],
        value = object[key];

    if ((value === undefined && !(key in object)) || !predicate(value)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var _baseConformsTo = (baseConformsTo);

// CONCATENATED MODULE: ./node_modules/lodash-es/conformsTo.js



/**
 * Checks if `object` conforms to `source` by invoking the predicate
 * properties of `source` with the corresponding property values of `object`.
 *
 * **Note:** This method is equivalent to `_.conforms` when `source` is
 * partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property predicates to conform to.
 * @returns {boolean} Returns `true` if `object` conforms, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
 * // => true
 *
 * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
 * // => false
 */
function conformsTo(object, source) {
  return source == null || _baseConformsTo(object, source, lodash_es_keys(source));
}

/* harmony default export */ var lodash_es_conformsTo = (conformsTo);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGt.js
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

/* harmony default export */ var _baseGt = (baseGt);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createRelationalOperation.js


/**
 * Creates a function that performs a relational operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @returns {Function} Returns the new relational operation function.
 */
function createRelationalOperation(operator) {
  return function(value, other) {
    if (!(typeof value == 'string' && typeof other == 'string')) {
      value = Object(toNumber["a" /* default */])(value);
      other = Object(toNumber["a" /* default */])(other);
    }
    return operator(value, other);
  };
}

/* harmony default export */ var _createRelationalOperation = (createRelationalOperation);

// CONCATENATED MODULE: ./node_modules/lodash-es/gt.js



/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = _createRelationalOperation(_baseGt);

/* harmony default export */ var lodash_es_gt = (gt);

// CONCATENATED MODULE: ./node_modules/lodash-es/gte.js


/**
 * Checks if `value` is greater than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than or equal to
 *  `other`, else `false`.
 * @see _.lte
 * @example
 *
 * _.gte(3, 1);
 * // => true
 *
 * _.gte(3, 3);
 * // => true
 *
 * _.gte(1, 3);
 * // => false
 */
var gte = _createRelationalOperation(function(value, other) {
  return value >= other;
});

/* harmony default export */ var lodash_es_gte = (gte);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsArrayBuffer.js



var _baseIsArrayBuffer_arrayBufferTag = '[object ArrayBuffer]';

/**
 * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 */
function baseIsArrayBuffer(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == _baseIsArrayBuffer_arrayBufferTag;
}

/* harmony default export */ var _baseIsArrayBuffer = (baseIsArrayBuffer);

// CONCATENATED MODULE: ./node_modules/lodash-es/isArrayBuffer.js




/* Node.js helper references. */
var nodeIsArrayBuffer = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isArrayBuffer;

/**
 * Checks if `value` is classified as an `ArrayBuffer` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
 * @example
 *
 * _.isArrayBuffer(new ArrayBuffer(2));
 * // => true
 *
 * _.isArrayBuffer(new Array(2));
 * // => false
 */
var isArrayBuffer = nodeIsArrayBuffer ? _baseUnary(nodeIsArrayBuffer) : _baseIsArrayBuffer;

/* harmony default export */ var lodash_es_isArrayBuffer = (isArrayBuffer);

// CONCATENATED MODULE: ./node_modules/lodash-es/isBoolean.js



/** `Object#toString` result references. */
var isBoolean_boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == isBoolean_boolTag);
}

/* harmony default export */ var lodash_es_isBoolean = (isBoolean);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsDate.js



/** `Object#toString` result references. */
var _baseIsDate_dateTag = '[object Date]';

/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */
function baseIsDate(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == _baseIsDate_dateTag;
}

/* harmony default export */ var _baseIsDate = (baseIsDate);

// CONCATENATED MODULE: ./node_modules/lodash-es/isDate.js




/* Node.js helper references. */
var nodeIsDate = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isDate;

/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */
var isDate = nodeIsDate ? _baseUnary(nodeIsDate) : _baseIsDate;

/* harmony default export */ var lodash_es_isDate = (isDate);

// CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var isPlainObject_objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(isObjectLike["a" /* default */])(value) || Object(_baseGetTag["a" /* default */])(value) != isPlainObject_objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/isElement.js



/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return Object(isObjectLike["a" /* default */])(value) && value.nodeType === 1 && !lodash_es_isPlainObject(value);
}

/* harmony default export */ var lodash_es_isElement = (isElement);

// CONCATENATED MODULE: ./node_modules/lodash-es/isEmpty.js









/** `Object#toString` result references. */
var isEmpty_mapTag = '[object Map]',
    isEmpty_setTag = '[object Set]';

/** Used for built-in method references. */
var isEmpty_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var isEmpty_hasOwnProperty = isEmpty_objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (lodash_es_isArrayLike(value) &&
      (Object(isArray["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(isBuffer["a" /* default */])(value) || lodash_es_isTypedArray(value) || lodash_es_isArguments(value))) {
    return !value.length;
  }
  var tag = _getTag(value);
  if (tag == isEmpty_mapTag || tag == isEmpty_setTag) {
    return !value.size;
  }
  if (_isPrototype(value)) {
    return !_baseKeys(value).length;
  }
  for (var key in value) {
    if (isEmpty_hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ var lodash_es_isEmpty = (isEmpty);

// CONCATENATED MODULE: ./node_modules/lodash-es/isEqual.js


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return _baseIsEqual(value, other);
}

/* harmony default export */ var lodash_es_isEqual = (isEqual);

// CONCATENATED MODULE: ./node_modules/lodash-es/isEqualWith.js


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? _baseIsEqual(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ var lodash_es_isEqualWith = (isEqualWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/isError.js




/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    isError_errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!Object(isObjectLike["a" /* default */])(value)) {
    return false;
  }
  var tag = Object(_baseGetTag["a" /* default */])(value);
  return tag == isError_errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !lodash_es_isPlainObject(value));
}

/* harmony default export */ var lodash_es_isError = (isError);

// CONCATENATED MODULE: ./node_modules/lodash-es/isFinite.js


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = _root["a" /* default */].isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite_isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

/* harmony default export */ var lodash_es_isFinite = (isFinite_isFinite);

// CONCATENATED MODULE: ./node_modules/lodash-es/isInteger.js


/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == Object(toInteger["a" /* default */])(value);
}

/* harmony default export */ var lodash_es_isInteger = (isInteger);

// CONCATENATED MODULE: ./node_modules/lodash-es/isMatch.js



/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || _baseIsMatch(object, source, _getMatchData(source));
}

/* harmony default export */ var lodash_es_isMatch = (isMatch);

// CONCATENATED MODULE: ./node_modules/lodash-es/isMatchWith.js



/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */
function isMatchWith(object, source, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return _baseIsMatch(object, source, _getMatchData(source), customizer);
}

/* harmony default export */ var lodash_es_isMatchWith = (isMatchWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNumber.js



/** `Object#toString` result references. */
var isNumber_numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == isNumber_numberTag);
}

/* harmony default export */ var lodash_es_isNumber = (isNumber);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNaN.js


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN_isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return lodash_es_isNumber(value) && value != +value;
}

/* harmony default export */ var lodash_es_isNaN = (isNaN_isNaN);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseIsNative.js + 1 modules
var _baseIsNative = __webpack_require__("94da");

// EXTERNAL MODULE: ./node_modules/lodash-es/_coreJsData.js
var _coreJsData = __webpack_require__("88e0");

// EXTERNAL MODULE: ./node_modules/lodash-es/stubFalse.js
var stubFalse = __webpack_require__("2f74");

// CONCATENATED MODULE: ./node_modules/lodash-es/_isMaskable.js




/**
 * Checks if `func` is capable of being masked.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
 */
var isMaskable = _coreJsData["a" /* default */] ? isFunction["a" /* default */] : stubFalse["a" /* default */];

/* harmony default export */ var _isMaskable = (isMaskable);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNative.js



/** Error message constants. */
var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.';

/**
 * Checks if `value` is a pristine native function.
 *
 * **Note:** This method can't reliably detect native functions in the presence
 * of the core-js package because core-js circumvents this kind of detection.
 * Despite multiple requests, the core-js maintainer has made it clear: any
 * attempt to fix the detection will be obstructed. As a result, we're left
 * with little choice but to throw an error. Unfortunately, this also affects
 * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
 * which rely on core-js.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (_isMaskable(value)) {
    throw new Error(CORE_ERROR_TEXT);
  }
  return Object(_baseIsNative["a" /* default */])(value);
}

/* harmony default export */ var lodash_es_isNative = (isNative);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNil.js
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ var lodash_es_isNil = (isNil);

// CONCATENATED MODULE: ./node_modules/lodash-es/isNull.js
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/* harmony default export */ var lodash_es_isNull = (isNull);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIsRegExp.js



/** `Object#toString` result references. */
var _baseIsRegExp_regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == _baseIsRegExp_regexpTag;
}

/* harmony default export */ var _baseIsRegExp = (baseIsRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/isRegExp.js




/* Node.js helper references. */
var nodeIsRegExp = _nodeUtil["a" /* default */] && _nodeUtil["a" /* default */].isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? _baseUnary(nodeIsRegExp) : _baseIsRegExp;

/* harmony default export */ var lodash_es_isRegExp = (isRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/isSafeInteger.js


/** Used as references for various `Number` constants. */
var isSafeInteger_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
 * double precision number which isn't the result of a rounded unsafe integer.
 *
 * **Note:** This method is based on
 * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
 * @example
 *
 * _.isSafeInteger(3);
 * // => true
 *
 * _.isSafeInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isSafeInteger(Infinity);
 * // => false
 *
 * _.isSafeInteger('3');
 * // => false
 */
function isSafeInteger(value) {
  return lodash_es_isInteger(value) && value >= -isSafeInteger_MAX_SAFE_INTEGER && value <= isSafeInteger_MAX_SAFE_INTEGER;
}

/* harmony default export */ var lodash_es_isSafeInteger = (isSafeInteger);

// CONCATENATED MODULE: ./node_modules/lodash-es/isUndefined.js
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ var lodash_es_isUndefined = (isUndefined);

// CONCATENATED MODULE: ./node_modules/lodash-es/isWeakMap.js



/** `Object#toString` result references. */
var isWeakMap_weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return Object(isObjectLike["a" /* default */])(value) && _getTag(value) == isWeakMap_weakMapTag;
}

/* harmony default export */ var lodash_es_isWeakMap = (isWeakMap);

// CONCATENATED MODULE: ./node_modules/lodash-es/isWeakSet.js



/** `Object#toString` result references. */
var weakSetTag = '[object WeakSet]';

/**
 * Checks if `value` is classified as a `WeakSet` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
 * @example
 *
 * _.isWeakSet(new WeakSet);
 * // => true
 *
 * _.isWeakSet(new Set);
 * // => false
 */
function isWeakSet(value) {
  return Object(isObjectLike["a" /* default */])(value) && Object(_baseGetTag["a" /* default */])(value) == weakSetTag;
}

/* harmony default export */ var lodash_es_isWeakSet = (isWeakSet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseLt.js
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

/* harmony default export */ var _baseLt = (baseLt);

// CONCATENATED MODULE: ./node_modules/lodash-es/lt.js



/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = _createRelationalOperation(_baseLt);

/* harmony default export */ var lodash_es_lt = (lt);

// CONCATENATED MODULE: ./node_modules/lodash-es/lte.js


/**
 * Checks if `value` is less than or equal to `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than or equal to
 *  `other`, else `false`.
 * @see _.gte
 * @example
 *
 * _.lte(1, 3);
 * // => true
 *
 * _.lte(3, 3);
 * // => true
 *
 * _.lte(3, 1);
 * // => false
 */
var lte = _createRelationalOperation(function(value, other) {
  return value <= other;
});

/* harmony default export */ var lodash_es_lte = (lte);

// CONCATENATED MODULE: ./node_modules/lodash-es/_iteratorToArray.js
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/* harmony default export */ var _iteratorToArray = (iteratorToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_asciiToArray.js
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/* harmony default export */ var _asciiToArray = (asciiToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unicodeToArray.js
/** Used to compose unicode character classes. */
var _unicodeToArray_rsAstralRange = '\\ud800-\\udfff',
    _unicodeToArray_rsComboMarksRange = '\\u0300-\\u036f',
    _unicodeToArray_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    _unicodeToArray_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    _unicodeToArray_rsComboRange = _unicodeToArray_rsComboMarksRange + _unicodeToArray_reComboHalfMarksRange + _unicodeToArray_rsComboSymbolsRange,
    _unicodeToArray_rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var _unicodeToArray_rsAstral = '[' + _unicodeToArray_rsAstralRange + ']',
    _unicodeToArray_rsCombo = '[' + _unicodeToArray_rsComboRange + ']',
    _unicodeToArray_rsFitz = '\\ud83c[\\udffb-\\udfff]',
    _unicodeToArray_rsModifier = '(?:' + _unicodeToArray_rsCombo + '|' + _unicodeToArray_rsFitz + ')',
    _unicodeToArray_rsNonAstral = '[^' + _unicodeToArray_rsAstralRange + ']',
    _unicodeToArray_rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    _unicodeToArray_rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    _unicodeToArray_rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var _unicodeToArray_reOptMod = _unicodeToArray_rsModifier + '?',
    _unicodeToArray_rsOptVar = '[' + _unicodeToArray_rsVarRange + ']?',
    _unicodeToArray_rsOptJoin = '(?:' + _unicodeToArray_rsZWJ + '(?:' + [_unicodeToArray_rsNonAstral, _unicodeToArray_rsRegional, _unicodeToArray_rsSurrPair].join('|') + ')' + _unicodeToArray_rsOptVar + _unicodeToArray_reOptMod + ')*',
    _unicodeToArray_rsSeq = _unicodeToArray_rsOptVar + _unicodeToArray_reOptMod + _unicodeToArray_rsOptJoin,
    _unicodeToArray_rsSymbol = '(?:' + [_unicodeToArray_rsNonAstral + _unicodeToArray_rsCombo + '?', _unicodeToArray_rsCombo, _unicodeToArray_rsRegional, _unicodeToArray_rsSurrPair, _unicodeToArray_rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var _unicodeToArray_reUnicode = RegExp(_unicodeToArray_rsFitz + '(?=' + _unicodeToArray_rsFitz + ')|' + _unicodeToArray_rsSymbol + _unicodeToArray_rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(_unicodeToArray_reUnicode) || [];
}

/* harmony default export */ var _unicodeToArray = (unicodeToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stringToArray.js




/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return _hasUnicode(string)
    ? _unicodeToArray(string)
    : _asciiToArray(string);
}

/* harmony default export */ var _stringToArray = (stringToArray);

// CONCATENATED MODULE: ./node_modules/lodash-es/toArray.js











/** `Object#toString` result references. */
var toArray_mapTag = '[object Map]',
    toArray_setTag = '[object Set]';

/** Built-in value references. */
var symIterator = _Symbol["a" /* default */] ? _Symbol["a" /* default */].iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (lodash_es_isArrayLike(value)) {
    return lodash_es_isString(value) ? _stringToArray(value) : Object(_copyArray["a" /* default */])(value);
  }
  if (symIterator && value[symIterator]) {
    return _iteratorToArray(value[symIterator]());
  }
  var tag = _getTag(value),
      func = tag == toArray_mapTag ? _mapToArray : (tag == toArray_setTag ? _setToArray : lodash_es_values);

  return func(value);
}

/* harmony default export */ var lodash_es_toArray = (toArray);

// EXTERNAL MODULE: ./node_modules/lodash-es/toFinite.js
var toFinite = __webpack_require__("cb09");

// CONCATENATED MODULE: ./node_modules/lodash-es/toPlainObject.js



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return _copyObject(value, lodash_es_keysIn(value));
}

/* harmony default export */ var lodash_es_toPlainObject = (toPlainObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/toSafeInteger.js



/** Used as references for various `Number` constants. */
var toSafeInteger_MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */
function toSafeInteger(value) {
  return value
    ? _baseClamp(Object(toInteger["a" /* default */])(value), -toSafeInteger_MAX_SAFE_INTEGER, toSafeInteger_MAX_SAFE_INTEGER)
    : (value === 0 ? value : 0);
}

/* harmony default export */ var lodash_es_toSafeInteger = (toSafeInteger);

// EXTERNAL MODULE: ./node_modules/lodash-es/toString.js
var lodash_es_toString = __webpack_require__("79f6");

// CONCATENATED MODULE: ./node_modules/lodash-es/lang.default.js

























































/* harmony default export */ var lang_default = ({
  castArray: lodash_es_castArray, clone: lodash_es_clone, cloneDeep: lodash_es_cloneDeep, cloneDeepWith: lodash_es_cloneDeepWith, cloneWith: lodash_es_cloneWith,
  conformsTo: lodash_es_conformsTo, eq: eq["a" /* default */], gt: lodash_es_gt, gte: lodash_es_gte, isArguments: lodash_es_isArguments,
  isArray: isArray["a" /* default */], isArrayBuffer: lodash_es_isArrayBuffer, isArrayLike: lodash_es_isArrayLike, isArrayLikeObject: lodash_es_isArrayLikeObject, isBoolean: lodash_es_isBoolean,
  isBuffer: isBuffer["a" /* default */], isDate: lodash_es_isDate, isElement: lodash_es_isElement, isEmpty: lodash_es_isEmpty, isEqual: lodash_es_isEqual,
  isEqualWith: lodash_es_isEqualWith, isError: lodash_es_isError, isFinite: lodash_es_isFinite, isFunction: isFunction["a" /* default */], isInteger: lodash_es_isInteger,
  isLength: lodash_es_isLength, isMap: lodash_es_isMap, isMatch: lodash_es_isMatch, isMatchWith: lodash_es_isMatchWith, isNaN: lodash_es_isNaN,
  isNative: lodash_es_isNative, isNil: lodash_es_isNil, isNull: lodash_es_isNull, isNumber: lodash_es_isNumber, isObject: isObject["a" /* default */],
  isObjectLike: isObjectLike["a" /* default */], isPlainObject: lodash_es_isPlainObject, isRegExp: lodash_es_isRegExp, isSafeInteger: lodash_es_isSafeInteger, isSet: lodash_es_isSet,
  isString: lodash_es_isString, isSymbol: isSymbol["a" /* default */], isTypedArray: lodash_es_isTypedArray, isUndefined: lodash_es_isUndefined, isWeakMap: lodash_es_isWeakMap,
  isWeakSet: lodash_es_isWeakSet, lt: lodash_es_lt, lte: lodash_es_lte, toArray: lodash_es_toArray, toFinite: toFinite["a" /* default */],
  toInteger: toInteger["a" /* default */], toLength: lodash_es_toLength, toNumber: toNumber["a" /* default */], toPlainObject: lodash_es_toPlainObject, toSafeInteger: lodash_es_toSafeInteger,
  toString: lodash_es_toString["a" /* default */]
});

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToNumber.js


/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(isSymbol["a" /* default */])(value)) {
    return NAN;
  }
  return +value;
}

/* harmony default export */ var _baseToNumber = (baseToNumber);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseToString.js
var _baseToString = __webpack_require__("2c57");

// CONCATENATED MODULE: ./node_modules/lodash-es/_createMathOperation.js



/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function(value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = Object(_baseToString["a" /* default */])(value);
        other = Object(_baseToString["a" /* default */])(other);
      } else {
        value = _baseToNumber(value);
        other = _baseToNumber(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

/* harmony default export */ var _createMathOperation = (createMathOperation);

// CONCATENATED MODULE: ./node_modules/lodash-es/add.js


/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = _createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

/* harmony default export */ var lodash_es_add = (add);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createRound.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var _createRound_nativeIsFinite = _root["a" /* default */].isFinite,
    _createRound_nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = Object(toNumber["a" /* default */])(number);
    precision = precision == null ? 0 : _createRound_nativeMin(Object(toInteger["a" /* default */])(precision), 292);
    if (precision && _createRound_nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (Object(lodash_es_toString["a" /* default */])(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (Object(lodash_es_toString["a" /* default */])(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

/* harmony default export */ var _createRound = (createRound);

// CONCATENATED MODULE: ./node_modules/lodash-es/ceil.js


/**
 * Computes `number` rounded up to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round up.
 * @param {number} [precision=0] The precision to round up to.
 * @returns {number} Returns the rounded up number.
 * @example
 *
 * _.ceil(4.006);
 * // => 5
 *
 * _.ceil(6.004, 2);
 * // => 6.01
 *
 * _.ceil(6040, -2);
 * // => 6100
 */
var ceil = _createRound('ceil');

/* harmony default export */ var lodash_es_ceil = (ceil);

// CONCATENATED MODULE: ./node_modules/lodash-es/divide.js


/**
 * Divide two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} dividend The first number in a division.
 * @param {number} divisor The second number in a division.
 * @returns {number} Returns the quotient.
 * @example
 *
 * _.divide(6, 4);
 * // => 1.5
 */
var divide = _createMathOperation(function(dividend, divisor) {
  return dividend / divisor;
}, 1);

/* harmony default export */ var lodash_es_divide = (divide);

// CONCATENATED MODULE: ./node_modules/lodash-es/floor.js


/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */
var floor = _createRound('floor');

/* harmony default export */ var lodash_es_floor = (floor);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseExtremum.js


/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !Object(isSymbol["a" /* default */])(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

/* harmony default export */ var _baseExtremum = (baseExtremum);

// CONCATENATED MODULE: ./node_modules/lodash-es/max.js




/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? _baseExtremum(array, identity["a" /* default */], _baseGt)
    : undefined;
}

/* harmony default export */ var lodash_es_max = (max);

// CONCATENATED MODULE: ./node_modules/lodash-es/maxBy.js




/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? _baseExtremum(array, _baseIteratee(iteratee, 2), _baseGt)
    : undefined;
}

/* harmony default export */ var lodash_es_maxBy = (maxBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseSum.js
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

/* harmony default export */ var _baseSum = (baseSum);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMean.js


/** Used as references for various `Number` constants. */
var _baseMean_NAN = 0 / 0;

/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */
function baseMean(array, iteratee) {
  var length = array == null ? 0 : array.length;
  return length ? (_baseSum(array, iteratee) / length) : _baseMean_NAN;
}

/* harmony default export */ var _baseMean = (baseMean);

// CONCATENATED MODULE: ./node_modules/lodash-es/mean.js



/**
 * Computes the mean of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the mean.
 * @example
 *
 * _.mean([4, 2, 8, 6]);
 * // => 5
 */
function mean(array) {
  return _baseMean(array, identity["a" /* default */]);
}

/* harmony default export */ var lodash_es_mean = (mean);

// CONCATENATED MODULE: ./node_modules/lodash-es/meanBy.js



/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */
function meanBy(array, iteratee) {
  return _baseMean(array, _baseIteratee(iteratee, 2));
}

/* harmony default export */ var lodash_es_meanBy = (meanBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/min.js




/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? _baseExtremum(array, identity["a" /* default */], _baseLt)
    : undefined;
}

/* harmony default export */ var lodash_es_min = (min);

// CONCATENATED MODULE: ./node_modules/lodash-es/minBy.js




/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? _baseExtremum(array, _baseIteratee(iteratee, 2), _baseLt)
    : undefined;
}

/* harmony default export */ var lodash_es_minBy = (minBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/multiply.js


/**
 * Multiply two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {number} multiplier The first number in a multiplication.
 * @param {number} multiplicand The second number in a multiplication.
 * @returns {number} Returns the product.
 * @example
 *
 * _.multiply(6, 4);
 * // => 24
 */
var multiply = _createMathOperation(function(multiplier, multiplicand) {
  return multiplier * multiplicand;
}, 1);

/* harmony default export */ var lodash_es_multiply = (multiply);

// CONCATENATED MODULE: ./node_modules/lodash-es/round.js


/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = _createRound('round');

/* harmony default export */ var lodash_es_round = (round);

// CONCATENATED MODULE: ./node_modules/lodash-es/subtract.js


/**
 * Subtract two numbers.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {number} minuend The first number in a subtraction.
 * @param {number} subtrahend The second number in a subtraction.
 * @returns {number} Returns the difference.
 * @example
 *
 * _.subtract(6, 4);
 * // => 2
 */
var subtract = _createMathOperation(function(minuend, subtrahend) {
  return minuend - subtrahend;
}, 0);

/* harmony default export */ var lodash_es_subtract = (subtract);

// CONCATENATED MODULE: ./node_modules/lodash-es/sum.js



/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? _baseSum(array, identity["a" /* default */])
    : 0;
}

/* harmony default export */ var lodash_es_sum = (sum);

// CONCATENATED MODULE: ./node_modules/lodash-es/sumBy.js



/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? _baseSum(array, _baseIteratee(iteratee, 2))
    : 0;
}

/* harmony default export */ var lodash_es_sumBy = (sumBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/math.default.js
















/* harmony default export */ var math_default = ({
  add: lodash_es_add, ceil: lodash_es_ceil, divide: lodash_es_divide, floor: lodash_es_floor, max: lodash_es_max,
  maxBy: lodash_es_maxBy, mean: lodash_es_mean, meanBy: lodash_es_meanBy, min: lodash_es_min, minBy: lodash_es_minBy,
  multiply: lodash_es_multiply, round: lodash_es_round, subtract: lodash_es_subtract, sum: lodash_es_sum, sumBy: lodash_es_sumBy
});

// CONCATENATED MODULE: ./node_modules/lodash-es/clamp.js



/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = Object(toNumber["a" /* default */])(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = Object(toNumber["a" /* default */])(lower);
    lower = lower === lower ? lower : 0;
  }
  return _baseClamp(Object(toNumber["a" /* default */])(number), lower, upper);
}

/* harmony default export */ var lodash_es_clamp = (clamp);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseInRange.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseInRange_nativeMax = Math.max,
    _baseInRange_nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= _baseInRange_nativeMin(start, end) && number < _baseInRange_nativeMax(start, end);
}

/* harmony default export */ var _baseInRange = (baseInRange);

// CONCATENATED MODULE: ./node_modules/lodash-es/inRange.js




/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = Object(toFinite["a" /* default */])(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = Object(toFinite["a" /* default */])(end);
  }
  number = Object(toNumber["a" /* default */])(number);
  return _baseInRange(number, start, end);
}

/* harmony default export */ var lodash_es_inRange = (inRange);

// CONCATENATED MODULE: ./node_modules/lodash-es/random.js




/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var random_nativeMin = Math.min,
    random_nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && _isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = Object(toFinite["a" /* default */])(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = Object(toFinite["a" /* default */])(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = random_nativeRandom();
    return random_nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return _baseRandom(lower, upper);
}

/* harmony default export */ var lodash_es_random = (random);

// CONCATENATED MODULE: ./node_modules/lodash-es/number.default.js




/* harmony default export */ var number_default = ({
  clamp: lodash_es_clamp, inRange: lodash_es_inRange, random: lodash_es_random
});

// CONCATENATED MODULE: ./node_modules/lodash-es/_createAssigner.js



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(_baseRest["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ var _createAssigner = (createAssigner);

// CONCATENATED MODULE: ./node_modules/lodash-es/assign.js







/** Used for built-in method references. */
var assign_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var assign_hasOwnProperty = assign_objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign_assign = _createAssigner(function(object, source) {
  if (_isPrototype(source) || lodash_es_isArrayLike(source)) {
    _copyObject(source, lodash_es_keys(source), object);
    return;
  }
  for (var key in source) {
    if (assign_hasOwnProperty.call(source, key)) {
      _assignValue(object, key, source[key]);
    }
  }
});

/* harmony default export */ var lodash_es_assign = (assign_assign);

// CONCATENATED MODULE: ./node_modules/lodash-es/assignIn.js




/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = _createAssigner(function(object, source) {
  _copyObject(source, lodash_es_keysIn(source), object);
});

/* harmony default export */ var lodash_es_assignIn = (assignIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/assignInWith.js




/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = _createAssigner(function(object, source, srcIndex, customizer) {
  _copyObject(source, lodash_es_keysIn(source), object, customizer);
});

/* harmony default export */ var lodash_es_assignInWith = (assignInWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/assignWith.js




/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = _createAssigner(function(object, source, srcIndex, customizer) {
  _copyObject(source, lodash_es_keys(source), object, customizer);
});

/* harmony default export */ var lodash_es_assignWith = (assignWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/at.js



/**
 * Creates an array of values corresponding to `paths` of `object`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Array} Returns the picked values.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _.at(object, ['a[0].b.c', 'a[1]']);
 * // => [3, 4]
 */
var at = _flatRest(_baseAt);

/* harmony default export */ var lodash_es_at = (at);

// CONCATENATED MODULE: ./node_modules/lodash-es/create.js



/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = Object(_baseCreate["a" /* default */])(prototype);
  return properties == null ? result : _baseAssign(result, properties);
}

/* harmony default export */ var lodash_es_create = (create);

// CONCATENATED MODULE: ./node_modules/lodash-es/defaults.js





/** Used for built-in method references. */
var defaults_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var defaults_hasOwnProperty = defaults_objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = Object(_baseRest["a" /* default */])(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && _isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = lodash_es_keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (Object(eq["a" /* default */])(value, defaults_objectProto[key]) && !defaults_hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

/* harmony default export */ var lodash_es_defaults = (defaults);

// CONCATENATED MODULE: ./node_modules/lodash-es/_assignMergeValue.js



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(eq["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    _baseAssignValue(object, key, value);
  }
}

/* harmony default export */ var _assignMergeValue = (assignMergeValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/_safeGet.js
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ var _safeGet = (safeGet);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMergeDeep.js
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = _safeGet(object, key),
      srcValue = _safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    _assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(isArray["a" /* default */])(srcValue),
        isBuff = !isArr && Object(isBuffer["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && lodash_es_isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(isArray["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (lodash_es_isArrayLikeObject(objValue)) {
        newValue = Object(_copyArray["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(_cloneBuffer["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = _cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (lodash_es_isPlainObject(srcValue) || lodash_es_isArguments(srcValue)) {
      newValue = objValue;
      if (lodash_es_isArguments(objValue)) {
        newValue = lodash_es_toPlainObject(objValue);
      }
      else if (!Object(isObject["a" /* default */])(objValue) || Object(isFunction["a" /* default */])(objValue)) {
        newValue = _initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  _assignMergeValue(object, key, newValue);
}

/* harmony default export */ var _baseMergeDeep = (baseMergeDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseMerge.js








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  _baseFor(source, function(srcValue, key) {
    stack || (stack = new _Stack);
    if (Object(isObject["a" /* default */])(srcValue)) {
      _baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(_safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      _assignMergeValue(object, key, newValue);
    }
  }, lodash_es_keysIn);
}

/* harmony default export */ var _baseMerge = (baseMerge);

// CONCATENATED MODULE: ./node_modules/lodash-es/_customDefaultsMerge.js



/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
  if (Object(isObject["a" /* default */])(objValue) && Object(isObject["a" /* default */])(srcValue)) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, objValue);
    _baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
    stack['delete'](srcValue);
  }
  return objValue;
}

/* harmony default export */ var _customDefaultsMerge = (customDefaultsMerge);

// CONCATENATED MODULE: ./node_modules/lodash-es/mergeWith.js



/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = _createAssigner(function(object, source, srcIndex, customizer) {
  _baseMerge(object, source, srcIndex, customizer);
});

/* harmony default export */ var lodash_es_mergeWith = (mergeWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/defaultsDeep.js





/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */
var defaultsDeep = Object(_baseRest["a" /* default */])(function(args) {
  args.push(undefined, _customDefaultsMerge);
  return Object(_apply["a" /* default */])(lodash_es_mergeWith, undefined, args);
});

/* harmony default export */ var lodash_es_defaultsDeep = (defaultsDeep);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseToPairs.js


/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return Object(_arrayMap["a" /* default */])(props, function(key) {
    return [key, object[key]];
  });
}

/* harmony default export */ var _baseToPairs = (baseToPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/_setToPairs.js
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

/* harmony default export */ var _setToPairs = (setToPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createToPairs.js





/** `Object#toString` result references. */
var _createToPairs_mapTag = '[object Map]',
    _createToPairs_setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = _getTag(object);
    if (tag == _createToPairs_mapTag) {
      return _mapToArray(object);
    }
    if (tag == _createToPairs_setTag) {
      return _setToPairs(object);
    }
    return _baseToPairs(object, keysFunc(object));
  };
}

/* harmony default export */ var _createToPairs = (createToPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/toPairs.js



/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = _createToPairs(lodash_es_keys);

/* harmony default export */ var lodash_es_toPairs = (toPairs);

// CONCATENATED MODULE: ./node_modules/lodash-es/toPairsIn.js



/**
 * Creates an array of own and inherited enumerable string keyed-value pairs
 * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
 * or set, its entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entriesIn
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairsIn(new Foo);
 * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
 */
var toPairsIn = _createToPairs(lodash_es_keysIn);

/* harmony default export */ var lodash_es_toPairsIn = (toPairsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFindKey.js
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */
function baseFindKey(collection, predicate, eachFunc) {
  var result;
  eachFunc(collection, function(value, key, collection) {
    if (predicate(value, key, collection)) {
      result = key;
      return false;
    }
  });
  return result;
}

/* harmony default export */ var _baseFindKey = (baseFindKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/findKey.js




/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */
function findKey(object, predicate) {
  return _baseFindKey(object, _baseIteratee(predicate, 3), _baseForOwn);
}

/* harmony default export */ var lodash_es_findKey = (findKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/findLastKey.js




/**
 * This method is like `_.findKey` except that it iterates over elements of
 * a collection in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findLastKey(users, function(o) { return o.age < 40; });
 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastKey(users, { 'age': 36, 'active': true });
 * // => 'barney'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastKey(users, 'active');
 * // => 'pebbles'
 */
function findLastKey(object, predicate) {
  return _baseFindKey(object, _baseIteratee(predicate, 3), _baseForOwnRight);
}

/* harmony default export */ var lodash_es_findLastKey = (findLastKey);

// CONCATENATED MODULE: ./node_modules/lodash-es/forIn.js




/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */
function forIn(object, iteratee) {
  return object == null
    ? object
    : _baseFor(object, _castFunction(iteratee), lodash_es_keysIn);
}

/* harmony default export */ var lodash_es_forIn = (forIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/forInRight.js




/**
 * This method is like `_.forIn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forInRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
 */
function forInRight(object, iteratee) {
  return object == null
    ? object
    : _baseForRight(object, _castFunction(iteratee), lodash_es_keysIn);
}

/* harmony default export */ var lodash_es_forInRight = (forInRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/forOwn.js



/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && _baseForOwn(object, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forOwn = (forOwn);

// CONCATENATED MODULE: ./node_modules/lodash-es/forOwnRight.js



/**
 * This method is like `_.forOwn` except that it iterates over properties of
 * `object` in the opposite order.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwnRight(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
 */
function forOwnRight(object, iteratee) {
  return object && _baseForOwnRight(object, _castFunction(iteratee));
}

/* harmony default export */ var lodash_es_forOwnRight = (forOwnRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseFunctions.js



/**
 * The base implementation of `_.functions` which creates an array of
 * `object` function property names filtered from `props`.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} props The property names to filter.
 * @returns {Array} Returns the function names.
 */
function baseFunctions(object, props) {
  return _arrayFilter(props, function(key) {
    return Object(isFunction["a" /* default */])(object[key]);
  });
}

/* harmony default export */ var _baseFunctions = (baseFunctions);

// CONCATENATED MODULE: ./node_modules/lodash-es/functions.js



/**
 * Creates an array of function property names from own enumerable properties
 * of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functionsIn
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functions(new Foo);
 * // => ['a', 'b']
 */
function functions(object) {
  return object == null ? [] : _baseFunctions(object, lodash_es_keys(object));
}

/* harmony default export */ var lodash_es_functions = (functions);

// CONCATENATED MODULE: ./node_modules/lodash-es/functionsIn.js



/**
 * Creates an array of function property names from own and inherited
 * enumerable properties of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functions
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functionsIn(new Foo);
 * // => ['a', 'b', 'c']
 */
function functionsIn(object) {
  return object == null ? [] : _baseFunctions(object, lodash_es_keysIn(object));
}

/* harmony default export */ var lodash_es_functionsIn = (functionsIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseHas.js
/** Used for built-in method references. */
var _baseHas_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _baseHas_hasOwnProperty = _baseHas_objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && _baseHas_hasOwnProperty.call(object, key);
}

/* harmony default export */ var _baseHas = (baseHas);

// CONCATENATED MODULE: ./node_modules/lodash-es/has.js



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && _hasPath(object, path, _baseHas);
}

/* harmony default export */ var lodash_es_has = (has);

// EXTERNAL MODULE: ./node_modules/lodash-es/constant.js
var constant = __webpack_require__("706c");

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseInverter.js


/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  _baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/* harmony default export */ var _baseInverter = (baseInverter);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createInverter.js


/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return _baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

/* harmony default export */ var _createInverter = (createInverter);

// CONCATENATED MODULE: ./node_modules/lodash-es/invert.js




/** Used for built-in method references. */
var invert_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = invert_objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = _createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, Object(constant["a" /* default */])(identity["a" /* default */]));

/* harmony default export */ var lodash_es_invert = (invert);

// CONCATENATED MODULE: ./node_modules/lodash-es/invertBy.js



/** Used for built-in method references. */
var invertBy_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var invertBy_hasOwnProperty = invertBy_objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var invertBy_nativeObjectToString = invertBy_objectProto.toString;

/**
 * This method is like `_.invert` except that the inverted object is generated
 * from the results of running each element of `object` thru `iteratee`. The
 * corresponding inverted value of each inverted key is an array of keys
 * responsible for generating the inverted value. The iteratee is invoked
 * with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.1.0
 * @category Object
 * @param {Object} object The object to invert.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invertBy(object);
 * // => { '1': ['a', 'c'], '2': ['b'] }
 *
 * _.invertBy(object, function(value) {
 *   return 'group' + value;
 * });
 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
 */
var invertBy = _createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = invertBy_nativeObjectToString.call(value);
  }

  if (invertBy_hasOwnProperty.call(result, value)) {
    result[value].push(key);
  } else {
    result[value] = [key];
  }
}, _baseIteratee);

/* harmony default export */ var lodash_es_invertBy = (invertBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/invoke.js



/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = Object(_baseRest["a" /* default */])(_baseInvoke);

/* harmony default export */ var lodash_es_invoke = (invoke);

// CONCATENATED MODULE: ./node_modules/lodash-es/mapKeys.js




/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee, 3);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

/* harmony default export */ var lodash_es_mapKeys = (mapKeys);

// CONCATENATED MODULE: ./node_modules/lodash-es/mapValues.js




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = _baseIteratee(iteratee, 3);

  _baseForOwn(object, function(value, key, object) {
    _baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ var lodash_es_mapValues = (mapValues);

// CONCATENATED MODULE: ./node_modules/lodash-es/merge.js



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = _createAssigner(function(object, source, srcIndex) {
  _baseMerge(object, source, srcIndex);
});

/* harmony default export */ var lodash_es_merge = (merge);

// CONCATENATED MODULE: ./node_modules/lodash-es/_customOmitClone.js


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return lodash_es_isPlainObject(value) ? undefined : value;
}

/* harmony default export */ var _customOmitClone = (customOmitClone);

// CONCATENATED MODULE: ./node_modules/lodash-es/omit.js









/** Used to compose bitmasks for cloning. */
var omit_CLONE_DEEP_FLAG = 1,
    omit_CLONE_FLAT_FLAG = 2,
    omit_CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = _flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = Object(_arrayMap["a" /* default */])(paths, function(path) {
    path = Object(_castPath["a" /* default */])(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  _copyObject(object, _getAllKeysIn(object), result);
  if (isDeep) {
    result = _baseClone(result, omit_CLONE_DEEP_FLAG | omit_CLONE_FLAT_FLAG | omit_CLONE_SYMBOLS_FLAG, _customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    _baseUnset(result, paths[length]);
  }
  return result;
});

/* harmony default export */ var lodash_es_omit = (omit);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePickBy.js




/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = Object(_baseGet["a" /* default */])(object, path);

    if (predicate(value, path)) {
      _baseSet(result, Object(_castPath["a" /* default */])(path, object), value);
    }
  }
  return result;
}

/* harmony default export */ var _basePickBy = (basePickBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/pickBy.js





/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = Object(_arrayMap["a" /* default */])(_getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = _baseIteratee(predicate);
  return _basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

/* harmony default export */ var lodash_es_pickBy = (pickBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/omitBy.js




/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return lodash_es_pickBy(object, lodash_es_negate(_baseIteratee(predicate)));
}

/* harmony default export */ var lodash_es_omitBy = (omitBy);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePick.js



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return _basePickBy(object, paths, function(value, path) {
    return lodash_es_hasIn(object, path);
  });
}

/* harmony default export */ var _basePick = (basePick);

// CONCATENATED MODULE: ./node_modules/lodash-es/pick.js



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = _flatRest(function(object, paths) {
  return object == null ? {} : _basePick(object, paths);
});

/* harmony default export */ var lodash_es_pick = (pick);

// CONCATENATED MODULE: ./node_modules/lodash-es/result.js




/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result_result(object, path, defaultValue) {
  path = Object(_castPath["a" /* default */])(path, object);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[Object(_toKey["a" /* default */])(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = Object(isFunction["a" /* default */])(value) ? value.call(object) : value;
  }
  return object;
}

/* harmony default export */ var lodash_es_result = (result_result);

// CONCATENATED MODULE: ./node_modules/lodash-es/set.js


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set_set(object, path, value) {
  return object == null ? object : _baseSet(object, path, value);
}

/* harmony default export */ var lodash_es_set = (set_set);

// CONCATENATED MODULE: ./node_modules/lodash-es/setWith.js


/**
 * This method is like `_.set` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.setWith(object, '[0][1]', 'a', Object);
 * // => { '0': { '1': 'a' } }
 */
function setWith(object, path, value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : _baseSet(object, path, value, customizer);
}

/* harmony default export */ var lodash_es_setWith = (setWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/transform.js











/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = Object(isArray["a" /* default */])(object),
      isArrLike = isArr || Object(isBuffer["a" /* default */])(object) || lodash_es_isTypedArray(object);

  iteratee = _baseIteratee(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (Object(isObject["a" /* default */])(object)) {
      accumulator = Object(isFunction["a" /* default */])(Ctor) ? Object(_baseCreate["a" /* default */])(_getPrototype(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? _arrayEach["a" /* default */] : _baseForOwn)(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

/* harmony default export */ var lodash_es_transform = (transform);

// CONCATENATED MODULE: ./node_modules/lodash-es/unset.js


/**
 * Removes the property at `path` of `object`.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
 * _.unset(object, 'a[0].b.c');
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 *
 * _.unset(object, ['a', '0', 'b', 'c']);
 * // => true
 *
 * console.log(object);
 * // => { 'a': [{ 'b': {} }] };
 */
function unset(object, path) {
  return object == null ? true : _baseUnset(object, path);
}

/* harmony default export */ var lodash_es_unset = (unset);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseUpdate.js



/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseUpdate(object, path, updater, customizer) {
  return _baseSet(object, path, updater(Object(_baseGet["a" /* default */])(object, path)), customizer);
}

/* harmony default export */ var _baseUpdate = (baseUpdate);

// CONCATENATED MODULE: ./node_modules/lodash-es/update.js



/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */
function update(object, path, updater) {
  return object == null ? object : _baseUpdate(object, path, _castFunction(updater));
}

/* harmony default export */ var lodash_es_update = (update);

// CONCATENATED MODULE: ./node_modules/lodash-es/updateWith.js



/**
 * This method is like `_.update` except that it accepts `customizer` which is
 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
 * path creation is handled by the method instead. The `customizer` is invoked
 * with three arguments: (nsValue, key, nsObject).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {};
 *
 * _.updateWith(object, '[0][1]', _.constant('a'), Object);
 * // => { '0': { '1': 'a' } }
 */
function updateWith(object, path, updater, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return object == null ? object : _baseUpdate(object, path, _castFunction(updater), customizer);
}

/* harmony default export */ var lodash_es_updateWith = (updateWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/valuesIn.js



/**
 * Creates an array of the own and inherited enumerable string keyed property
 * values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.valuesIn(new Foo);
 * // => [1, 2, 3] (iteration order is not guaranteed)
 */
function valuesIn(object) {
  return object == null ? [] : _baseValues(object, lodash_es_keysIn(object));
}

/* harmony default export */ var lodash_es_valuesIn = (valuesIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/object.default.js
















































/* harmony default export */ var object_default = ({
  assign: lodash_es_assign, assignIn: lodash_es_assignIn, assignInWith: lodash_es_assignInWith, assignWith: lodash_es_assignWith, at: lodash_es_at,
  create: lodash_es_create, defaults: lodash_es_defaults, defaultsDeep: lodash_es_defaultsDeep, entries: lodash_es_toPairs, entriesIn: lodash_es_toPairsIn,
  extend: lodash_es_assignIn, extendWith: lodash_es_assignInWith, findKey: lodash_es_findKey, findLastKey: lodash_es_findLastKey, forIn: lodash_es_forIn,
  forInRight: lodash_es_forInRight, forOwn: lodash_es_forOwn, forOwnRight: lodash_es_forOwnRight, functions: lodash_es_functions, functionsIn: lodash_es_functionsIn,
  get: lodash_es_get["a" /* default */], has: lodash_es_has, hasIn: lodash_es_hasIn, invert: lodash_es_invert, invertBy: lodash_es_invertBy,
  invoke: lodash_es_invoke, keys: lodash_es_keys, keysIn: lodash_es_keysIn, mapKeys: lodash_es_mapKeys, mapValues: lodash_es_mapValues,
  merge: lodash_es_merge, mergeWith: lodash_es_mergeWith, omit: lodash_es_omit, omitBy: lodash_es_omitBy, pick: lodash_es_pick,
  pickBy: lodash_es_pickBy, result: lodash_es_result, set: lodash_es_set, setWith: lodash_es_setWith, toPairs: lodash_es_toPairs,
  toPairsIn: lodash_es_toPairsIn, transform: lodash_es_transform, unset: lodash_es_unset, update: lodash_es_update, updateWith: lodash_es_updateWith,
  values: lodash_es_values, valuesIn: lodash_es_valuesIn
});

// EXTERNAL MODULE: ./node_modules/lodash-es/_LazyWrapper.js
var _LazyWrapper = __webpack_require__("062a");

// EXTERNAL MODULE: ./node_modules/lodash-es/_LodashWrapper.js
var _LodashWrapper = __webpack_require__("1a7d");

// CONCATENATED MODULE: ./node_modules/lodash-es/thru.js
/**
 * This method is like `_.tap` except that it returns the result of `interceptor`.
 * The purpose of this method is to "pass thru" values replacing intermediate
 * results in a method chain sequence.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns the result of `interceptor`.
 * @example
 *
 * _('  abc  ')
 *  .chain()
 *  .trim()
 *  .thru(function(value) {
 *    return [value];
 *  })
 *  .value();
 * // => ['abc']
 */
function thru(value, interceptor) {
  return interceptor(value);
}

/* harmony default export */ var lodash_es_thru = (thru);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperAt.js







/**
 * This method is the wrapper version of `_.at`.
 *
 * @name at
 * @memberOf _
 * @since 1.0.0
 * @category Seq
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
 *
 * _(object).at(['a[0].b.c', 'a[1]']).value();
 * // => [3, 4]
 */
var wrapperAt = _flatRest(function(paths) {
  var length = paths.length,
      start = length ? paths[0] : 0,
      value = this.__wrapped__,
      interceptor = function(object) { return _baseAt(object, paths); };

  if (length > 1 || this.__actions__.length ||
      !(value instanceof _LazyWrapper["a" /* default */]) || !Object(_isIndex["a" /* default */])(start)) {
    return this.thru(interceptor);
  }
  value = value.slice(start, +start + (length ? 1 : 0));
  value.__actions__.push({
    'func': lodash_es_thru,
    'args': [interceptor],
    'thisArg': undefined
  });
  return new _LodashWrapper["a" /* default */](value, this.__chain__).thru(function(array) {
    if (length && !array.length) {
      array.push(undefined);
    }
    return array;
  });
});

/* harmony default export */ var lodash_es_wrapperAt = (wrapperAt);

// EXTERNAL MODULE: ./node_modules/lodash-es/wrapperLodash.js
var wrapperLodash = __webpack_require__("96d9");

// CONCATENATED MODULE: ./node_modules/lodash-es/chain.js


/**
 * Creates a `lodash` wrapper instance that wraps `value` with explicit method
 * chain sequences enabled. The result of such sequences must be unwrapped
 * with `_#value`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Seq
 * @param {*} value The value to wrap.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36 },
 *   { 'user': 'fred',    'age': 40 },
 *   { 'user': 'pebbles', 'age': 1 }
 * ];
 *
 * var youngest = _
 *   .chain(users)
 *   .sortBy('age')
 *   .map(function(o) {
 *     return o.user + ' is ' + o.age;
 *   })
 *   .head()
 *   .value();
 * // => 'pebbles is 1'
 */
function chain_chain(value) {
  var result = Object(wrapperLodash["a" /* default */])(value);
  result.__chain__ = true;
  return result;
}

/* harmony default export */ var lodash_es_chain = (chain_chain);

// CONCATENATED MODULE: ./node_modules/lodash-es/commit.js


/**
 * Executes the chain sequence and returns the wrapped result.
 *
 * @name commit
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2];
 * var wrapped = _(array).push(3);
 *
 * console.log(array);
 * // => [1, 2]
 *
 * wrapped = wrapped.commit();
 * console.log(array);
 * // => [1, 2, 3]
 *
 * wrapped.last();
 * // => 3
 *
 * console.log(array);
 * // => [1, 2, 3]
 */
function wrapperCommit() {
  return new _LodashWrapper["a" /* default */](this.value(), this.__chain__);
}

/* harmony default export */ var commit = (wrapperCommit);

// CONCATENATED MODULE: ./node_modules/lodash-es/next.js


/**
 * Gets the next value on a wrapped object following the
 * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
 *
 * @name next
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the next iterator value.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 1 }
 *
 * wrapped.next();
 * // => { 'done': false, 'value': 2 }
 *
 * wrapped.next();
 * // => { 'done': true, 'value': undefined }
 */
function wrapperNext() {
  if (this.__values__ === undefined) {
    this.__values__ = lodash_es_toArray(this.value());
  }
  var done = this.__index__ >= this.__values__.length,
      value = done ? undefined : this.__values__[this.__index__++];

  return { 'done': done, 'value': value };
}

/* harmony default export */ var next = (wrapperNext);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseLodash.js
var _baseLodash = __webpack_require__("5c54");

// EXTERNAL MODULE: ./node_modules/lodash-es/_wrapperClone.js
var _wrapperClone = __webpack_require__("e79e");

// CONCATENATED MODULE: ./node_modules/lodash-es/plant.js



/**
 * Creates a clone of the chain sequence planting `value` as the wrapped value.
 *
 * @name plant
 * @memberOf _
 * @since 3.2.0
 * @category Seq
 * @param {*} value The value to plant.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2]).map(square);
 * var other = wrapped.plant([3, 4]);
 *
 * other.value();
 * // => [9, 16]
 *
 * wrapped.value();
 * // => [1, 4]
 */
function wrapperPlant(value) {
  var result,
      parent = this;

  while (parent instanceof _baseLodash["a" /* default */]) {
    var clone = Object(_wrapperClone["a" /* default */])(parent);
    clone.__index__ = 0;
    clone.__values__ = undefined;
    if (result) {
      previous.__wrapped__ = clone;
    } else {
      result = clone;
    }
    var previous = clone;
    parent = parent.__wrapped__;
  }
  previous.__wrapped__ = value;
  return result;
}

/* harmony default export */ var plant = (wrapperPlant);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperReverse.js





/**
 * This method is the wrapper version of `_.reverse`.
 *
 * **Note:** This method mutates the wrapped array.
 *
 * @name reverse
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _(array).reverse().value()
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function wrapperReverse() {
  var value = this.__wrapped__;
  if (value instanceof _LazyWrapper["a" /* default */]) {
    var wrapped = value;
    if (this.__actions__.length) {
      wrapped = new _LazyWrapper["a" /* default */](this);
    }
    wrapped = wrapped.reverse();
    wrapped.__actions__.push({
      'func': lodash_es_thru,
      'args': [lodash_es_reverse],
      'thisArg': undefined
    });
    return new _LodashWrapper["a" /* default */](wrapped, this.__chain__);
  }
  return this.thru(lodash_es_reverse);
}

/* harmony default export */ var lodash_es_wrapperReverse = (wrapperReverse);

// CONCATENATED MODULE: ./node_modules/lodash-es/tap.js
/**
 * This method invokes `interceptor` and returns `value`. The interceptor
 * is invoked with one argument; (value). The purpose of this method is to
 * "tap into" a method chain sequence in order to modify intermediate results.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @param {*} value The value to provide to `interceptor`.
 * @param {Function} interceptor The function to invoke.
 * @returns {*} Returns `value`.
 * @example
 *
 * _([1, 2, 3])
 *  .tap(function(array) {
 *    // Mutate input array.
 *    array.pop();
 *  })
 *  .reverse()
 *  .value();
 * // => [2, 1]
 */
function tap(value, interceptor) {
  interceptor(value);
  return value;
}

/* harmony default export */ var lodash_es_tap = (tap);

// CONCATENATED MODULE: ./node_modules/lodash-es/toIterator.js
/**
 * Enables the wrapper to be iterable.
 *
 * @name Symbol.iterator
 * @memberOf _
 * @since 4.0.0
 * @category Seq
 * @returns {Object} Returns the wrapper object.
 * @example
 *
 * var wrapped = _([1, 2]);
 *
 * wrapped[Symbol.iterator]() === wrapped;
 * // => true
 *
 * Array.from(wrapped);
 * // => [1, 2]
 */
function wrapperToIterator() {
  return this;
}

/* harmony default export */ var toIterator = (wrapperToIterator);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseWrapperValue.js




/**
 * The base implementation of `wrapperValue` which returns the result of
 * performing a sequence of actions on the unwrapped `value`, where each
 * successive action is supplied the return value of the previous.
 *
 * @private
 * @param {*} value The unwrapped value.
 * @param {Array} actions Actions to perform to resolve the unwrapped value.
 * @returns {*} Returns the resolved value.
 */
function baseWrapperValue(value, actions) {
  var result = value;
  if (result instanceof _LazyWrapper["a" /* default */]) {
    result = result.value();
  }
  return _arrayReduce(actions, function(result, action) {
    return action.func.apply(action.thisArg, _arrayPush([result], action.args));
  }, result);
}

/* harmony default export */ var _baseWrapperValue = (baseWrapperValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperValue.js


/**
 * Executes the chain sequence to resolve the unwrapped value.
 *
 * @name value
 * @memberOf _
 * @since 0.1.0
 * @alias toJSON, valueOf
 * @category Seq
 * @returns {*} Returns the resolved unwrapped value.
 * @example
 *
 * _([1, 2, 3]).value();
 * // => [1, 2, 3]
 */
function wrapperValue() {
  return _baseWrapperValue(this.__wrapped__, this.__actions__);
}

/* harmony default export */ var lodash_es_wrapperValue = (wrapperValue);

// CONCATENATED MODULE: ./node_modules/lodash-es/wrapperChain.js


/**
 * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
 *
 * @name chain
 * @memberOf _
 * @since 0.1.0
 * @category Seq
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 }
 * ];
 *
 * // A sequence without explicit chaining.
 * _(users).head();
 * // => { 'user': 'barney', 'age': 36 }
 *
 * // A sequence with explicit chaining.
 * _(users)
 *   .chain()
 *   .head()
 *   .pick('user')
 *   .value();
 * // => { 'user': 'barney' }
 */
function wrapperChain() {
  return lodash_es_chain(this);
}

/* harmony default export */ var lodash_es_wrapperChain = (wrapperChain);

// CONCATENATED MODULE: ./node_modules/lodash-es/seq.default.js















/* harmony default export */ var seq_default = ({
  at: lodash_es_wrapperAt, chain: lodash_es_chain, commit: commit, lodash: wrapperLodash["a" /* default */], next: next,
  plant: plant, reverse: lodash_es_wrapperReverse, tap: lodash_es_tap, thru: lodash_es_thru, toIterator: toIterator,
  toJSON: lodash_es_wrapperValue, value: lodash_es_wrapperValue, valueOf: lodash_es_wrapperValue, wrapperChain: lodash_es_wrapperChain
});

// CONCATENATED MODULE: ./node_modules/lodash-es/_createCaseFirst.js





/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = Object(lodash_es_toString["a" /* default */])(string);

    var strSymbols = _hasUnicode(string)
      ? _stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? _castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/* harmony default export */ var _createCaseFirst = (createCaseFirst);

// CONCATENATED MODULE: ./node_modules/lodash-es/upperFirst.js


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = _createCaseFirst('toUpperCase');

/* harmony default export */ var lodash_es_upperFirst = (upperFirst);

// CONCATENATED MODULE: ./node_modules/lodash-es/capitalize.js



/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return lodash_es_upperFirst(Object(lodash_es_toString["a" /* default */])(string).toLowerCase());
}

/* harmony default export */ var lodash_es_capitalize = (capitalize);

// CONCATENATED MODULE: ./node_modules/lodash-es/_basePropertyOf.js
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ var _basePropertyOf = (basePropertyOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_deburrLetter.js


/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = _basePropertyOf(deburredLetters);

/* harmony default export */ var _deburrLetter = (deburrLetter);

// CONCATENATED MODULE: ./node_modules/lodash-es/deburr.js



/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var deburr_rsComboMarksRange = '\\u0300-\\u036f',
    deburr_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    deburr_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    deburr_rsComboRange = deburr_rsComboMarksRange + deburr_reComboHalfMarksRange + deburr_rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var deburr_rsCombo = '[' + deburr_rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(deburr_rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  return string && string.replace(reLatin, _deburrLetter).replace(reComboMark, '');
}

/* harmony default export */ var lodash_es_deburr = (deburr);

// CONCATENATED MODULE: ./node_modules/lodash-es/_asciiWords.js
/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/* harmony default export */ var _asciiWords = (asciiWords);

// CONCATENATED MODULE: ./node_modules/lodash-es/_hasUnicodeWord.js
/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/* harmony default export */ var _hasUnicodeWord = (hasUnicodeWord);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unicodeWords.js
/** Used to compose unicode character classes. */
var _unicodeWords_rsAstralRange = '\\ud800-\\udfff',
    _unicodeWords_rsComboMarksRange = '\\u0300-\\u036f',
    _unicodeWords_reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    _unicodeWords_rsComboSymbolsRange = '\\u20d0-\\u20ff',
    _unicodeWords_rsComboRange = _unicodeWords_rsComboMarksRange + _unicodeWords_reComboHalfMarksRange + _unicodeWords_rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    _unicodeWords_rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    _unicodeWords_rsCombo = '[' + _unicodeWords_rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + _unicodeWords_rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    _unicodeWords_rsFitz = '\\ud83c[\\udffb-\\udfff]',
    _unicodeWords_rsModifier = '(?:' + _unicodeWords_rsCombo + '|' + _unicodeWords_rsFitz + ')',
    _unicodeWords_rsNonAstral = '[^' + _unicodeWords_rsAstralRange + ']',
    _unicodeWords_rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    _unicodeWords_rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    _unicodeWords_rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    _unicodeWords_reOptMod = _unicodeWords_rsModifier + '?',
    _unicodeWords_rsOptVar = '[' + _unicodeWords_rsVarRange + ']?',
    _unicodeWords_rsOptJoin = '(?:' + _unicodeWords_rsZWJ + '(?:' + [_unicodeWords_rsNonAstral, _unicodeWords_rsRegional, _unicodeWords_rsSurrPair].join('|') + ')' + _unicodeWords_rsOptVar + _unicodeWords_reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    _unicodeWords_rsSeq = _unicodeWords_rsOptVar + _unicodeWords_reOptMod + _unicodeWords_rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, _unicodeWords_rsRegional, _unicodeWords_rsSurrPair].join('|') + ')' + _unicodeWords_rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/* harmony default export */ var _unicodeWords = (unicodeWords);

// CONCATENATED MODULE: ./node_modules/lodash-es/words.js





/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return _hasUnicodeWord(string) ? _unicodeWords(string) : _asciiWords(string);
  }
  return string.match(pattern) || [];
}

/* harmony default export */ var lodash_es_words = (words);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createCompounder.js




/** Used to compose unicode capture groups. */
var _createCompounder_rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(_createCompounder_rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return _arrayReduce(lodash_es_words(lodash_es_deburr(string).replace(reApos, '')), callback, '');
  };
}

/* harmony default export */ var _createCompounder = (createCompounder);

// CONCATENATED MODULE: ./node_modules/lodash-es/camelCase.js



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = _createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? lodash_es_capitalize(word) : word);
});

/* harmony default export */ var lodash_es_camelCase = (camelCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/endsWith.js





/**
 * Checks if `string` ends with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=string.length] The position to search up to.
 * @returns {boolean} Returns `true` if `string` ends with `target`,
 *  else `false`.
 * @example
 *
 * _.endsWith('abc', 'c');
 * // => true
 *
 * _.endsWith('abc', 'b');
 * // => false
 *
 * _.endsWith('abc', 'b', 2);
 * // => true
 */
function endsWith(string, target, position) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  target = Object(_baseToString["a" /* default */])(target);

  var length = string.length;
  position = position === undefined
    ? length
    : _baseClamp(Object(toInteger["a" /* default */])(position), 0, length);

  var end = position;
  position -= target.length;
  return position >= 0 && string.slice(position, end) == target;
}

/* harmony default export */ var lodash_es_endsWith = (endsWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/_escapeHtmlChar.js


/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = _basePropertyOf(htmlEscapes);

/* harmony default export */ var _escapeHtmlChar = (escapeHtmlChar);

// CONCATENATED MODULE: ./node_modules/lodash-es/escape.js



/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"']/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape_escape(string) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, _escapeHtmlChar)
    : string;
}

/* harmony default export */ var lodash_es_escape = (escape_escape);

// CONCATENATED MODULE: ./node_modules/lodash-es/escapeRegExp.js


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

/* harmony default export */ var lodash_es_escapeRegExp = (escapeRegExp);

// CONCATENATED MODULE: ./node_modules/lodash-es/kebabCase.js


/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = _createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

/* harmony default export */ var lodash_es_kebabCase = (kebabCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/lowerCase.js


/**
 * Converts `string`, as space separated words, to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.lowerCase('--Foo-Bar--');
 * // => 'foo bar'
 *
 * _.lowerCase('fooBar');
 * // => 'foo bar'
 *
 * _.lowerCase('__FOO_BAR__');
 * // => 'foo bar'
 */
var lowerCase = _createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toLowerCase();
});

/* harmony default export */ var lodash_es_lowerCase = (lowerCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/lowerFirst.js


/**
 * Converts the first character of `string` to lower case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.lowerFirst('Fred');
 * // => 'fred'
 *
 * _.lowerFirst('FRED');
 * // => 'fRED'
 */
var lowerFirst = _createCaseFirst('toLowerCase');

/* harmony default export */ var lodash_es_lowerFirst = (lowerFirst);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRepeat.js
/** Used as references for various `Number` constants. */
var _baseRepeat_MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseRepeat_nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > _baseRepeat_MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = _baseRepeat_nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

/* harmony default export */ var _baseRepeat = (baseRepeat);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createPadding.js







/* Built-in method references for those with the same name as other `lodash` methods. */
var _createPadding_nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : Object(_baseToString["a" /* default */])(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? _baseRepeat(chars, length) : chars;
  }
  var result = _baseRepeat(chars, _createPadding_nativeCeil(length / _stringSize(chars)));
  return _hasUnicode(chars)
    ? _castSlice(_stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

/* harmony default export */ var _createPadding = (createPadding);

// CONCATENATED MODULE: ./node_modules/lodash-es/pad.js





/* Built-in method references for those with the same name as other `lodash` methods. */
var pad_nativeCeil = Math.ceil,
    pad_nativeFloor = Math.floor;

/**
 * Pads `string` on the left and right sides if it's shorter than `length`.
 * Padding characters are truncated if they can't be evenly divided by `length`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.pad('abc', 8);
 * // => '  abc   '
 *
 * _.pad('abc', 8, '_-');
 * // => '_-abc_-_'
 *
 * _.pad('abc', 3);
 * // => 'abc'
 */
function pad(string, length, chars) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  length = Object(toInteger["a" /* default */])(length);

  var strLength = length ? _stringSize(string) : 0;
  if (!length || strLength >= length) {
    return string;
  }
  var mid = (length - strLength) / 2;
  return (
    _createPadding(pad_nativeFloor(mid), chars) +
    string +
    _createPadding(pad_nativeCeil(mid), chars)
  );
}

/* harmony default export */ var lodash_es_pad = (pad);

// CONCATENATED MODULE: ./node_modules/lodash-es/padEnd.js





/**
 * Pads `string` on the right side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padEnd('abc', 6);
 * // => 'abc   '
 *
 * _.padEnd('abc', 6, '_-');
 * // => 'abc_-_'
 *
 * _.padEnd('abc', 3);
 * // => 'abc'
 */
function padEnd(string, length, chars) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  length = Object(toInteger["a" /* default */])(length);

  var strLength = length ? _stringSize(string) : 0;
  return (length && strLength < length)
    ? (string + _createPadding(length - strLength, chars))
    : string;
}

/* harmony default export */ var lodash_es_padEnd = (padEnd);

// CONCATENATED MODULE: ./node_modules/lodash-es/padStart.js





/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  length = Object(toInteger["a" /* default */])(length);

  var strLength = length ? _stringSize(string) : 0;
  return (length && strLength < length)
    ? (_createPadding(length - strLength, chars) + string)
    : string;
}

/* harmony default export */ var lodash_es_padStart = (padStart);

// CONCATENATED MODULE: ./node_modules/lodash-es/parseInt.js



/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeParseInt = _root["a" /* default */].parseInt;

/**
 * Converts `string` to an integer of the specified radix. If `radix` is
 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
 * hexadecimal, in which case a `radix` of `16` is used.
 *
 * **Note:** This method aligns with the
 * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category String
 * @param {string} string The string to convert.
 * @param {number} [radix=10] The radix to interpret `value` by.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.parseInt('08');
 * // => 8
 *
 * _.map(['6', '08', '10'], _.parseInt);
 * // => [6, 8, 10]
 */
function parseInt_parseInt(string, radix, guard) {
  if (guard || radix == null) {
    radix = 0;
  } else if (radix) {
    radix = +radix;
  }
  return nativeParseInt(Object(lodash_es_toString["a" /* default */])(string).replace(reTrimStart, ''), radix || 0);
}

/* harmony default export */ var lodash_es_parseInt = (parseInt_parseInt);

// CONCATENATED MODULE: ./node_modules/lodash-es/repeat.js





/**
 * Repeats the given string `n` times.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to repeat.
 * @param {number} [n=1] The number of times to repeat the string.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the repeated string.
 * @example
 *
 * _.repeat('*', 3);
 * // => '***'
 *
 * _.repeat('abc', 2);
 * // => 'abcabc'
 *
 * _.repeat('abc', 0);
 * // => ''
 */
function repeat(string, n, guard) {
  if ((guard ? _isIterateeCall(string, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = Object(toInteger["a" /* default */])(n);
  }
  return _baseRepeat(Object(lodash_es_toString["a" /* default */])(string), n);
}

/* harmony default export */ var lodash_es_repeat = (repeat);

// CONCATENATED MODULE: ./node_modules/lodash-es/replace.js


/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = Object(lodash_es_toString["a" /* default */])(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

/* harmony default export */ var lodash_es_replace = (replace);

// CONCATENATED MODULE: ./node_modules/lodash-es/snakeCase.js


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = _createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

/* harmony default export */ var lodash_es_snakeCase = (snakeCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/split.js








/** Used as references for the maximum length and index of an array. */
var split_MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && _isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? split_MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = Object(lodash_es_toString["a" /* default */])(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !lodash_es_isRegExp(separator))
      )) {
    separator = Object(_baseToString["a" /* default */])(separator);
    if (!separator && _hasUnicode(string)) {
      return _castSlice(_stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

/* harmony default export */ var lodash_es_split = (split);

// CONCATENATED MODULE: ./node_modules/lodash-es/startCase.js



/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = _createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + lodash_es_upperFirst(word);
});

/* harmony default export */ var lodash_es_startCase = (startCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/startsWith.js





/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  position = position == null
    ? 0
    : _baseClamp(Object(toInteger["a" /* default */])(position), 0, string.length);

  target = Object(_baseToString["a" /* default */])(target);
  return string.slice(position, position + target.length) == target;
}

/* harmony default export */ var lodash_es_startsWith = (startsWith);

// CONCATENATED MODULE: ./node_modules/lodash-es/attempt.js




/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = Object(_baseRest["a" /* default */])(function(func, args) {
  try {
    return Object(_apply["a" /* default */])(func, undefined, args);
  } catch (e) {
    return lodash_es_isError(e) ? e : new Error(e);
  }
});

/* harmony default export */ var lodash_es_attempt = (attempt);

// CONCATENATED MODULE: ./node_modules/lodash-es/_customDefaultsAssignIn.js


/** Used for built-in method references. */
var _customDefaultsAssignIn_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _customDefaultsAssignIn_hasOwnProperty = _customDefaultsAssignIn_objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (Object(eq["a" /* default */])(objValue, _customDefaultsAssignIn_objectProto[key]) && !_customDefaultsAssignIn_hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

/* harmony default export */ var _customDefaultsAssignIn = (customDefaultsAssignIn);

// CONCATENATED MODULE: ./node_modules/lodash-es/_escapeStringChar.js
/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/* harmony default export */ var _escapeStringChar = (escapeStringChar);

// CONCATENATED MODULE: ./node_modules/lodash-es/_reInterpolate.js
/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/* harmony default export */ var _reInterpolate = (reInterpolate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_reEscape.js
/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/* harmony default export */ var _reEscape = (reEscape);

// CONCATENATED MODULE: ./node_modules/lodash-es/_reEvaluate.js
/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/* harmony default export */ var _reEvaluate = (reEvaluate);

// CONCATENATED MODULE: ./node_modules/lodash-es/templateSettings.js





/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB) as well as ES2015 template strings. Change the
 * following template settings to use alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': _reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': _reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': _reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': lodash_es_escape }
  }
};

/* harmony default export */ var lodash_es_templateSettings = (templateSettings);

// CONCATENATED MODULE: ./node_modules/lodash-es/template.js












/** Error message constants. */
var INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to validate the `validate` option in `_.template` variable.
 *
 * Forbids characters which could potentially change the meaning of the function argument definition:
 * - "()," (modification of function parameters)
 * - "=" (default value)
 * - "[]{}" (destructuring of function parameters)
 * - "/" (beginning of a comment)
 * - whitespace
 */
var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/** Used for built-in method references. */
var template_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var template_hasOwnProperty = template_objectProto.hasOwnProperty;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES template literal delimiter as an "interpolate" delimiter.
 * // Disable support by replacing the "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = lodash_es_templateSettings.imports._.templateSettings || lodash_es_templateSettings;

  if (guard && _isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = Object(lodash_es_toString["a" /* default */])(string);
  options = lodash_es_assignInWith({}, options, settings, _customDefaultsAssignIn);

  var imports = lodash_es_assignInWith({}, options.imports, settings.imports, _customDefaultsAssignIn),
      importsKeys = lodash_es_keys(imports),
      importsValues = _baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp(
    (options.escape || reNoMatch).source + '|' +
    interpolate.source + '|' +
    (interpolate === _reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
    (options.evaluate || reNoMatch).source + '|$'
  , 'g');

  // Use a sourceURL for easier debugging.
  // The sourceURL gets injected into the source that's eval-ed, so be careful
  // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
  // and escape the comment, thus injecting code that gets evaled.
  var sourceURL = template_hasOwnProperty.call(options, 'sourceURL')
    ? ('//# sourceURL=' +
       (options.sourceURL + '').replace(/\s/g, ' ') +
       '\n')
    : '';

  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, _escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = template_hasOwnProperty.call(options, 'variable') && options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Throw an error if a forbidden character was found in `variable`, to prevent
  // potential command injection attacks.
  else if (reForbiddenIdentifierChars.test(variable)) {
    throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
  }

  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
    .replace(reEmptyStringMiddle, '$1')
    .replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' +
    (variable
      ? ''
      : 'obj || (obj = {});\n'
    ) +
    "var __t, __p = ''" +
    (isEscaping
       ? ', __e = _.escape'
       : ''
    ) +
    (isEvaluating
      ? ', __j = Array.prototype.join;\n' +
        "function print() { __p += __j.call(arguments, '') }\n"
      : ';\n'
    ) +
    source +
    'return __p\n}';

  var result = lodash_es_attempt(function() {
    return Function(importsKeys, sourceURL + 'return ' + source)
      .apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (lodash_es_isError(result)) {
    throw result;
  }
  return result;
}

/* harmony default export */ var lodash_es_template = (template);

// CONCATENATED MODULE: ./node_modules/lodash-es/toLower.js


/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return Object(lodash_es_toString["a" /* default */])(value).toLowerCase();
}

/* harmony default export */ var lodash_es_toLower = (toLower);

// CONCATENATED MODULE: ./node_modules/lodash-es/toUpper.js


/**
 * Converts `string`, as a whole, to upper case just like
 * [String#toUpperCase](https://mdn.io/toUpperCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.toUpper('--foo-bar--');
 * // => '--FOO-BAR--'
 *
 * _.toUpper('fooBar');
 * // => 'FOOBAR'
 *
 * _.toUpper('__foo_bar__');
 * // => '__FOO_BAR__'
 */
function toUpper(value) {
  return Object(lodash_es_toString["a" /* default */])(value).toUpperCase();
}

/* harmony default export */ var lodash_es_toUpper = (toUpper);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseTrim.js
var _baseTrim = __webpack_require__("4b6e");

// CONCATENATED MODULE: ./node_modules/lodash-es/_charsEndIndex.js


/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && Object(_baseIndexOf["a" /* default */])(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/* harmony default export */ var _charsEndIndex = (charsEndIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/_charsStartIndex.js


/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && Object(_baseIndexOf["a" /* default */])(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/* harmony default export */ var _charsStartIndex = (charsStartIndex);

// CONCATENATED MODULE: ./node_modules/lodash-es/trim.js








/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  if (string && (guard || chars === undefined)) {
    return Object(_baseTrim["a" /* default */])(string);
  }
  if (!string || !(chars = Object(_baseToString["a" /* default */])(chars))) {
    return string;
  }
  var strSymbols = _stringToArray(string),
      chrSymbols = _stringToArray(chars),
      start = _charsStartIndex(strSymbols, chrSymbols),
      end = _charsEndIndex(strSymbols, chrSymbols) + 1;

  return _castSlice(strSymbols, start, end).join('');
}

/* harmony default export */ var lodash_es_trim = (trim);

// EXTERNAL MODULE: ./node_modules/lodash-es/_trimmedEndIndex.js
var _trimmedEndIndex = __webpack_require__("b890");

// CONCATENATED MODULE: ./node_modules/lodash-es/trimEnd.js







/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  if (string && (guard || chars === undefined)) {
    return string.slice(0, Object(_trimmedEndIndex["a" /* default */])(string) + 1);
  }
  if (!string || !(chars = Object(_baseToString["a" /* default */])(chars))) {
    return string;
  }
  var strSymbols = _stringToArray(string),
      end = _charsEndIndex(strSymbols, _stringToArray(chars)) + 1;

  return _castSlice(strSymbols, 0, end).join('');
}

/* harmony default export */ var lodash_es_trimEnd = (trimEnd);

// CONCATENATED MODULE: ./node_modules/lodash-es/trimStart.js






/** Used to match leading whitespace. */
var trimStart_reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(trimStart_reTrimStart, '');
  }
  if (!string || !(chars = Object(_baseToString["a" /* default */])(chars))) {
    return string;
  }
  var strSymbols = _stringToArray(string),
      start = _charsStartIndex(strSymbols, _stringToArray(chars));

  return _castSlice(strSymbols, start).join('');
}

/* harmony default export */ var lodash_es_trimStart = (trimStart);

// CONCATENATED MODULE: ./node_modules/lodash-es/truncate.js










/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var truncate_reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (Object(isObject["a" /* default */])(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? Object(toInteger["a" /* default */])(options.length) : length;
    omission = 'omission' in options ? Object(_baseToString["a" /* default */])(options.omission) : omission;
  }
  string = Object(lodash_es_toString["a" /* default */])(string);

  var strLength = string.length;
  if (_hasUnicode(string)) {
    var strSymbols = _stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - _stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? _castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (lodash_es_isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, Object(lodash_es_toString["a" /* default */])(truncate_reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(Object(_baseToString["a" /* default */])(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

/* harmony default export */ var lodash_es_truncate = (truncate);

// CONCATENATED MODULE: ./node_modules/lodash-es/_unescapeHtmlChar.js


/** Used to map HTML entities to characters. */
var htmlUnescapes = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

/**
 * Used by `_.unescape` to convert HTML entities to characters.
 *
 * @private
 * @param {string} chr The matched character to unescape.
 * @returns {string} Returns the unescaped character.
 */
var unescapeHtmlChar = _basePropertyOf(htmlUnescapes);

/* harmony default export */ var _unescapeHtmlChar = (unescapeHtmlChar);

// CONCATENATED MODULE: ./node_modules/lodash-es/unescape.js



/** Used to match HTML entities and HTML characters. */
var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source);

/**
 * The inverse of `_.escape`; this method converts the HTML entities
 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
 * their corresponding characters.
 *
 * **Note:** No other HTML entities are unescaped. To unescape additional
 * HTML entities use a third-party library like [_he_](https://mths.be/he).
 *
 * @static
 * @memberOf _
 * @since 0.6.0
 * @category String
 * @param {string} [string=''] The string to unescape.
 * @returns {string} Returns the unescaped string.
 * @example
 *
 * _.unescape('fred, barney, &amp; pebbles');
 * // => 'fred, barney, & pebbles'
 */
function unescape_unescape(string) {
  string = Object(lodash_es_toString["a" /* default */])(string);
  return (string && reHasEscapedHtml.test(string))
    ? string.replace(reEscapedHtml, _unescapeHtmlChar)
    : string;
}

/* harmony default export */ var lodash_es_unescape = (unescape_unescape);

// CONCATENATED MODULE: ./node_modules/lodash-es/upperCase.js


/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = _createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});

/* harmony default export */ var lodash_es_upperCase = (upperCase);

// CONCATENATED MODULE: ./node_modules/lodash-es/string.default.js
































/* harmony default export */ var string_default = ({
  camelCase: lodash_es_camelCase, capitalize: lodash_es_capitalize, deburr: lodash_es_deburr, endsWith: lodash_es_endsWith, escape: lodash_es_escape,
  escapeRegExp: lodash_es_escapeRegExp, kebabCase: lodash_es_kebabCase, lowerCase: lodash_es_lowerCase, lowerFirst: lodash_es_lowerFirst, pad: lodash_es_pad,
  padEnd: lodash_es_padEnd, padStart: lodash_es_padStart, parseInt: lodash_es_parseInt, repeat: lodash_es_repeat, replace: lodash_es_replace,
  snakeCase: lodash_es_snakeCase, split: lodash_es_split, startCase: lodash_es_startCase, startsWith: lodash_es_startsWith, template: lodash_es_template,
  templateSettings: lodash_es_templateSettings, toLower: lodash_es_toLower, toUpper: lodash_es_toUpper, trim: lodash_es_trim, trimEnd: lodash_es_trimEnd,
  trimStart: lodash_es_trimStart, truncate: lodash_es_truncate, unescape: lodash_es_unescape, upperCase: lodash_es_upperCase, upperFirst: lodash_es_upperFirst,
  words: lodash_es_words
});

// CONCATENATED MODULE: ./node_modules/lodash-es/bindAll.js






/**
 * Binds methods of an object to the object itself, overwriting the existing
 * method.
 *
 * **Note:** This method doesn't set the "length" property of bound functions.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Object} object The object to bind and assign the bound methods to.
 * @param {...(string|string[])} methodNames The object method names to bind.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var view = {
 *   'label': 'docs',
 *   'click': function() {
 *     console.log('clicked ' + this.label);
 *   }
 * };
 *
 * _.bindAll(view, ['click']);
 * jQuery(element).on('click', view.click);
 * // => Logs 'clicked docs' when clicked.
 */
var bindAll = _flatRest(function(object, methodNames) {
  Object(_arrayEach["a" /* default */])(methodNames, function(key) {
    key = Object(_toKey["a" /* default */])(key);
    _baseAssignValue(object, key, Object(bind["a" /* default */])(object[key], object));
  });
  return object;
});

/* harmony default export */ var lodash_es_bindAll = (bindAll);

// CONCATENATED MODULE: ./node_modules/lodash-es/cond.js





/** Error message constants. */
var cond_FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that iterates over `pairs` and invokes the corresponding
 * function of the first predicate to return truthy. The predicate-function
 * pairs are invoked with the `this` binding and arguments of the created
 * function.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Array} pairs The predicate-function pairs.
 * @returns {Function} Returns the new composite function.
 * @example
 *
 * var func = _.cond([
 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
 *   [_.stubTrue,                      _.constant('no match')]
 * ]);
 *
 * func({ 'a': 1, 'b': 2 });
 * // => 'matches A'
 *
 * func({ 'a': 0, 'b': 1 });
 * // => 'matches B'
 *
 * func({ 'a': '1', 'b': '2' });
 * // => 'no match'
 */
function cond(pairs) {
  var length = pairs == null ? 0 : pairs.length,
      toIteratee = _baseIteratee;

  pairs = !length ? [] : Object(_arrayMap["a" /* default */])(pairs, function(pair) {
    if (typeof pair[1] != 'function') {
      throw new TypeError(cond_FUNC_ERROR_TEXT);
    }
    return [toIteratee(pair[0]), pair[1]];
  });

  return Object(_baseRest["a" /* default */])(function(args) {
    var index = -1;
    while (++index < length) {
      var pair = pairs[index];
      if (Object(_apply["a" /* default */])(pair[0], this, args)) {
        return Object(_apply["a" /* default */])(pair[1], this, args);
      }
    }
  });
}

/* harmony default export */ var lodash_es_cond = (cond);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseConforms.js



/**
 * The base implementation of `_.conforms` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 */
function baseConforms(source) {
  var props = lodash_es_keys(source);
  return function(object) {
    return _baseConformsTo(object, source, props);
  };
}

/* harmony default export */ var _baseConforms = (baseConforms);

// CONCATENATED MODULE: ./node_modules/lodash-es/conforms.js



/** Used to compose bitmasks for cloning. */
var conforms_CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes the predicate properties of `source` with
 * the corresponding property values of a given object, returning `true` if
 * all predicates return truthy, else `false`.
 *
 * **Note:** The created function is equivalent to `_.conformsTo` with
 * `source` partially applied.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 2, 'b': 1 },
 *   { 'a': 1, 'b': 2 }
 * ];
 *
 * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
 * // => [{ 'a': 1, 'b': 2 }]
 */
function conforms(source) {
  return _baseConforms(_baseClone(source, conforms_CLONE_DEEP_FLAG));
}

/* harmony default export */ var lodash_es_conforms = (conforms);

// CONCATENATED MODULE: ./node_modules/lodash-es/defaultTo.js
/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */
function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value;
}

/* harmony default export */ var lodash_es_defaultTo = (defaultTo);

// EXTERNAL MODULE: ./node_modules/lodash-es/_getData.js
var _getData = __webpack_require__("fa3e");

// EXTERNAL MODULE: ./node_modules/lodash-es/_getFuncName.js
var _getFuncName = __webpack_require__("7edc");

// EXTERNAL MODULE: ./node_modules/lodash-es/_isLaziable.js
var _isLaziable = __webpack_require__("661c");

// CONCATENATED MODULE: ./node_modules/lodash-es/_createFlow.js







/** Error message constants. */
var _createFlow_FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var _createFlow_WRAP_CURRY_FLAG = 8,
    _createFlow_WRAP_PARTIAL_FLAG = 32,
    _createFlow_WRAP_ARY_FLAG = 128,
    _createFlow_WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return _flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = _LodashWrapper["a" /* default */].prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(_createFlow_FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && Object(_getFuncName["a" /* default */])(func) == 'wrapper') {
        var wrapper = new _LodashWrapper["a" /* default */]([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = Object(_getFuncName["a" /* default */])(func),
          data = funcName == 'wrapper' ? Object(_getData["a" /* default */])(func) : undefined;

      if (data && Object(_isLaziable["a" /* default */])(data[0]) &&
            data[1] == (_createFlow_WRAP_ARY_FLAG | _createFlow_WRAP_CURRY_FLAG | _createFlow_WRAP_PARTIAL_FLAG | _createFlow_WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[Object(_getFuncName["a" /* default */])(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && Object(_isLaziable["a" /* default */])(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && Object(isArray["a" /* default */])(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

/* harmony default export */ var _createFlow = (createFlow);

// CONCATENATED MODULE: ./node_modules/lodash-es/flow.js


/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = _createFlow();

/* harmony default export */ var lodash_es_flow = (flow);

// CONCATENATED MODULE: ./node_modules/lodash-es/flowRight.js


/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = _createFlow(true);

/* harmony default export */ var lodash_es_flowRight = (flowRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/iteratee.js



/** Used to compose bitmasks for cloning. */
var iteratee_CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee_iteratee(func) {
  return _baseIteratee(typeof func == 'function' ? func : _baseClone(func, iteratee_CLONE_DEEP_FLAG));
}

/* harmony default export */ var lodash_es_iteratee = (iteratee_iteratee);

// CONCATENATED MODULE: ./node_modules/lodash-es/matches.js



/** Used to compose bitmasks for cloning. */
var matches_CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that performs a partial deep comparison between a given
 * object and `source`, returning `true` if the given object has equivalent
 * property values, else `false`.
 *
 * **Note:** The created function is equivalent to `_.isMatch` with `source`
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
 * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */
function matches(source) {
  return _baseMatches(_baseClone(source, matches_CLONE_DEEP_FLAG));
}

/* harmony default export */ var lodash_es_matches = (matches);

// CONCATENATED MODULE: ./node_modules/lodash-es/matchesProperty.js



/** Used to compose bitmasks for cloning. */
var matchesProperty_CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that performs a partial deep comparison between the
 * value at `path` of a given object to `srcValue`, returning `true` if the
 * object value is equivalent, else `false`.
 *
 * **Note:** Partial comparisons will match empty array and empty object
 * `srcValue` values against any array or object value, respectively. See
 * `_.isEqual` for a list of supported value comparisons.
 *
 * **Note:** Multiple values can be checked by combining several matchers
 * using `_.overSome`
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 * @example
 *
 * var objects = [
 *   { 'a': 1, 'b': 2, 'c': 3 },
 *   { 'a': 4, 'b': 5, 'c': 6 }
 * ];
 *
 * _.find(objects, _.matchesProperty('a', 4));
 * // => { 'a': 4, 'b': 5, 'c': 6 }
 *
 * // Checking for several possible values
 * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
 * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
 */
function matchesProperty(path, srcValue) {
  return _baseMatchesProperty(path, _baseClone(srcValue, matchesProperty_CLONE_DEEP_FLAG));
}

/* harmony default export */ var lodash_es_matchesProperty = (matchesProperty);

// CONCATENATED MODULE: ./node_modules/lodash-es/method.js



/**
 * Creates a function that invokes the method at `path` of a given object.
 * Any additional arguments are provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': _.constant(2) } },
 *   { 'a': { 'b': _.constant(1) } }
 * ];
 *
 * _.map(objects, _.method('a.b'));
 * // => [2, 1]
 *
 * _.map(objects, _.method(['a', 'b']));
 * // => [2, 1]
 */
var method = Object(_baseRest["a" /* default */])(function(path, args) {
  return function(object) {
    return _baseInvoke(object, path, args);
  };
});

/* harmony default export */ var lodash_es_method = (method);

// CONCATENATED MODULE: ./node_modules/lodash-es/methodOf.js



/**
 * The opposite of `_.method`; this method creates a function that invokes
 * the method at a given path of `object`. Any additional arguments are
 * provided to the invoked method.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Util
 * @param {Object} object The object to query.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {Function} Returns the new invoker function.
 * @example
 *
 * var array = _.times(3, _.constant),
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.methodOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
 * // => [2, 0]
 */
var methodOf = Object(_baseRest["a" /* default */])(function(object, args) {
  return function(path) {
    return _baseInvoke(object, path, args);
  };
});

/* harmony default export */ var lodash_es_methodOf = (methodOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/mixin.js








/**
 * Adds all own enumerable string keyed function properties of a source
 * object to the destination object. If `object` is a function, then methods
 * are added to its prototype as well.
 *
 * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
 * avoid conflicts caused by modifying the original.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {Function|Object} [object=lodash] The destination object.
 * @param {Object} source The object of functions to add.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
 * @returns {Function|Object} Returns `object`.
 * @example
 *
 * function vowels(string) {
 *   return _.filter(string, function(v) {
 *     return /[aeiou]/i.test(v);
 *   });
 * }
 *
 * _.mixin({ 'vowels': vowels });
 * _.vowels('fred');
 * // => ['e']
 *
 * _('fred').vowels().value();
 * // => ['e']
 *
 * _.mixin({ 'vowels': vowels }, { 'chain': false });
 * _('fred').vowels();
 * // => ['e']
 */
function mixin(object, source, options) {
  var props = lodash_es_keys(source),
      methodNames = _baseFunctions(source, props);

  var chain = !(Object(isObject["a" /* default */])(options) && 'chain' in options) || !!options.chain,
      isFunc = Object(isFunction["a" /* default */])(object);

  Object(_arrayEach["a" /* default */])(methodNames, function(methodName) {
    var func = source[methodName];
    object[methodName] = func;
    if (isFunc) {
      object.prototype[methodName] = function() {
        var chainAll = this.__chain__;
        if (chain || chainAll) {
          var result = object(this.__wrapped__),
              actions = result.__actions__ = Object(_copyArray["a" /* default */])(this.__actions__);

          actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
          result.__chain__ = chainAll;
          return result;
        }
        return func.apply(object, _arrayPush([this.value()], arguments));
      };
    }
  });

  return object;
}

/* harmony default export */ var lodash_es_mixin = (mixin);

// CONCATENATED MODULE: ./node_modules/lodash-es/nthArg.js




/**
 * Creates a function that gets the argument at index `n`. If `n` is negative,
 * the nth argument from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [n=0] The index of the argument to return.
 * @returns {Function} Returns the new pass-thru function.
 * @example
 *
 * var func = _.nthArg(1);
 * func('a', 'b', 'c', 'd');
 * // => 'b'
 *
 * var func = _.nthArg(-2);
 * func('a', 'b', 'c', 'd');
 * // => 'c'
 */
function nthArg(n) {
  n = Object(toInteger["a" /* default */])(n);
  return Object(_baseRest["a" /* default */])(function(args) {
    return _baseNth(args, n);
  });
}

/* harmony default export */ var lodash_es_nthArg = (nthArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createOver.js







/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */
function createOver(arrayFunc) {
  return _flatRest(function(iteratees) {
    iteratees = Object(_arrayMap["a" /* default */])(iteratees, _baseUnary(_baseIteratee));
    return Object(_baseRest["a" /* default */])(function(args) {
      var thisArg = this;
      return arrayFunc(iteratees, function(iteratee) {
        return Object(_apply["a" /* default */])(iteratee, thisArg, args);
      });
    });
  });
}

/* harmony default export */ var _createOver = (createOver);

// CONCATENATED MODULE: ./node_modules/lodash-es/over.js



/**
 * Creates a function that invokes `iteratees` with the arguments it receives
 * and returns their results.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.over([Math.max, Math.min]);
 *
 * func(1, 2, 3, 4);
 * // => [4, 1]
 */
var over = _createOver(_arrayMap["a" /* default */]);

/* harmony default export */ var lodash_es_over = (over);

// CONCATENATED MODULE: ./node_modules/lodash-es/overEvery.js



/**
 * Creates a function that checks if **all** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * Following shorthands are possible for providing predicates.
 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overEvery([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => false
 *
 * func(NaN);
 * // => false
 */
var overEvery = _createOver(_arrayEvery);

/* harmony default export */ var lodash_es_overEvery = (overEvery);

// CONCATENATED MODULE: ./node_modules/lodash-es/overSome.js



/**
 * Creates a function that checks if **any** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * Following shorthands are possible for providing predicates.
 * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
 * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overSome([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => true
 *
 * func(NaN);
 * // => false
 *
 * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
 * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
 */
var overSome = _createOver(_arraySome);

/* harmony default export */ var lodash_es_overSome = (overSome);

// CONCATENATED MODULE: ./node_modules/lodash-es/propertyOf.js


/**
 * The opposite of `_.property`; this method creates a function that returns
 * the value at a given path of `object`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var array = [0, 1, 2],
 *     object = { 'a': array, 'b': array, 'c': array };
 *
 * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
 * // => [2, 0]
 *
 * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
 * // => [2, 0]
 */
function propertyOf(object) {
  return function(path) {
    return object == null ? undefined : Object(_baseGet["a" /* default */])(object, path);
  };
}

/* harmony default export */ var lodash_es_propertyOf = (propertyOf);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseRange.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _baseRange_nativeCeil = Math.ceil,
    _baseRange_nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = _baseRange_nativeMax(_baseRange_nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/* harmony default export */ var _baseRange = (baseRange);

// CONCATENATED MODULE: ./node_modules/lodash-es/_createRange.js




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && _isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = Object(toFinite["a" /* default */])(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = Object(toFinite["a" /* default */])(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : Object(toFinite["a" /* default */])(step);
    return _baseRange(start, end, step, fromRight);
  };
}

/* harmony default export */ var _createRange = (createRange);

// CONCATENATED MODULE: ./node_modules/lodash-es/range.js


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range_range = _createRange();

/* harmony default export */ var lodash_es_range = (range_range);

// CONCATENATED MODULE: ./node_modules/lodash-es/rangeRight.js


/**
 * This method is like `_.range` except that it populates values in
 * descending order.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.range
 * @example
 *
 * _.rangeRight(4);
 * // => [3, 2, 1, 0]
 *
 * _.rangeRight(-4);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 5);
 * // => [4, 3, 2, 1]
 *
 * _.rangeRight(0, 20, 5);
 * // => [15, 10, 5, 0]
 *
 * _.rangeRight(0, -4, -1);
 * // => [-3, -2, -1, 0]
 *
 * _.rangeRight(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.rangeRight(0);
 * // => []
 */
var rangeRight = _createRange(true);

/* harmony default export */ var lodash_es_rangeRight = (rangeRight);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubObject.js
/**
 * This method returns a new empty object.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Object} Returns the new empty object.
 * @example
 *
 * var objects = _.times(2, _.stubObject);
 *
 * console.log(objects);
 * // => [{}, {}]
 *
 * console.log(objects[0] === objects[1]);
 * // => false
 */
function stubObject() {
  return {};
}

/* harmony default export */ var lodash_es_stubObject = (stubObject);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubString.js
/**
 * This method returns an empty string.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {string} Returns the empty string.
 * @example
 *
 * _.times(2, _.stubString);
 * // => ['', '']
 */
function stubString() {
  return '';
}

/* harmony default export */ var lodash_es_stubString = (stubString);

// CONCATENATED MODULE: ./node_modules/lodash-es/stubTrue.js
/**
 * This method returns `true`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `true`.
 * @example
 *
 * _.times(2, _.stubTrue);
 * // => [true, true]
 */
function stubTrue() {
  return true;
}

/* harmony default export */ var lodash_es_stubTrue = (stubTrue);

// CONCATENATED MODULE: ./node_modules/lodash-es/times.js




/** Used as references for various `Number` constants. */
var times_MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var times_MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var times_nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = Object(toInteger["a" /* default */])(n);
  if (n < 1 || n > times_MAX_SAFE_INTEGER) {
    return [];
  }
  var index = times_MAX_ARRAY_LENGTH,
      length = times_nativeMin(n, times_MAX_ARRAY_LENGTH);

  iteratee = _castFunction(iteratee);
  n -= times_MAX_ARRAY_LENGTH;

  var result = _baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

/* harmony default export */ var lodash_es_times = (times);

// EXTERNAL MODULE: ./node_modules/lodash-es/_stringToPath.js + 1 modules
var _stringToPath = __webpack_require__("ff50");

// CONCATENATED MODULE: ./node_modules/lodash-es/toPath.js








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(isArray["a" /* default */])(value)) {
    return Object(_arrayMap["a" /* default */])(value, _toKey["a" /* default */]);
  }
  return Object(isSymbol["a" /* default */])(value) ? [value] : Object(_copyArray["a" /* default */])(Object(_stringToPath["a" /* default */])(Object(lodash_es_toString["a" /* default */])(value)));
}

/* harmony default export */ var lodash_es_toPath = (toPath);

// CONCATENATED MODULE: ./node_modules/lodash-es/uniqueId.js


/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return Object(lodash_es_toString["a" /* default */])(prefix) + id;
}

/* harmony default export */ var lodash_es_uniqueId = (uniqueId);

// CONCATENATED MODULE: ./node_modules/lodash-es/util.default.js

































/* harmony default export */ var util_default = ({
  attempt: lodash_es_attempt, bindAll: lodash_es_bindAll, cond: lodash_es_cond, conforms: lodash_es_conforms, constant: constant["a" /* default */],
  defaultTo: lodash_es_defaultTo, flow: lodash_es_flow, flowRight: lodash_es_flowRight, identity: identity["a" /* default */], iteratee: lodash_es_iteratee,
  matches: lodash_es_matches, matchesProperty: lodash_es_matchesProperty, method: lodash_es_method, methodOf: lodash_es_methodOf, mixin: lodash_es_mixin,
  noop: noop["a" /* default */], nthArg: lodash_es_nthArg, over: lodash_es_over, overEvery: lodash_es_overEvery, overSome: lodash_es_overSome,
  property: lodash_es_property, propertyOf: lodash_es_propertyOf, range: lodash_es_range, rangeRight: lodash_es_rangeRight, stubArray: lodash_es_stubArray,
  stubFalse: stubFalse["a" /* default */], stubObject: lodash_es_stubObject, stubString: lodash_es_stubString, stubTrue: lodash_es_stubTrue, times: lodash_es_times,
  toPath: lodash_es_toPath, uniqueId: lodash_es_uniqueId
});

// EXTERNAL MODULE: ./node_modules/lodash-es/_createHybrid.js + 2 modules
var _createHybrid = __webpack_require__("3f2c");

// CONCATENATED MODULE: ./node_modules/lodash-es/_lazyClone.js



/**
 * Creates a clone of the lazy wrapper object.
 *
 * @private
 * @name clone
 * @memberOf LazyWrapper
 * @returns {Object} Returns the cloned `LazyWrapper` object.
 */
function lazyClone() {
  var result = new _LazyWrapper["a" /* default */](this.__wrapped__);
  result.__actions__ = Object(_copyArray["a" /* default */])(this.__actions__);
  result.__dir__ = this.__dir__;
  result.__filtered__ = this.__filtered__;
  result.__iteratees__ = Object(_copyArray["a" /* default */])(this.__iteratees__);
  result.__takeCount__ = this.__takeCount__;
  result.__views__ = Object(_copyArray["a" /* default */])(this.__views__);
  return result;
}

/* harmony default export */ var _lazyClone = (lazyClone);

// CONCATENATED MODULE: ./node_modules/lodash-es/_lazyReverse.js


/**
 * Reverses the direction of lazy iteration.
 *
 * @private
 * @name reverse
 * @memberOf LazyWrapper
 * @returns {Object} Returns the new reversed `LazyWrapper` object.
 */
function lazyReverse() {
  if (this.__filtered__) {
    var result = new _LazyWrapper["a" /* default */](this);
    result.__dir__ = -1;
    result.__filtered__ = true;
  } else {
    result = this.clone();
    result.__dir__ *= -1;
  }
  return result;
}

/* harmony default export */ var _lazyReverse = (lazyReverse);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getView.js
/* Built-in method references for those with the same name as other `lodash` methods. */
var _getView_nativeMax = Math.max,
    _getView_nativeMin = Math.min;

/**
 * Gets the view, applying any `transforms` to the `start` and `end` positions.
 *
 * @private
 * @param {number} start The start of the view.
 * @param {number} end The end of the view.
 * @param {Array} transforms The transformations to apply to the view.
 * @returns {Object} Returns an object containing the `start` and `end`
 *  positions of the view.
 */
function getView(start, end, transforms) {
  var index = -1,
      length = transforms.length;

  while (++index < length) {
    var data = transforms[index],
        size = data.size;

    switch (data.type) {
      case 'drop':      start += size; break;
      case 'dropRight': end -= size; break;
      case 'take':      end = _getView_nativeMin(end, start + size); break;
      case 'takeRight': start = _getView_nativeMax(start, end - size); break;
    }
  }
  return { 'start': start, 'end': end };
}

/* harmony default export */ var _getView = (getView);

// CONCATENATED MODULE: ./node_modules/lodash-es/_lazyValue.js




/** Used to indicate the type of lazy iteratees. */
var LAZY_FILTER_FLAG = 1,
    LAZY_MAP_FLAG = 2;

/* Built-in method references for those with the same name as other `lodash` methods. */
var _lazyValue_nativeMin = Math.min;

/**
 * Extracts the unwrapped value from its lazy wrapper.
 *
 * @private
 * @name value
 * @memberOf LazyWrapper
 * @returns {*} Returns the unwrapped value.
 */
function lazyValue() {
  var array = this.__wrapped__.value(),
      dir = this.__dir__,
      isArr = Object(isArray["a" /* default */])(array),
      isRight = dir < 0,
      arrLength = isArr ? array.length : 0,
      view = _getView(0, arrLength, this.__views__),
      start = view.start,
      end = view.end,
      length = end - start,
      index = isRight ? end : (start - 1),
      iteratees = this.__iteratees__,
      iterLength = iteratees.length,
      resIndex = 0,
      takeCount = _lazyValue_nativeMin(length, this.__takeCount__);

  if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
    return _baseWrapperValue(array, this.__actions__);
  }
  var result = [];

  outer:
  while (length-- && resIndex < takeCount) {
    index += dir;

    var iterIndex = -1,
        value = array[index];

    while (++iterIndex < iterLength) {
      var data = iteratees[iterIndex],
          iteratee = data.iteratee,
          type = data.type,
          computed = iteratee(value);

      if (type == LAZY_MAP_FLAG) {
        value = computed;
      } else if (!computed) {
        if (type == LAZY_FILTER_FLAG) {
          continue outer;
        } else {
          break outer;
        }
      }
    }
    result[resIndex++] = value;
  }
  return result;
}

/* harmony default export */ var _lazyValue = (lazyValue);

// EXTERNAL MODULE: ./node_modules/lodash-es/_realNames.js
var _realNames = __webpack_require__("1433");

// CONCATENATED MODULE: ./node_modules/lodash-es/lodash.default.js
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */





































/** Used as the semantic version number. */
var VERSION = '4.17.21';

/** Used to compose bitmasks for function metadata. */
var lodash_default_WRAP_BIND_KEY_FLAG = 2;

/** Used to indicate the type of lazy iteratees. */
var lodash_default_LAZY_FILTER_FLAG = 1,
    LAZY_WHILE_FLAG = 3;

/** Used as references for the maximum length and index of an array. */
var lodash_default_MAX_ARRAY_LENGTH = 4294967295;

/** Used for built-in method references. */
var lodash_default_arrayProto = Array.prototype,
    lodash_default_objectProto = Object.prototype;

/** Used to check objects for own properties. */
var lodash_default_hasOwnProperty = lodash_default_objectProto.hasOwnProperty;

/** Built-in value references. */
var lodash_default_symIterator = _Symbol["a" /* default */] ? _Symbol["a" /* default */].iterator : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var lodash_default_nativeMax = Math.max,
    lodash_default_nativeMin = Math.min;

// wrap `_.mixin` so it works when provided only one argument
var lodash_default_mixin = (function(func) {
  return function(object, source, options) {
    if (options == null) {
      var isObj = Object(isObject["a" /* default */])(source),
          props = isObj && lodash_es_keys(source),
          methodNames = props && props.length && _baseFunctions(source, props);

      if (!(methodNames ? methodNames.length : isObj)) {
        options = source;
        source = object;
        object = this;
      }
    }
    return func(object, source, options);
  };
}(lodash_es_mixin));

// Add methods that return wrapped values in chain sequences.
wrapperLodash["a" /* default */].after = function_default.after;
wrapperLodash["a" /* default */].ary = function_default.ary;
wrapperLodash["a" /* default */].assign = object_default.assign;
wrapperLodash["a" /* default */].assignIn = object_default.assignIn;
wrapperLodash["a" /* default */].assignInWith = object_default.assignInWith;
wrapperLodash["a" /* default */].assignWith = object_default.assignWith;
wrapperLodash["a" /* default */].at = object_default.at;
wrapperLodash["a" /* default */].before = function_default.before;
wrapperLodash["a" /* default */].bind = function_default.bind;
wrapperLodash["a" /* default */].bindAll = util_default.bindAll;
wrapperLodash["a" /* default */].bindKey = function_default.bindKey;
wrapperLodash["a" /* default */].castArray = lang_default.castArray;
wrapperLodash["a" /* default */].chain = seq_default.chain;
wrapperLodash["a" /* default */].chunk = array_default.chunk;
wrapperLodash["a" /* default */].compact = array_default.compact;
wrapperLodash["a" /* default */].concat = array_default.concat;
wrapperLodash["a" /* default */].cond = util_default.cond;
wrapperLodash["a" /* default */].conforms = util_default.conforms;
wrapperLodash["a" /* default */].constant = util_default.constant;
wrapperLodash["a" /* default */].countBy = collection_default.countBy;
wrapperLodash["a" /* default */].create = object_default.create;
wrapperLodash["a" /* default */].curry = function_default.curry;
wrapperLodash["a" /* default */].curryRight = function_default.curryRight;
wrapperLodash["a" /* default */].debounce = function_default.debounce;
wrapperLodash["a" /* default */].defaults = object_default.defaults;
wrapperLodash["a" /* default */].defaultsDeep = object_default.defaultsDeep;
wrapperLodash["a" /* default */].defer = function_default.defer;
wrapperLodash["a" /* default */].delay = function_default.delay;
wrapperLodash["a" /* default */].difference = array_default.difference;
wrapperLodash["a" /* default */].differenceBy = array_default.differenceBy;
wrapperLodash["a" /* default */].differenceWith = array_default.differenceWith;
wrapperLodash["a" /* default */].drop = array_default.drop;
wrapperLodash["a" /* default */].dropRight = array_default.dropRight;
wrapperLodash["a" /* default */].dropRightWhile = array_default.dropRightWhile;
wrapperLodash["a" /* default */].dropWhile = array_default.dropWhile;
wrapperLodash["a" /* default */].fill = array_default.fill;
wrapperLodash["a" /* default */].filter = collection_default.filter;
wrapperLodash["a" /* default */].flatMap = collection_default.flatMap;
wrapperLodash["a" /* default */].flatMapDeep = collection_default.flatMapDeep;
wrapperLodash["a" /* default */].flatMapDepth = collection_default.flatMapDepth;
wrapperLodash["a" /* default */].flatten = array_default.flatten;
wrapperLodash["a" /* default */].flattenDeep = array_default.flattenDeep;
wrapperLodash["a" /* default */].flattenDepth = array_default.flattenDepth;
wrapperLodash["a" /* default */].flip = function_default.flip;
wrapperLodash["a" /* default */].flow = util_default.flow;
wrapperLodash["a" /* default */].flowRight = util_default.flowRight;
wrapperLodash["a" /* default */].fromPairs = array_default.fromPairs;
wrapperLodash["a" /* default */].functions = object_default.functions;
wrapperLodash["a" /* default */].functionsIn = object_default.functionsIn;
wrapperLodash["a" /* default */].groupBy = collection_default.groupBy;
wrapperLodash["a" /* default */].initial = array_default.initial;
wrapperLodash["a" /* default */].intersection = array_default.intersection;
wrapperLodash["a" /* default */].intersectionBy = array_default.intersectionBy;
wrapperLodash["a" /* default */].intersectionWith = array_default.intersectionWith;
wrapperLodash["a" /* default */].invert = object_default.invert;
wrapperLodash["a" /* default */].invertBy = object_default.invertBy;
wrapperLodash["a" /* default */].invokeMap = collection_default.invokeMap;
wrapperLodash["a" /* default */].iteratee = util_default.iteratee;
wrapperLodash["a" /* default */].keyBy = collection_default.keyBy;
wrapperLodash["a" /* default */].keys = lodash_es_keys;
wrapperLodash["a" /* default */].keysIn = object_default.keysIn;
wrapperLodash["a" /* default */].map = collection_default.map;
wrapperLodash["a" /* default */].mapKeys = object_default.mapKeys;
wrapperLodash["a" /* default */].mapValues = object_default.mapValues;
wrapperLodash["a" /* default */].matches = util_default.matches;
wrapperLodash["a" /* default */].matchesProperty = util_default.matchesProperty;
wrapperLodash["a" /* default */].memoize = function_default.memoize;
wrapperLodash["a" /* default */].merge = object_default.merge;
wrapperLodash["a" /* default */].mergeWith = object_default.mergeWith;
wrapperLodash["a" /* default */].method = util_default.method;
wrapperLodash["a" /* default */].methodOf = util_default.methodOf;
wrapperLodash["a" /* default */].mixin = lodash_default_mixin;
wrapperLodash["a" /* default */].negate = lodash_es_negate;
wrapperLodash["a" /* default */].nthArg = util_default.nthArg;
wrapperLodash["a" /* default */].omit = object_default.omit;
wrapperLodash["a" /* default */].omitBy = object_default.omitBy;
wrapperLodash["a" /* default */].once = function_default.once;
wrapperLodash["a" /* default */].orderBy = collection_default.orderBy;
wrapperLodash["a" /* default */].over = util_default.over;
wrapperLodash["a" /* default */].overArgs = function_default.overArgs;
wrapperLodash["a" /* default */].overEvery = util_default.overEvery;
wrapperLodash["a" /* default */].overSome = util_default.overSome;
wrapperLodash["a" /* default */].partial = function_default.partial;
wrapperLodash["a" /* default */].partialRight = function_default.partialRight;
wrapperLodash["a" /* default */].partition = collection_default.partition;
wrapperLodash["a" /* default */].pick = object_default.pick;
wrapperLodash["a" /* default */].pickBy = object_default.pickBy;
wrapperLodash["a" /* default */].property = util_default.property;
wrapperLodash["a" /* default */].propertyOf = util_default.propertyOf;
wrapperLodash["a" /* default */].pull = array_default.pull;
wrapperLodash["a" /* default */].pullAll = array_default.pullAll;
wrapperLodash["a" /* default */].pullAllBy = array_default.pullAllBy;
wrapperLodash["a" /* default */].pullAllWith = array_default.pullAllWith;
wrapperLodash["a" /* default */].pullAt = array_default.pullAt;
wrapperLodash["a" /* default */].range = util_default.range;
wrapperLodash["a" /* default */].rangeRight = util_default.rangeRight;
wrapperLodash["a" /* default */].rearg = function_default.rearg;
wrapperLodash["a" /* default */].reject = collection_default.reject;
wrapperLodash["a" /* default */].remove = array_default.remove;
wrapperLodash["a" /* default */].rest = function_default.rest;
wrapperLodash["a" /* default */].reverse = array_default.reverse;
wrapperLodash["a" /* default */].sampleSize = collection_default.sampleSize;
wrapperLodash["a" /* default */].set = object_default.set;
wrapperLodash["a" /* default */].setWith = object_default.setWith;
wrapperLodash["a" /* default */].shuffle = collection_default.shuffle;
wrapperLodash["a" /* default */].slice = array_default.slice;
wrapperLodash["a" /* default */].sortBy = collection_default.sortBy;
wrapperLodash["a" /* default */].sortedUniq = array_default.sortedUniq;
wrapperLodash["a" /* default */].sortedUniqBy = array_default.sortedUniqBy;
wrapperLodash["a" /* default */].split = string_default.split;
wrapperLodash["a" /* default */].spread = function_default.spread;
wrapperLodash["a" /* default */].tail = array_default.tail;
wrapperLodash["a" /* default */].take = array_default.take;
wrapperLodash["a" /* default */].takeRight = array_default.takeRight;
wrapperLodash["a" /* default */].takeRightWhile = array_default.takeRightWhile;
wrapperLodash["a" /* default */].takeWhile = array_default.takeWhile;
wrapperLodash["a" /* default */].tap = seq_default.tap;
wrapperLodash["a" /* default */].throttle = function_default.throttle;
wrapperLodash["a" /* default */].thru = lodash_es_thru;
wrapperLodash["a" /* default */].toArray = lang_default.toArray;
wrapperLodash["a" /* default */].toPairs = object_default.toPairs;
wrapperLodash["a" /* default */].toPairsIn = object_default.toPairsIn;
wrapperLodash["a" /* default */].toPath = util_default.toPath;
wrapperLodash["a" /* default */].toPlainObject = lang_default.toPlainObject;
wrapperLodash["a" /* default */].transform = object_default.transform;
wrapperLodash["a" /* default */].unary = function_default.unary;
wrapperLodash["a" /* default */].union = array_default.union;
wrapperLodash["a" /* default */].unionBy = array_default.unionBy;
wrapperLodash["a" /* default */].unionWith = array_default.unionWith;
wrapperLodash["a" /* default */].uniq = array_default.uniq;
wrapperLodash["a" /* default */].uniqBy = array_default.uniqBy;
wrapperLodash["a" /* default */].uniqWith = array_default.uniqWith;
wrapperLodash["a" /* default */].unset = object_default.unset;
wrapperLodash["a" /* default */].unzip = array_default.unzip;
wrapperLodash["a" /* default */].unzipWith = array_default.unzipWith;
wrapperLodash["a" /* default */].update = object_default.update;
wrapperLodash["a" /* default */].updateWith = object_default.updateWith;
wrapperLodash["a" /* default */].values = object_default.values;
wrapperLodash["a" /* default */].valuesIn = object_default.valuesIn;
wrapperLodash["a" /* default */].without = array_default.without;
wrapperLodash["a" /* default */].words = string_default.words;
wrapperLodash["a" /* default */].wrap = function_default.wrap;
wrapperLodash["a" /* default */].xor = array_default.xor;
wrapperLodash["a" /* default */].xorBy = array_default.xorBy;
wrapperLodash["a" /* default */].xorWith = array_default.xorWith;
wrapperLodash["a" /* default */].zip = array_default.zip;
wrapperLodash["a" /* default */].zipObject = array_default.zipObject;
wrapperLodash["a" /* default */].zipObjectDeep = array_default.zipObjectDeep;
wrapperLodash["a" /* default */].zipWith = array_default.zipWith;

// Add aliases.
wrapperLodash["a" /* default */].entries = object_default.toPairs;
wrapperLodash["a" /* default */].entriesIn = object_default.toPairsIn;
wrapperLodash["a" /* default */].extend = object_default.assignIn;
wrapperLodash["a" /* default */].extendWith = object_default.assignInWith;

// Add methods to `lodash.prototype`.
lodash_default_mixin(wrapperLodash["a" /* default */], wrapperLodash["a" /* default */]);

// Add methods that return unwrapped values in chain sequences.
wrapperLodash["a" /* default */].add = math_default.add;
wrapperLodash["a" /* default */].attempt = util_default.attempt;
wrapperLodash["a" /* default */].camelCase = string_default.camelCase;
wrapperLodash["a" /* default */].capitalize = string_default.capitalize;
wrapperLodash["a" /* default */].ceil = math_default.ceil;
wrapperLodash["a" /* default */].clamp = number_default.clamp;
wrapperLodash["a" /* default */].clone = lang_default.clone;
wrapperLodash["a" /* default */].cloneDeep = lang_default.cloneDeep;
wrapperLodash["a" /* default */].cloneDeepWith = lang_default.cloneDeepWith;
wrapperLodash["a" /* default */].cloneWith = lang_default.cloneWith;
wrapperLodash["a" /* default */].conformsTo = lang_default.conformsTo;
wrapperLodash["a" /* default */].deburr = string_default.deburr;
wrapperLodash["a" /* default */].defaultTo = util_default.defaultTo;
wrapperLodash["a" /* default */].divide = math_default.divide;
wrapperLodash["a" /* default */].endsWith = string_default.endsWith;
wrapperLodash["a" /* default */].eq = lang_default.eq;
wrapperLodash["a" /* default */].escape = string_default.escape;
wrapperLodash["a" /* default */].escapeRegExp = string_default.escapeRegExp;
wrapperLodash["a" /* default */].every = collection_default.every;
wrapperLodash["a" /* default */].find = collection_default.find;
wrapperLodash["a" /* default */].findIndex = array_default.findIndex;
wrapperLodash["a" /* default */].findKey = object_default.findKey;
wrapperLodash["a" /* default */].findLast = collection_default.findLast;
wrapperLodash["a" /* default */].findLastIndex = array_default.findLastIndex;
wrapperLodash["a" /* default */].findLastKey = object_default.findLastKey;
wrapperLodash["a" /* default */].floor = math_default.floor;
wrapperLodash["a" /* default */].forEach = collection_default.forEach;
wrapperLodash["a" /* default */].forEachRight = collection_default.forEachRight;
wrapperLodash["a" /* default */].forIn = object_default.forIn;
wrapperLodash["a" /* default */].forInRight = object_default.forInRight;
wrapperLodash["a" /* default */].forOwn = object_default.forOwn;
wrapperLodash["a" /* default */].forOwnRight = object_default.forOwnRight;
wrapperLodash["a" /* default */].get = object_default.get;
wrapperLodash["a" /* default */].gt = lang_default.gt;
wrapperLodash["a" /* default */].gte = lang_default.gte;
wrapperLodash["a" /* default */].has = object_default.has;
wrapperLodash["a" /* default */].hasIn = object_default.hasIn;
wrapperLodash["a" /* default */].head = array_default.head;
wrapperLodash["a" /* default */].identity = identity["a" /* default */];
wrapperLodash["a" /* default */].includes = collection_default.includes;
wrapperLodash["a" /* default */].indexOf = array_default.indexOf;
wrapperLodash["a" /* default */].inRange = number_default.inRange;
wrapperLodash["a" /* default */].invoke = object_default.invoke;
wrapperLodash["a" /* default */].isArguments = lang_default.isArguments;
wrapperLodash["a" /* default */].isArray = isArray["a" /* default */];
wrapperLodash["a" /* default */].isArrayBuffer = lang_default.isArrayBuffer;
wrapperLodash["a" /* default */].isArrayLike = lang_default.isArrayLike;
wrapperLodash["a" /* default */].isArrayLikeObject = lang_default.isArrayLikeObject;
wrapperLodash["a" /* default */].isBoolean = lang_default.isBoolean;
wrapperLodash["a" /* default */].isBuffer = lang_default.isBuffer;
wrapperLodash["a" /* default */].isDate = lang_default.isDate;
wrapperLodash["a" /* default */].isElement = lang_default.isElement;
wrapperLodash["a" /* default */].isEmpty = lang_default.isEmpty;
wrapperLodash["a" /* default */].isEqual = lang_default.isEqual;
wrapperLodash["a" /* default */].isEqualWith = lang_default.isEqualWith;
wrapperLodash["a" /* default */].isError = lang_default.isError;
wrapperLodash["a" /* default */].isFinite = lang_default.isFinite;
wrapperLodash["a" /* default */].isFunction = lang_default.isFunction;
wrapperLodash["a" /* default */].isInteger = lang_default.isInteger;
wrapperLodash["a" /* default */].isLength = lang_default.isLength;
wrapperLodash["a" /* default */].isMap = lang_default.isMap;
wrapperLodash["a" /* default */].isMatch = lang_default.isMatch;
wrapperLodash["a" /* default */].isMatchWith = lang_default.isMatchWith;
wrapperLodash["a" /* default */].isNaN = lang_default.isNaN;
wrapperLodash["a" /* default */].isNative = lang_default.isNative;
wrapperLodash["a" /* default */].isNil = lang_default.isNil;
wrapperLodash["a" /* default */].isNull = lang_default.isNull;
wrapperLodash["a" /* default */].isNumber = lang_default.isNumber;
wrapperLodash["a" /* default */].isObject = isObject["a" /* default */];
wrapperLodash["a" /* default */].isObjectLike = lang_default.isObjectLike;
wrapperLodash["a" /* default */].isPlainObject = lang_default.isPlainObject;
wrapperLodash["a" /* default */].isRegExp = lang_default.isRegExp;
wrapperLodash["a" /* default */].isSafeInteger = lang_default.isSafeInteger;
wrapperLodash["a" /* default */].isSet = lang_default.isSet;
wrapperLodash["a" /* default */].isString = lang_default.isString;
wrapperLodash["a" /* default */].isSymbol = lang_default.isSymbol;
wrapperLodash["a" /* default */].isTypedArray = lang_default.isTypedArray;
wrapperLodash["a" /* default */].isUndefined = lang_default.isUndefined;
wrapperLodash["a" /* default */].isWeakMap = lang_default.isWeakMap;
wrapperLodash["a" /* default */].isWeakSet = lang_default.isWeakSet;
wrapperLodash["a" /* default */].join = array_default.join;
wrapperLodash["a" /* default */].kebabCase = string_default.kebabCase;
wrapperLodash["a" /* default */].last = lodash_es_last;
wrapperLodash["a" /* default */].lastIndexOf = array_default.lastIndexOf;
wrapperLodash["a" /* default */].lowerCase = string_default.lowerCase;
wrapperLodash["a" /* default */].lowerFirst = string_default.lowerFirst;
wrapperLodash["a" /* default */].lt = lang_default.lt;
wrapperLodash["a" /* default */].lte = lang_default.lte;
wrapperLodash["a" /* default */].max = math_default.max;
wrapperLodash["a" /* default */].maxBy = math_default.maxBy;
wrapperLodash["a" /* default */].mean = math_default.mean;
wrapperLodash["a" /* default */].meanBy = math_default.meanBy;
wrapperLodash["a" /* default */].min = math_default.min;
wrapperLodash["a" /* default */].minBy = math_default.minBy;
wrapperLodash["a" /* default */].stubArray = util_default.stubArray;
wrapperLodash["a" /* default */].stubFalse = util_default.stubFalse;
wrapperLodash["a" /* default */].stubObject = util_default.stubObject;
wrapperLodash["a" /* default */].stubString = util_default.stubString;
wrapperLodash["a" /* default */].stubTrue = util_default.stubTrue;
wrapperLodash["a" /* default */].multiply = math_default.multiply;
wrapperLodash["a" /* default */].nth = array_default.nth;
wrapperLodash["a" /* default */].noop = util_default.noop;
wrapperLodash["a" /* default */].now = date_default.now;
wrapperLodash["a" /* default */].pad = string_default.pad;
wrapperLodash["a" /* default */].padEnd = string_default.padEnd;
wrapperLodash["a" /* default */].padStart = string_default.padStart;
wrapperLodash["a" /* default */].parseInt = string_default.parseInt;
wrapperLodash["a" /* default */].random = number_default.random;
wrapperLodash["a" /* default */].reduce = collection_default.reduce;
wrapperLodash["a" /* default */].reduceRight = collection_default.reduceRight;
wrapperLodash["a" /* default */].repeat = string_default.repeat;
wrapperLodash["a" /* default */].replace = string_default.replace;
wrapperLodash["a" /* default */].result = object_default.result;
wrapperLodash["a" /* default */].round = math_default.round;
wrapperLodash["a" /* default */].sample = collection_default.sample;
wrapperLodash["a" /* default */].size = collection_default.size;
wrapperLodash["a" /* default */].snakeCase = string_default.snakeCase;
wrapperLodash["a" /* default */].some = collection_default.some;
wrapperLodash["a" /* default */].sortedIndex = array_default.sortedIndex;
wrapperLodash["a" /* default */].sortedIndexBy = array_default.sortedIndexBy;
wrapperLodash["a" /* default */].sortedIndexOf = array_default.sortedIndexOf;
wrapperLodash["a" /* default */].sortedLastIndex = array_default.sortedLastIndex;
wrapperLodash["a" /* default */].sortedLastIndexBy = array_default.sortedLastIndexBy;
wrapperLodash["a" /* default */].sortedLastIndexOf = array_default.sortedLastIndexOf;
wrapperLodash["a" /* default */].startCase = string_default.startCase;
wrapperLodash["a" /* default */].startsWith = string_default.startsWith;
wrapperLodash["a" /* default */].subtract = math_default.subtract;
wrapperLodash["a" /* default */].sum = math_default.sum;
wrapperLodash["a" /* default */].sumBy = math_default.sumBy;
wrapperLodash["a" /* default */].template = string_default.template;
wrapperLodash["a" /* default */].times = util_default.times;
wrapperLodash["a" /* default */].toFinite = lang_default.toFinite;
wrapperLodash["a" /* default */].toInteger = toInteger["a" /* default */];
wrapperLodash["a" /* default */].toLength = lang_default.toLength;
wrapperLodash["a" /* default */].toLower = string_default.toLower;
wrapperLodash["a" /* default */].toNumber = lang_default.toNumber;
wrapperLodash["a" /* default */].toSafeInteger = lang_default.toSafeInteger;
wrapperLodash["a" /* default */].toString = lang_default.toString;
wrapperLodash["a" /* default */].toUpper = string_default.toUpper;
wrapperLodash["a" /* default */].trim = string_default.trim;
wrapperLodash["a" /* default */].trimEnd = string_default.trimEnd;
wrapperLodash["a" /* default */].trimStart = string_default.trimStart;
wrapperLodash["a" /* default */].truncate = string_default.truncate;
wrapperLodash["a" /* default */].unescape = string_default.unescape;
wrapperLodash["a" /* default */].uniqueId = util_default.uniqueId;
wrapperLodash["a" /* default */].upperCase = string_default.upperCase;
wrapperLodash["a" /* default */].upperFirst = string_default.upperFirst;

// Add aliases.
wrapperLodash["a" /* default */].each = collection_default.forEach;
wrapperLodash["a" /* default */].eachRight = collection_default.forEachRight;
wrapperLodash["a" /* default */].first = array_default.head;

lodash_default_mixin(wrapperLodash["a" /* default */], (function() {
  var source = {};
  _baseForOwn(wrapperLodash["a" /* default */], function(func, methodName) {
    if (!lodash_default_hasOwnProperty.call(wrapperLodash["a" /* default */].prototype, methodName)) {
      source[methodName] = func;
    }
  });
  return source;
}()), { 'chain': false });

/**
 * The semantic version number.
 *
 * @static
 * @memberOf _
 * @type {string}
 */
wrapperLodash["a" /* default */].VERSION = VERSION;
(wrapperLodash["a" /* default */].templateSettings = string_default.templateSettings).imports._ = wrapperLodash["a" /* default */];

// Assign default placeholders.
Object(_arrayEach["a" /* default */])(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
  wrapperLodash["a" /* default */][methodName].placeholder = wrapperLodash["a" /* default */];
});

// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
Object(_arrayEach["a" /* default */])(['drop', 'take'], function(methodName, index) {
  _LazyWrapper["a" /* default */].prototype[methodName] = function(n) {
    n = n === undefined ? 1 : lodash_default_nativeMax(Object(toInteger["a" /* default */])(n), 0);

    var result = (this.__filtered__ && !index)
      ? new _LazyWrapper["a" /* default */](this)
      : this.clone();

    if (result.__filtered__) {
      result.__takeCount__ = lodash_default_nativeMin(n, result.__takeCount__);
    } else {
      result.__views__.push({
        'size': lodash_default_nativeMin(n, lodash_default_MAX_ARRAY_LENGTH),
        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
      });
    }
    return result;
  };

  _LazyWrapper["a" /* default */].prototype[methodName + 'Right'] = function(n) {
    return this.reverse()[methodName](n).reverse();
  };
});

// Add `LazyWrapper` methods that accept an `iteratee` value.
Object(_arrayEach["a" /* default */])(['filter', 'map', 'takeWhile'], function(methodName, index) {
  var type = index + 1,
      isFilter = type == lodash_default_LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

  _LazyWrapper["a" /* default */].prototype[methodName] = function(iteratee) {
    var result = this.clone();
    result.__iteratees__.push({
      'iteratee': _baseIteratee(iteratee, 3),
      'type': type
    });
    result.__filtered__ = result.__filtered__ || isFilter;
    return result;
  };
});

// Add `LazyWrapper` methods for `_.head` and `_.last`.
Object(_arrayEach["a" /* default */])(['head', 'last'], function(methodName, index) {
  var takeName = 'take' + (index ? 'Right' : '');

  _LazyWrapper["a" /* default */].prototype[methodName] = function() {
    return this[takeName](1).value()[0];
  };
});

// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
Object(_arrayEach["a" /* default */])(['initial', 'tail'], function(methodName, index) {
  var dropName = 'drop' + (index ? '' : 'Right');

  _LazyWrapper["a" /* default */].prototype[methodName] = function() {
    return this.__filtered__ ? new _LazyWrapper["a" /* default */](this) : this[dropName](1);
  };
});

_LazyWrapper["a" /* default */].prototype.compact = function() {
  return this.filter(identity["a" /* default */]);
};

_LazyWrapper["a" /* default */].prototype.find = function(predicate) {
  return this.filter(predicate).head();
};

_LazyWrapper["a" /* default */].prototype.findLast = function(predicate) {
  return this.reverse().find(predicate);
};

_LazyWrapper["a" /* default */].prototype.invokeMap = Object(_baseRest["a" /* default */])(function(path, args) {
  if (typeof path == 'function') {
    return new _LazyWrapper["a" /* default */](this);
  }
  return this.map(function(value) {
    return _baseInvoke(value, path, args);
  });
});

_LazyWrapper["a" /* default */].prototype.reject = function(predicate) {
  return this.filter(lodash_es_negate(_baseIteratee(predicate)));
};

_LazyWrapper["a" /* default */].prototype.slice = function(start, end) {
  start = Object(toInteger["a" /* default */])(start);

  var result = this;
  if (result.__filtered__ && (start > 0 || end < 0)) {
    return new _LazyWrapper["a" /* default */](result);
  }
  if (start < 0) {
    result = result.takeRight(-start);
  } else if (start) {
    result = result.drop(start);
  }
  if (end !== undefined) {
    end = Object(toInteger["a" /* default */])(end);
    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
  }
  return result;
};

_LazyWrapper["a" /* default */].prototype.takeRightWhile = function(predicate) {
  return this.reverse().takeWhile(predicate).reverse();
};

_LazyWrapper["a" /* default */].prototype.toArray = function() {
  return this.take(lodash_default_MAX_ARRAY_LENGTH);
};

// Add `LazyWrapper` methods to `lodash.prototype`.
_baseForOwn(_LazyWrapper["a" /* default */].prototype, function(func, methodName) {
  var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
      isTaker = /^(?:head|last)$/.test(methodName),
      lodashFunc = wrapperLodash["a" /* default */][isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
      retUnwrapped = isTaker || /^find/.test(methodName);

  if (!lodashFunc) {
    return;
  }
  wrapperLodash["a" /* default */].prototype[methodName] = function() {
    var value = this.__wrapped__,
        args = isTaker ? [1] : arguments,
        isLazy = value instanceof _LazyWrapper["a" /* default */],
        iteratee = args[0],
        useLazy = isLazy || Object(isArray["a" /* default */])(value);

    var interceptor = function(value) {
      var result = lodashFunc.apply(wrapperLodash["a" /* default */], _arrayPush([value], args));
      return (isTaker && chainAll) ? result[0] : result;
    };

    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
      // Avoid lazy use if the iteratee has a "length" value other than `1`.
      isLazy = useLazy = false;
    }
    var chainAll = this.__chain__,
        isHybrid = !!this.__actions__.length,
        isUnwrapped = retUnwrapped && !chainAll,
        onlyLazy = isLazy && !isHybrid;

    if (!retUnwrapped && useLazy) {
      value = onlyLazy ? value : new _LazyWrapper["a" /* default */](this);
      var result = func.apply(value, args);
      result.__actions__.push({ 'func': lodash_es_thru, 'args': [interceptor], 'thisArg': undefined });
      return new _LodashWrapper["a" /* default */](result, chainAll);
    }
    if (isUnwrapped && onlyLazy) {
      return func.apply(this, args);
    }
    result = this.thru(interceptor);
    return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
  };
});

// Add `Array` methods to `lodash.prototype`.
Object(_arrayEach["a" /* default */])(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
  var func = lodash_default_arrayProto[methodName],
      chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
      retUnwrapped = /^(?:pop|shift)$/.test(methodName);

  wrapperLodash["a" /* default */].prototype[methodName] = function() {
    var args = arguments;
    if (retUnwrapped && !this.__chain__) {
      var value = this.value();
      return func.apply(Object(isArray["a" /* default */])(value) ? value : [], args);
    }
    return this[chainName](function(value) {
      return func.apply(Object(isArray["a" /* default */])(value) ? value : [], args);
    });
  };
});

// Map minified method names to their real names.
_baseForOwn(_LazyWrapper["a" /* default */].prototype, function(func, methodName) {
  var lodashFunc = wrapperLodash["a" /* default */][methodName];
  if (lodashFunc) {
    var key = lodashFunc.name + '';
    if (!lodash_default_hasOwnProperty.call(_realNames["a" /* default */], key)) {
      _realNames["a" /* default */][key] = [];
    }
    _realNames["a" /* default */][key].push({ 'name': methodName, 'func': lodashFunc });
  }
});

_realNames["a" /* default */][Object(_createHybrid["a" /* default */])(undefined, lodash_default_WRAP_BIND_KEY_FLAG).name] = [{
  'name': 'wrapper',
  'func': undefined
}];

// Add methods to `LazyWrapper`.
_LazyWrapper["a" /* default */].prototype.clone = _lazyClone;
_LazyWrapper["a" /* default */].prototype.reverse = _lazyReverse;
_LazyWrapper["a" /* default */].prototype.value = _lazyValue;

// Add chain sequence methods to the `lodash` wrapper.
wrapperLodash["a" /* default */].prototype.at = seq_default.at;
wrapperLodash["a" /* default */].prototype.chain = seq_default.wrapperChain;
wrapperLodash["a" /* default */].prototype.commit = seq_default.commit;
wrapperLodash["a" /* default */].prototype.next = seq_default.next;
wrapperLodash["a" /* default */].prototype.plant = seq_default.plant;
wrapperLodash["a" /* default */].prototype.reverse = seq_default.reverse;
wrapperLodash["a" /* default */].prototype.toJSON = wrapperLodash["a" /* default */].prototype.valueOf = wrapperLodash["a" /* default */].prototype.value = seq_default.value;

// Add lazy aliases.
wrapperLodash["a" /* default */].prototype.first = wrapperLodash["a" /* default */].prototype.head;

if (lodash_default_symIterator) {
  wrapperLodash["a" /* default */].prototype[lodash_default_symIterator] = seq_default.toIterator;
}

/* harmony default export */ var lodash_default = (wrapperLodash["a" /* default */]);

// CONCATENATED MODULE: ./src/utils/models/selection.js









/* eslint-disable no-underscore-dangle */



/**
 * @typedef {TinyEmitter} EventBus This is sparse documentation for the implementation provided by the tiny-emitter library.
 * @property {Function} emit `('event-name', data)` Emit an event with the given event name.
 * @property {Function} on `('event-name', eventListener)` Attach an event-listener for the event.
 * @property {Function} once `('event-name', eventListener)` Attach an event-listener for the event and detach after the first invocation.
 * @property {Function} off `('event-name', [eventListener])` Detach an event-listener for the event.
 */

/**
 * @typedef {Object} SelectionData The data returned by the `selection.getData()` method.
 * @property {Node} commonAncestor The common ancestor of the start and end nodes.
 * @property {Node} endNode The end node.
 * @property {String} endNodeSelector The selector for the end node element.
 * @property {Number} endOffset The offset for the end node.
 * @property {Node} startNode The start node.
 * @property {String} startNodeSelector The selector for the start node element.
 * @property {Number} startOffset The offset for the start node.
 * @property {String} text The text for the selection.
 */

/**
 * Selection class.
 */

var selection_Selection = /*#__PURE__*/function () {
  /**
   * @param {Object} options The options to be used by the Selection instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   *
   * @example
   * const contextEl = document.querySelector('main');
   *
   * const selection = new Selection({
   *   contextContainer: contextEl,
   *   ignoredElements: [
   *     'span',
   *     '.nebula-button',
   *   ],
   * });
   *
   * // update from data
   * selection.updateFromData(...);
   *
   * // or, listen to events
   * selection.on('select', ...);
   */
  function Selection(options) {
    _classCallCheck(this, Selection);

    Object(defineProperty["a" /* default */])(this, "_clientId", void 0);

    Object(defineProperty["a" /* default */])(this, "_commonAncestor", void 0);

    Object(defineProperty["a" /* default */])(this, "_domHelper", void 0);

    Object(defineProperty["a" /* default */])(this, "_endNode", void 0);

    Object(defineProperty["a" /* default */])(this, "_endNodeSelector", void 0);

    Object(defineProperty["a" /* default */])(this, "_endOffset", void 0);

    Object(defineProperty["a" /* default */])(this, "_eventBus", void 0);

    Object(defineProperty["a" /* default */])(this, "_isStale", void 0);

    Object(defineProperty["a" /* default */])(this, "_startNode", void 0);

    Object(defineProperty["a" /* default */])(this, "_startNodeSelector", void 0);

    Object(defineProperty["a" /* default */])(this, "_startOffset", void 0);

    Object(defineProperty["a" /* default */])(this, "_text", void 0);

    this._clientId = Selection.getNextClientId();
    this._domHelper = new dom({
      contextContainer: options === null || options === void 0 ? void 0 : options.contextContainer,
      ignoredElements: options === null || options === void 0 ? void 0 : options.ignoredElements,
      nodeSelectors: options === null || options === void 0 ? void 0 : options.nodeSelectors
    });
    this._eventBus = new tiny_emitter_default.a();
    this.clearData();
    this.setStale();
  }
  /**
   * Clear any selection data.
   */


  _createClass(Selection, [{
    key: "clientId",
    get:
    /**
     * The unique client ID of this instance.
     * @type {Number}
     * @readonly
     *
     * @example
     * const selection = new Selection();
     *
     * // prints the client-id
     * console.log(selection.clientId);
     *
     * // throws an exception
     * selection.clientId = 123;
     */
    function get() {
      return this._clientId;
    }
    /**
     * The common ancestor element to the start and end nodes of the instance.
     * @type {Node.ELEMENT_NODE}
     * @readonly
     */

  }, {
    key: "commonAncestor",
    get: function get() {
      if (this._commonAncestor) {
        return this._commonAncestor;
      }

      this._commonAncestor = dom.getCommonAncestor(this.startNode, this.endNode);
      return this._commonAncestor;
    }
    /**
     * The context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     */

  }, {
    key: "contextContainer",
    get: function get() {
      return this.domHelper.contextContainer;
    },
    set: function set(val) {
      this.domHelper.contextContainer = val;
    }
    /**
     * The immediate parent of context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     * @readonly
     */

  }, {
    key: "contextContainerParent",
    get: function get() {
      var _this$contextContaine;

      return ((_this$contextContaine = this.contextContainer) === null || _this$contextContaine === void 0 ? void 0 : _this$contextContaine.parentNode) || null;
    }
    /**
     * The {@link DomHelper} instance used by this selection.
     * @type {DomHelper}
     * @readonly
     */

  }, {
    key: "domHelper",
    get: function get() {
      return this._domHelper;
    }
    /**
     * The end node of the selection.
     * @type {Node}
     */

  }, {
    key: "endNode",
    get: function get() {
      this.endNode = this._getActiveDomNode(this._endNode, this.endNodeSelector, this.endOffset);
      return this._endNode;
    },
    set: function set(val) {
      if (val === this._endNode) {
        return;
      }

      this._commonAncestor = null;
      this._endNode = val;
    }
    /**
     * The context element for the end node.
     * @readonly
     */

  }, {
    key: "endNodeContextElement",
    get: function get() {
      return document.querySelector(this.endNodeSelector) || null;
    }
    /**
     * The CSS selector for the end node.
     * @readonly
     */

  }, {
    key: "endNodeSelector",
    get: function get() {
      return this._endNodeSelector;
    }
    /**
     * The offset for the end node.
     * @readonly
     */

  }, {
    key: "endOffset",
    get: function get() {
      return this._endOffset;
    }
    /**
     * The event bus for this instance.
     * @type {EventBus}
     * @readonly
     */

  }, {
    key: "eventBus",
    get: function get() {
      return this._eventBus;
    }
    /**
     * The array of ignored element selectors.
     * @type {String[]}
     */

  }, {
    key: "ignoredElements",
    get: function get() {
      return this.domHelper.ignoredElements;
    },
    set: function set(val) {
      this.domHelper.ignoredElements = val;
    }
    /**
     * A flag indicating whether this selection is stale.
     * This flag is NOT set automatically and relies on
     * other parts of the code setting and using it
     * appropriately.
     * @type {Boolean}
     * @readonly
     */

  }, {
    key: "isStale",
    get: function get() {
      return this._isStale;
    }
    /**
     * The node selectors data object.
     * @type {NodeSelectorsData}
     */

  }, {
    key: "nodeSelectors",
    get: function get() {
      return this.domHelper.nodeSelectors;
    },
    set: function set(val) {
      this.domHelper.nodeSelectors = val;
    }
    /**
     * The start node of the selection.
     * @type {Node}
     */

  }, {
    key: "startNode",
    get: function get() {
      this.startNode = this._getActiveDomNode(this._startNode, this.startNodeSelector, this.startOffset);
      return this._startNode;
    },
    set: function set(val) {
      if (val === this._startNode) {
        return;
      }

      this._commonAncestor = null;
      this._startNode = val;
    }
    /**
     * The context element for the start node.
     * @readonly
     */

  }, {
    key: "startNodeContextElement",
    get: function get() {
      return document.querySelector(this.startNodeSelector) || null;
    }
    /**
     * The CSS selector for the start node.
     * @readonly
     */

  }, {
    key: "startNodeSelector",
    get: function get() {
      return this._startNodeSelector;
    }
    /**
     * The offset for the start node.
     * @readonly
     */

  }, {
    key: "startOffset",
    get: function get() {
      return this._startOffset;
    }
    /**
     * The text of the given selection.
     * @type {?String}
     * @readonly
     */

  }, {
    key: "text",
    get: function get() {
      return this._text;
    }
  }, {
    key: "clearData",
    value: function clearData() {
      this._commonAncestor = null;
      this._endNode = null;
      this._endOffset = null;
      this._endNodeSelector = null;
      this._startNode = null;
      this._startOffset = null;
      this._startNodeSelector = null;
      this._text = null;
      this.setFresh();
    }
    /**
     * Dispatch an event on the event-bus.
     * @private
     * @param {String} eventName The name of the event to dispatch.
     * @param {Any} data The data to pass along into the event data.
     */

  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(eventName, data) {
      this.eventBus.emit(eventName, {
        context: this,
        data: data
      });
    }
    /**
     * Get the active text-node from the DOM. Used to get around stale selections in the DOM after DOM manipulation actions.
     * @private
     * @param {Node} textNode The text-node to check and return the active node for.
     * @param {String} elementSelector The selector of the parent element containing the text-node
     * @param {Number} trueOffset The true offset of the node in the DOM with respect to it's parent element.
     * @returns {Node} Returns the active text node.
     */

  }, {
    key: "_getActiveDomNode",
    value: function _getActiveDomNode(textNode, elementSelector, trueOffset) {
      if (!textNode) {
        // GIGO
        return null;
      }

      if (dom.isNodeInDom(textNode)) {
        // Already in DOM
        return textNode;
      } // Reset the commonAncestor data


      this._commonAncestor = null; // Use the selector and the true-offset
      // to grab the text node.

      var parentElement = document.querySelector(elementSelector);
      var nodeData = dom.getTextNodeFromOffset(parentElement, trueOffset);
      return nodeData.targetNode;
    }
    /**
     * Returns a {@link SelectionData} object with all the relevant selection data that can then be used to save to and update from a data-store.
     * @returns {SelectionData} Returns an object with all the relevant selection data.
     */

  }, {
    key: "getData",
    value: function getData() {
      return {
        commonAncestor: this.commonAncestor,
        endNode: this.endNode,
        endNodeSelector: this.endNodeSelector,
        endOffset: this.endOffset,
        startNode: this.startNode,
        startNodeSelector: this.startNodeSelector,
        startOffset: this.startOffset,
        text: this.text
      };
    }
    /**
     * Get an array of the marked elements. If the optional `markerId` is provided,
     * it will only return the elements corresponding to that id.
     * @param {Number} [markerId] Optional numeric marker id.
     * @returns {Array} An array of the marked elements.
     */

  }, {
    key: "getMarkedElements",
    value: function getMarkedElements() {
      var markerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var selector = ".de-selection-marker[data-client-id=\"".concat(this.clientId, "\"]");

      if (markerId) {
        selector = "".concat(selector, "[data-marker-id=\"").concat(markerId, "\"]");
      }

      var markedElements = Object(toConsumableArray["a" /* default */])(document.querySelectorAll(selector));

      return markedElements;
    }
    /**
     * Marks the selection with elements in the DOM. Can be used to target with
     * other software like TTS or highlighting.
     * @param {String} element The element that will wrap the selection. Defaults to `<mark>` but can be overwritten
     */

  }, {
    key: "mark",
    value: function mark() {
      var _this = this;

      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'mark';

      if (!this.startNode || !this.endNode) {
        // Not a valid selection
        return [];
      } // Remove stale markers.


      this.unmark();
      var textNodes = null;

      if (this.startNode === this.endNode) {
        textNodes = [this.startNode];
      } else {
        var intermediateTextNodes = dom.getIntermediateTextNodes(this.startNode, this.endNode);
        textNodes = [this.startNode].concat(Object(toConsumableArray["a" /* default */])(intermediateTextNodes), [this.endNode]);
      }

      var markerId = Selection.getNextMarkerId();
      var elementIdPrefix = "de-selection_client-".concat(this.clientId, "_marker-").concat(markerId, "_");
      var lastIndex = textNodes.length - 1; // All text nodes

      lodash_default.forEachRight(textNodes, function (textNode, index) {
        var elementId = "".concat(elementIdPrefix, "index-").concat(index);
        var injectionElement = document.createElement(element);
        injectionElement.classList.add('de-selection-marker');
        injectionElement.setAttribute('id', elementId);
        injectionElement.setAttribute('data-client-id', _this.clientId);
        injectionElement.setAttribute('data-marker-id', markerId);
        injectionElement.setAttribute('data-index', index);
        var startOffset = null;
        var endOffset = null;

        if (index === 0) {
          var startNodeData = dom.getTextNodeFromOffset(_this.startNodeContextElement, _this.startOffset, true);
          startOffset = startNodeData.relativeOffset;
        }

        if (index === lastIndex) {
          var endNodeData = dom.getTextNodeFromOffset(_this.endNodeContextElement, _this.endOffset, false);
          endOffset = endNodeData.relativeOffset;
        }

        dom.injectElementInNode(textNode, injectionElement, startOffset, endOffset);
      }); // Return the marked elements


      return this.getMarkedElements(markerId);
    }
    /**
     * Selects the text in the DOM.
     */

  }, {
    key: "select",
    value: function select() {
      if (!this.startNode || !this.endNode) {
        return;
      }

      var selectionRange = Selection.getSelectionRange({
        startNodeSelector: this.startNodeSelector,
        startOffset: this.startOffset,
        endNodeSelector: this.endNodeSelector,
        endOffset: this.endOffset
      });

      if (!selectionRange) {
        return;
      }

      var domSelection = document.getSelection();
      domSelection.empty();
      domSelection.addRange(selectionRange);

      this._dispatchEvent('select', this);
    }
    /**
     * Sets the current selection as fresh (not stale).
     */

  }, {
    key: "setFresh",
    value: function setFresh() {
      this._isStale = false;
    }
    /**
     * Sets the current selection as stale.
     */

  }, {
    key: "setStale",
    value: function setStale() {
      this._isStale = true;
    }
    /**
     * Unmarks the current markers from the DOM. If a `markerId` is
     * provided only elements corresponding to that id are unmarked.
     * @param {Number} [markerId] Optional numeric marker id.
    */

  }, {
    key: "unmark",
    value: function unmark() {
      var markerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var elementsToUnmark = this.getMarkedElements(markerId);
      elementsToUnmark.forEach(function (markedElement) {
        var htmlContent = markedElement.innerHTML;
        dom.replaceNodeWithContent(markedElement, htmlContent);
      });
    }
    /**
     * Update the selection using data instead of DOM Ranges. Will implicityly mark the selection as fresh.
     * @param {Object} selectionData An object that contains data pertaining to the selection.
     * @returns {Boolean} Returns `true` if successful, `false` otherwise.
     */

  }, {
    key: "updateFromData",
    value: function updateFromData(selectionData) {
      var selectionRange = Selection.getSelectionRange({
        startNodeSelector: selectionData.startNodeSelector,
        startOffset: selectionData.startOffset,
        endNodeSelector: selectionData.endNodeSelector,
        endOffset: selectionData.endOffset
      });

      if (!selectionRange) {
        return false;
      }

      this.updateFromRange(selectionRange);
      return true;
    }
    /**
     * Updates the current selection using the given Range instance.
     * @param {Range} range The Range instance to use to update the selection.
     */

  }, {
    key: "updateFromRange",
    value: function updateFromRange(range) {
      var selection = {
        endNode: range.endContainer,
        endOffset: range.endOffset,
        startNode: range.startContainer,
        startOffset: range.startOffset
      };
      this._text = range.toString() || null;
      var isEndNodeBeforeStartNode = dom.compareNodePosition(selection.startNode, selection.endNode).isPreceding;

      if (selection.startNode === selection.endNode && selection.startOffset > selection.endOffset) {
        // Text-selection is backwards within the same node.
        // Reverse the offsets for data-processing.
        var newStartOffset = selection.endOffset;
        var newEndOffset = selection.startOffset;
        selection.startOffset = newStartOffset;
        selection.endOffset = newEndOffset;
      } else if (isEndNodeBeforeStartNode) {
        // Text-selection is backward and spans across different nodes.
        // Reverse the start and end data to simplify processing.
        var newStartNode = selection.endNode;
        var _newStartOffset = selection.endOffset;
        var newEndNode = selection.startNode;
        var _newEndOffset = selection.startOffset;
        selection.startNode = newStartNode;
        selection.startOffset = _newStartOffset;
        selection.endNode = newEndNode;
        selection.endOffset = _newEndOffset;
      } // We want to distill the selection object to ONLY ever
      // provide text-nodes for startNode and endNode.
      //
      // Why?
      // It helps to reduce the logic around checking for ELEMENT vs TEXT
      // around marking and resetting selections.
      // Unset the common ancestor data


      this._commonAncestor = null; // Ensure we ALWAYS work with text-nodes.

      var endNodeData = dom.getTextNodeFromOffset(selection.endNode, selection.endOffset, false);
      var endNode = endNodeData.targetNode; // Set the text node

      this.endNode = endNode;
      this._endNodeSelector = this.domHelper.getNodeSelector(endNode); // Grab the "true" offset for the text-node

      this._endOffset = dom.getOffsetForTextNode(endNode, this.endNodeContextElement, endNodeData.relativeOffset); // Ensure we ALWAYS work with text-nodes.

      var startNodeData = dom.getTextNodeFromOffset(selection.startNode, selection.startOffset, true);
      var startNode = startNodeData.targetNode; // Set the text node

      this.startNode = startNode; // Grab the selector for the parent-element

      this._startNodeSelector = this.domHelper.getNodeSelector(startNode); // Grab the "true" offset for the text-node

      this._startOffset = dom.getOffsetForTextNode(startNode, this.startNodeContextElement, startNodeData.relativeOffset);
      this.setFresh();
    } // +===================================+
    // | Static implementation starts here |
    // +===================================+

  }], [{
    key: "getNextClientId",
    value:
    /**
     * Returns a unique numeric client-id for the current window and increments the _nextClientId counter by 1.
     * @returns {Number} A unique numeric client-id for the current window.
     */
    function getNextClientId() {
      var nextClientId = this._nextClientId;
      this._nextClientId += 1;
      return nextClientId;
    }
    /**
     * Returns a unique numeric marker-id for the current window and increments the _nextMarkerId counter by 1.
     * @returns {Number} A unique numeric marker-id for the current window.
     */

  }, {
    key: "getNextMarkerId",
    value: function getNextMarkerId() {
      var nextMarkerId = this._nextMarkerId;
      this._nextMarkerId += 1;
      return nextMarkerId;
    }
    /**
     * Returns the selection range from the given selection data.
     * @param {SelectionData} selectionData The selection data to use for defining the range.
     * @returns {?Range} The selection Range instance or `null` if the data is invalid.
     */

  }, {
    key: "getSelectionRange",
    value: function getSelectionRange(selectionData) {
      var selectionRange = new Range();
      var startElement = document.querySelector(selectionData.startNodeSelector);
      var endElement = document.querySelector(selectionData.endNodeSelector);

      if (!startElement || !endElement) {
        // One or both of the elements were NOT found in the DOM.
        // Return nothing.
        return null;
      }

      var startNodeData = dom.getTextNodeFromOffset(startElement, selectionData.startOffset, true);
      selectionRange.setStart(startNodeData.targetNode, startNodeData.relativeOffset);
      var endNodeData = dom.getTextNodeFromOffset(endElement, selectionData.endOffset, false);
      selectionRange.setEnd(endNodeData.targetNode, endNodeData.relativeOffset);
      return selectionRange;
    }
  }]);

  return Selection;
}();

Object(defineProperty["a" /* default */])(selection_Selection, "_nextClientId", 1);

Object(defineProperty["a" /* default */])(selection_Selection, "_nextMarkerId", 1);

/* harmony default export */ var models_selection = (selection_Selection);
// CONCATENATED MODULE: ./src/utils/helpers/selection.js










/* eslint-disable no-underscore-dangle */



/**
 * @typedef {Object} SelectionHelperEventData The {@link SelectionHelper} event data.
 * @property {SelectionHelper} context The `SelectionHelper` context (instance).
 * @property {*} data Any additional data passed by the event. Usually `null`.
 * @property {Selection} selection The `Selection` instance related to the event.
 */

/**
 * SelectionHelper class.
 */

var selection_SelectionHelper = /*#__PURE__*/function () {
  /**
   * @param {Object} options The options to be used by the SelectionHelper instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   *
   * @example
   * const contextEl = document.querySelector('main');
   *
   * const selectionHelper = new SelectionHelper({
   *   contextContainer: contextEl,
   *   ignoredElements: [
   *     'span',
   *     '.nebula-button',
   *   ],
   * });
   *
   * // update from data
   * selectionHelper.updateFromData(...);
   *
   * // or, listen to events
   * selectionHelper.on('select', ...);
   */
  function SelectionHelper(options) {
    _classCallCheck(this, SelectionHelper);

    Object(defineProperty["a" /* default */])(this, "_clientId", void 0);

    Object(defineProperty["a" /* default */])(this, "_domHelper", void 0);

    Object(defineProperty["a" /* default */])(this, "_eventBus", void 0);

    Object(defineProperty["a" /* default */])(this, "_selection", void 0);

    this._clientId = SelectionHelper.getNextClientId();
    this._domHelper = new dom({
      contextContainer: options === null || options === void 0 ? void 0 : options.contextContainer,
      ignoredElements: options === null || options === void 0 ? void 0 : options.ignoredElements,
      nodeSelectors: options === null || options === void 0 ? void 0 : options.nodeSelectors
    });
    this._selection = new models_selection({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    });
    this._eventBus = new tiny_emitter_default.a();
    SelectionHelper.add(this);
  }
  /**
   * Clean up any handlers and registrations for this instance.
   */


  _createClass(SelectionHelper, [{
    key: "clientId",
    get:
    /**
     * The unique client ID of this instance.
     * @type {Number}
     * @readonly
     *
     * @example
     * const selectionHelper = new SelectionHelper();
     *
     * // prints the client-id
     * console.log(selectionHelper.clientId);
     *
     * // throws an exception
     * selectionHelper.clientId = 123;
     */
    function get() {
      return this._clientId;
    }
  }, {
    key: "contextContainer",
    get: function get() {
      return this.domHelper.contextContainer;
    }
    /**
     * The context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     */
    ,
    set: function set(val) {
      this.domHelper.contextContainer = val;
    }
    /**
     * The immediate parent of context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     * @readonly
     */

  }, {
    key: "contextContainerParent",
    get: function get() {
      var _this$contextContaine;

      return ((_this$contextContaine = this.contextContainer) === null || _this$contextContaine === void 0 ? void 0 : _this$contextContaine.parentNode) || null;
    }
    /**
     * The {@link DomHelper} instance used by this selection.
     * @type {DomHelper}
     * @readonly
     */

  }, {
    key: "domHelper",
    get: function get() {
      return this._domHelper;
    }
    /**
     * The event bus for this instance.
     * @type {EventBus}
     * @readonly
     */

  }, {
    key: "eventBus",
    get: function get() {
      return this._eventBus;
    }
    /**
     * The array of ignored element selectors.
     * @type {String[]}
     */

  }, {
    key: "ignoredElements",
    get: function get() {
      return this.domHelper.ignoredElements;
    },
    set: function set(val) {
      this.domHelper.ignoredElements = val;
    }
    /**
     * The node selectors data object.
     * @type {NodeSelectorsData}
     */

  }, {
    key: "nodeSelectors",
    get: function get() {
      return this.domHelper.nodeSelectors;
    },
    set: function set(val) {
      this.domHelper.nodeSelectors = val;
    }
    /**
     * The {@link Selection} instance linked to this helper.
     * @type {Selection}
     * @readonly
     */

  }, {
    key: "selection",
    get: function get() {
      return this._selection;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      SelectionHelper.remove(this.clientId);
    }
    /**
     * Dispatch an event on the event-bus.
     * @private
     * @param {String} eventName The name of the event to dispatch.
     * @param {Any} data The data to pass along into the event data.
     */

  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(eventName, data) {
      this.eventBus.emit(eventName, {
        context: this,
        data: data,
        selection: this.selection
      });
    }
    /**
     * Handler for selection start from the singleton.
     * @private
     * @emits SelectionHelper#selection:start
     */

  }, {
    key: "_onSelectionStart",
    value: function _onSelectionStart() {
      /**
       * Selection start event.
       * @event SelectionHelper#selection:start
       * @type {SelectionHelperEventData}
       */
      this._dispatchEvent('selection:start');
    }
    /**
     * Event handler for 'selection:change' from the singleton.
     * @private
     * @emits SelectionHelper#selection:change
     */

  }, {
    key: "_onSelectionChange",
    value: function _onSelectionChange(selection) {
      this.updateSelection(selection);
      /**
       * Selection change event.
       * @event SelectionHelper#selection:change
       * @type {SelectionHelperEventData}
       */

      this._dispatchEvent('selection:change');
    }
    /**
     * Handler for selection stop from the singleton.
     * @private
     * @emits SelectionHelper#selection:stop
     */

  }, {
    key: "_onSelectionStop",
    value: function _onSelectionStop(selection) {
      this.updateSelection(selection);
      /**
       * Selection stop event.
       * @event SelectionHelper#selection:stop
       * @type {SelectionHelperEventData}
       */

      this._dispatchEvent('selection:stop');
    }
    /**
     * Updates the internal selection object using an external selection object.
     * @param {Selection} selection An instance of `Selection`.
     */

  }, {
    key: "updateSelection",
    value: function updateSelection(selection) {
      var selectionData = selection.getData();

      if (!selectionData.startNode || !selectionData.endNode) {
        // TODO: consider implications of clicking outside the
        // context-container.
        // Blank data. The selection was probably cleared.
        return;
      } // TODO: Should this be part of selection.js instead?


      if (!this.domHelper.isNodeInContextContainer(selectionData.startNode) || !this.domHelper.isNodeInContextContainer(selectionData.endNode)) {
        // TODO: Check whether selection is empty versus is outside of context-container.
        // What happens when only one node is out of range?
        // Keep the old selection data but mark it as stale.
        this.selection.setStale();
        return;
      }

      this.selection.updateFromData(selectionData);
      this.selection.setFresh();
    } // +===================================+
    // | Static implementation starts here |
    // +===================================+

  }], [{
    key: "isLoaded",
    get: function get() {
      return this._isLoaded;
    }
  }, {
    key: "selection",
    get: function get() {
      return this._selection;
    }
    /**
     * Registers the SelectionHelper instance with the singleton for managing it better.
     * This also helps ensure we only attach event-listeners to the DOM only when there
     * are active instances on the page.
     * @param {SelectionHelper} selectionHelper An instance of the SelectionHelper.
     */

  }, {
    key: "add",
    value: function add(selectionHelper) {
      this.selectionHelpers.set(selectionHelper.clientId, selectionHelper);
      this.load(); // Supports updating new selection
      // helpers after the static one
      // is already loaded.

      selectionHelper.updateSelection(this.selection);
    }
    /**
     * Adds event-listeners to the document.
     * @private
     */

  }, {
    key: "_addEventListeners",
    value: function _addEventListeners() {
      var _this = this;

      // Aborting will make the browser remove
      // the event listeners.
      //
      // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
      // > Event listeners can also be removed by passing an AbortSignal
      // > to an addEventListener() and then later calling abort() on the controller
      // > owning the signal.
      //
      // No more binding and unbinding hacks.
      this._eventAbortController = new AbortController();
      var signal = this._eventAbortController.signal;
      document.addEventListener('pointerdown', function (event) {
        return _this._onPointerDown(event);
      }, {
        signal: signal
      });
      document.addEventListener('pointerup', function (event) {
        return _this._onPointerUp(event);
      }, {
        signal: signal
      });
      document.addEventListener('selectionchange', function (event) {
        return _this._onSelectionChange(event);
      }, {
        signal: signal
      });
    }
    /**
     * Helper method to clear all text selections from the page.
     */

  }, {
    key: "clearSelection",
    value: function clearSelection() {
      document.getSelection().empty();
    }
    /**
     * Returns a unique numeric client-id for the current window and increments the nextClientId counter by 1.
     * @returns {Number} A unique numeric client-id for the current window.
     */

  }, {
    key: "getNextClientId",
    value: function getNextClientId() {
      var nextClientId = this._nextClientId;
      this._nextClientId += 1;
      return nextClientId;
    }
    /**
     * This takes in a selection with either single or multiple selection ranges
     * and returns one normalized range across the selection.
     * This is used in cases where some web-browsers like Firefox may return
     * non-contiguous selection ranges causing the selection/highlight to have
     * incorrect offsets.
     * @param {window.Selection} selection A native `window.Selection` object.
     * @returns {?Range} Returns the normalized range object for the given selection, `null` otherwise.
     */

  }, {
    key: "getNormalizedSelectionRange",
    value: function getNormalizedSelectionRange() {
      var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var currentSelection = selection || window.getSelection();
      var rangeCount = currentSelection.rangeCount;

      if (rangeCount < 1) {
        // blank selection
        return null;
      }

      var firstRange = currentSelection.getRangeAt(0);
      var lastRange = currentSelection.getRangeAt(rangeCount - 1);
      var normalizedRange = new Range();
      normalizedRange.setStart(firstRange.startContainer, firstRange.startOffset);
      normalizedRange.setEnd(lastRange.endContainer, lastRange.endOffset);
      return normalizedRange;
    }
    /**
     * Loads and initializes the SelectionHelper singleton. This method can be safely
     * called multiple times as the internal checks ensure that the singleton initializes
     * just once.
     */

  }, {
    key: "load",
    value: function load() {
      if (this.isLoaded) {
        return;
      }

      this._selection = new models_selection(); // Grab whatever is currently selected in
      // the document.

      this.updateSelection();

      this._addEventListeners();

      this._isLoaded = true;
    }
    /**
     * Event handler for the `pointerdown` event.
     * @private
     */

  }, {
    key: "_onPointerDown",
    value: function _onPointerDown() {
      this._isCapturingSelection = true;

      this._onSelectionStart();
    }
    /**
     * Event handler for the `pointerup` event.
     * @private
     */

  }, {
    key: "_onPointerUp",
    value: function _onPointerUp() {
      this._isCapturingSelection = false;
      this.updateSelection();

      this._onSelectionStop();
    }
    /**
     * Event handler for the `selectionchange` event.
     * @private
     */

  }, {
    key: "_onSelectionChange",
    value: function _onSelectionChange() {
      if (!this._isCapturingSelection) {
        return;
      }

      this.updateSelection();
    }
    /**
     * Handler for selection start.
     * @private
     */

  }, {
    key: "_onSelectionStart",
    value: function _onSelectionStart() {
      var _this2 = this;

      this.selectionHelpers.forEach(function (selectionHelper) {
        selectionHelper._onSelectionStart(_this2.selection);
      });
    }
    /**
     * Handler for selection start.
     * @private
     */

  }, {
    key: "_onSelectionStop",
    value: function _onSelectionStop() {
      var _this3 = this;

      this.selectionHelpers.forEach(function (selectionHelper) {
        selectionHelper._onSelectionStop(_this3.selection);
      });
    }
    /**
     * De-registers the SelectionHelper instance with the singleton for managing it better.
     * This helps ensure we clean up any event-listeners attached to the DOM after the last
     * instance has been removed from use on the page.
     * @param {SelectionHelper} selectionHelper An instance of the SelectionHelper.
     */

  }, {
    key: "remove",
    value: function remove(clientId) {
      if (!this.selectionHelpers.has(clientId)) {
        return;
      }

      this.selectionHelpers.delete(clientId);

      if (this.selectionHelpers.size === 0) {
        this.unload();
      }
    }
    /**
     * Removes event listeners from the document
     * @private
     */

  }, {
    key: "_removeEventListeners",
    value: function _removeEventListeners() {
      // Aborting will make the browser remove
      // the event listeners.
      //
      // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
      // > Event listeners can also be removed by passing an AbortSignal
      // > to an addEventListener() and then later calling abort() on the controller
      // > owning the signal.
      //
      // No more binding and unbinding hacks.
      this._eventAbortController.abort();
    }
    /**
     * Unloads the SelectionHelper singleton. This method can be safely called multiple times
     * as the internal checks ensure that the singleton unloads just once.
     */

  }, {
    key: "unload",
    value: function unload() {
      if (!this.isLoaded) {
        return;
      }

      this._removeEventListeners();

      this._selection = null;
      this._isLoaded = false;
    }
    /**
     * Updates the selection data based on the current
     * selection in the window.
     */

  }, {
    key: "updateSelection",
    value: function updateSelection() {
      var _this4 = this;

      var normalizedRange = this.getNormalizedSelectionRange();

      if (!normalizedRange) {
        // blank selection
        this.selection.clearData();
        return;
      }

      this.selection.updateFromRange(normalizedRange);
      this.selectionHelpers.forEach(function (selectionHelper) {
        selectionHelper._onSelectionChange(_this4.selection);
      });
    }
  }]);

  return SelectionHelper;
}();

Object(defineProperty["a" /* default */])(selection_SelectionHelper, "_eventAbortController", void 0);

Object(defineProperty["a" /* default */])(selection_SelectionHelper, "_isCapturingSelection", false);

Object(defineProperty["a" /* default */])(selection_SelectionHelper, "_isLoaded", false);

Object(defineProperty["a" /* default */])(selection_SelectionHelper, "_nextClientId", 1);

Object(defineProperty["a" /* default */])(selection_SelectionHelper, "_selection", null);

Object(defineProperty["a" /* default */])(selection_SelectionHelper, "selectionHelpers", new Map());

/* harmony default export */ var helpers_selection = (selection_SelectionHelper);
// CONCATENATED MODULE: ./src/mixins/text-to-speech.js













var currentlyPlayingComponent = null;
/* harmony default export */ var text_to_speech = ({
  emits: ['tts:speak-text', 'tts:speak-element', 'tts:play', 'tts:pause', 'tts:stop'],
  data: function data() {
    return {
      domControl: null,
      languageCode: null,
      loadTextToSpeech: true,
      readableElements: [],
      readingMath: null,
      textHelpScript: null,
      speechstream: null,
      speechTools: null,
      voiceList: voice_list
    };
  },
  mounted: function mounted() {
    var _this = this;

    return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$languageCode;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.loadTextToSpeech) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return SpeechStreamLoader.init();

            case 4:
              _this.setLanguageCode(_this.getDefaultlanguageCode()); // Get reference to speechstream object


              _this.speechstream = SpeechStreamLoader.speechstream;
              _this.domControl = SpeechStreamLoader.domControl;
              _this.speechTools = SpeechStreamLoader.speechTools;
              _this.ignoredClassList = SpeechStreamLoader.ignoredClassList;
              _this.languageCode = (_this$languageCode = _this.languageCode) !== null && _this$languageCode !== void 0 ? _this$languageCode : _this.getDefaultlanguageCode();

              _this.setVoiceByLanguage(_this.languageCode);

              _this.setupSpeechHighlighting();

              _this.speechTools.setPageCompleteCallback(function () {
                _this.clearMathStyles();

                if (!_this.readableElements.length && _this !== currentlyPlayingComponent) {
                  return;
                }

                if (_this.readableElements.length > 0) {
                  // take out the first element
                  // only shift if we're not reading a mathjax element
                  if (!_this.readingMath) _this.readableElements.shift(); // read the next element.

                  _this.speakElements(_this.readableElements);
                }

                if (_this.eventBus) {
                  _this.eventBus.emit('tts:page-complete', _this.readableElements);
                }
              });

              if (_this.eventBus) {
                _this.eventBus.emit('tts:initialized', _this);
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {
    isSpeaking: function isSpeaking() {
      var _this$speechTools;

      return (_this$speechTools = this.speechTools) === null || _this$speechTools === void 0 ? void 0 : _this$speechTools.isSpeaking();
    },
    isPaused: function isPaused() {
      var _this$speechTools2;

      return (_this$speechTools2 = this.speechTools) === null || _this$speechTools2 === void 0 ? void 0 : _this$speechTools2.isPaused();
    },
    isStopped: function isStopped() {
      return !this.isSpeaking && !this.isPaused;
    },
    hasReadableElements: function hasReadableElements() {
      return this.readableElements.length;
    }
  },
  methods: {
    clearMathStyles: function clearMathStyles() {
      // HACK FOR SPEECHSTREAM
      // Since we're forcing styles on a parent element,
      // once we're done reading that element, we have to set the element style back to what it was.
      // So, we remove any previous styling on MathML elements that have been added.
      var mathEls = Object(toConsumableArray["a" /* default */])(document.querySelectorAll('.MathJax'));

      if (mathEls.length) {
        mathEls.forEach(function (mL) {
          // eslint-disable-next-line no-param-reassign
          mL.style.backgroundColor = 'inherit';
        });
      }
    },
    getDefaultlanguageCode: function getDefaultlanguageCode() {
      return window.initData ? window.initData.locale : document.getElementsByTagName('html')[0].getAttribute('lang');
    },
    setLanguageCode: function setLanguageCode(langCode) {
      // Put lang code into a standardized format. 'en_GB' => 'en-GB'
      this.languageCode = langCode.toLowerCase().replace(/_/, '-');
    },
    setVoiceByLanguage: function setVoiceByLanguage(langCode) {
      // Sets the voice with a matching voice in voice-list.json
      var voiceToUse = {};
      voice_list.forEach(function (voice) {
        voice.language.codes.forEach(function (code) {
          if (code === langCode) {
            voiceToUse = voice;
          }
        });
      });
      this.setVoice(voiceToUse.voice_id);
    },
    setVoice: function setVoice(voiceName) {
      this.speechstream.speechTools.setVoice(voiceName);
    },
    speakText: function speakText(text) {
      // Speaks a text string
      currentlyPlayingComponent = this;
      this.$emit('tts:speak-text', text);
      this.speechstream.speechTools.speakText(text);
    },

    /**
         * Speak text in the element passed to this function.
         *
         * @param {string}      elementSelector Element to speak
         * @param {boolean}     cont            Optional parameter -- If true, continue to next element.
     */
    speakElement: function speakElement(elementSelector) {
      var cont = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var elToSpeak = document.querySelector(elementSelector);
      var ttsLang = elToSpeak.getAttribute('data-tts-lang');

      if (ttsLang) {
        // set voice based on data atrribute
        this.setVoiceByLanguage(ttsLang);
      }

      if (this.isSpeaking) {
        // Stop speech if already speaking. Also clears out highlighting of current word/sentence.
        this.stop();
      }

      if (elToSpeak) {
        currentlyPlayingComponent = this;
        this.$emit('tts:speak-element', elToSpeak);
        this.speechstream.speechTools.speakElement(elToSpeak, cont);
      } // reset to default language code to handle the case
      // where some elements may be set to different languages
      // than the default


      this.setVoiceByLanguage(this.getDefaultlanguageCode());
    },

    /**
     * speakElements passes each item of an array of elements to speakElement
     * and waits to read the next item until all items in array have been read.
     */
    speakElements: function speakElements(elements) {
      var _this2 = this;

      // filter out any elements that should be ignored
      this.readableElements = elements.filter(function (el) {
        return !_this2.ignoredClassList.some(function (className) {
          return el.parentElement.classList.contains(className);
        });
      });
      if (!this.readableElements.length) return;
      var currentElement = this.readableElements[0]; // read the first element in array
      // using speechTools' speakElement function since it takes an element instead of a selector

      this.$emit('tts:play');
      var currentElMathParent = currentElement.closest('.math-formula');

      if (!currentElMathParent) {
        this.readingMath = false;
        this.speechTools.speakElement(this.readableElements[0], false);
      } else {
        // HACK FOR SPEECHSTREAM
        // SpeechStream wraps text nodes with a highlight style IF it can find them
        // since MathMl elements are failing to get highlighted or get read in a continuous loop,
        // we have to tell speechstream to read (and style) a specific element instead.
        // get the MathJax-Element-# to check all other elements against.
        this.readingMath = true;
        var MathJaxId = currentElMathParent.querySelector('[type="math/mml"]').getAttribute('id');
        var MathJaxDisplaySpan = currentElMathParent.querySelector("#".concat(MathJaxId, "-Frame"));
        currentElMathParent.id = "".concat(MathJaxId, "-Wrapper");
        this.readableElements = this.readableElements.filter(function (el) {
          return !el.closest("#".concat(MathJaxId, "-Wrapper"));
        });
        MathJaxDisplaySpan.style.backgroundColor = "".concat(nebula_tokens.tokens.color.teach.primary['400']); // filter all elements that have the same parent out of readable elements

        this.speechTools.speakById("".concat(MathJaxId, "-Wrapper"), false);
      }
    },
    play: function play() {
      var commonAncestor = helpers_selection.selection.commonAncestor;
      var isMathSelection = dom.isNodeInSelector(commonAncestor, '.math-formula');

      if (isMathSelection) {
        var mathEl = commonAncestor.closest('.MathJax');
        mathEl.style.backgroundColor = "".concat(nebula_tokens.tokens.color.teach.primary['400']);
      } // Play any selected text or from beginning of page or from preset element.
      // Selection is set either by user interaction or programmatically


      if (!this.isSpeaking && !this.isPaused) {
        currentlyPlayingComponent = this;
        this.$emit('tts:play');
        this.speechstream.speechTools.play();
      }

      if (this.isSpeaking || this.isPaused) {
        // Pauses any active speech, use this call to start the speech again.
        this.pause();
      }
    },
    pause: function pause() {
      // Pauses any active speech, use this call to start the speech again.
      this.$emit('tts:pause');
      this.speechstream.speechTools.pause();
    },
    stop: function stop() {
      // clear out readable elements array
      if (this.readableElements.length) {
        this.readableElements = [];
      } // Stops any active speech and clears speech highlighting.


      this.$emit('tts:stop');
      this.speechstream.speechTools.stop();
    },
    setupSpeechHighlighting: function setupSpeechHighlighting() {
      this.speechstream.speechTools.setSentenceHighlightStyle('background-color:transparent;');
      this.speechstream.speechTools.setWordHighlightStyle("background-color:".concat(nebula_tokens.tokens.color.teach.primary['400'], ";"));
    }
  },
  beforeUnmount: function beforeUnmount() {
    var ttsScript = document.getElementById('de-tts');

    if (ttsScript) {
      ttsScript.remove();
    }
  }
});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__("dca8");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-int.js
var es_parse_int = __webpack_require__("e25e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.entries.js
var es_object_entries = __webpack_require__("4fad");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__("e9c4");

// CONCATENATED MODULE: ./src/utils/api/notebook/highlight.js









 // Sets the origin for the API URL. Defaults to a blank string `''`
// to generate relative URLs.
//
// Example values that can be expected to be set are:
//   - 'https://app.discoveryeducation.com'
//   - '//app.discoveryeducation.com'
//   - 'https://some.other.domain.tld'
//   - ''
//
// This value CANNOT be set directly. Use the provided `setApiOrigin`
// and `getApiOrigin` helpers to manipulate and read the value.
//

var highlightApiOrigin = '/apiproxy';
var HIGHLIGHT_API_URL_PREFIX = '/v1/notebook/highlight';
function highlight_createHighlight(hightlightData, csrfToken) {
  var apiUrl = "".concat(highlightApiOrigin).concat(HIGHLIGHT_API_URL_PREFIX);
  var formData = new FormData();
  Object.entries(hightlightData).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    // references need to be JSON encoded
    if (key === 'references' && typeof val !== 'string') {
      formData.append(key, JSON.stringify(val));
    } else {
      formData.append(key, val);
    }
  });
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Token': csrfToken
  };
  return axios_default.a.post(apiUrl, formData, {
    headers: headers,
    withCredentials: true
  });
}
function deleteHighlight(highlightId) {
  var apiUrl = "".concat(highlightApiOrigin).concat(HIGHLIGHT_API_URL_PREFIX, "/").concat(highlightId);
  return axios_default.a.delete(apiUrl, {
    withCredentials: true
  });
}
function getApiOrigin() {
  return highlightApiOrigin;
}
function highlight_retrieveAllHighlights(conceptId) {
  var apiUrl = "".concat(highlightApiOrigin).concat(HIGHLIGHT_API_URL_PREFIX);
  return axios_default.a.get(apiUrl, {
    params: {
      concept_id: conceptId
    }
  });
}
/**
 * grab highlights by provided references
 * @param {Array} references list of objects each containing a reference_id and reference_type
 * @returns null
 */

function highlight_retrieveAllHighlightsByReference(references) {
  var apiUrl = "".concat(highlightApiOrigin).concat(HIGHLIGHT_API_URL_PREFIX, "/reference");
  return axios_default.a.get(apiUrl, {
    params: {
      references: JSON.stringify(references)
    }
  });
}
function setApiOrigin() {
  var _newApiOrigin$trim;

  var newApiOrigin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  // Trim the string, replace trailing slashes.
  // Default to blank if falsy.
  highlightApiOrigin = (newApiOrigin === null || newApiOrigin === void 0 ? void 0 : (_newApiOrigin$trim = newApiOrigin.trim()) === null || _newApiOrigin$trim === void 0 ? void 0 : _newApiOrigin$trim.replace(/[/]+$/, '')) || '';
}
function updateHighlight(highlightId, highlightData) {
  var apiUrl = "".concat(highlightApiOrigin).concat(HIGHLIGHT_API_URL_PREFIX, "/").concat(highlightId);
  return axios_default.a.patch(apiUrl, highlightData, {
    withCredentials: true
  });
}
function updateHighlightColor(highlightId, color) {
  var apiUrl = "".concat(highlightApiOrigin).concat(HIGHLIGHT_API_URL_PREFIX, "/").concat(highlightId);
  return axios_default.a.patch(apiUrl, {
    color: color
  }, {
    withCredentials: true
  });
}
/* harmony default export */ var notebook_highlight = ({
  createHighlight: highlight_createHighlight,
  deleteHighlight: deleteHighlight,
  getApiOrigin: getApiOrigin,
  retrieveAllHighlights: highlight_retrieveAllHighlights,
  setApiOrigin: setApiOrigin,
  updateHighlight: updateHighlight,
  updateHighlightColor: updateHighlightColor,
  retrieveAllHighlightsByReference: highlight_retrieveAllHighlightsByReference
});
// CONCATENATED MODULE: ./src/utils/models/highlight.js






















/* eslint-disable no-underscore-dangle */





var highlightPrimaryCssClass = 'de-highlight';
var highlightColor = {
  BLUE: 'blue',
  GREEN: 'green',
  PINK: 'pink',
  YELLOW: 'yellow'
};
Object.freeze(highlightColor);
var highlightColorMeta = new Map(); // BLUE

highlightColorMeta.set(highlightColor.BLUE, {
  color: highlightColor.BLUE,
  css: [highlightPrimaryCssClass, "".concat(highlightPrimaryCssClass, "--blue")],
  legacyCss: ['highlighted', 'hl_blue']
}); // GREEN

highlightColorMeta.set(highlightColor.GREEN, {
  color: highlightColor.GREEN,
  css: [highlightPrimaryCssClass, "".concat(highlightPrimaryCssClass, "--green")],
  legacyCss: ['highlighted', 'hl_green']
}); // PINK

highlightColorMeta.set(highlightColor.PINK, {
  color: highlightColor.PINK,
  css: [highlightPrimaryCssClass, "".concat(highlightPrimaryCssClass, "--pink")],
  legacyCss: ['highlighted', 'hl_pink']
}); // YELLOW

highlightColorMeta.set(highlightColor.YELLOW, {
  color: highlightColor.YELLOW,
  css: [highlightPrimaryCssClass, "".concat(highlightPrimaryCssClass, "--yellow")],
  legacyCss: ['highlighted', 'hl_yellow']
});
/**
 * HighlightEventData
 */

/**
 * @typedef {Object} HighlightEventData The {@link Highlight} event data.
 * @property {Highlight} context The `Highlight` context (instance).
 * @property {*} data Any additional data passed by the event. Usually `null`.
 */

/**
 * Highlight class.
 */

var highlight_Highlight = /*#__PURE__*/function () {
  /**
   * @param {Object} options The options to be used by the Selection instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   */
  function Highlight(options) {
    _classCallCheck(this, Highlight);

    Object(defineProperty["a" /* default */])(this, "_clientId", null);

    Object(defineProperty["a" /* default */])(this, "color", null);

    Object(defineProperty["a" /* default */])(this, "_domHelper", null);

    Object(defineProperty["a" /* default */])(this, "_eventBus", null);

    Object(defineProperty["a" /* default */])(this, "id", null);

    Object(defineProperty["a" /* default */])(this, "metadata", null);

    Object(defineProperty["a" /* default */])(this, "_selection", null);

    Object(defineProperty["a" /* default */])(this, "_selectionText", null);

    this._clientId = Highlight.getNextClientId();
    this._eventBus = new tiny_emitter_default.a();
    this.metadata = {};
    this._domHelper = new dom({
      contextContainer: options === null || options === void 0 ? void 0 : options.contextContainer,
      ignoredElements: options === null || options === void 0 ? void 0 : options.ignoredElements,
      nodeSelectors: options === null || options === void 0 ? void 0 : options.nodeSelectors
    }); // set the default color

    this.setColor(Highlight.color.YELLOW);
    Highlight.add(this);
  }
  /**
   * Updates the data for the highlight from the given save-state data and injects it into the DOM.
   * @param {Object} highlightData The highlight save-state data.
   * @returns {Boolean} Returns a `true` if successful, `false` otherwise.
   */


  _createClass(Highlight, [{
    key: "clientId",
    get: // Only used for rendering on the client
    // ID of highlight in the database (upon save)

    /**
     * The unique client ID of this instance.
     * @type {Number}
     * @readonly
     *
     * @example
     * const highlight = new Highlight();
     *
     * // prints the client-id
     * console.log(highlight.clientId);
     *
     * // throws an exception
     * highlight.clientId = 123;
     */
    function get() {
      return this._clientId;
    }
  }, {
    key: "colorCss",
    get: function get() {
      return Highlight.colorMeta.get(this.color) || null;
    }
    /**
     * The context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     */

  }, {
    key: "contextContainer",
    get: function get() {
      return this.domHelper.contextContainer;
    },
    set: function set(val) {
      this.domHelper.contextContainer = val;
    }
    /**
     * The immediate parent of context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     * @readonly
     */

  }, {
    key: "contextContainerParent",
    get: function get() {
      var _this$contextContaine;

      return ((_this$contextContaine = this.contextContainer) === null || _this$contextContaine === void 0 ? void 0 : _this$contextContaine.parentNode) || null;
    }
  }, {
    key: "domHelper",
    get: function get() {
      return this._domHelper;
    }
    /**
     * The event bus for this instance.
     * @type {EventBus}
     * @readonly
     */

  }, {
    key: "eventBus",
    get: function get() {
      return this._eventBus;
    }
    /**
     * The array of ignored element selectors.
     * @type {String[]}
     */

  }, {
    key: "ignoredElements",
    get: function get() {
      return this.domHelper.ignoredElements;
    },
    set: function set(val) {
      this.domHelper.ignoredElements = val;
    }
    /**
     * The node selectors data object.
     * @type {NodeSelectorsData}
     */

  }, {
    key: "nodeSelectors",
    get: function get() {
      var nodeSelectors = this.domHelper.nodeSelectors;
      return Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, nodeSelectors), {}, {
        selectorPostProcessor: this._selectorPostProcessor
      });
    },
    set: function set(val) {
      this.domHelper.nodeSelectors = val;
    }
    /**
     * The {@link Selection} instance linked to this highlight.
     * @type {Selection}
     * @readonly
     */

  }, {
    key: "selection",
    get: function get() {
      return this._selection;
    }
    /**
     * The text of the highlight.
     * @type {?String}
     * @readonly
     */

  }, {
    key: "text",
    get: function get() {
      return this._selectionText;
    }
  }, {
    key: "createFromData",
    value: function createFromData(highlightData) {
      this.id = highlightData.id || null;
      var selection = new models_selection({
        contextContainer: this.contextContainer,
        ignoredElements: this.ignoredElements,
        nodeSelectors: this.nodeSelectors
      });
      var success = selection.updateFromData({
        startNodeSelector: highlightData.node1,
        startOffset: highlightData.offset1,
        endNodeSelector: highlightData.node2,
        endOffset: highlightData.offset2
      });

      if (!success) {
        return false;
      }

      selection.setStale();
      this._selection = selection;
      this._selectionText = highlightData.selectedText || selection.text || null;
      this.metadata = {
        asset_id: highlightData.assetId,
        concept_id: highlightData.guidConceptId,
        course_id: highlightData.courseGuid,
        relationship_type_id: highlightData.relationshipTypeGuid,
        subdiscipline_id: highlightData.subdisciplineGuid,
        unit_id: highlightData.unitGuid
      };
      var color = highlightData.color.replace(/^hl_/, '');
      this.setColor(color);
      this.createHighlight();
      return true;
    }
    /**
     * Updates the data for the highlight from the selection in the
     * provided `SelectionHelper` instance, sets the appropriate `color`,
     * and injects the highlight into the DOM.
     * @param {Object} highlightData The highlight save-state data.
     * @returns {Boolean} Returns a `true` if successful, `false` otherwise.
     */

  }, {
    key: "createFromSelection",
    value: function createFromSelection(selectionHelper, color) {
      this.updateSelection(selectionHelper);

      if (!this._selection) {
        return false;
      }

      this.setColor(color);
      this.createHighlight();
      return true;
    }
    /**
     * Creates and injects the highlights in the DOM.
     */

  }, {
    key: "createHighlight",
    value: function createHighlight() {
      var _this = this;

      var _this$_selection = this._selection,
          startNode = _this$_selection.startNode,
          startNodeContextElement = _this$_selection.startNodeContextElement,
          startOffset = _this$_selection.startOffset,
          endNode = _this$_selection.endNode,
          endNodeContextElement = _this$_selection.endNodeContextElement,
          endOffset = _this$_selection.endOffset;

      if (!startNode || !endNode) {
        // incorrect selection
        return;
      }

      var relativeStartOffset = dom.getTextNodeFromOffset(startNodeContextElement, startOffset, true).relativeOffset;
      var relativeEndOffset = dom.getTextNodeFromOffset(endNodeContextElement, endOffset, false).relativeOffset; // Clear any text selection on page

      helpers_selection.clearSelection(); // Remove the existing highlight before (re)creating it.

      this.removeHighlight();

      if (startNode === endNode) {
        // we are working within the same text node
        this._injectHighlightElement(startNode, relativeStartOffset, relativeEndOffset);

        return;
      }

      var intermediateTextNodes = this.domHelper.getIntermediateTextNodes(startNode, endNode);

      if (intermediateTextNodes.length) {
        intermediateTextNodes.forEach(function (intermediateTextNode) {
          _this._injectHighlightElement(intermediateTextNode);
        });
      }

      this._injectHighlightElement(startNode, relativeStartOffset, null);

      this._injectHighlightElement(endNode, 0, relativeEndOffset);
    } // TODO: How to enforce NOT reusing deleted/stale instances?

    /**
     * Deletes a highlight from the database, and removes it from the DOM and state-management in memory.
     * @returns {Boolean} Returns `true` if a highlight was found and deleted, `false` otherwise.
     */

  }, {
    key: "delete",
    value: function () {
      var _delete2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.deselect();
                this.removeHighlight();
                Highlight.remove(this.clientId);

                if (this.id) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", false);

              case 5:
                return _context.abrupt("return", deleteHighlight(this.id));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
    /**
     * DeSelects/makes inactive a currently active highlight on the screen.
     * @emits Highlight#deselect
     */

  }, {
    key: "deselect",
    value: function deselect() {
      if (Highlight.activeHighlight === this) {
        Highlight._setActiveHighlight(null);
      }

      this.getHighlightElements().forEach(function (highlightElement) {
        return highlightElement.classList.remove('de-highlight--selected');
      });
      /**
       * Highlight deselected event.
       * @event Highlight#deselect
       * @type {HighlightEventData}
       */

      this._dispatchEvent('deselect');
    } // TODO: How to enforce NOT reusing destroyed/stale instances?

    /**
     * Helper to clean up highlights from the DOM and memory. This method
     * does NOT delete the highlight from the database. If that is your
     * intention, use `.delete()` instead.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.deselect();
      this.removeHighlight();
      Highlight.remove(this.clientId);
    }
    /**
     * Dispatch an event on the event-bus.
     * @private
     * @param {String} eventName The name of the event to dispatch.
     * @param {Object} [data] The data to pass along into the event data.
     */

  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(eventName) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var mergedData = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, data), {}, {
        highlight: this
      });

      this.eventBus.emit(eventName, {
        context: this,
        data: mergedData
      });
    }
    /**
     * Get the highlight-data that is used to save state to the DB.
     * @returns {Object} The highlight data to be used in a save-state.
     */

  }, {
    key: "getData",
    value: function getData() {
      var metadata = this.metadata || {};
      var assetId = metadata.asset_id || null; // check the references to see if there is an asset there

      if (!assetId && metadata.references) {
        var asset = metadata.references.find(function (item) {
          return item.reference_type === 'asset';
        });

        if (asset) {
          assetId = asset.reference_id;
        }
      }

      if (!assetId) {
        var _this$_domHelper$getP;

        // TODO: (future work) Make this more resilient in the future.
        // This is how the TB needs to grab the asset-id.
        assetId = ((_this$_domHelper$getP = this._domHelper.getParentElements(this._selection.startNode, '.cit-row')[0]) === null || _this$_domHelper$getP === void 0 ? void 0 : _this$_domHelper$getP.dataset.guid) || null;
      }

      var data = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, metadata), {}, {
        id: this.id,
        node_1: this._selection.startNodeSelector,
        offset_1: this._selection.startOffset,
        node_2: this._selection.endNodeSelector,
        offset_2: this._selection.endOffset,
        asset_id: assetId,
        color: "hl_".concat(this.color),
        selected_text: this._selectionText,
        references: metadata.references || []
      });

      return data;
    }
    /**
     * The API saves data in snake-case but returns it in camel-case.
     * This is our attempt to normalize some of the data on the FE when manipulating it.
     * @returns {Object} Camel-case data.
     */

  }, {
    key: "getDataCamelCase",
    value: function getDataCamelCase() {
      var data = this.getData();

      var camelCaseData = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, data), {}, {
        node1: data.node_1,
        offset1: data.offset_1,
        node2: data.node_2,
        offset2: data.offset_2,
        assetId: data.asset_id,
        courseGuid: data.course_id,
        guidConceptId: data.concept_id,
        relationshipTypeGuid: data.relationship_type_id,
        subdisciplineGuid: data.subdiscipline_id,
        unitGuid: data.unit_id
      });

      var dedupKeys = ['node_1', 'offset_1', 'node_2', 'offset_2', 'asset_id', 'course_id', 'concept_id', 'relationship_type_id', 'subdiscipline_id', 'unit_id'];
      dedupKeys.forEach(function (key) {
        return delete camelCaseData[key];
      });
      return camelCaseData;
    }
    /**
     * Grabs all the elements in the DOM corresponding to the current highlight.
     * @returns {NodeList} Returns a NodeList of all the elements in the DOM for the current highlight.
     */

  }, {
    key: "getHighlightElements",
    value: function getHighlightElements() {
      var escapedClientId = CSS.escape(this.clientId);
      var selector = ".de-highlight[data-highlight-client-id=\"".concat(escapedClientId, "\"]");
      return Object(toConsumableArray["a" /* default */])(document.querySelectorAll(selector));
    }
    /**
     * Inject the highlight element on the given node with optional start and end offsets.
     * @private
     * @param {Node} node The text node to inject the highlight into.
     * @param {Number} [startOffset] An optional start offset.
     * @param {Number} [endOffset] An optional end offset.
     */

  }, {
    key: "_injectHighlightElement",
    value: function _injectHighlightElement(node) {
      var _highlightElement$cla;

      var startOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var endOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var highlightElement = document.createElement('mark');

      if (startOffset !== null && endOffset !== null && startOffset === endOffset) {
        // zero-length injection
        // ignore and return
        return;
      }

      (_highlightElement$cla = highlightElement.classList).add.apply(_highlightElement$cla, Object(toConsumableArray["a" /* default */])(this.colorCss.css.concat(this.colorCss.legacyCss)));

      highlightElement.setAttribute('data-highlight-client-id', this.clientId);

      if (this.id) {
        highlightElement.setAttribute('data-highlight-id', this.id);
      }

      highlightElement.setAttribute('tabindex', '0');
      dom.injectElementInNode(node, highlightElement, startOffset, endOffset);
    }
    /**
     * Remove the current highlight elements from the DOM.
     */

  }, {
    key: "removeHighlight",
    value: function removeHighlight() {
      var highlightElems = this.getHighlightElements();
      highlightElems.forEach(function (highlightElem) {
        var content = highlightElem.innerHTML;
        dom.replaceNodeWithContent(highlightElem, content);
      });
    }
    /**
     * Save the current highlight to the database.
     * @param {String} csrfToken The CSRF token for the request.
     * @returns {Promise} The promise from the appropriate underlying axios calls.
     */

  }, {
    key: "save",
    value: function () {
      var _save = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(csrfToken) {
        var _this2 = this;

        var data, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = this.getData();

                if (!this.id) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", updateHighlight(this.id, data));

              case 3:
                if (!this.id && 'id' in data) {
                  delete data.id;
                } // send api call


                _context2.next = 6;
                return highlight_createHighlight(data, csrfToken);

              case 6:
                response = _context2.sent;
                this.id = response.data.id; // Update the highlight element attribute with the id on save.

                this.getHighlightElements().forEach(function (highlightElement) {
                  highlightElement.setAttribute('data-highlight-id', _this2.id);
                });
                return _context2.abrupt("return", response.data);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function save(_x) {
        return _save.apply(this, arguments);
      }

      return save;
    }()
    /**
     * Selects/makes active a current highlight on the screen. Implicitly dispatches a 'select' event on the instance as well.
     * @emits Highlight#select
     */

  }, {
    key: "select",
    value: function select() {
      Highlight._setActiveHighlight(this);

      this.getHighlightElements().forEach(function (highlightElement) {
        return highlightElement.classList.add('de-highlight--selected');
      });
      /**
       * Highlight selected event.
       * @event Highlight#select
       * @type {HighlightEventData}
       */

      this._dispatchEvent('select');
    }
    /**
     * The selector post-processor used to generate the correct data for highlighting save-states.
     * @private
     * @param {Node} node The current element being processed.
     * @param {Object} selectorData
     * @returns {?String} The string selector to use, or `null` to ignore the current element.
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "_selectorPostProcessor",
    value: function _selectorPostProcessor(node, selectorData) {
      var _updatedSelectorData$, _targetElement$localN;

      // cloning the data
      var updatedSelectorData = {
        primary: Object(objectSpread2["a" /* default */])({}, selectorData.primary),
        intermediate: Object(objectSpread2["a" /* default */])({}, selectorData.intermediate),
        target: Object(objectSpread2["a" /* default */])({}, selectorData.target)
      };
      var primaryElement = updatedSelectorData === null || updatedSelectorData === void 0 ? void 0 : (_updatedSelectorData$ = updatedSelectorData.primary) === null || _updatedSelectorData$ === void 0 ? void 0 : _updatedSelectorData$.element;

      if (!primaryElement) {
        return selectorData;
      }

      var primaryElementId = primaryElement === null || primaryElement === void 0 ? void 0 : primaryElement.id;

      if (primaryElementId) {
        // use the ID if available
        // e.g. #cit--676bb579-7027-4f56-9c99-7a72b04e7948
        updatedSelectorData.primary.selector = "#".concat(primaryElementId);
      }

      var targetElement = selectorData.target.element;
      var nodeName = (_targetElement$localN = targetElement.localName) === null || _targetElement$localN === void 0 ? void 0 : _targetElement$localN.trim().toLowerCase();
      var nthChildString = dom.getNthChildString(targetElement); // e.g. '> p:nth-child(7)'

      var targetSelector = "> ".concat(nodeName).concat(nthChildString);
      updatedSelectorData.target.selector = targetSelector;
      return updatedSelectorData;
    }
    /**
     * Set the current highlight color.
     * @param {String} color The highlight color.
     */

  }, {
    key: "setColor",
    value: function setColor(color) {
      var oldColor = this.color;

      if (color === oldColor) {
        return;
      }

      var isValidColor = Highlight.colorMeta.has(color);

      if (isValidColor) {
        this.color = color;
      } else {
        this.color = oldColor || Highlight.color.YELLOW;
      }

      var highlightElements = this.getHighlightElements();
      highlightElements.forEach(function (element) {
        element.classList.remove("de-highlight--".concat(oldColor), "hl_".concat(oldColor));
        element.classList.add("de-highlight--".concat(color), "hl_".concat(color));
      });
    }
    /**
     * Attempts to update the highlight instance using the provided data object.
     * @param {Object} highlightData The highlight data-object.
     * @returns {Boolean} Returns `true` if successful, `false` otherwise.
     */

  }, {
    key: "updateFromData",
    value: function updateFromData(highlightData) {
      this.id = highlightData.id || null;
      this.removeHighlight();
      var selection = new models_selection({
        contextContainer: this.contextContainer,
        ignoredElements: this.ignoredElements,
        nodeSelectors: this.nodeSelectors
      });
      var success = selection.updateFromData({
        startNodeSelector: highlightData.node1,
        startOffset: highlightData.offset1,
        endNodeSelector: highlightData.node2,
        endOffset: highlightData.offset2
      });

      if (!success) {
        return false;
      }

      selection.setStale();
      this._selection = selection;
      this._selectionText = highlightData.selectedText || selection.text || null;
      this.metadata = {
        asset_id: highlightData.assetId,
        concept_id: highlightData.guidConceptId,
        course_id: highlightData.courseGuid,
        relationship_type_id: highlightData.relationshipTypeGuid,
        subdiscipline_id: highlightData.subdisciplineGuid,
        unit_id: highlightData.unitGuid
      };
      var color = highlightData.color.replace(/^hl_/, '');
      this.setColor(color);
      this.createHighlight();
      return true;
    }
    /**
     * This method retrieves a copy of the text-selection
     * object at runtime. This is needed because the original
     * selection object is mutable and changes instantly as the
     * user clicks around the window. We do NOT want our data
     * to change in the middle of processing the highlight.
     * @returns {object} An object with a copy `startNode`, `startOffset`, `endNode`, `endOffset` from the text selection on the page.
    */

  }, {
    key: "updateSelection",
    value: function updateSelection(selectionHelper) {
      var selection = selectionHelper.selection;
      var selectionCopy = new models_selection({
        contextContainer: this.contextContainer,
        ignoredElements: this.ignoredElements,
        nodeSelectors: this.nodeSelectors
      });
      selectionCopy.nodeSelectors = this.nodeSelectors;
      selectionCopy.updateFromData({
        startNodeSelector: selection.startNodeSelector,
        startOffset: selection.startOffset,
        endNodeSelector: selection.endNodeSelector,
        endOffset: selection.endOffset
      });
      selectionCopy.setStale();
      this._selection = selectionCopy;
      this._selectionText = selectionCopy.text;

      if (this._domHelper.isNodeInIgnoredList(selection.startNode) || this._domHelper.isNodeInIgnoredList(selection.endNode)) {
        this._selection = null;
      }
    } // +===================================+
    // | Static implementation starts here |
    // +===================================+

  }], [{
    key: "activeHighlight",
    get:
    /**
     * Get the active highlight selected in the memory/DOM.
     * Read-only property. To set the active highlight, call
     * `.select()` on the appropriate highlight.
     * @readonly
     * @type {Highlight}
     */
    function get() {
      return this._activeHighlight;
    }
    /**
     * The highlight Color enum. This should (relatively closely) match the color
     * string identifiers used in highlighting and the highlight data.
     * @static
     * @constant
     * @type {Object}
     */

  }, {
    key: "color",
    get: function get() {
      return highlightColor;
    }
    /**
     * A `Map` of the color and various metadata associated with them.
     * @static
     * @constant
     * @type {Map}
     */

  }, {
    key: "colorMeta",
    get: function get() {
      return highlightColorMeta;
    }
    /**
     * A map of the highlights currently available on the page. The keys are based on `clientId`.
     * @static
     * @readonly
     * @type {Map}
     */

  }, {
    key: "highlights",
    get: function get() {
      return this._highlights;
    }
    /**
     * Registers the Highlight instance with the singleton for managing it better.
     * This also helps ensure we only attach event-listeners when there are active
     * instances on the page.
     * @param {Highlight} highlight An instance of the Highlight.
     */

  }, {
    key: "add",
    value: function add(highlight) {
      this.highlights.set(highlight.clientId, highlight);
    }
    /**
     * Batch deletes a the given set of highlights.
     * WARNING: This operation is non-atomic.
     * TODO: Work with BE to update the API to make these operations atomic.
     * @param {Array} highlights An array of highlight objects to delete from the database.
     * @returns {Promise} A promise to hook into to know when the delete completes (or fails).
     */

  }, {
    key: "batchDelete",
    value: function () {
      var _batchDelete = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(highlights) {
        var deletePromises;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                deletePromises = [];
                highlights.forEach(function (highlight) {
                  deletePromises.push(highlight.delete());
                });
                return _context3.abrupt("return", Promise.all(deletePromises));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function batchDelete(_x2) {
        return _batchDelete.apply(this, arguments);
      }

      return batchDelete;
    }()
    /**
     * Get an active `Highlight` instance from the given client-id.
     * @param {Number} highlightClientId The client-id for the requested highlighted.
     * @returns {?Highlight} Returns the matching `Highlight` instance or `null` if not found.
     */

  }, {
    key: "getByClientId",
    value: function getByClientId(highlightClientId) {
      var parsedHighlightClientId = parseInt(highlightClientId, 10);
      var highlight = this.highlights.get(parsedHighlightClientId) || null;
      return highlight;
    }
    /**
     * Returns a unique numeric client-id for the current window and increments the nextClientId counter by 1.
     * @returns {Number} A unique numeric client-id for the current window.
     */

  }, {
    key: "getNextClientId",
    value: function getNextClientId() {
      var nextClientId = this._nextClientId;
      this._nextClientId += 1;
      return nextClientId;
    }
    /**
     * Retrieve the associated highlight object from a given node in the DOM.
     * @param {Node} node The node front which to retrieve the highlight.
     * @returns {?Highlight} The highlight instance, or `null` if not found.
     */

  }, {
    key: "getHighlightFromNode",
    value: function getHighlightFromNode(node) {
      var retVal = {
        highlight: null,
        highlightElement: null
      };

      if (!node) {
        // If the node is invalid, return null.
        return retVal;
      }

      var element = dom.isElementNode(node) ? node : node.parentElement;

      if (!element.classList.contains('de-highlight')) {
        // If the element is NOT a highlight, return null.
        return retVal;
      } // Grab the client-id and parse it as an integer.


      var highlightClientId = parseInt(element.getAttribute('data-highlight-client-id'), 10); // Capture the highlight based on the client-id.

      var highlight = this.getByClientId(highlightClientId);

      if (highlight) {
        retVal.highlight = highlight;
        retVal.highlightElement = element;
      }

      return retVal;
    }
    /**
     * Unregisters the Highlight instance with the singleton for managing it better.
     * This helps ensure we clean up any attached event-listeners after the last
     * instance has been removed from use on the page.
     * @param {Number} clientId The client-id of an instance of Highlight.
     */

  }, {
    key: "remove",
    value: function remove(clientId) {
      var highlight = this.highlights.get(clientId);

      if (!highlight) {
        return;
      }

      this.highlights.delete(clientId);
    }
    /**
     * Remove all highlights from the DOM.
     */

  }, {
    key: "removeAll",
    value: function removeAll() {
      this.highlights.forEach(function (highlight) {
        highlight.destroy();
      });
    }
    /**
     * Sets (or unsets) the active highlight being tracked on screen. Passing `null` unsets it.
     * This method is NOT to be called directly. Use the `.select()` and `.deselect()` methods
     * on the highlight instance instead.
     * @private
     * @param {Highlight} highlight The highlight instance.
     */

  }, {
    key: "_setActiveHighlight",
    value: function _setActiveHighlight(highlight) {
      var oldHighlight = this.activeHighlight;

      if (highlight === oldHighlight) {
        return;
      }

      if (oldHighlight) {
        this._activeHighlight = null;
        oldHighlight.deselect();
      }

      if (!highlight) {
        return;
      }

      this._activeHighlight = highlight;
    }
  }]);

  return Highlight;
}();

Object(defineProperty["a" /* default */])(highlight_Highlight, "_activeHighlight", null);

Object(defineProperty["a" /* default */])(highlight_Highlight, "_highlights", new Map());

Object(defineProperty["a" /* default */])(highlight_Highlight, "_nextClientId", 1);

/* harmony default export */ var models_highlight = (highlight_Highlight);
// CONCATENATED MODULE: ./src/utils/helpers/highlight.js

















/* eslint-disable no-underscore-dangle */






var highlight_HighlightHelper = /*#__PURE__*/function () {
  /**
   * @param {Object} options The options to be used by the Selection instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   */
  function HighlightHelper(options) {
    _classCallCheck(this, HighlightHelper);

    Object(defineProperty["a" /* default */])(this, "_clientId", null);

    Object(defineProperty["a" /* default */])(this, "_domHelper", null);

    Object(defineProperty["a" /* default */])(this, "_eventBus", null);

    this._clientId = HighlightHelper.getNextClientId();
    this._eventBus = new tiny_emitter_default.a();
    this._domHelper = new dom({
      contextContainer: options === null || options === void 0 ? void 0 : options.contextContainer,
      ignoredElements: options === null || options === void 0 ? void 0 : options.ignoredElements,
      nodeSelectors: options === null || options === void 0 ? void 0 : options.nodeSelectors
    });
    HighlightHelper.add(this);
  }
  /**
   * Create a new highlight from the given save-state data and inject it into the DOM.
   * @param {Object} highlightData The highlight save-state data.
   * @returns {?Highlight} Returns a new instance of `Highlight` if successful, `null` otherwise.
   */


  _createClass(HighlightHelper, [{
    key: "clientId",
    get:
    /**
     * The unique client ID of this instance.
     * @type {Number}
     * @readonly
     *
     * @example
     * const highlightHelper = new HighlightHelper();
     *
     * // prints the client-id
     * console.log(highlightHelper.clientId);
     *
     * // throws an exception
     * highlightHelper.clientId = 123;
     */
    function get() {
      return this._clientId;
    }
    /**
     * The context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     */

  }, {
    key: "contextContainer",
    get: function get() {
      return this.domHelper.contextContainer;
    },
    set: function set(val) {
      this.domHelper.contextContainer = val;
    }
    /**
     * The immediate parent of context-container to which this instance is bound to.
     * @type {Node.ELEMENT_NODE}
     * @readonly
     */

  }, {
    key: "contextContainerParent",
    get: function get() {
      var _this$contextContaine;

      return ((_this$contextContaine = this.contextContainer) === null || _this$contextContaine === void 0 ? void 0 : _this$contextContaine.parentNode) || null;
    }
    /**
     * The {@link DomHelper} instance used by this selection.
     * @type {DomHelper}
     * @readonly
     */

  }, {
    key: "domHelper",
    get: function get() {
      return this._domHelper;
    }
    /**
     * The event bus for this instance.
     * @type {EventBus}
     * @readonly
     */

  }, {
    key: "eventBus",
    get: function get() {
      return this._eventBus;
    }
    /**
     * The array of ignored element selectors.
     * @type {String[]}
     */

  }, {
    key: "ignoredElements",
    get: function get() {
      return this.domHelper.ignoredElements;
    },
    set: function set(val) {
      this.domHelper.ignoredElements = val;
    }
    /**
     * The node selectors data object.
     * @type {NodeSelectorsData}
     */

  }, {
    key: "nodeSelectors",
    get: function get() {
      return this.domHelper.nodeSelectors;
    },
    set: function set(val) {
      this.domHelper.nodeSelectors = val;
    }
  }, {
    key: "createFromData",
    value: function createFromData(highlightData) {
      var highlight = new models_highlight({
        contextContainer: this.contextContainer,
        ignoredElements: this.ignoredElements,
        nodeSelectors: this.nodeSelectors
      });
      var success = highlight.createFromData(highlightData);

      if (!success) {
        return null;
      }

      return highlight;
    }
    /**
     * Create or update the highlight with the given information.
     * WARNING: This method creates multiple axios requests in non-atomic operations.
     * TODO: Work with BE to make these operations atomic.
     * @param {SelectionHelper} selectionHelper The selection helper to use for creating/updating the highlight.
     * @param {String} color A valid highlight color string. See `Highlight.color` for details.
     * @param {Object} metadata The metadata related to the highlight.
     * @param {String} csrfToken The CSRF token to use with the API requests.
     * @returns {Promise} Returns a promise.
     */

  }, {
    key: "createOrUpdate",
    value: function () {
      var _createOrUpdate = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(selectionHelper, color, metadata, csrfToken) {
        var highlightState, startNodeCompleteOverlap, startNodeHighlight, endNodeCompleteOverlap, endNodeHighlight, intermediateHighlights, updatedSelectionHelper, selection, highlight, success, startNodeHighlightData, newHighlight, endNodeHighlightData, _newHighlight, _startNodeHighlightData, _endNodeHighlightData, _newHighlight2, _startNodeHighlightData2, originalNode, originalStartOffset, _newHighlight3, _originalNode, originalOffset, _newHighlight4, endOffset, middleHighlight, middleHighlightEndNodeSelector, middleHighlightEndOffset, middleHighlightData, endHighlight;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                highlightState = HighlightHelper.state;
                startNodeCompleteOverlap = highlightState.startNodeCompleteOverlap, startNodeHighlight = highlightState.startNodeHighlight, endNodeCompleteOverlap = highlightState.endNodeCompleteOverlap, endNodeHighlight = highlightState.endNodeHighlight, intermediateHighlights = highlightState.intermediateHighlights;
                updatedSelectionHelper = new helpers_selection({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                }); // This helps us to change the selections frame-of-reference.
                // It auto-updates the selectors and true offsets based on
                // the current instances' settings.

                updatedSelectionHelper.updateSelection(selectionHelper.selection);
                selection = updatedSelectionHelper.selection;
                _context.next = 7;
                return models_highlight.batchDelete(intermediateHighlights);

              case 7:
                if (!(!startNodeHighlight && !endNodeHighlight)) {
                  _context.next = 15;
                  break;
                }

                // Fresh highlight, no complications
                highlight = new models_highlight({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                });
                success = highlight.createFromSelection(updatedSelectionHelper, color);

                if (success) {
                  _context.next = 13;
                  break;
                }

                // Highlighting failed.
                // Remove any orphan data.
                highlight.delete();
                return _context.abrupt("return", false);

              case 13:
                highlight.metadata = metadata;
                return _context.abrupt("return", highlight.save(csrfToken));

              case 15:
                if (!(startNodeHighlight && !endNodeHighlight)) {
                  _context.next = 31;
                  break;
                }

                startNodeHighlightData = startNodeHighlight.getDataCamelCase();

                if (!(color === startNodeHighlight.color || startNodeCompleteOverlap)) {
                  _context.next = 23;
                  break;
                }

                // same color - extend the highlight
                startNodeHighlightData.node2 = selection.endNodeSelector;
                startNodeHighlightData.offset2 = selection.endOffset;
                startNodeHighlightData.color = color; // update from data

                startNodeHighlight.updateFromData(startNodeHighlightData);
                return _context.abrupt("return", startNodeHighlight.save(csrfToken));

              case 23:
                // different color - split highlight
                //
                startNodeHighlightData.offset2 = selection.startOffset; // update from data

                startNodeHighlight.updateFromData(startNodeHighlightData);
                _context.next = 27;
                return startNodeHighlight.save(csrfToken);

              case 27:
                // Create new highlight
                newHighlight = new models_highlight({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                });
                newHighlight.createFromData({
                  node1: startNodeHighlightData.node2,
                  offset1: startNodeHighlightData.offset2,
                  node2: selection.endNodeSelector,
                  offset2: selection.endOffset,
                  color: color
                });
                newHighlight.metadata = metadata;
                return _context.abrupt("return", newHighlight.save(csrfToken));

              case 31:
                if (!(!startNodeHighlight && endNodeHighlight)) {
                  _context.next = 47;
                  break;
                }

                endNodeHighlightData = endNodeHighlight.getDataCamelCase();

                if (!(color === endNodeHighlight.color || endNodeCompleteOverlap)) {
                  _context.next = 39;
                  break;
                }

                // same color - extend the highlight
                endNodeHighlightData.node1 = selection.startNodeSelector;
                endNodeHighlightData.offset1 = selection.startOffset;
                endNodeHighlightData.color = color; // update from data

                endNodeHighlight.updateFromData(endNodeHighlightData);
                return _context.abrupt("return", endNodeHighlight.save(csrfToken));

              case 39:
                // different color - split highlight
                //
                endNodeHighlightData.offset1 = selection.endOffset; // update from data

                endNodeHighlight.updateFromData(endNodeHighlightData);
                _context.next = 43;
                return endNodeHighlight.save(csrfToken);

              case 43:
                // Create new highlight
                _newHighlight = new models_highlight({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                });

                _newHighlight.createFromData({
                  node1: selection.startNodeSelector,
                  offset1: selection.startOffset,
                  node2: endNodeHighlightData.node1,
                  offset2: endNodeHighlightData.offset1,
                  color: color
                });

                _newHighlight.metadata = metadata;
                return _context.abrupt("return", _newHighlight.save(csrfToken));

              case 47:
                if (!(startNodeHighlight && endNodeHighlight && startNodeHighlight !== endNodeHighlight)) {
                  _context.next = 132;
                  break;
                }

                _startNodeHighlightData = startNodeHighlight.getDataCamelCase();
                _endNodeHighlightData = endNodeHighlight.getDataCamelCase();

                if (!(!startNodeCompleteOverlap && !endNodeCompleteOverlap)) {
                  _context.next = 89;
                  break;
                }

                if (!(color !== startNodeHighlight.color && color !== endNodeHighlight.color)) {
                  _context.next = 64;
                  break;
                }

                // different color
                // shorten start
                _startNodeHighlightData.offset2 = selection.startOffset; // update from data

                startNodeHighlight.updateFromData(_startNodeHighlightData);
                _context.next = 56;
                return startNodeHighlight.save(csrfToken);

              case 56:
                // shorten end
                _endNodeHighlightData.offset1 = selection.endOffset; // update from data

                endNodeHighlight.updateFromData(_endNodeHighlightData);
                _context.next = 60;
                return endNodeHighlight.save(csrfToken);

              case 60:
                // Create new highlight
                _newHighlight2 = new models_highlight({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                });

                _newHighlight2.createFromData({
                  node1: _startNodeHighlightData.node2,
                  offset1: _startNodeHighlightData.offset2,
                  node2: _endNodeHighlightData.node1,
                  offset2: _endNodeHighlightData.offset1,
                  color: color
                }); // TODO: cleanup the metadata mess


                _newHighlight2.metadata = metadata;
                return _context.abrupt("return", _newHighlight2.save(csrfToken));

              case 64:
                if (!(color === startNodeHighlight.color && startNodeHighlight.color === endNodeHighlight.color)) {
                  _context.next = 71;
                  break;
                }

                // same color both
                // extend start
                // delete end
                // merge notes
                // TODO: (future work) preserve end-highlight note
                _startNodeHighlightData.node2 = _endNodeHighlightData.node2;
                _startNodeHighlightData.offset2 = _endNodeHighlightData.offset2; // delete end highlight

                _context.next = 69;
                return endNodeHighlight.delete();

              case 69:
                // update from data
                startNodeHighlight.updateFromData(_startNodeHighlightData);
                return _context.abrupt("return", startNodeHighlight.save(csrfToken));

              case 71:
                if (!(color === startNodeHighlight.color && startNodeHighlight.color !== endNodeHighlight.color)) {
                  _context.next = 80;
                  break;
                }

                // same color start
                // extend start
                // shorten end
                // shorten end
                _endNodeHighlightData.offset1 = selection.endOffset; // update from data

                endNodeHighlight.updateFromData(_endNodeHighlightData);
                _context.next = 76;
                return endNodeHighlight.save(csrfToken);

              case 76:
                // extend start
                _startNodeHighlightData.node2 = _endNodeHighlightData.node1;
                _startNodeHighlightData.offset2 = _endNodeHighlightData.offset1; // update from data

                startNodeHighlight.updateFromData(_startNodeHighlightData);
                return _context.abrupt("return", startNodeHighlight.save(csrfToken));

              case 80:
                if (!(color === endNodeHighlight.color && startNodeHighlight.color !== endNodeHighlight.color)) {
                  _context.next = 89;
                  break;
                }

                // same color end
                // shorten start
                // extend end
                // shorten start
                _startNodeHighlightData.offset2 = selection.startOffset; // update from data

                startNodeHighlight.updateFromData(_startNodeHighlightData);
                _context.next = 85;
                return startNodeHighlight.save(csrfToken);

              case 85:
                // extend end
                _endNodeHighlightData.node1 = _startNodeHighlightData.node2;
                _endNodeHighlightData.offset1 = _startNodeHighlightData.offset2; // update from data

                endNodeHighlight.updateFromData(_endNodeHighlightData);
                return _context.abrupt("return", endNodeHighlight.save(csrfToken));

              case 89:
                if (!(startNodeCompleteOverlap && !endNodeCompleteOverlap)) {
                  _context.next = 106;
                  break;
                }

                if (!(color === endNodeHighlight.color)) {
                  _context.next = 98;
                  break;
                }

                // one big highlight with end highlight deleted
                _startNodeHighlightData.node2 = _endNodeHighlightData.node2;
                _startNodeHighlightData.offset2 = _endNodeHighlightData.offset2; // delete end highlight

                _context.next = 95;
                return endNodeHighlight.delete();

              case 95:
                // update from data
                startNodeHighlight.updateFromData(_startNodeHighlightData);
                startNodeHighlight.setColor(color);
                return _context.abrupt("return", startNodeHighlight.save(csrfToken));

              case 98:
                // different color
                // shorten end
                // extend start w/ new color
                // shorten end
                _endNodeHighlightData.offset1 = selection.endOffset; // update from data

                endNodeHighlight.updateFromData(_endNodeHighlightData);
                _context.next = 102;
                return endNodeHighlight.save(csrfToken);

              case 102:
                // extend start w/ new color
                _startNodeHighlightData.offset2 = selection.endOffset; // update from data

                startNodeHighlight.updateFromData(_startNodeHighlightData);
                startNodeHighlight.setColor(color);
                return _context.abrupt("return", startNodeHighlight.save(csrfToken));

              case 106:
                if (!(!startNodeCompleteOverlap && endNodeCompleteOverlap)) {
                  _context.next = 124;
                  break;
                }

                if (!(color === startNodeHighlight.color)) {
                  _context.next = 115;
                  break;
                }

                // one big highlight with end highlight deleted
                _startNodeHighlightData.node2 = _endNodeHighlightData.node2;
                _startNodeHighlightData.offset2 = _endNodeHighlightData.offset2; // delete end highlight

                _context.next = 112;
                return endNodeHighlight.delete();

              case 112:
                // update from data
                startNodeHighlight.updateFromData(_startNodeHighlightData);
                startNodeHighlight.setColor(color);
                return _context.abrupt("return", startNodeHighlight.save(csrfToken));

              case 115:
                // different color
                // shorten start
                // extend end w/ new color
                // shorten start
                _startNodeHighlightData.offset2 = selection.startOffset; // update from data

                startNodeHighlight.updateFromData(_startNodeHighlightData);
                _context.next = 119;
                return startNodeHighlight.save(csrfToken);

              case 119:
                // extend end w/ new color
                // extend end
                _endNodeHighlightData.node1 = _startNodeHighlightData.node2;
                _endNodeHighlightData.offset1 = _startNodeHighlightData.offset2; // update from data

                endNodeHighlight.updateFromData(_endNodeHighlightData);
                endNodeHighlight.setColor(color);
                return _context.abrupt("return", endNodeHighlight.save(csrfToken));

              case 124:
                if (!(startNodeCompleteOverlap && endNodeCompleteOverlap)) {
                  _context.next = 132;
                  break;
                }

                // extend start
                // delete end
                _startNodeHighlightData.node2 = _endNodeHighlightData.node2;
                _startNodeHighlightData.offset2 = _endNodeHighlightData.offset2; // delete end highlight

                _context.next = 129;
                return endNodeHighlight.delete();

              case 129:
                // update from data
                startNodeHighlight.updateFromData(_startNodeHighlightData);
                startNodeHighlight.setColor(color);
                return _context.abrupt("return", startNodeHighlight.save(csrfToken));

              case 132:
                if (!(startNodeHighlight && startNodeHighlight === endNodeHighlight)) {
                  _context.next = 178;
                  break;
                }

                if (!(color === startNodeHighlight.color)) {
                  _context.next = 135;
                  break;
                }

                return _context.abrupt("return", true);

              case 135:
                if (!(startNodeCompleteOverlap && endNodeCompleteOverlap)) {
                  _context.next = 138;
                  break;
                }

                startNodeHighlight.setColor(color);
                return _context.abrupt("return", startNodeHighlight.save(csrfToken));

              case 138:
                _startNodeHighlightData2 = startNodeHighlight.getDataCamelCase(); // start complete overlap

                if (!(startNodeCompleteOverlap && !endNodeCompleteOverlap)) {
                  _context.next = 150;
                  break;
                }

                // shorten start
                // create new highlight
                originalNode = _startNodeHighlightData2.node1;
                originalStartOffset = _startNodeHighlightData2.offset1; // shorten start

                _startNodeHighlightData2.offset1 = selection.endOffset; // update from data

                startNodeHighlight.updateFromData(_startNodeHighlightData2);
                _context.next = 146;
                return startNodeHighlight.save(csrfToken);

              case 146:
                // Create new highlight
                _newHighlight3 = new models_highlight({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                });

                _newHighlight3.createFromData({
                  node1: originalNode,
                  offset1: originalStartOffset,
                  node2: originalNode,
                  offset2: _startNodeHighlightData2.offset1,
                  color: color
                }); // TODO: cleanup the metadata mess


                _newHighlight3.metadata = metadata;
                return _context.abrupt("return", _newHighlight3.save(csrfToken));

              case 150:
                if (!(!startNodeCompleteOverlap && endNodeCompleteOverlap)) {
                  _context.next = 161;
                  break;
                }

                // shorten start
                // create new highlight
                _originalNode = _startNodeHighlightData2.node2;
                originalOffset = _startNodeHighlightData2.offset2; // shorten start

                _startNodeHighlightData2.offset2 = selection.startOffset; // update from data

                startNodeHighlight.updateFromData(_startNodeHighlightData2);
                _context.next = 157;
                return startNodeHighlight.save(csrfToken);

              case 157:
                // Create new highlight
                _newHighlight4 = new models_highlight({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                });

                _newHighlight4.createFromData({
                  node1: _originalNode,
                  offset1: _startNodeHighlightData2.offset2,
                  node2: _originalNode,
                  offset2: originalOffset,
                  color: color
                }); // TODO: cleanup the metadata mess


                _newHighlight4.metadata = metadata;
                return _context.abrupt("return", _newHighlight4.save(csrfToken));

              case 161:
                // no complete overlap
                // shorten start
                // create middle split
                // create end split with the same color as start
                endOffset = _startNodeHighlightData2.offset2; // shorten start

                _startNodeHighlightData2.offset2 = selection.startOffset; // update from data

                startNodeHighlight.updateFromData(_startNodeHighlightData2);
                _context.next = 166;
                return startNodeHighlight.save(csrfToken);

              case 166:
                // create middle split
                // Create middle highlight
                middleHighlight = new models_highlight({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                });
                middleHighlightEndNodeSelector = selection.endNodeSelector;
                middleHighlightEndOffset = selection.endOffset;
                middleHighlight.createFromData({
                  node1: _startNodeHighlightData2.node2,
                  offset1: _startNodeHighlightData2.offset2,
                  node2: middleHighlightEndNodeSelector,
                  offset2: middleHighlightEndOffset,
                  color: color
                }); // TODO: cleanup the metadata mess

                middleHighlight.metadata = metadata;
                _context.next = 173;
                return middleHighlight.save(csrfToken);

              case 173:
                middleHighlightData = middleHighlight.getDataCamelCase(); // Create end highlight

                endHighlight = new models_highlight({
                  ignoredElements: this.ignoredElements,
                  contextContainer: this.contextContainer,
                  nodeSelectors: this.nodeSelectors
                });
                endHighlight.createFromData({
                  node1: middleHighlightData.node2,
                  offset1: middleHighlightData.offset2,
                  node2: middleHighlightData.node2,
                  offset2: endOffset,
                  color: startNodeHighlight.color
                }); // TODO: cleanup the metadata mess

                endHighlight.metadata = metadata;
                return _context.abrupt("return", endHighlight.save(csrfToken));

              case 178:
                return _context.abrupt("return", false);

              case 179:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createOrUpdate(_x, _x2, _x3, _x4) {
        return _createOrUpdate.apply(this, arguments);
      }

      return createOrUpdate;
    }()
    /**
     * Dispatch an event on the event-bus.
     * @private
     * @param {String} eventName The name of the event to dispatch.
     * @param {Any} data The data to pass along into the event data.
     */

  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(eventName, data) {
      this.eventBus.emit(eventName, {
        context: this,
        data: data
      });
    }
    /**
     * Thist method is triggered on state-change from the singleton.
     * @private
     */

  }, {
    key: "_onStateChange",
    value: function _onStateChange(newState, previousState) {
      this._dispatchEvent('state:change', {
        state: newState,
        previousState: previousState
      });
    } // +===================================+
    // | Static implementation starts here |
    // +===================================+

  }], [{
    key: "apiOrigin",
    get:
    /**
     * The API origin to use with the highlight-helper endpoints.
     */
    function get() {
      return getApiOrigin();
    },
    set: function set(origin) {
      if (!origin) {
        return;
      }

      setApiOrigin(origin);
    }
    /**
     * A map of the highlight-helpers currently available on the page. The keys are based on `clientId`.
     * @static
     * @readonly
     * @type {Map}
     */

  }, {
    key: "highlightHelpers",
    get: function get() {
      return this._highlightHelpers;
    }
  }, {
    key: "selectionHelper",
    get: function get() {
      return this._selectionHelper;
    }
    /**
     * The current state being tracked by the HighlightHelper class.
     * @readonly
     */

  }, {
    key: "state",
    get: function get() {
      if (!this._state) {
        this._state = this.getDefaultState();
      }

      return this._state;
    }
    /**
     * Registers the Highlight instance with the singleton for managing it better.
     * This also helps ensure we only attach event-listeners when there are active
     * instances on the page.
     * @param {HighlightHelper} highlightHelper An instance of the HighlightHelper.
     */

  }, {
    key: "add",
    value: function add(highlightHelper) {
      this.highlightHelpers.set(highlightHelper.clientId, highlightHelper);
      this.load();
    }
    /**
     * Adds event-listeners.
     * @private
     */

  }, {
    key: "_addEventListeners",
    value: function _addEventListeners() {
      this.selectionHelper.eventBus.on('selection:change', this._onSelectionChange, this);
    }
    /**
     * Returns a default state object to be populated with the correct data.
     * @returns {Object} A default state object with empty or null values.
     */

  }, {
    key: "getDefaultState",
    value: function getDefaultState() {
      return {
        startNodeHighlight: null,
        startNodeHighlightElement: null,
        startNodeCompleteOverlap: false,
        startNodePartialOverlap: false,
        endNodeHighlight: null,
        endNodeHighlightElement: null,
        endNodeCompleteOverlap: false,
        endNodePartialOverlap: false,
        intermediateHighlights: [],
        isExtendingHighlight: false,
        selection: null
      };
    }
    /**
     * Returns a unique numeric client-id for the current window and increments the nextClientId counter by 1.
     * @returns {Number} A unique numeric client-id for the current window.
     */

  }, {
    key: "getNextClientId",
    value: function getNextClientId() {
      var nextClientId = this._nextClientId;
      this._nextClientId += 1;
      return nextClientId;
    }
    /**
     * Loads and initializes the SelectionHelper singleton. This method can be safely
     * called multiple times as the internal checks ensure that the singleton initializes
     * just once.
     */

  }, {
    key: "load",
    value: function load() {
      if (this.isLoaded) {
        return;
      }

      this._selectionHelper = new helpers_selection();
      this._state = this.getDefaultState();

      this._addEventListeners();

      this._isLoaded = true;
    }
    /**
     * The event listener for `SelectionHelper`'s `selection:change` event.
     * @private
     * @param {Object} data The event data.
     */

  }, {
    key: "_onSelectionChange",
    value: function _onSelectionChange(data) {
      var selection = data.selection;
      var endNode = selection.endNode,
          startNode = selection.startNode;
      var state = this.getDefaultState();
      state.selection = selection;
      var startNodeHighlightData = models_highlight.getHighlightFromNode(startNode);
      state.startNodeHighlight = startNodeHighlightData.highlight;
      state.startNodeHighlightElement = startNodeHighlightData.highlightElement;

      if (state.startNodeHighlight) {
        var startNodeHighlightElements = state.startNodeHighlight.getHighlightElements();
        var isFirstStartHighlightElement = startNodeHighlightElements.indexOf(state.startNodeHighlightElement) === 0;
        state.startNodeCompleteOverlap = selection.startOffset === 0 && isFirstStartHighlightElement;
        state.startNodePartialOverlap = !state.startNodeCompleteOverlap;
      }

      var endNodeHighlightData = models_highlight.getHighlightFromNode(endNode);
      state.endNodeHighlight = endNodeHighlightData.highlight;
      state.endNodeHighlightElement = endNodeHighlightData.highlightElement;

      if (state.endNodeHighlightElement) {
        var endNodeHighlightElements = state.endNodeHighlight.getHighlightElements();
        var lastEndHighlightOffset = endNodeHighlightElements.length - 1;
        var isLastEndHighlightElement = endNodeHighlightElements.indexOf(state.endNodeHighlightElement) === lastEndHighlightOffset;
        var endNodeHighlightContentLastOffset = state.endNodeHighlightElement.textContent.length;
        state.endNodeCompleteOverlap = selection.endOffset === endNodeHighlightContentLastOffset && isLastEndHighlightElement;
        state.endNodePartialOverlap = !state.endNodeCompleteOverlap;
      }

      var allIntermediateHighlightElements = dom.getIntermediateElementNodes(state.startNodeHighlightElement || startNode, state.endNodeHighlightElement || endNode).filter(function (intermediateElement) {
        return intermediateElement.classList.contains('de-highlight');
      });
      var intermediateHighlights = [];
      allIntermediateHighlightElements.forEach(function (element) {
        var highlightClientId = parseInt(element.getAttribute('data-highlight-client-id'), 10);
        var highlight = models_highlight.getByClientId(highlightClientId);

        if (highlight === state.startNodeHighlight || highlight === state.endNodeHighlight) {
          // Don't push start and end highlights into the intermediates.
          return;
        }

        if (!intermediateHighlights.includes(highlight)) {
          intermediateHighlights.push(highlight);
        }
      });
      state.intermediateHighlights = intermediateHighlights;
      this.setState(state);
      var activeHighlight = models_highlight.activeHighlight;

      if (selection.text && activeHighlight) {
        activeHighlight.deselect();
      }

      if (!selection.text) {
        // No text selection, which implies that
        // a highlight may have been selected.
        var highlight = state.startNodeHighlight;

        if (!highlight) {
          return;
        }

        highlight.select();
      }
    }
    /**
     * Unregisters the HighlighHelper instance with the singleton for managing it better.
     * This helps ensure we clean up any attached event-listeners after the last
     * instance has been removed from use on the page.
     * @param {Number} clientId The client-id of an instance of HighlightHelper.
     */

  }, {
    key: "remove",
    value: function remove(clientId) {
      var highlightHelper = this.highlightHelpers.get(clientId);

      if (!highlightHelper) {
        return;
      }

      this.highlightHelpers.delete(clientId);

      if (this.highlightHelpers.size === 0) {
        this.unload();
      }
    }
    /**
     * Removes event listeners.
     * @private
     */

  }, {
    key: "_removeEventListeners",
    value: function _removeEventListeners() {
      this.selectionHelper.eventBus.off('selection:change', this._onSelectionChange);
    }
    /**
     * Get all highlights from the database.
     * @param {String} conceptId The concept GUID for retrieving the highlights.
     * @returns {Array} Returns an array of highlight data objects.
     */

  }, {
    key: "retrieveAllHighlights",
    value: function retrieveAllHighlights(conceptId) {
      return highlight_retrieveAllHighlights(conceptId).then(function (response) {
        return response.data.highlights;
      });
    }
    /**
     * Get all highlights from the database using references
     * @param {Array} references The concept GUID for retrieving the highlights.
     * @returns {Array} Returns an array of highlight data objects.
     */

  }, {
    key: "retrieveAllHighlightsByReference",
    value: function retrieveAllHighlightsByReference(references) {
      return highlight_retrieveAllHighlightsByReference(references).then(function (response) {
        return response.data.highlights;
      });
    }
    /**
     * Updates the state of the highlights on the page.
     * @param {Object} state The state to override with.
     */

  }, {
    key: "setState",
    value: function setState(state) {
      var previousState = Object(objectSpread2["a" /* default */])({}, this._state);

      var newState = Object(objectSpread2["a" /* default */])(Object(objectSpread2["a" /* default */])({}, previousState), state);

      this._state = newState;
      this.highlightHelpers.forEach(function (highlightHelper) {
        highlightHelper._onStateChange(newState, previousState);
      });
    }
    /**
     * Unloads the SelectionHelper singleton. This method can be safely called multiple times
     * as the internal checks ensure that the singleton unloads just once.
     */

  }, {
    key: "unload",
    value: function unload() {
      if (!this.isLoaded) {
        return;
      }

      this._removeEventListeners();

      this._selectionHelper.destroy();

      this._selectionHelper = null;
      this._isLoaded = false;
    }
  }]);

  return HighlightHelper;
}();

Object(defineProperty["a" /* default */])(highlight_HighlightHelper, "_highlightHelpers", new Map());

Object(defineProperty["a" /* default */])(highlight_HighlightHelper, "_isLoaded", false);

Object(defineProperty["a" /* default */])(highlight_HighlightHelper, "_nextClientId", 1);

Object(defineProperty["a" /* default */])(highlight_HighlightHelper, "_selectionHelper", null);

Object(defineProperty["a" /* default */])(highlight_HighlightHelper, "_state", null);

/* harmony default export */ var helpers_highlight = (highlight_HighlightHelper);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/text-select-tools/TextSelectTools.vue?vue&type=template&id=561d7002

var TextSelectToolsvue_type_template_id_561d7002_hoisted_1 = {
  class: "text-select__controls-wrapper"
};
var TextSelectToolsvue_type_template_id_561d7002_hoisted_2 = {
  class: "text-select__controls-options"
};
var TextSelectToolsvue_type_template_id_561d7002_hoisted_3 = {
  class: "text-select__controls-tts-buttons"
};
var TextSelectToolsvue_type_template_id_561d7002_hoisted_4 = {
  key: 0,
  class: "text-select__controls-highlight-buttons"
};
function TextSelectToolsvue_type_template_id_561d7002_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NebulaButton = Object(external_vue_["resolveComponent"])("NebulaButton");

  var _component_NebulaButtonGroup = Object(external_vue_["resolveComponent"])("NebulaButtonGroup");

  return (!$data.loadTextToSpeech || _ctx.speechstream) && ($data.ttsControlsOpen || _ctx.isSpeaking || _ctx.isPaused) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", {
    class: "text-select__wrapper",
    style: Object(external_vue_["normalizeStyle"])($options.coords),
    key: $options.getCurrentHighlight()
  }, [Object(external_vue_["createElementVNode"])("div", TextSelectToolsvue_type_template_id_561d7002_hoisted_1, [Object(external_vue_["createElementVNode"])("div", TextSelectToolsvue_type_template_id_561d7002_hoisted_2, [Object(external_vue_["createVNode"])(_component_NebulaButtonGroup, {
    class: "text-select__controls"
  }, {
    buttons: Object(external_vue_["withCtx"])(function () {
      return [Object(external_vue_["createElementVNode"])("div", TextSelectToolsvue_type_template_id_561d7002_hoisted_3, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
        "aria-label": $options.statusText,
        class: Object(external_vue_["normalizeClass"])("text-select__button text-select__button--".concat($options.statusIcon)),
        onClick: Object(external_vue_["withModifiers"])($options.handlePlay, ["stop"]),
        "icon-left": $options.statusIcon,
        text: $options.statusText,
        size: "s",
        type: "flat"
      }, null, 8, ["aria-label", "class", "onClick", "icon-left", "text"])]), $props.useHighlights && (!$data.ignoredSelection || $options.checkSelection().isHighlight) ? (Object(external_vue_["openBlock"])(), Object(external_vue_["createElementBlock"])("div", TextSelectToolsvue_type_template_id_561d7002_hoisted_4, [Object(external_vue_["createVNode"])(_component_NebulaButton, {
        "aria-label": _ctx.$t('Remove Highlight'),
        class: "text-select__highlight-button text-select__highlight-button--remove",
        "is-disabled": !$options.getCurrentHighlight(),
        type: "flat",
        size: "s",
        "icon-left": "checkbox-strike",
        onClick: Object(external_vue_["withModifiers"])($options.removeHighlight, ["prevent"])
      }, null, 8, ["aria-label", "is-disabled", "onClick"]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
        "aria-label": _ctx.$t('Highlight Yellow'),
        class: Object(external_vue_["normalizeClass"])(["text-select__highlight-button text-select__highlight-button--yellow", {
          'text-select__highlight-button--active': $data.currentHighlightColor === 'yellow'
        }]),
        type: "flat",
        size: "s",
        "icon-left": "checkbox-empty",
        onClick: _cache[0] || (_cache[0] = Object(external_vue_["withModifiers"])(function ($event) {
          return $options.handleHighlight('yellow');
        }, ["prevent"]))
      }, null, 8, ["aria-label", "class"]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
        "aria-label": _ctx.$t('Highlight Pink'),
        class: Object(external_vue_["normalizeClass"])(["text-select__highlight-button text-select__highlight-button--pink", {
          'text-select__highlight-button--active': $data.currentHighlightColor === 'pink'
        }]),
        type: "flat",
        size: "s",
        "icon-left": "checkbox-empty",
        onClick: _cache[1] || (_cache[1] = Object(external_vue_["withModifiers"])(function ($event) {
          return $options.handleHighlight('pink');
        }, ["prevent"]))
      }, null, 8, ["aria-label", "class"]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
        "aria-label": _ctx.$t('Highlight Green'),
        class: Object(external_vue_["normalizeClass"])(["text-select__highlight-button text-select__highlight-button--green", {
          'text-select__highlight-button--active': $data.currentHighlightColor === 'green'
        }]),
        type: "flat",
        size: "s",
        "icon-left": "checkbox-empty",
        onClick: _cache[2] || (_cache[2] = Object(external_vue_["withModifiers"])(function ($event) {
          return $options.handleHighlight('green');
        }, ["prevent"]))
      }, null, 8, ["aria-label", "class"]), Object(external_vue_["createVNode"])(_component_NebulaButton, {
        "aria-label": _ctx.$t('Highlight Blue'),
        class: Object(external_vue_["normalizeClass"])(["text-select__highlight-button text-select__highlight-button--blue", {
          'text-select__highlight-button--active': $data.currentHighlightColor === 'blue'
        }]),
        type: "flat",
        size: "s",
        "icon-left": "checkbox-empty",
        onClick: _cache[3] || (_cache[3] = Object(external_vue_["withModifiers"])(function ($event) {
          return $options.handleHighlight('blue');
        }, ["prevent"]))
      }, null, 8, ["aria-label", "class"])])) : Object(external_vue_["createCommentVNode"])("", true)];
    }),
    _: 1
  })])])], 4)) : Object(external_vue_["createCommentVNode"])("", true);
}
// CONCATENATED MODULE: ./src/components/text-select-tools/TextSelectTools.vue?vue&type=template&id=561d7002

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__("8ba4");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader-v16/dist??ref--1-1!./src/components/text-select-tools/TextSelectTools.vue?vue&type=script&lang=js















/* harmony default export */ var TextSelectToolsvue_type_script_lang_js = ({
  name: 'TextSelectTools',
  components: {
    NebulaButton: nebula_components_["NebulaButton"],
    NebulaButtonGroup: nebula_components_["NebulaButtonGroup"]
  },
  data: function data() {
    return {
      activeTool: 'tts',
      cachedSelectionData: null,
      cachedSelectedText: null,
      contextContainer: null,
      cooldownTimerId: null,
      currentHighlightColor: null,
      eventAbortController: new AbortController(),
      eventBus: new tiny_emitter_default.a(),
      highlightHelper: null,
      ignoredSelection: null,
      loadTextToSpeech: this.useSpeechTools,
      pointerCoordinates: {
        x: null,
        y: null
      },
      selectedText: null,
      ttsControlsOpen: false,
      selectionHelper: null,
      selectWrapperObserver: null
    };
  },
  props: {
    // textSelectTools expects to get locked to a parent HTMLElement
    contextContainerSelector: {
      type: String,
      required: true
    },
    pageData: {
      type: Object,
      required: false
    },
    ignoredElements: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initData: {
      type: Object,
      required: false
    },
    metadata: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    nodeSelectors: {
      type: Object,
      required: true
    },
    useHighlights: {
      type: Boolean,
      default: true
    },
    useSpeechTools: {
      type: Boolean,
      default: true
    },
    apiOrigin: {
      type: String,
      default: null
    },
    apiVersion: {
      type: Number,
      default: 1,
      validator: function validator(value) {
        return [1, 2].includes(value);
      }
    },
    offsetX: {
      type: Number,
      default: 0
    },
    offsetY: {
      type: Number,
      default: 0
    },
    placementFunc: {
      type: Function,
      default: null
    }
  },
  mixins: [text_to_speech],
  emits: ['highlight-created', 'highlight-deleted', 'highlight-updated'],
  mounted: function mounted() {
    var _this = this;

    this.contextContainer = document.querySelector(this.contextContainerSelector);
    this.highlightHelper = new helpers_highlight({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    });

    if (this.apiOrigin) {
      // This will set the API origin for all requests
      // to the highlight endpoint on the page.
      helpers_highlight.apiOrigin = this.apiOrigin;
    }

    this.selectionHelper = new helpers_selection({
      contextContainer: this.contextContainer,
      ignoredElements: this.ignoredElements,
      nodeSelectors: this.nodeSelectors
    });
    this.retrieveHighlights();
    this.checkHighlights();

    if (!this.useSpeechTools) {
      this.startTextSelect();
      return;
    }

    this.eventBus.on('tts:initialized', function () {
      // waits for tts to get initialized before setting up page level TTS config.
      _this.startTextSelect();

      var _this$speechstream = _this.speechstream,
          domControlTools = _this$speechstream.domControlTools,
          speechTools = _this$speechstream.speechTools;
      domControlTools.setStartPoint(_this.contextContainer);
      speechTools.setContinuousReading(false);
    });
    this.eventBus.on('tts:page-complete', function (elements) {
      if (!elements.length) {
        // remove <de-selection> elements if all elements have been read.
        _this.selectionHelper.selection.unmark(); // if not selected on a highlight, reset selection.


        if (!_this.getCurrentHighlight()) {
          _this.resetSelection();
        } // Forcing a closeTools as selectors are not constructed for ignored elemenets


        if (!_this.getCurrentHighlight() && (_this.checkSelection().isIgnored || _this.checkSelection().isPartiallyIgnored)) {
          _this.closeTools();
        }
      }

      if (_this.ignoredSelection) {
        _this.closeTools();
      }
    });
  },
  computed: {
    version: function version() {
      // any highlight with references is by default version 2
      if (this.metadata.references && this.metadata.references.length) {
        return 2;
      }

      return this.apiVersion;
    },
    coords: function coords() {
      var _this$pointerCoordina = this.pointerCoordinates,
          x = _this$pointerCoordina.x,
          y = _this$pointerCoordina.y;
      return {
        left: "".concat(x, "px"),
        top: "".concat(y, "px")
      };
    },
    isInCooldown: function isInCooldown() {
      return !!this.cooldownTimerId;
    },
    statusIcon: function statusIcon() {
      // paused
      if (this.isPaused) return 'play'; // speaking

      if (this.isSpeaking || this.readableElements.length) return 'pause'; // default

      return 'play';
    },
    statusText: function statusText() {
      // paused
      if (this.isPaused) return this.$t('Play Text'); // speaking

      if (this.isSpeaking || this.readableElements.length) return this.$t('Pause Text'); // default

      return this.$t('Play Text');
    },
    ttsActive: function ttsActive() {
      return this.activeTool === 'tts';
    },
    highlightActive: function highlightActive() {
      return this.activeTool === 'highlight';
    },
    highlightToken: function highlightToken() {
      return this.initData.csrf_tokens.notebook.highlight;
    }
  },
  methods: {
    checkSelection: function checkSelection() {
      var _this$getSelection = this.getSelection(),
          startNode = _this$getSelection.startNode,
          endNode = _this$getSelection.endNode;

      var currentHighlight = this.getCurrentHighlight();
      var domHelper = this.selectionHelper.domHelper;

      if (currentHighlight) {
        this.currentHighlightColor = currentHighlight.color;
      } else {
        this.currentHighlightColor = null;
      }

      var selectionParams = {
        isHighlight: !!currentHighlight,
        isIgnored: domHelper.isNodeInIgnoredList(startNode) && domHelper.isNodeInIgnoredList(endNode),
        isPartiallyIgnored: domHelper.isNodeInIgnoredList(startNode) || domHelper.isNodeInIgnoredList(endNode)
      };

      if (selectionParams.isIgnored || selectionParams.isPartiallyIgnored) {
        this.ignoredSelection = true;
      }

      return selectionParams;
    },
    clearCooldownTimer: function clearCooldownTimer() {
      if (!this.cooldownTimerId) {
        return;
      }

      clearTimeout(this.cooldownTimerId);
      this.cooldownTimerId = null;
    },
    closeTools: function closeTools() {
      var currentHighlight = this.getCurrentHighlight();

      if (currentHighlight) {
        currentHighlight.deselect();
      }

      this.handleStop(); // check for any new highlights

      this.activeTool = 'tts';
      this.ttsControlsOpen = false;
      this.ignoredSelection = null;
      this.startCooldownTimer();
    },
    getCurrentHighlight: function getCurrentHighlight() {
      return models_highlight.activeHighlight;
    },
    getSelection: function getSelection() {
      return this.selectionHelper.selection;
    },
    handlePlay: function handlePlay() {
      if (this.isSpeaking || this.isPaused || this.hasReadableElements) {
        this.pause();
        return;
      }

      var currentHighlight = this.getCurrentHighlight();
      var selection = currentHighlight ? currentHighlight.selection : this.getSelection();
      this.cachedSelectionData = selection ? selection.getData() : null; // highlights that span across HTML Elements will get pushed into an array.
      // We will read through each item in the array until we reach the end.
      // Note: Reading through elements in an array causes breaking text and partial reads.
      // This is partially due to logic in the speechstream logic that enforces breaks on sentence breaks
      // TODO: replace speechstream service with AWS Polly so we have more granular control over TTS.

      var speakableElements;

      if (!this.useHighlights) {
        this.play();
        return;
      } // If selection is inside an ignoredElement on the page


      if (!currentHighlight && (this.checkSelection().isIgnored || this.checkSelection().isPartiallyIgnored)) {
        // DEFAULT PLAY
        this.play();
        return;
      }

      if (currentHighlight) {
        // PLAYS ON HIGHLIGHT
        speakableElements = currentHighlight.getHighlightElements();
      } else {
        // PLAYS ON SELECTION
        // marks all selected elements for speaking
        speakableElements = this.selectionHelper.selection.mark('de-speakable');
      }

      this.speakElements(speakableElements);
    },
    handleStop: function handleStop() {
      if (this.isSpeaking || this.isPaused || this.hasReadableElements) {
        this.stop();
        this.selectionHelper.selection.unmark();
      }
    },
    handleHighlight: function handleHighlight(color) {
      var _this2 = this;

      return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var currentHighlight, _response, highlightMetadata, _this2$pageData$conce, _this2$pageData$conce2, _this2$pageData$conce3, _this2$pageData$conce4, _this2$pageData$conce5, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentHighlight = _this2.getCurrentHighlight();

                if (!currentHighlight) {
                  _context.next = 9;
                  break;
                }

                // HAS a current-highlight
                currentHighlight.setColor(color);
                _context.next = 5;
                return currentHighlight.save(_this2.highlightToken);

              case 5:
                _response = _context.sent;

                _this2.$emit('highlight-updated', _response.data);

                _this2.currentHighlightColor = currentHighlight.color;
                return _context.abrupt("return");

              case 9:
                if (_this2.version === 2) {
                  highlightMetadata = _this2.metadata;
                } else {
                  highlightMetadata = Object(objectSpread2["a" /* default */])({
                    concept_id: _this2.initData.concept_id,
                    course_id: _this2.initData.course_id,
                    relationship_type_id: _this2.initData.tab_id,
                    subdiscipline_id: (_this2$pageData$conce = _this2.pageData.concept) === null || _this2$pageData$conce === void 0 ? void 0 : (_this2$pageData$conce2 = _this2$pageData$conce.unit) === null || _this2$pageData$conce2 === void 0 ? void 0 : (_this2$pageData$conce3 = _this2$pageData$conce2.subdiscipline) === null || _this2$pageData$conce3 === void 0 ? void 0 : _this2$pageData$conce3.id,
                    unit_id: (_this2$pageData$conce4 = _this2.pageData.concept) === null || _this2$pageData$conce4 === void 0 ? void 0 : (_this2$pageData$conce5 = _this2$pageData$conce4.unit) === null || _this2$pageData$conce5 === void 0 ? void 0 : _this2$pageData$conce5.id
                  }, _this2.metadata);
                }

                _context.next = 12;
                return _this2.highlightHelper.createOrUpdate(_this2.selectionHelper, color, highlightMetadata, _this2.highlightToken);

              case 12:
                response = _context.sent;

                // emit create result
                _this2.$emit('highlight-created', response);

                _this2.closeTools();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    removeHighlight: function removeHighlight() {
      var _this3 = this;

      return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var currentHighlight;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                currentHighlight = _this3.getCurrentHighlight();

                if (currentHighlight) {
                  _context2.next = 4;
                  break;
                }

                _this3.closeTools();

                return _context2.abrupt("return");

              case 4:
                _context2.next = 6;
                return currentHighlight.delete();

              case 6:
                _this3.$emit('highlight-deleted', currentHighlight.id);

                _this3.closeTools();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    resetSelection: function resetSelection() {
      if (!this.cachedSelectionData) {
        return;
      }

      var selection = this.getSelection();
      selection.updateFromData(this.cachedSelectionData);
      selection.select();
    },
    retrieveHighlights: function retrieveHighlights() {
      var _this4 = this;

      return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this4$initData, _this4$metadata$refer;

        var highlightsData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.useHighlights) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (!((_this4$initData = _this4.initData) !== null && _this4$initData !== void 0 && _this4$initData.highlightsData)) {
                  _context3.next = 6;
                  break;
                }

                highlightsData = _this4.initData.highlightsData;
                _context3.next = 15;
                break;

              case 6:
                if (!(_this4.version === 2 && (_this4$metadata$refer = _this4.metadata.references) !== null && _this4$metadata$refer !== void 0 && _this4$metadata$refer.length)) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 9;
                return helpers_highlight.retrieveAllHighlightsByReference(_this4.metadata.references);

              case 9:
                highlightsData = _context3.sent;
                _context3.next = 15;
                break;

              case 12:
                _context3.next = 14;
                return helpers_highlight.retrieveAllHighlights(_this4.initData.concept_id);

              case 14:
                highlightsData = _context3.sent;

              case 15:
                highlightsData.forEach(function (highlightData) {
                  var highlight = _this4.highlightHelper.createFromData(highlightData);

                  if (!highlight) {
                    return;
                  }

                  highlight.eventBus.on('select', _this4.onSelectHighlight, _this4);
                });

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    checkHighlights: function checkHighlights() {
      var _this5 = this;

      var highlightsInDom = document.querySelectorAll('.de-highlight');
      highlightsInDom.forEach(function (domHighlight) {
        // iOS touch events default to focus on a touchend event
        // which prevents the toolbar from opening.
        // this code in place to ensure that an initial tap does the
        // expected behavior of selecting the mark element and opening the toolbar
        // and runs on mounted() and updated() lifecycle hooks
        // Another potential solution could be to use a custom WebComponent
        // in order to use the WebComponent's `connectedCallback()` method
        // This would require further refactoring to _injectHighlightElement() in
        // src/utils/models/highlight.js and styling considerations anywhere that
        // <mark> elements are used.
        if (!domHighlight.ontouchend) {
          // eslint-disable-next-line no-param-reassign
          domHighlight.ontouchend = function (event) {
            _this5.selectMarkElement(event);
          };
        }
      });
    },
    startCooldownTimer: function startCooldownTimer() {
      // Block the TTS tools from re-triggering
      // until the cooldown timer expires.
      if (this.isInCooldown) {
        return;
      }

      var timeout = 200;
      this.cooldownTimerId = setTimeout(this.clearCooldownTimer, timeout);
    },
    getSelectionChange: function getSelectionChange() {
      var selection = this.getSelection();

      if (!selection) {
        return;
      }

      this.checkSelection();
      var commonAncestor = selection.commonAncestor; // locks textSelectTools to parent component.

      if (this.contextContainer.contains(commonAncestor)) {
        this.selectedText = selection.text;
      }
    },
    onSelectHighlight: function onSelectHighlight(highlight) {
      this.selectedText = highlight.text;
    },
    onPointerDown: function onPointerDown(event) {
      if (dom.compareNodePosition(this.$el, event.target).isDescendant) {
        // Pointer is clicked inside of the toolbar
        return;
      }

      this.getSelectionChange(); // Saves a copy of selectedText to compare against pointerup event

      this.cachedSelectedText = this.selectedText;
      this.closeTools();
      this.clearCooldownTimer();
    },
    selectMarkElement: function selectMarkElement(event) {
      var dataset = event.target.dataset;
      var targetHighlight = models_highlight.getByClientId(dataset.highlightClientId);
      targetHighlight.select();
      this.pointerCoordinates.x = event.pageX - this.offsetX; // accounts for touch event size

      this.pointerCoordinates.y = event.pageY + 20 - this.offsetY;
      this.ttsControlsOpen = true;
    },
    setPointerCoords: function setPointerCoords(event) {
      var _this6 = this;

      // Only called on pointer-up
      var currentHighlight = this.getCurrentHighlight();
      var selection = this.getSelection();
      var selectionTextUnchanged = selection.text === this.cachedSelectedText;
      this.cachedSelectionData = selection ? selection.getData() : null; // if pointer-up is not in contextContainer

      if (!dom.compareNodePosition(this.contextContainer, event.target).isDescendant) {
        return;
      } // if pointer is let up inside of the toolbar


      if (dom.compareNodePosition(this.$el, event.target).isDescendant) {
        return;
      }

      if (selectionTextUnchanged && (!selection || !currentHighlight)) {
        this.closeTools();
      } // if the pointer-up is on a de-highlight, it should select that highlight


      if (event.target.classList.contains('de-highlight') && event.pointerType !== 'mouse') {
        this.selectionHelper.selection.clearData();
        helpers_selection.clearSelection();
        this.selectMarkElement(event);
      }

      if (this.ttsControlsOpen) {
        // if pointer-up happens outside of toolbar while toolbar is open
        if (event.target.classList.contains('de-highlight') && event.pointerType !== 'mouse') {
          this.selectMarkElement(event);
          return;
        }

        if (!dom.compareNodePosition(this.$el, event.target).isDescendant) {
          if (!selection.text || selectionTextUnchanged) {
            this.closeTools();
            return;
          }
        }
      } // sets coordinataes on highlight click


      if (!selection.text && currentHighlight) {
        // Reset pointer co-ordinates
        this.pointerCoordinates.x = event.pageX - this.offsetX;
        this.pointerCoordinates.y = event.pageY + 10 - this.offsetY;
        this.ttsControlsOpen = true;
        return;
      }

      if (this.isInCooldown) {
        // In cooldown mode
        return;
      } // sets coordinates on text selrction


      var isTextSelected = !!selection.text;

      if (!isTextSelected) {
        // If no selection, toolbar should be closed.
        this.closeTools();
        return;
      } // Stop speaking


      this.handleStop(); // Reset pointer co-ordinates

      this.pointerCoordinates.x = event.pageX - this.offsetX;
      this.pointerCoordinates.y = event.pageY + 10 - this.offsetY; // Has selection, open toolbar.
      // If already open, will reposition according to the new
      // pointer co-ordinates we set a few lines above.

      this.ttsControlsOpen = true; // Ensure the tools are contained inside of container

      this.$nextTick(function () {
        _this6.checkIntersection();
      });
    },
    startTextSelect: function startTextSelect() {
      var _this7 = this;

      // initiate event listeners
      var signal = this.eventAbortController.signal;
      this.selectionHelper.eventBus.on('selection:change', this.getSelectionChange, this);
      document.addEventListener('pointerdown', function (event) {
        return _this7.onPointerDown(event);
      }, {
        signal: signal
      });
      document.addEventListener('pointerup', function (event) {
        return _this7.setPointerCoords(event);
      }, {
        signal: signal
      });
      document.addEventListener('touchend', function (event) {
        // Overwrite default tap behaviour for touch devices
        var closestButton = event.target.closest('.nebula-button');

        if (closestButton) {
          event.preventDefault();
          closestButton.click();
        }
      });
    },
    toggleActiveTools: function toggleActiveTools(event) {
      var currentTarget = event.currentTarget; // set activeTool according to currentTarget

      this.activeTool = currentTarget.dataset.tool;
    },
    checkIntersection: function checkIntersection() {
      var _this8 = this;

      if (this.placementFunc) {
        // if the implementer provided a function to check intersection, use that
        // instead of the default
        var coords = this.placementFunc(); // the return value of the placement function must return a numeric value for
        // x and y to be applied

        if (Number.isInteger(coords.x)) {
          this.pointerCoordinates.x = coords.x;
        }

        if (Number.isInteger(coords.y)) {
          this.pointerCoordinates.y = coords.y;
        }

        return;
      } // no placement func supplied? go as normal


      var wrapper = document.querySelector('.text-select__wrapper');

      if (!wrapper) {
        return;
      }

      this.selectWrapperObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var wrapperWidth = entry.boundingClientRect.width;
            var visibleWrapper = entry.intersectionRect.width;
            var intersectionOffset = wrapperWidth - visibleWrapper + 16;
            _this8.pointerCoordinates.x = entry.intersectionRect.x - intersectionOffset - _this8.offsetX;
          }
        });
      });

      if (this.ttsControlsOpen) {
        this.selectWrapperObserver.observe(wrapper);
      } else {
        this.selectWrapperObserver.unobserve(wrapper);
      }
    }
  },
  updated: function updated() {
    this.checkHighlights();
  },
  beforeUnmount: function beforeUnmount() {
    var _this9 = this;

    // remove DOM-event listeners
    this.eventAbortController.abort();
    this.selectionHelper.eventBus.off();
    this.selectionHelper.destroy();

    if (this.selectWrapperObserver) {
      this.selectWrapperObserver.disconnect();
    }

    models_highlight.highlights.forEach(function (highlight) {
      highlight.eventBus.off('select', _this9.onSelectHighlight);
    });
  },
  watch: {
    ttsControlsOpen: function ttsControlsOpen(open) {
      var _this10 = this;

      if (open) {
        this.$nextTick(function () {
          _this10.checkIntersection();
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/text-select-tools/TextSelectTools.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./src/components/text-select-tools/TextSelectTools.vue?vue&type=style&index=0&id=561d7002&lang=stylus
var TextSelectToolsvue_type_style_index_0_id_561d7002_lang_stylus = __webpack_require__("7b2a");

// CONCATENATED MODULE: ./src/components/text-select-tools/TextSelectTools.vue







const TextSelectTools_exports_ = /*#__PURE__*/exportHelper_default()(TextSelectToolsvue_type_script_lang_js, [['render',TextSelectToolsvue_type_template_id_561d7002_render]])

/* harmony default export */ var TextSelectTools = (TextSelectTools_exports_);
// CONCATENATED MODULE: ./src/main-lib.js






/*
 * This is the entry file for the npm package. If you'd like anything to be available in
 * the package, add it to the exports here. Unfortunately directly exporting something
 * that we've imported is still an "experimental feature," hence the extra step
 * of renaming the imports.
 */






















var main_lib_ActionMenu = ActionMenu;
var main_lib_ErrorPage = ErrorPage;
var main_lib_TechbookContentErrorPage = TechbookContentErrorPage;
var MyContentUploadModal = Object(external_vue_["defineAsyncComponent"])(function () {
  return Promise.all(/* import() | MyContentUploadModal */[__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "5030"));
});
var PlayerComponents = player_components;
var main_lib_SearchBox = SearchBox;
var ShareModal = Object(external_vue_["defineAsyncComponent"])(function () {
  return __webpack_require__.e(/* import() | ShareModal */ 8).then(__webpack_require__.bind(null, "8726"));
});
var DownloadVideoModal = Object(external_vue_["defineAsyncComponent"])(function () {
  return Promise.all(/* import() | DownloadVideoModal */[__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "f441"));
});
var DualAssignModal2023 = Object(external_vue_["defineAsyncComponent"])(function () {
  return __webpack_require__.e(/* import() | DualAssignModal2023 */ 5).then(__webpack_require__.bind(null, "dc15"));
});
var CreateWithStudioModal = Object(external_vue_["defineAsyncComponent"])(function () {
  return __webpack_require__.e(/* import() | CreateWithStudioModal */ 3).then(__webpack_require__.bind(null, "6ae4"));
});
var main_lib_ChannelCardCarousel = ChannelCardCarousel;
var main_lib_StaySignedInModal = StaySignedInModal;
var main_lib_SSOStaySignedInModal = SSOStaySignedInModal;
var GoogleClassroomModal = Object(external_vue_["defineAsyncComponent"])(function () {
  return __webpack_require__.e(/* import() | GoogleClassroomModal */ 6).then(__webpack_require__.bind(null, "a58f"));
});
var main_lib_CleverIDMappingDropdown = CleverIDMappingDropdown;
var textToSpeech = text_to_speech;
var imageUrl = image_url;
var profileAvatars = profileAvatars_namespaceObject;
var profileBackgrounds = profileBackgrounds_namespaceObject;
var UsersImportAccordion = Object(external_vue_["defineAsyncComponent"])(function () {
  return __webpack_require__.e(/* import() | AdminComponents */ 1).then(__webpack_require__.bind(null, "7cf5"));
});
var UsersManageAccordion = Object(external_vue_["defineAsyncComponent"])(function () {
  return __webpack_require__.e(/* import() | AdminComponents */ 1).then(__webpack_require__.bind(null, "8bd8"));
});
var main_lib_i18nPluralTerms = i18nPluralTerms;
var main_lib_DomHelper = dom;
var main_lib_Highlight = models_highlight;
var main_lib_HighlightHelper = helpers_highlight;
var main_lib_Selection = models_selection;
var main_lib_SelectionHelper = helpers_selection;
var main_lib_TextSelectTools = TextSelectTools;
/* harmony default export */ var main_lib = ({
  ActionMenu: main_lib_ActionMenu,
  ErrorPage: main_lib_ErrorPage,
  TechbookContentErrorPageImport: TechbookContentErrorPage,
  MyContentUploadModal: MyContentUploadModal,
  PlayerComponents: PlayerComponents,
  SearchBox: main_lib_SearchBox,
  ShareModal: ShareModal,
  DownloadVideoModal: DownloadVideoModal,
  DualAssignModal2023: DualAssignModal2023,
  CreateWithStudioModal: CreateWithStudioModal,
  ChannelCardCarousel: main_lib_ChannelCardCarousel,
  StaySignedInModal: main_lib_StaySignedInModal,
  SSOStaySignedInModalImport: SSOStaySignedInModal,
  GoogleClassroomModal: GoogleClassroomModal,
  CleverIDMappingDropdown: main_lib_CleverIDMappingDropdown,
  textToSpeech: textToSpeech,
  imageUrl: imageUrl,
  profileAvatars: profileAvatars,
  profileBackgrounds: profileBackgrounds,
  UsersImportAccordion: UsersImportAccordion,
  UsersManageAccordion: UsersManageAccordion,
  i18nPluralTerms: main_lib_i18nPluralTerms,
  DomHelper: main_lib_DomHelper,
  Highlight: main_lib_Highlight,
  HighlightHelper: main_lib_HighlightHelper,
  Selection: main_lib_Selection,
  SelectionHelper: main_lib_SelectionHelper,
  TextSelectTools: main_lib_TextSelectTools
});
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (main_lib);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fea9":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "ff50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/lodash-es/memoize.js
var memoize = __webpack_require__("a134");

// CONCATENATED MODULE: ./node_modules/lodash-es/_memoizeCapped.js


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(memoize["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ var _memoizeCapped = (memoizeCapped);

// CONCATENATED MODULE: ./node_modules/lodash-es/_stringToPath.js


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = _memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ var _stringToPath = __webpack_exports__["a"] = (stringToPath);


/***/ }),

/***/ "ff51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ })

/******/ });
//# sourceMappingURL=platform-components.common.js.map